webpackJsonp([385],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68acded4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(852);
function injectStyle (ssrContext) {
  __webpack_require__(842)
  __webpack_require__(843)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68acded4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68acded4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

module.exports = utils_library;

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(24);

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(9);

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(575);
/* global process */


// import * as actions from './actions'
// import * as getters from './getters'


var debug = "production" !== 'production';

// 载入 views 目录下所有文件模块
var modules = __webpack_require__(96).requires(__webpack_require__(576));

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["default"].Store({
  state: __WEBPACK_IMPORTED_MODULE_1__state__["a" /* default */],
  // getters,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__,
  // actions,
  modules: modules,
  strict: debug
}));

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getLoginInfo;
/* harmony export (immutable) */ __webpack_exports__["a"] = getExpiredTime;
/* unused harmony export onlogin */
/* unused harmony export onlogout */
/* harmony export (immutable) */ __webpack_exports__["g"] = onloginExpired;
/* unused harmony export getUser */
/* harmony export (immutable) */ __webpack_exports__["e"] = login;
/* harmony export (immutable) */ __webpack_exports__["f"] = logout;
/* harmony export (immutable) */ __webpack_exports__["d"] = isLoggedIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = getToken;
/* unused harmony export setToken */
/*
 * 用户登录认证的方法集
 * @Author: anker.wang
 * @Date: 2018-01-08 11:24:54
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-25 13:41:44
 */

var timer = null;
var user = null;
var queue = {
  login: [],
  logout: [],
  expired: []
};

function triggerQueue(queue, data) {
  queue.forEach(function (event) {
    event(data);
  });
}

function b64DecodeUnicode(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
}

function getLoginInfo(token) {
  // decode user info from token
  try {
    var start = token.indexOf('.') + 1;
    var end = token.indexOf('.', start);
    var encoded = token.substr(start, end - start);
    var claimStr = b64DecodeUnicode(encoded);
    var claim = JSON.parse(claimStr);
    claim.user.usertype = String(claim.user.usertype);
    return claim;
  } catch (e) {
    return null;
  }
}

function getExpiredTime(loginTime, validTime) {
  var currentTime = new Date().getTime();
  // 过期时间 = 有效期(validTime - 5分钟) + 登录时间 - 当前时间
  var expirationTime = 1000 * validTime - 300000 + loginTime * 1000 - currentTime;
  // 返回有效时间
  return expirationTime;
}

function loginExpiredTimer(loginTime, validTime) {
  // 清除计时器
  timer && clearInterval(timer);
  // 过期事件触发
  var expirationTime = getExpiredTime(loginTime, validTime);
  if (expirationTime <= 0) {
    triggerQueue(queue.expired);
  } else {
    timer = setInterval(function () {
      triggerQueue(queue.expired);
    }, expirationTime);
  }
}

/**
 * 登录事件
 * @param callback
 */
function onlogin(callback) {
  queue.login.push(callback);
}

/**
 * 退出登录事件
 * @param callback
 */
function onlogout(callback) {
  queue.logout.push(callback);
}

/**
 * 登录过期事件
 * @param callback
 */
function onloginExpired(callback) {
  queue.expired.push(callback);
}

/**
 * 获得用户信息
 * @returns {*}
 */
function getUser() {
  return user;
}

/**
 * 退出登录
 * @param token 无token时将从缓存登录
 * @returns {*}
 */
function login(token) {
  if (token) {
    // 解析用户信息
    var data = getLoginInfo(token);
    // 获取到用户信息
    if (data) {
      user = data.user;
      // 储存登录 token
      setToken(token);
      // 返回登录成功的事件
      triggerQueue(queue.login, data.user);
      // 登录有效期计时器
      loginExpiredTimer(data.iat, data.vt);
      // 返回用户信息
      return data.user;
    }
  } else {
    // 当token不存在时尝试从缓存中读取
    var storgeToken = getToken();
    if (storgeToken) {
      var _data = getLoginInfo(storgeToken);
      if (getExpiredTime(_data.iat, _data.vt) > 0) {
        user = _data.user;
        // 返回登录成功的事件
        triggerQueue(queue.login, _data.user);
        // 登录有效期计时器
        loginExpiredTimer(_data.iat, _data.vt);
        // 返回用户信息
        return _data.user;
      } else {
        logout();
      }
    }
  }
  return false;
}

/**
 * 退出登录
 */
function logout() {
  localStorage.removeItem('token');
  user = null;
  triggerQueue(queue.logout);
}

/**
 * 是否已经登录
 * @returns {boolean}
 */
function isLoggedIn() {
  return user !== null;
}

/**
 * 获得token
 * @returns {string | null}
 */
function getToken() {
  return localStorage.getItem('token');
}

/**
 * 设置token
 * @param token
 */
function setToken(token) {
  localStorage.setItem('token', token);
}

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["requires"] = requires;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

/*
 * 根据给定的多个文件路径引入模块
 * @Author: anker.wang
 * @Date: 2018-01-08 11:21:15
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-11 17:35:55
 */

function requires(require) {
  var assign = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var modules = {};
  require.keys().forEach(function (path) {
    var _module = require("" + path);
    // 是否合并对象
    if (assign) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(modules, _module);
    } else {
      modules[path] = _module;
    }
  });
  return modules;
}

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_LAYOUT_CLIENT_HEIGHT */
/* unused harmony export SET_LAYOUT_CLIENT_WIDTH */
/* unused harmony export SET_LAYOUT_COLLAPSE */
/* unused harmony export COLLAPSE_MENU */
/* unused harmony export LOGIN */
/* unused harmony export LOGOUT */
/* unused harmony export SET_LOADING_REQUEST_COUNT */
/* unused harmony export OPEN_LOADING */
/* unused harmony export CLOSE_LOADING */
/* unused harmony export SET_STEP_TEMPLATE_TABLE */
/* unused harmony export SET_TASK_TEMPLATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_USER_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_USER_PAGINATION; });
/* unused harmony export VISIBLE_LAYOUT_EXPORT_DIALOG */
/* unused harmony export SET_LAYOUT_EXPORT_NAME */
/* unused harmony export SET_LAYOUT_EXPORT_PERCENTAGE */
/* unused harmony export SET_LAYOUT_EXPORT_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_USER_RELATED_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER_OPTIONS; });
var SET_LAYOUT_CLIENT_HEIGHT = 'SET_LAYOUT_CLIENT_HEIGHT';
var SET_LAYOUT_CLIENT_WIDTH = 'SET_LAYOUT_CLIENT_WIDTH';
var SET_LAYOUT_COLLAPSE = 'SET_LAYOUT_COLLAPSE';
var COLLAPSE_MENU = 'COLLAPSE_MENU';
var LOGIN = 'LOGIN';
var LOGOUT = 'LOGOUT';
var SET_LOADING_REQUEST_COUNT = 'SET_LOADING_REQUEST_COUNT';
var OPEN_LOADING = 'OPEN_LOADING';
var CLOSE_LOADING = 'CLOSE_LOADING';
var SET_STEP_TEMPLATE_TABLE = 'SET_STEP_TEMPLATE_TABLE';
var SET_TASK_TEMPLATE = 'SET_TASK_TEMPLATE';

var SET_USER_TABLE = 'SET_USER_TABLE';
var SET_USER_PAGINATION = 'SET_USER_PAGINATION';

var VISIBLE_LAYOUT_EXPORT_DIALOG = 'VISIBLE_LAYOUT_EXPORT_DIALOG';
var SET_LAYOUT_EXPORT_NAME = 'SET_LAYOUT_EXPORT_NAME';
var SET_LAYOUT_EXPORT_PERCENTAGE = 'SET_LAYOUT_EXPORT_PERCENTAGE';
var SET_LAYOUT_EXPORT_STATUS = 'SET_LAYOUT_EXPORT_STATUS';
var SET_USER_RELATED_OPTIONS = 'SET_USER_RELATED_OPTIONS';
var SET_USER_OPTIONS = 'SET_USER_OPTIONS';

/***/ }),
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(10);

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(71);

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports = ELEMENT;

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderTable", function() { return getOrderTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReviewTaskPendingList", function() { return getReviewTaskPendingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryReviewTaskList", function() { return getQueryReviewTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPendingReviewTaskStats", function() { return getPendingReviewTaskStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReviewPlanQuery", function() { return getReviewPlanQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTaskAssignment", function() { return submitTaskAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "evalReturnOrderApi", function() { return evalReturnOrderApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReturnOrderEvalResultApi", function() { return getReturnOrderEvalResultApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderArchivedTable", function() { return getOrderArchivedTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryOrderAppealTableApi", function() { return queryOrderAppealTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryOrderAppealInternWrongStatApi", function() { return queryOrderAppealInternWrongStatApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderAppealDetail", function() { return getOrderAppealDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderAppealByOrderIdApi", function() { return getOrderAppealByOrderIdApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderAppealPassApi", function() { return orderAppealPassApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderAppealRejectApi", function() { return orderAppealRejectApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderLocked", function() { return orderLocked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchSucceed", function() { return batchSucceed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBatchSuccceed", function() { return onBatchSuccceed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBatchWithdraw", function() { return onBatchWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBatchCheckDetection", function() { return onBatchCheckDetection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrderMemo", function() { return updateOrderMemo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOrder", function() { return exportOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOrderArchived", function() { return exportOrderArchived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOrderSneakSimilarity", function() { return exportOrderSneakSimilarity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOrderLowScoreFaceImgApi", function() { return exportOrderLowScoreFaceImgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderDetailInfo", function() { return getOrderDetailInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderWithdraw", function() { return orderWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderFinishEnforce", function() { return orderFinishEnforce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderReset2Finish", function() { return orderReset2Finish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderReset2Process", function() { return orderReset2Process; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderVerifyFaceEnforce", function() { return orderVerifyFaceEnforce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderFaceList", function() { return getOrderFaceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderScoredFaceListApi", function() { return getOrderScoredFaceListApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMiDanOrderTable", function() { return getMiDanOrderTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allowExchangeOrderApi", function() { return allowExchangeOrderApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exchangeOrderApi", function() { return exchangeOrderApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderLatestCompressDetailApi", function() { return getOrderLatestCompressDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrderEvidenceCompressTaskApi", function() { return createOrderEvidenceCompressTaskApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRecognizeQrcodeData", function() { return getRecognizeQrcodeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQrcodeContentData", function() { return getQrcodeContentData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var sjfBase = window._env_.VUE_APP_SJF_API_HOST;
var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST || '';
var getOrderTable = function getOrderTable(params) {
  return axios.post(base + '/order/query', params);
};

// 待分配列表（order-audit-api）
var getReviewTaskPendingList = function getReviewTaskPendingList(params) {
  return axios.get(orderAuditBase + '/admin/review-task/pending-list', { params: params });
};

// 复核任务列表（主表 audited_order_result，关联一条 audit_task）
var getQueryReviewTaskList = function getQueryReviewTaskList(params) {
  return axios.get(orderAuditBase + '/admin/audited-order-result/query-review-task-list', { params: params });
};

// 待复核任务统计：按 intern_user_id 返回每人待复核工单数（含 name）
var getPendingReviewTaskStats = function getPendingReviewTaskStats(params) {
  return axios.get(orderAuditBase + '/admin/audited-order-result/pending-review-task-stats', { params: params });
};

// 复核计划目标配置：按 admin_id、plan_date 查询，无则目标为 0
var getReviewPlanQuery = function getReviewPlanQuery(params) {
  return axios.get(orderAuditBase + '/admin/review-plan/query', { params: params });
};

// 确认分配：提交来源分配与复核分配配置
var submitTaskAssignment = function submitTaskAssignment(data) {
  return axios.post(orderAuditBase + '/admin/audited-order-result/task-assignment', data);
};

var evalReturnOrderApi = function evalReturnOrderApi(params) {
  return axios.post(orderAuditBase + '/admin/return-order-eval/evaluate/' + params.orderid, params);
};
var getReturnOrderEvalResultApi = function getReturnOrderEvalResultApi(params) {
  return axios.get(orderAuditBase + '/admin/return-order-eval/get-result/' + params.orderid, { params: params });
};

var getOrderArchivedTable = function getOrderArchivedTable(params) {
  return axios.post(base + '/order/query_archived', params);
};

// 工单申诉管理列表
var queryOrderAppealTableApi = function queryOrderAppealTableApi(params) {
  return axios.post(base + '/order-appeal/query', params);
};

// 工单申诉-实习生误审统计（按原审核人聚合）
var queryOrderAppealInternWrongStatApi = function queryOrderAppealInternWrongStatApi(params) {
  return axios.post(base + '/order-appeal/intern_wrong_review_stat', params);
};

// 工单申诉详情
var getOrderAppealDetail = function getOrderAppealDetail(_ref) {
  var id = _ref.id;

  return axios.get(base + '/order-appeal/get_' + id);
};
var getOrderAppealByOrderIdApi = function getOrderAppealByOrderIdApi(_ref2) {
  var id = _ref2.id;

  return axios.get(base + '/order-appeal/get_by_order_' + id);
};
var orderAppealPassApi = function orderAppealPassApi(params) {
  return axios.post(base + '/order-appeal/audit_pass_' + params.id, params);
};
var orderAppealRejectApi = function orderAppealRejectApi(params) {
  return axios.post(base + '/order-appeal/audit_reject_' + params.id, params);
};

var orderLocked = function orderLocked(params) {
  return axios.post(base + '/lock_order_' + params.orderid, params);
};
var batchSucceed = function batchSucceed(params) {
  return axios.post(base + '/order/bulk_complete', params);
};
var onBatchSuccceed = function onBatchSuccceed(params) {
  return axios.post(base + '/order/batch_complete', params);
};
var onBatchWithdraw = function onBatchWithdraw(params) {
  return axios.post(base + '/order/batch_withdraw', params);
};
var onBatchCheckDetection = function onBatchCheckDetection(params) {
  return axios.post(base + '/order/batch_audit', params);
};
var updateOrderMemo = function updateOrderMemo(params) {
  return axios.post(base + '/order/update_memo', params);
};
var exportOrder = function exportOrder(params) {
  return axios.post(base + '/order/export', params);
};
var exportOrderArchived = function exportOrderArchived(params) {
  return axios.post(base + '/order/export_archived', params);
};
var exportOrderSneakSimilarity = function exportOrderSneakSimilarity(params) {
  return axios.post(base + '/order/export_sneak_similarity', params);
};
var exportOrderLowScoreFaceImgApi = function exportOrderLowScoreFaceImgApi(params) {
  return axios.post(base + '/order/export_low_score_face_img', params);
};
var getOrderDetailInfo = function getOrderDetailInfo(_ref3) {
  var id = _ref3.id;

  return axios.get(base + '/order/get_' + id);
};
var orderWithdraw = function orderWithdraw(params) {
  return axios.post(base + '/withdraw_order_' + params.orderid, params);
};
var orderFinishEnforce = function orderFinishEnforce(params) {
  return axios.post(base + '/finish_order_enforce_' + params.orderid, params);
};
var orderReset2Finish = function orderReset2Finish(params) {
  return axios.post(base + '/order/reset_to_finish_' + params.orderid, params);
};
var orderReset2Process = function orderReset2Process(params) {
  return axios.post(base + '/order/reset_to_process_' + params.orderid, params);
};
var orderVerifyFaceEnforce = function orderVerifyFaceEnforce(_ref4) {
  var orderid = _ref4.orderid;

  return axios.post(base + '/order/pass_verified_face_enforce_' + orderid);
};
var getOrderFaceList = function getOrderFaceList(_ref5) {
  var orderid = _ref5.orderid;

  return axios.get(base + '/order/get_verified_face_' + orderid);
};
var getOrderScoredFaceListApi = function getOrderScoredFaceListApi(params) {
  return axios.get(base + '/order/get_scored_face_' + params.orderid, { params: params });
};

var getMiDanOrderTable = function getMiDanOrderTable(params) {
  return axios.get(base + '/midan/orderlist/' + params.id, params);
};
var allowExchangeOrderApi = function allowExchangeOrderApi(params) {
  return axios.post(base + '/order/allow_exchange', params);
};
var exchangeOrderApi = function exchangeOrderApi(params) {
  return axios.post(base + '/order/exchange?orderid1=' + params.orderid1 + '&orderid2=' + params.orderid2, params);
};

var getOrderLatestCompressDetailApi = function getOrderLatestCompressDetailApi(params) {
  return axios.get(base + '/order/latest_compress_detail_' + params.orderid, { params: params });
};
var createOrderEvidenceCompressTaskApi = function createOrderEvidenceCompressTaskApi(params) {
  return axios.get(base + '/order/compress_evidence_' + params.orderid, { params: params });
};

// SJF 二维码识别
var getRecognizeQrcodeData = function getRecognizeQrcodeData(params) {
  return axios.post(sjfBase + '/admin/admin2/recognize_qrcode', params);
};

var getQrcodeContentData = function getQrcodeContentData(params) {
  return axios.post(sjfBase + '/admin/admin2/cli_read_qrcode', params);
};

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





var isRefreshToken = false;

/**
 * 刷新token
 */
function refreshToken() {
  isRefreshToken = true;
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('refreshToken').then(function (_ref) {
    var data = _ref.data;

    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('LOGIN', data.jwt);
    isRefreshToken = false;
  });
}

function showAlert(promise) {
  return promise.catch(function (thrown) {
    if (!__WEBPACK_IMPORTED_MODULE_3_axios___default.a.isCancel(thrown)) {
      if (thrown.response) {
        if (thrown.response.data.hasOwnProperty('ret') && thrown.response.data.hasOwnProperty('msg')) {
          __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].alert(thrown.response.data.msg, '错误提示', { type: 'thrown' });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].alert(thrown.response.data.toString(), '响应错误', { type: 'thrown' });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].alert(thrown.toString(), '错误提示', { type: 'thrown' });
      }
    }
    // 返回响应错误
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(thrown);
  });
}

function handleData(promise) {
  return promise.then(function (response) {
    // 刷新token
    if (response.headers['sj-auth-require-refresh'] && !isRefreshToken) {
      refreshToken();
    }
    // 响应数据处理
    var data = response.data;
    var error = null;
    if (data.hasOwnProperty('ret')) {
      // 服务报错
      if (data.ret) {
        if (data.ret === 855) {
          Router.push('/settings/change-password?showDefaultPasswordHint=1');
        }
        // 含响应消息
        if (data.msg) {
          error = new Error(data.msg.toString());
        } else {
          error = new Error(data.toString());
        }
      } else {
        // 正确响应
        if (data.hasOwnProperty('detail')) {
          response.data = data.detail;
        }
        return response;
      }
    } else {
      error = new Error(data.toString());
    }
    error.response = response;
    // 抛出异常
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}

function showLoading(promise) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OPEN_LOADING');
  return promise.finally(function () {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('CLOSE_LOADING', 1);
  });
}

function request(name, params, config) {
  return handleData(request.dispatch(name, params, config));
}

function getRequestItems() {
  var items = {};
  var models = __webpack_require__(96).requires(__webpack_require__(214), false);
  // 模块列表
  for (var path in models) {
    if (models.hasOwnProperty(path)) {
      // 请求列表
      for (var name in models[path]) {
        if (models[path].hasOwnProperty(name)) {
          // api 是否已存在
          if (items.hasOwnProperty(name)) {
            console.error(items[name].path + ' \u548C ' + path + ' \u4E2D\u7684 ' + name + ' \u65B9\u6CD5\u51B2\u7A81\u3002');
          } else {
            items[name] = models[path][name];
            items[name].path = path;
          }
        }
      }
    }
  }
  return items;
}

/**
 * 异常响应
 * @param thrown
 */
function exceptionResponse(thrown) {
  if (__WEBPACK_IMPORTED_MODULE_3_axios___default.a.isCancel(thrown)) {
    console.warn('Request canceled', thrown.message);
  } else {
    // 存在响应
    if (thrown.response) {
      // 请求失败
      if (thrown.response.status > 200) {
        Router.push('/exception/404');
      } else {
        // 响应无权限
        if (thrown.response.data) {
          if (thrown.response.data.ret === 403) {
            Router.push('/exception/403');
            return;
          }
          if (thrown.response.data.ret === 855) {
            Router.push('/settings/change-password?showDefaultPasswordHint=1');
            return;
          }
        }
        // 响应的内容无法解析
        Router.push('/exception/424');
      }
    }
  }
}

request.items = getRequestItems();

request.dispatch = function (name, params, config) {
  return request.items[name](params, config);
};

request.alert = function (name, params, config) {
  return showAlert(request(name, params, config));
};

request.loading = function (name, params, config) {
  return showLoading(request(name, params, config));
};

request.common = function (name, params, config) {
  return showLoading(showAlert(request(name, params, config)));
};

request.all = function (items) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(items);
};

request.all.common = function (items) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OPEN_LOADING');
  return showAlert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(items)).finally(function () {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('CLOSE_LOADING', 1);
  });
};

request.all.loading = function (items) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OPEN_LOADING');
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(items).finally(function () {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('CLOSE_LOADING', 1);
  });
};

request.all.alert = function (items) {
  return showAlert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(items));
};

request.page = function (name, params, config) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OPEN_LOADING');
  return request(name, params, config).catch(function (error) {
    // 异常响应
    exceptionResponse(error);
    // 抛出异常
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }).finally(function () {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('CLOSE_LOADING', 1);
  });
};

request.all.page = function (items) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OPEN_LOADING');
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(items).catch(function (error) {
    // 异常响应
    exceptionResponse(error);
    // 抛出异常
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }).finally(function () {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('CLOSE_LOADING', 1);
  });
};

request.map = function (items) {
  var requests = {};
  items.forEach(function (name) {
    requests[name] = function (params, config) {
      return request(name, params, config);
    };
  });
  return requests;
};

// 取消请求操作
request.cancelAll = function () {};
request.cancelToken = null;
request.createCancelToken = function () {
  var source = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.CancelToken.source();
  request.cancelAll = source.cancel;
  request.cancelToken = source.token;
};

/* harmony default export */ __webpack_exports__["default"] = (request);

/***/ }),
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(42);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnreadInboxMessageCount", function() { return getUnreadInboxMessageCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readAdminInboxMessage", function() { return readAdminInboxMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAdminInboxMessage", function() { return queryAdminInboxMessage; });
var base = window._env_.VUE_APP_ADMIN_HOST;

var getUnreadInboxMessageCount = function getUnreadInboxMessageCount() {
  return axios.post(base + "/admin_inbox_message/get_unread_inbox_messages");
};

var readAdminInboxMessage = function readAdminInboxMessage(param) {
  return axios.post(base + "/admin_inbox_message/read", param);
};

var queryAdminInboxMessage = function queryAdminInboxMessage(params) {
  return axios.post(base + "/admin_inbox_message/query", params);
};

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin-inbox-message/admin-inbox-message.api.js": 158,
	"./app-banner/app-banner.api.js": 647,
	"./app-popup/app-popup.api.js": 648,
	"./area/area.api.js": 649,
	"./audio-asr-check/audio-asr-check.api.js": 650,
	"./audit-batchjob/audit-batchjob.api.js": 651,
	"./audit-intern/audit-intern.api.js": 270,
	"./audit-task-setting/audit-task-setting.api.js": 652,
	"./audit-task-setting/return-order-evaluation.api.js": 653,
	"./audit-task/audit-task.api.js": 654,
	"./banquet-task/banquet-task.api.js": 655,
	"./batch-jobs/batch-jobs.api.js": 656,
	"./batch/batch.api.js": 657,
	"./big-data-view/big-data-view.api.js": 658,
	"./city-map/city-map.api.js": 659,
	"./clb-alipay-flow/clb-alipay-flow.api.js": 660,
	"./clb-product-area/clb-product-area.api.js": 661,
	"./clb-product-category/clb-product-category.api.js": 662,
	"./clb-product/clb-product.api.js": 663,
	"./clb-step-template/clb-step-template.api.js": 664,
	"./clb-task-template/clb-task-template.api.js": 665,
	"./company-bank-account/company-bank-account.api.js": 666,
	"./cover-estimate/cover-estimate.api.js": 667,
	"./customer-batch/customer-batch.api.js": 668,
	"./customer-project-report/customer-project-report.api.js": 669,
	"./customer-project/customer-project.api.js": 670,
	"./customer-projectcost/customer-projectcost.api.js": 671,
	"./customer-receipt/customer-receipt.api.js": 672,
	"./customer-task/customer-task.api.js": 673,
	"./customer/customer.api.js": 674,
	"./executive-budget/executive-budget.api.js": 675,
	"./fair-prize/fairPrize.api.js": 676,
	"./fair-reward/fairReward.api.js": 677,
	"./fair-stock/fairStock.api.js": 678,
	"./fair-upload/fairUpload.api.js": 679,
	"./fair/fair.api.js": 680,
	"./finance-config/finance-config.api.js": 681,
	"./finance/finance.api.js": 682,
	"./flbanner/flbanner.api.js": 683,
	"./group-batch/group-batch.api.js": 684,
	"./hr/hr.api.js": 685,
	"./img-flow-config/img-flow-config.api.js": 686,
	"./img-flow-model/img-flow-model.api.js": 687,
	"./img-flow-order/img-flow-order.api.js": 688,
	"./img-flow-product/img-flow-product.api.js": 689,
	"./intelligent-customer-service/intelligent-customer-service.api.js": 690,
	"./intelligent-outbound-call/intelligent-outbound-call.api.js": 691,
	"./invoice-apply/invoice-apply.api.js": 692,
	"./issue/issue.api.js": 693,
	"./launch-page-activity/launch-page-activity.api.js": 694,
	"./login/login.api.js": 695,
	"./map-comment-feedback/map-comment-feedback.api.js": 696,
	"./market-ng/market-ng.api.js": 697,
	"./market/market-cs-location-log.api.js": 698,
	"./market/market.api.js": 699,
	"./midan/midan.api.js": 700,
	"./middle-end-task/middle-end-task.api.js": 701,
	"./occupation-questionnaire/occupation-questionnaire.api.js": 702,
	"./occupation/occupation.api.js": 703,
	"./order-image-recapture-detection/order-image-recapture-detection.api.js": 704,
	"./order-review-target-management/order-review-assessment.api.js": 705,
	"./order-review/order-review.api.js": 257,
	"./order/order.api.js": 153,
	"./oss/oss.api.js": 706,
	"./pay-conditions/pay-conditions.api.js": 707,
	"./payment-approval-new/payment-approval.api.js": 708,
	"./payment-approval/payment-approval.api.js": 709,
	"./payment-center/payment-center.api.js": 271,
	"./payment-manager-new/payment-manager.api.js": 710,
	"./payment-manager/payment-manager.api.js": 711,
	"./payment-refund/payment-refund.api.js": 712,
	"./permission-apply/permission-apply.api.js": 713,
	"./permission-group/permission-group.api.js": 714,
	"./platform-androidapk-test/platform-androidapk-test.api.js": 715,
	"./platform-department/platform-department.api.js": 716,
	"./platform-role/platform-role.api.js": 717,
	"./platform-upload/platform-upload.api.js": 718,
	"./platform-user-province/platform-user-province.api.js": 719,
	"./platform-user-whitelist/platform-user-whitelist.api.js": 720,
	"./platform-user/platform-user.api.js": 259,
	"./platform/platform.api.js": 721,
	"./point/point.api.js": 722,
	"./position/position.api.js": 723,
	"./price-batch/price-batch.api.js": 724,
	"./project-task-package/project-task-package.api.js": 725,
	"./project/project.api.js": 726,
	"./question-error-message/question-error-message.api.js": 727,
	"./received-payment/received-payment.api.js": 728,
	"./resume/resume.api.js": 729,
	"./satisfaction-email/satisfaction-email.api.js": 730,
	"./settings/settings.api.js": 731,
	"./statistic/pages/CityGroup/city-group.api.js": 732,
	"./statistic/pages/Promoter/promoter.api.js": 733,
	"./statistic/pages/ScreenProject/screen-project.api.js": 734,
	"./step-template/step-template.api.js": 735,
	"./store-collection/store-collection.api.js": 736,
	"./task-batch/task-batch.api.js": 737,
	"./task-notice/task-notice.api.js": 738,
	"./task-order/task-order.api.js": 739,
	"./task-package-home/task-package-home.api.js": 740,
	"./task/review-plan.api.js": 741,
	"./task/review-task.api.js": 742,
	"./task/task.api.js": 743,
	"./teke-customer/tekeCustomer.api.js": 744,
	"./teke-order/tekeOrder.api.js": 745,
	"./teke-tag/tekeTag.api.js": 746,
	"./training/training.api.js": 747,
	"./user-bank-account/user-bank-account.api.js": 748,
	"./user-batch-tag/user-batch-tag.api.js": 749,
	"./user-cover/user-cover.api.js": 750,
	"./user-credit/user-credit.api.js": 751,
	"./user-order-stat/userOrderStat.api.js": 752,
	"./user-tag/userTag.api.js": 753,
	"./user-workinfo/user-workinfo.api.js": 754,
	"./users/users.api.js": 258,
	"./violation-alert/violation-alert.api.js": 755,
	"./wecom/wecom.api.js": 756,
	"./work-info-business-type/work-info-business-type.api.js": 757,
	"./work-info-company/work-info-company.api.js": 758,
	"./work-info-work-type/work-info-work-type.api.js": 759,
	"./workbench/workbench.api.js": 760
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = permissionhost;
var base = window._env_.VUE_APP_HOST;

function permissionhost(params) {
  if (params && params.host) {
    return "//" + params.host;
  } else {
    return base;
  }
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_login_components_Login__ = __webpack_require__(272);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LoginDialog',
  components: { Login: __WEBPACK_IMPORTED_MODULE_0__views_login_components_Login__["a" /* default */] },
  data: function data() {
    return {
      visible: false
    };
  },
  created: function created() {},

  methods: {
    onLogin: function onLogin() {
      this.visible = false;
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_api_request__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(68);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      loading: false,
      errorMsg: '',
      accountOrPwdWrong: false,
      codeImageData: '',
      form: {
        name: '',
        password: '',
        captchacode: ''
      },
      rules: {
        name: [{ required: true, message: '请输入用户名', trigger: 'blur' }, { min: 2, max: 20, message: '用户名长度在 2 到 20 个字符', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }, { min: 3, max: 60, message: '密码长度在 3 到 60 个字符', trigger: 'blur' }],
        captchacode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      isForcePwd: false
    };
  },
  mounted: function mounted() {
    document.addEventListener('keyup', this.keyup);
  },
  destroyed: function destroyed() {
    document.removeEventListener('keyup', this.keyup);
  },

  methods: {
    keyup: function keyup(e) {
      var keyCode = e.keyCode || e.which || e.charCode;
      if (keyCode === 13) {
        this.login();
      }
    },
    login: function login() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var reinforcesWitchResult;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_2__core_api_request__["default"])('reinforcesWitch');

              case 2:
                reinforcesWitchResult = _context2.sent;

                _this.isForcePwd = reinforcesWitchResult.data;
                _this.errorMsg = '';
                _this.loading = true;
                _this.$refs.loginForm.validate(function (valid) {
                  if (valid) {
                    var params = filter.copyJson(_this.form);
                    if (_this.isForcePwd && _this.accountOrPwdWrong) {
                      params.captchaCodeToken = _this.captchaCodeToken;
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_2__core_api_request__["default"])('login', params).then(function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
                        var data = _ref2.data;
                        var loginFailed;
                        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('LOGIN', data.jwt);
                                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('SET_PERMISSIONS', []);

                                _context.next = 4;
                                return __WEBPACK_IMPORTED_MODULE_2__core_api_request__["default"].common('getVersion');

                              case 4:
                                // 用户权限控制
                                if (__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.login.user.usertype === '1') {
                                  _this.goHomeOrChangePwdPage(_this.form.password);
                                } else {
                                  loginFailed = function loginFailed() {
                                    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('LOGOUT');
                                    _this.errorMsg = '登录失败，网络异常';
                                    _this.loading = false;
                                  };

                                  Object(__WEBPACK_IMPORTED_MODULE_2__core_api_request__["default"])('getPermission').then(function (_ref3) {
                                    var data = _ref3.data;

                                    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('SET_PERMISSIONS', data);
                                  }).catch(loginFailed).then(function () {
                                    Object(__WEBPACK_IMPORTED_MODULE_2__core_api_request__["default"])('getApiPermission').then(function (_ref4) {
                                      var data = _ref4.data;

                                      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].commit('SET_API_PERMISSIONS', data);
                                      _this.goHomeOrChangePwdPage(_this.form.password);
                                    }).catch(loginFailed);
                                  });
                                }

                              case 5:
                              case 'end':
                                return _context.stop();
                            }
                          }
                        }, _callee, _this);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }()).catch(function (error) {
                      if (error.response) {
                        if (error.response.data.ret === 403) {
                          _this.errorMsg = '登录失败，禁止访问';
                        } else if ([405, 412].includes(error.response.data.ret)) {
                          _this.errorMsg = error.response.data.msg;
                        } else {
                          _this.errorMsg = '登录失败，用户名或密码错误';
                          if (_this.isForcePwd) {
                            _this.accountOrPwdWrong = true;
                            _this.refreshCaptchaCode();
                          }
                        }
                      } else {
                        _this.errorMsg = '网络错误';
                      }
                      _this.loading = false;
                    });
                  } else {
                    _this.loading = false;
                    return false;
                  }
                });

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    goHomeOrChangePwdPage: function goHomeOrChangePwdPage(pwd) {
      if (this.isForcePwd) {
        if (this.isStrongPwd(pwd)) {
          this.$emit('login');
        } else {
          this.$router.push({ path: '/change-password' });
        }
      } else {
        this.$emit('login');
      }
    },
    refreshCaptchaCode: function refreshCaptchaCode() {
      var _this2 = this;

      Object(__WEBPACK_IMPORTED_MODULE_2__core_api_request__["default"])('fetchCaptchaCode').then(function (_ref5) {
        var data = _ref5.data;

        _this2.codeImageData = 'data:image/png;base64,' + data['imgdata'];
        _this2.captchaCodeToken = data['SJ_CaptchaCode_Token'];
      });
    },
    isStrongPwd: function isStrongPwd(pwd) {
      return pwd.length >= 8 && [/[\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]/, /[0-9]/, /[a-z]/, /[A-Z]/].map(function (regex) {
        return regex.test(pwd);
      }).reduce(function (result, current) {
        return result && current;
      }, true);
    }
  }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LayoutPanel',
  props: {
    showHeader: {
      type: Boolean,
      default: true
    },
    collapse: {
      type: Boolean,
      default: false
    },
    hideCollapse: {
      type: Boolean,
      default: false
    },
    bodyStyle: [String, Array, Object]
  },
  data: function data() {
    return {
      isCollapse: this.collapse
    };
  },

  computed: {},
  watch: {
    collapse: function collapse(val) {
      this.isCollapse !== val && (this.isCollapse = val);
    },
    isCollapse: function isCollapse(val) {
      this.collapse !== val && this.$emit('update:collapse', val);
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__xlsx__ = __webpack_require__(815);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExportExcelBox',
  data: function data() {
    return {
      loading: false,
      visible: false,
      type: 'object', // object array
      total: 0,
      fileType: 'xlsx',
      fileName: 'unnamed',
      fileHeader: null,
      keyName: 'key',
      labelName: 'text',
      fileData: [],
      request: null,
      requestParams: {},
      getResponseData: function getResponseData(data) {
        return data;
      },
      currentPage: 1,
      perPage: 50,
      retryTotal: 0,
      autoDownload: true,
      autoStart: true,
      backendRequestParams: {},
      /**
       * 开始 start
       * 停止 stop
       * 结束 end
       * 错误 error
       */
      status: ''
    };
  },

  computed: {
    totalPage: function totalPage() {
      return Math.ceil(this.total / this.perPage);
    },
    lastFileName: function lastFileName() {
      return this.fileName + '-' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYMMDDHHmmss') + 'T' + this.total;
    },
    percentage: function percentage() {
      var percentage = 0;
      if (this.total > 0) {
        percentage = parseInt(this.fileData.length / this.total * 100);
        if (percentage > 100) {
          return 100;
        }
      }
      return percentage;
    },
    progressStatus: function progressStatus() {
      switch (this.status) {
        case 'error':
          return 'exception';
        case 'end':
          return 'success';
        default:
          return null;
      }
    },
    progressMessage: function progressMessage() {
      if (this.total > 0) {
        switch (this.status) {
          case 'start':
            return '从服务器获取数据中，请不要关闭页面！';
          case 'stop':
            return '已暂停获取数据。';
          case 'end':
            return '数据已获取完毕，请点击下载获得Excel文件。';
          case 'error':
            if (this.retryTotal) {
              return '获取服务器数据再次发生了错误。';
            } else {
              return '获取服务器数据发生了错误。';
            }
          default:
            return '\u672C\u6B21\u5C06\u5BFC\u51FA' + this.total + '\u6761\u6570\u636E\u3002';
        }
      } else {
        return '没有找到导出的数据，请稍候重试。';
      }
    }
  },
  watch: {
    visible: function visible(val) {
      if (val && this.autoStart) {
        this.loading = true;
        this.start();
      }
    }
  },
  methods: {
    start: function start() {
      this.backendRequestParams = {};
      this.status = 'start';
      this.getData();
    },
    stop: function stop() {
      this.status = 'stop';
    },
    end: function end() {
      this.status = 'end';
    },
    error: function error() {
      this.status = 'error';
    },
    retry: function retry() {
      this.retryTotal++;
      this.start();
    },
    jump: function jump() {
      this.retryTotal = 0;
      this.currentPage++;
      this.start();
    },
    reset: function reset() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
    },
    handleClose: function handleClose() {
      var _this = this;

      this.visible = false;
      setTimeout(function () {
        return _this.reset();
      }, 250);
    },
    close: function close() {
      var _this2 = this;

      // 直接关闭
      if (!this.total || this.status === 'end') {
        return this.handleClose();
      }
      // 关闭提示
      this.$confirm('确认终止导出数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        return _this2.handleClose();
      });
    },
    getTotal: function getTotal() {
      var _this3 = this;

      this.request(filter.copyJson(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestParams, {
        current_page: 1,
        per_page: 0
      }))).then(function (_ref) {
        var data = _ref.data;

        _this3.total = data.total;
        _this3.loading = false;
      });
    },
    getData: function getData() {
      var _this4 = this;

      this.request(filter.copyJson(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.requestParams, this.backendRequestParams, {
        current_page: this.currentPage,
        per_page: this.perPage
      }))).then(function (_ref2) {
        var data = _ref2.data;

        _this4.loading = false;
        if (!_this4.total && data.total) {
          _this4.total = data.total;
        }
        // 停止、结束下载
        if (['stop', 'end'].includes(_this4.status)) {
          return;
        }
        // 获得响应
        data = _this4.getResponseData(data);

        if (data.backendRequestParams && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data.backendRequestParams).length) {
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this4.backendRequestParams, data.backendRequestParams);
        }

        // push 数据
        _this4.fileData.push.apply(_this4.fileData, data.data);
        // 数据总量是0条
        if (!_this4.total) {
          return _this4.end();
        }
        // 全部加载完成
        if (_this4.currentPage === _this4.totalPage) {
          setTimeout(function () {
            _this4.end();
            _this4.autoDownload && _this4.download();
          }, 250);
          return false;
        }
        // 继续加载
        _this4.currentPage++;
        _this4.getData();
      }, function () {
        _this4.error();
      });
    },
    download: function download() {
      var _this5 = this;

      var fileData = [];
      // 数据模式 第一行是表头
      if (this.type === 'array') {
        fileData = this.fileData;
      }
      if (this.type === 'object') {
        // 获得表格 header
        var headerKeys = [];
        var headerValue = [];
        if (this.fileHeader && this.fileHeader.length) {
          this.fileHeader.forEach(function (row) {
            headerKeys.push(row[_this5.keyName]);
            headerValue.push(row[_this5.labelName]);
          });
        }
        this.fileData.forEach(function (row) {
          _this5.fileHeader.forEach(function (headerItem) {
            if (headerItem.formatter) {
              var key = headerItem[_this5.keyName];
              row[key] = headerItem.formatter(row);
            }
          });
        });
        // 转换 object 为 array
        fileData = __WEBPACK_IMPORTED_MODULE_4__xlsx__["a" /* default */].ArrayObjectsToArrays(this.fileData, headerKeys);
        // 置入 header
        headerValue.length && (fileData[0] = headerValue);
      }
      __WEBPACK_IMPORTED_MODULE_4__xlsx__["a" /* default */].exportXlsx(fileData, { fileName: this.lastFileName, fileType: this.fileType });
      // 关闭
      this.status === 'end' && this.close();
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RemoteSelect',
  props: {
    value: [String, Number, Array, Object],
    placeholder: {
      type: String,
      default: '请输入关键字'
    },
    /**
     * 浏览器自动填充
     * 强制浏览器不自动填充的方法是为autocomplete设置一个随机的字符串，例如：autocomplete="nope" https://developer.mozilla.org/zh-CN/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
     * 语意化 e.g. autocomplete="new-user-street-address". https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c164
     */
    autocomplete: String,
    multiple: Boolean,
    /** 多选时是否折叠标签为一行（+N） */
    collapseTags: {
      type: Boolean,
      default: false
    },
    multipleLimit: Number,
    disabled: Boolean,
    clearable: Boolean,
    label: Function,
    valueKey: {
      type: String,
      default: 'id'
    },
    keywordKey: {
      type: String,
      default: 'keyword'
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    idKey: {
      type: String,
      default: 'id'
    },
    queryRequest: Function,
    queryParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    findRequest: Function,
    findParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    debounce: {
      type: Number,
      default: 300
    }
  },
  computed: {
    currentAutocomplete: function currentAutocomplete() {
      return this.autocomplete || 'select-search-' + this._uid;
    }
  },
  watch: {
    value: function value() {
      !_.isEqual(this.value, this.currentValue) && this.setCurrentValue();
    }
  },
  data: function data() {
    return {
      items: [],
      loading: false,
      fetchSeq: 0,
      currentValue: this.multiple ? [] : null
    };
  },
  created: function created() {
    var _this = this;

    this.value && this.setCurrentValue();
    // 输入搜索走防抖；点击展开时会 cancel 后立即请求
    this.debouncedSetOptions = _.debounce(function (params) {
      _this.fetchOptions(params);
    }, this.debounce);
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    if (this.debouncedSetOptions && this.debouncedSetOptions.cancel) {
      this.debouncedSetOptions.cancel();
    }
  },

  methods: {
    getLabel: function getLabel(item) {
      if (this.label) {
        return this.label(item);
      } else {
        return item[this.labelKey] + '/' + item[this.idKey];
      }
    },
    isEmptyValue: function isEmptyValue() {
      if (this.multiple) {
        return this.currentValue.length === 0;
      } else {
        return !this.currentValue;
      }
    },

    /**
     * 仅保留当前选中项，避免清空 options 后输入框丢失 label
     */
    getSelectedItems: function getSelectedItems() {
      var _this2 = this;

      if (this.multiple) {
        var values = this.currentValue || [];
        return (this.items || []).filter(function (item) {
          return values.indexOf(item[_this2.valueKey]) !== -1;
        });
      }
      if (!this.currentValue) {
        return [];
      }
      var selected = this.findOption(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.valueKey, this.currentValue));
      return selected ? [selected] : [];
    },

    /**
     * 进入加载态前先清掉旧的下拉结果（保留选中项）
     */
    prepareLoadingOptions: function prepareLoadingOptions() {
      this.items = this.getSelectedItems();
      this.loading = true;
    },
    emptyOptions: function emptyOptions() {
      this.items = [];
    },
    findOption: function findOption(params) {
      return _.find(this.items, params);
    },
    setCurrentValue: function setCurrentValue() {
      var _this3 = this;

      if (this.multiple) {
        this.currentValue = this.value || [];
        this.currentValue.forEach(function (value) {
          _this3.setOption(value);
        });
      } else {
        this.currentValue = this.value;
        this.setOption(this.currentValue);
      }
    },
    setOption: function setOption(value) {
      var _this4 = this;

      // 列表中不存在该列
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.valueKey, value);
      if (this.findRequest && value && !this.findOption(params)) {
        this.findRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, this.findParams)).then(function (_ref) {
          var data = _ref.data;

          _this4.items.push(data);
          _this4.$emit('find-success', data);
        });
      }
    },
    fetchOptions: function fetchOptions() {
      var _this5 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var requestId = ++this.fetchSeq;
      this.loading = true;
      // 实际发起请求时清掉旧下拉（保留选中项），避免仍短暂展示上一次结果
      var selectedItems = this.getSelectedItems();
      this.items = selectedItems;
      this.queryRequest(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, this.queryParams)).then(function (_ref2) {
        var data = _ref2.data;

        if (requestId !== _this5.fetchSeq) {
          return;
        }
        var items = Array.isArray(data.data) ? data.data : [];
        var merged = items.slice();
        selectedItems.forEach(function (selected) {
          var key = selected[_this5.valueKey];
          var exists = merged.some(function (item) {
            return String(item[_this5.valueKey]) === String(key);
          });
          if (!exists) {
            merged.unshift(selected);
          }
        });
        _this5.items = merged;
        if (!items.length) {
          _this5.$message.warning('暂无数据，请调整您的搜索条件再试试！');
        }
        _this5.$emit('query-success', data);
      }).finally(function () {
        if (requestId === _this5.fetchSeq) {
          _this5.loading = false;
        }
      });
    },
    remoteMethod: function remoteMethod(keyword) {
      if (keyword !== '') {
        this.debouncedSetOptions(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.keywordKey, keyword));
      } else if (!this.loading) {
        // 清空关键字或点开时：拉默认列表，而不是只剩当前选中项
        this.fetchOptions();
      }
    },
    change: function change(value) {
      this.$emit('input', value);
      this.$emit('change', value ? this.findOption(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, this.valueKey, value), this.findParams)) : value);
    },

    /**
     * 收起时只留选中项，避免下次展开先画出上一轮完整下拉
     */
    visibleChange: function visibleChange(visible) {
      if (visible) {
        return;
      }
      if (this.debouncedSetOptions && this.debouncedSetOptions.cancel) {
        this.debouncedSetOptions.cancel();
      }
      this.fetchSeq++;
      this.loading = false;
      this.items = this.getSelectedItems();
    },
    focus: function focus() {
      // 已有选中项时也要重新拉列表，否则下拉只剩当前选中的一项
      this.prepareLoadingOptions();
      if (this.debouncedSetOptions && this.debouncedSetOptions.cancel) {
        this.debouncedSetOptions.cancel();
      }
      this.fetchOptions();
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ButtonGutter',
  props: {},
  watch: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__ = __webpack_require__(223);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284678b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__(834);
function injectStyle (ssrContext) {
  __webpack_require__(831)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_284678b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_pages_exception_Exception__ = __webpack_require__(265);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Exception: __WEBPACK_IMPORTED_MODULE_0__core_pages_exception_Exception__["a" /* default */] },
  data: function data() {
    return {
      from: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    /* 在导航转入新的路由前获取数据, 不能获取this */
    next(function (vm) {
      vm.from = from;
    });
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    code: [Number, String],
    meaasge: String,
    form: Object
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Skeleton'
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LayoutHeader__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayoutMenu__ = __webpack_require__(848);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { LayoutMenu: __WEBPACK_IMPORTED_MODULE_1__LayoutMenu__["a" /* default */], LayoutHeader: __WEBPACK_IMPORTED_MODULE_0__LayoutHeader__["a" /* default */] },
  data: function data() {
    return {
      VUE_APP_VERSION: window._env_.VUE_APP_VERSION
    };
  },

  computed: Vuex.mapState({
    loading: function loading(state) {
      return state.loadingMain;
    },
    collapse: function collapse(state) {
      return state.collapseMenu;
    },
    clientHeight: function clientHeight(state) {
      return state.clientHeight;
    },
    clientWidth: function clientWidth(state) {
      return state.clientWidth;
    },
    user: function user(state) {
      return state.login.user;
    }
  }),
  watch: {},
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    var environment = void 0;
    if (location.href.includes('.ci.slicejobs.com')) {
      environment = 'pre';
    } else if (location.href.includes('.dev.slicejobs.com')) {
      environment = 'daily';
    } else if (location.href.includes('.slicejobs.com')) {
      environment = 'prod';
    } else {
      environment = 'local';
    }
    window.__bl && window.__bl.setConfig({
      uid: this.user.id,
      setUsername: function setUsername() {
        return _this.user.name;
      },
      environment: environment
    });
  },

  methods: {}
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    collapse: function collapse(state) {
      return state.collapseMenu;
    },
    autoCollapseMenu: function autoCollapseMenu(state) {
      return state.autoCollapseMenu;
    },
    user: function user(state) {
      return state.login.user;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapMutations(['COLLAPSE_MENU', 'SET_AUTO_COLLAPSE_MENU']), {
    logout: function logout() {
      var _this = this;

      this.$confirm('确认退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(function () {
        _this.$store.commit('LOGOUT');
        _this.$router.push(filter.loginPath(_this.$route.fullPath));
      });
    },
    changePassword: function changePassword() {
      this.$router.push({ path: '/settings/change-password' });
    },
    toggleAutoCollapseMenu: function toggleAutoCollapseMenu() {
      this.SET_AUTO_COLLAPSE_MENU(!this.autoCollapseMenu);
    },
    handleCommand: function handleCommand(command) {
      switch (command) {
        case 'logout':
          this.logout();
          break;
        case 'changePassword':
          this.changePassword();
          break;
      }
    }
  })
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_admin_inbox_message_admin_inbox_message_api__ = __webpack_require__(158);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      unreadInboxCount: 0,
      unreadInboxTimer: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    collapse: function collapse(state) {
      return state.collapseMenu;
    },
    autoCollapseMenu: function autoCollapseMenu(state) {
      return state.autoCollapseMenu;
    },
    user: function user(state) {
      return state.login.user;
    }
  }), {
    isIntern: function isIntern() {
      return parseInt(this.user.usertype) === 4;
    },
    canViewTaskMenu: function canViewTaskMenu() {
      // 非实习生保持现状；实习生额外要求具备新的 UI 权限
      return !this.isIntern || filter.hasPermission(40010);
    },

    /** 统计管理：具备 UI 权限 25，或非实习生（可展示并入的「推广项目进度」，与原先仅 !isIntern 可见一致） */
    canViewStatisticMenu: function canViewStatisticMenu() {
      return filter.hasPermission(25) || !this.isIntern;
    },
    activeMenu: function activeMenu() {
      var matched = this.$route.matched;
      for (var i = matched.length - 1; i >= 0; i--) {
        var menu = matched[i].meta && matched[i].meta.activeMenu;
        if (menu) {
          return menu;
        }
      }
      return this.$route.path;
    }
  }),
  watch: {},
  created: function created() {
    var _this = this;

    if (!this.isIntern) return;

    this.loadUnreadInboxCount();
    this.unreadInboxTimer = window.setInterval(function () {
      _this.loadUnreadInboxCount();
    }, 10 * 60 * 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.unreadInboxTimer !== null) {
      window.clearInterval(this.unreadInboxTimer);
      this.unreadInboxTimer = null;
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapMutations(['COLLAPSE_MENU']), {
    onMenuSelect: function onMenuSelect(index, indexPath) {
      // console.log(index, indexPath)
      if (this.autoCollapseMenu) {
        this.COLLAPSE_MENU(true);
      }
    },
    loadUnreadInboxCount: function loadUnreadInboxCount() {
      var _this2 = this;

      return Object(__WEBPACK_IMPORTED_MODULE_1__views_admin_inbox_message_admin_inbox_message_api__["getUnreadInboxMessageCount"])().then(function (response) {
        var body = response && response.data;
        if (!body || body.ret !== 0 || typeof body.detail !== 'number' || !isFinite(body.detail) || body.detail < 0) return;

        _this2.unreadInboxCount = body.detail;
      }).catch(function () {});
    }
  })
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_training_components_TrainingAiAssistantSidebar_vue__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_training_constants__ = __webpack_require__(972);
//
//
//
//
//
//
//
//
//
//
//
//
//




var SIDEBAR_WIDTH_COLLAPSED = 48;
var SIDEBAR_WIDTH_EXPANDED = 400;
var SIDEBAR_GAP = 8;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingPageLayout',
  components: {
    TrainingAiAssistantSidebar: __WEBPACK_IMPORTED_MODULE_0__views_training_components_TrainingAiAssistantSidebar_vue__["a" /* default */]
  },
  data: function data() {
    return {
      aiSidebarExpanded: false
    };
  },

  computed: {
    aiAssistantEnabled: function aiAssistantEnabled() {
      return __WEBPACK_IMPORTED_MODULE_1__views_training_training_constants__["a" /* TRAINING_AI_ASSISTANT_ENABLED */];
    },
    aiContext: function aiContext() {
      return this.$route.meta.aiContext || 'instruction-list';
    },
    pageTitle: function pageTitle() {
      return this.$route.meta.title || '';
    },
    mainStyle: function mainStyle() {
      if (!this.aiAssistantEnabled) {
        return {};
      }
      var sidebarWidth = this.aiSidebarExpanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED;
      return {
        paddingRight: sidebarWidth + SIDEBAR_GAP + 'px'
      };
    }
  },
  methods: {
    onSidebarExpandChange: function onSidebarExpandChange(expanded) {
      this.aiSidebarExpanded = !!expanded;
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_training_utils_training_ai_assistant_mock__ = __webpack_require__(970);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var QUICK_PROMPTS_MAP = {
  'instruction-list': ['如何上架培训？', '怎么筛选零工培训？', '上下架有什么区别？'],
  'instruction-form': ['培训配置要注意什么？', '关联考试有什么要求？'],
  'instruction-bind-history': ['绑定历史怎么看？', '绑定后何时生效？'],
  'instruction-records': ['进度怎么理解？', '导出包含哪些字段？'],
  'instruction-exam-records': ['怎么筛通过率？', '答卷状态有哪些？'],
  'instruction-exam-detail': ['如何看错题？', '得分怎么计算的？'],
  'course-list': ['教程和培训什么关系？'],
  'course-form': ['教程章节怎么组织？'],
  'knowledge-list': ['知识库怎么用？']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TrainingAiAssistantSidebar',
  props: {
    context: {
      type: String,
      default: 'instruction-list'
    },
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      expanded: false,
      draft: '',
      replying: false,
      messages: []
    };
  },

  computed: {
    canSend: function canSend() {
      return !!this.draft.trim() && !this.replying;
    },
    quickPrompts: function quickPrompts() {
      return QUICK_PROMPTS_MAP[this.context] || ['这个页面能做什么？'];
    }
  },
  watch: {
    context: {
      immediate: true,
      handler: function handler() {
        this.resetConversation();
      }
    },
    expanded: function expanded(value) {
      this.$emit('expand-change', value);
    },
    messages: function messages() {
      this.$nextTick(this.scrollToBottom);
    },
    replying: function replying() {
      this.$nextTick(this.scrollToBottom);
    }
  },
  mounted: function mounted() {
    this.$emit('expand-change', this.expanded);
  },

  methods: {
    resetConversation: function resetConversation() {
      this.messages = [{
        id: 'welcome-' + Date.now(),
        role: 'assistant',
        content: Object(__WEBPACK_IMPORTED_MODULE_1__views_training_utils_training_ai_assistant_mock__["a" /* buildWelcomeMessage */])(this.context),
        timestamp: new Date()
      }];
      this.draft = '';
      this.replying = false;
    },
    formatTime: function formatTime(value) {
      var date = value instanceof Date ? value : new Date(value);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_nan___default()(date.getTime())) {
        return '';
      }
      var hours = ('' + date.getHours()).padStart(2, '0');
      var minutes = ('' + date.getMinutes()).padStart(2, '0');
      return hours + ':' + minutes;
    },
    onComposerKeydown: function onComposerKeydown(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    },
    scrollToBottom: function scrollToBottom() {
      var el = this.$refs.messageList;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
    },
    sendMessage: function sendMessage(presetText) {
      var _this = this;

      var content = (presetText != null ? presetText : this.draft).trim();
      if (!content || this.replying) {
        return;
      }

      this.messages.push({
        id: 'user-' + Date.now(),
        role: 'user',
        content: content,
        timestamp: new Date()
      });
      this.draft = '';
      this.replying = true;

      Object(__WEBPACK_IMPORTED_MODULE_1__views_training_utils_training_ai_assistant_mock__["b" /* mockSendTrainingAiMessage */])({
        message: content,
        context: this.context,
        pageTitle: this.pageTitle
      }).then(function (reply) {
        _this.messages.push(reply);
      }).catch(function () {
        _this.$message.error('AI 助手暂时不可用，请稍后再试');
      }).finally(function () {
        _this.replying = false;
      });
    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoteSelect_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ead790_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoteSelect_vue__ = __webpack_require__(822);
function injectStyle (ssrContext) {
  __webpack_require__(819)
  __webpack_require__(820)
  this["$style"] = __webpack_require__(821)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12ead790"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemoteSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12ead790_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemoteSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

module.exports = XLSX;

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__other__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strcase__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__array__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__oss__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directive__ = __webpack_require__(322);

/*
 * 字段过滤处理方法集
 * @Author: anker.wang
 * @Date: 2018-01-08 11:23:21
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-20 22:13:44
 */










/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__date__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__math__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__strcase__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__array__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__oss__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__other__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__directive__["a" /* default */]));

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderDetail", function() { return getOrderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrderReviewAnswer", function() { return updateOrderReviewAnswer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewOrderPass", function() { return reviewOrderPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewOrderNotPass", function() { return reviewOrderNotPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnauditedOrdersCount", function() { return getUnauditedOrdersCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnauditedBanquetOrdersCount", function() { return getUnauditedBanquetOrdersCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRecommendOrder", function() { return getRecommendOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRecommendBanquetOrderApi", function() { return getRecommendBanquetOrderApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadOrderReviewFile", function() { return uploadOrderReviewFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadOrderReviewDirectFile", function() { return uploadOrderReviewDirectFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lockOrder", function() { return lockOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewClbOrderPass", function() { return reviewClbOrderPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "acquireOrder", function() { return acquireOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "releaseOrder", function() { return releaseOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveOrderReviewCache", function() { return saveOrderReviewCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readOrderReviewCache", function() { return readOrderReviewCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findRecognitionResults", function() { return findRecognitionResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matchRecognitionQuestionProduct", function() { return matchRecognitionQuestionProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "feedbackImageRecognitionException", function() { return feedbackImageRecognitionException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderReviewQuestionJoinImg", function() { return getOrderReviewQuestionJoinImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderReviewHistoryTable", function() { return getOrderReviewHistoryTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderReviewHistoryDetail", function() { return getOrderReviewHistoryDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderReviewHistoryQuestionStatus", function() { return getOrderReviewHistoryQuestionStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveOrderReviewAudioMarkers", function() { return saveOrderReviewAudioMarkers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkOrderStatus", function() { return checkOrderStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderLiveDetail", function() { return getOrderLiveDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSJFOrderDetail", function() { return getSJFOrderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSJFPlatformSetting", function() { return getSJFPlatformSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewOrderQuality", function() { return reviewOrderQuality; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAudioAsrCheckOrderResult", function() { return getAudioAsrCheckOrderResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskAuditReference", function() { return getTaskAuditReference; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var openapi = window._env_.VUE_APP_OPEN_API_HOST;
var imgr = window._env_.VUE_APP_IMG_FLOW_HOST;
var sjfBase = window._env_.VUE_APP_SJF_API_HOST;

var getOrderDetail = function getOrderDetail(_ref) {
  var id = _ref.id;

  return axios.get(base + "/order_" + id);
};
var updateOrderReviewAnswer = function updateOrderReviewAnswer(params) {
  return axios.post(base + "/modify_answer_order_" + params.id, params);
};
var reviewOrderPass = function reviewOrderPass(params) {
  return axios.post(base + "/pass_audit_order_" + params.id, params);
};
var reviewOrderNotPass = function reviewOrderNotPass(params) {
  return axios.post(base + "/fail_audit_order_" + params.id, params);
};
// 获取推荐待审核工单数量
var getUnauditedOrdersCount = function getUnauditedOrdersCount(params) {
  return axios.post(base + "/order/get_unaudited_orders_count", params);
};
// 获取推荐待审核宴席工单数量
var getUnauditedBanquetOrdersCount = function getUnauditedBanquetOrdersCount(params) {
  return axios.post(base + "/order/get_unaudited_banquet_orders_count", params);
};
// 推荐待审核工单
var getRecommendOrder = function getRecommendOrder(params) {
  return axios.post(base + "/order/recommend_order", params);
};

var getRecommendBanquetOrderApi = function getRecommendBanquetOrderApi(params) {
  return axios.post(base + "/order/recommend_banquet_order", params);
};

var uploadOrderReviewFile = function uploadOrderReviewFile(params) {
  return axios.post(base + "/order_uploadfile", params);
};
var uploadOrderReviewDirectFile = function uploadOrderReviewDirectFile(params) {
  return axios.post(base + "/order_direct_uploadfile", params);
};
var lockOrder = function lockOrder(params) {
  return axios.post(base + "/lock_order_" + params.id, params);
};
var reviewClbOrderPass = function reviewClbOrderPass(params) {
  return axios.post(base + "/clb/pass_audit_order_" + params.id, params);
};
var acquireOrder = function acquireOrder(params) {
  return axios.post(base + "/order/audit/acquire_" + params.id, params);
};
var releaseOrder = function releaseOrder(params) {
  return axios.post(base + "/order/audit/release_" + params.id, params);
};
var saveOrderReviewCache = function saveOrderReviewCache(params) {
  return axios.post(base + "/order/set_cache_" + params.id, params);
};
var readOrderReviewCache = function readOrderReviewCache(params) {
  return axios.get(base + "/order/get_cache_" + params.id, params);
};
// 获得图像识别结果
var findRecognitionResults = function findRecognitionResults(params) {
  return axios.post(imgr + "/app/ask_detection_result", params);
};

// 获得与标题匹配的识别产品
var matchRecognitionQuestionProduct = function matchRecognitionQuestionProduct(params) {
  return axios.post(imgr + "/app/ask_existance_of_product", params);
};
/**
 * 反馈识别异常
 */
var feedbackImageRecognitionException = function feedbackImageRecognitionException(params) {
  return axios.post(imgr + "/update_image/is_exception/" + params.id, params);
};
/**
 * 获得题目的拼接照片
 */
var getOrderReviewQuestionJoinImg = function getOrderReviewQuestionJoinImg(params) {
  return axios.get(imgr + "/app/ask_splice_question_image/" + params.id);
};
// 查询工单审核历史
var getOrderReviewHistoryTable = function getOrderReviewHistoryTable(params) {
  return axios.post(base + "/order/history/query", params);
};
// 获得工单审核历史详情
var getOrderReviewHistoryDetail = function getOrderReviewHistoryDetail(params) {
  return axios.get(base + "/order/history/get_" + params.id, { params: params });
};
// 获得工单审核历史的问题是否修改状态
var getOrderReviewHistoryQuestionStatus = function getOrderReviewHistoryQuestionStatus(params) {
  return axios.get(base + "/order/history/step_status_" + params.id, { params: params });
};
// 添加工单审核录音证据的标记点
var saveOrderReviewAudioMarkers = function saveOrderReviewAudioMarkers(params) {
  return axios.post(base + "/order/upload_record_marker", params);
};
// 检测工单状态
var checkOrderStatus = function checkOrderStatus(params) {
  return axios.get(base + "/order/check_status_" + params.id, { params: params });
};

// 获取直播工单审核
var getOrderLiveDetail = function getOrderLiveDetail(params) {
  return axios.get(openapi + "/jnc/order/get_" + params.id, { params: params });
};

// sjf 订单详情接口
var getSJFOrderDetail = function getSJFOrderDetail(params) {
  return axios.get(sjfBase + "/admin/admin2/task_banquet_data_" + params.id, { params: params });
};

var getSJFPlatformSetting = function getSJFPlatformSetting(params) {
  return axios.get(sjfBase + "/admin/admin2/settings/all", { params: params });
};

// 工单复核 API
var reviewOrderQuality = function reviewOrderQuality(params) {
  return axios.post(base + "/order/review_quality", params);
};

// 工单 ASR 风险检查结果
var getAudioAsrCheckOrderResult = function getAudioAsrCheckOrderResult(_ref2) {
  var id = _ref2.id;

  return axios.get(base + "/audio_asr_check_order_result_" + id);
};

// 任务审核参照数据
var getTaskAuditReference = function getTaskAuditReference(params) {
  return axios.get(base + "/task/audit_reference", { params: params });
};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserTable", function() { return getUserTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserDetail_", function() { return getUserDetail_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserDetail", function() { return getUserDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserRelatedOptions", function() { return getUserRelatedOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryCustomerService", function() { return getQueryCustomerService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addCustomerService", function() { return addCustomerService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modifyCustomerService", function() { return modifyCustomerService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchCustomerService", function() { return searchCustomerService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserDevice", function() { return getUserDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserOperate", function() { return getUserOperate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserAccount", function() { return getUserAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLog", function() { return getUserLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserWorkInfoLog", function() { return getUserWorkInfoLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCredit", function() { return getUserCredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCreditList", function() { return getCreditList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPointList", function() { return getPointList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserPoints", function() { return getUserPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMasTable", function() { return getMasTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarketInfo", function() { return getMarketInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadUserMasImg", function() { return uploadUserMasImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUserMas", function() { return addUserMas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAreaList", function() { return getAreaList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTagInfo", function() { return getTagInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserList", function() { return getUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserTagName", function() { return getUserTagName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserMarketName", function() { return getUserMarketName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserAbilitiesName", function() { return getUserAbilitiesName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserAttributes", function() { return getUserAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUser", function() { return updateUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadUserImg", function() { return uploadUserImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adminDirectUploadFilesApi", function() { return adminDirectUploadFilesApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserDetailOption", function() { return getUserDetailOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUser", function() { return createUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "freezeUser", function() { return freezeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unFreezeUser", function() { return unFreezeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unBoundUserWeixin", function() { return unBoundUserWeixin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryUser", function() { return queryUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryDeletedUsers", function() { return queryDeletedUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryDevices", function() { return queryDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportDeviceDetail", function() { return exportDeviceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeviceDetail", function() { return getDeviceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeviceStats", function() { return getDeviceStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryUserDevices", function() { return queryUserDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeBlacklistCellphone", function() { return removeBlacklistCellphone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUser", function() { return exportUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchExportUserInfo", function() { return batchExportUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserAccountList", function() { return getUserAccountList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserPointsList", function() { return getUserPointsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCurrentWithdrawUser", function() { return exportCurrentWithdrawUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserWorkinfo", function() { return updateUserWorkinfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserPhone", function() { return updateUserPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUserById", function() { return exportUserById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUserByPhone", function() { return exportUserByPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchAddUserTagById", function() { return batchAddUserTagById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchAddUserTagByPhone", function() { return batchAddUserTagByPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewbieDefineCondApi", function() { return getNewbieDefineCondApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewbieDefineCondApi", function() { return setNewbieDefineCondApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewbieMissionCfgApi", function() { return getNewbieMissionCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewbieMissionCfgApi", function() { return setNewbieMissionCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryRiskUsers", function() { return queryRiskUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRiskUserStats", function() { return getRiskUserStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRiskUserDetail", function() { return getRiskUserDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmRiskUser", function() { return confirmRiskUser; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getUserTable = function getUserTable(params) {
  return axios.post(base + "/query_user", params);
};
// 获取用户编辑详情
var getUserDetail_ = function getUserDetail_(params) {
  return axios.get(base + "/user_" + params.userid, { params: params });
};
// 获取用户详情
var getUserDetail = function getUserDetail(id) {
  return axios.get(base + "/userdetail_" + id);
};
var getUserRelatedOptions = function getUserRelatedOptions(params) {
  return axios.get(base + "/userrelated_options");
};
var getQueryCustomerService = function getQueryCustomerService(params) {
  return axios.post(base + "/query_customerservice", params);
};
var addCustomerService = function addCustomerService(params) {
  return axios.post(base + "/add_customerservice", params);
};
var modifyCustomerService = function modifyCustomerService(params) {
  return axios.post(base + "/modify_customerservice", params);
};
var searchCustomerService = function searchCustomerService(params) {
  return axios.post(base + "/search_customer_service", params);
};
var getUserDevice = function getUserDevice(userid) {
  return axios.get(base + "/userdevice_" + userid);
};
var getUserOperate = function getUserOperate(userid) {
  return axios.get(base + "/opinfo_user_" + userid);
};
var getUserAccount = function getUserAccount(userid) {
  return axios.get(base + "/useraccount_" + userid);
};
var getUserLog = function getUserLog(userid) {
  return axios.get(base + "/adminlog_user_" + userid);
};
var getUserWorkInfoLog = function getUserWorkInfoLog(params) {
  return axios.post(base + "/get_workinfo_log_" + params.userid, params);
};
var getUserCredit = function getUserCredit(userid) {
  return axios.get(base + "/usercredit_" + userid);
};
var getCreditList = function getCreditList(params) {
  return axios.post(base + "/creditflow_user_" + params.userid, params);
};
var getPointList = function getPointList(params) {
  return axios.post(base + "/pointflow_user_" + params.userid, params);
};
var getUserPoints = function getUserPoints(id) {
  return axios.get(base + "/userpoints_" + id);
};
var getMasTable = function getMasTable(params) {
  return axios.post(base + "/query_user_massmsg", params);
};
var getMarketInfo = function getMarketInfo(params) {
  return axios.post(base + "/query_market", params);
};
var uploadUserMasImg = function uploadUserMasImg(params) {
  return axios.post(base + "/massmsg_uploadfile", params);
};
var addUserMas = function addUserMas(params) {
  return axios.post(base + "/add_user_massmsg", params);
};

var getAreaList = function getAreaList(id) {
  return axios.get(base + "/arealist_" + id);
};
var getTagInfo = function getTagInfo(params) {
  return axios.post(base + "/query_tag", params);
};
var getUserList = function getUserList(params) {
  return axios.post(base + "/query_user", params);
};
var getUserTagName = function getUserTagName(params) {
  return axios.post(base + "/get_user_tag_name", params);
};
var getUserMarketName = function getUserMarketName(params) {
  return axios.post(base + "/get_user_market_name", params);
};
var getUserAbilitiesName = function getUserAbilitiesName(params) {
  return axios.post(base + "/get_user_abilities_name", params);
};
var getUserAttributes = function getUserAttributes(params) {
  return axios.post(base + "/get_user_attributes_name", params);
};
var updateUser = function updateUser(params) {
  return axios.post(base + "/edit_user_" + params.userid, params);
};
var uploadUserImg = function uploadUserImg(params) {
  return axios.post(base + "/user_uploadfile", params);
};
var adminDirectUploadFilesApi = function adminDirectUploadFilesApi(params) {
  return axios.post(base + "/admin_direct_upload_files", params);
};
var getUserDetailOption = function getUserDetailOption(id) {
  return axios.get(base + "/get_user_detail_option_" + id);
};
var getUser = function getUser(id) {
  return axios.get(base + "/user_" + id);
};
var createUser = function createUser(params) {
  return axios.post(base + "/create_user", params);
};
var freezeUser = function freezeUser(params) {
  return axios.post(base + "/freeze_user_" + params.userid, params);
};
var unFreezeUser = function unFreezeUser(id) {
  return axios.post(base + "/unfreeze_user_" + id);
};
var unBoundUserWeixin = function unBoundUserWeixin(_ref) {
  var id = _ref.id;

  return axios.post(base + "/unbind_user_weixin_" + id);
};
var queryUser = function queryUser(params) {
  return axios.post(base + "/user/query", params);
};
var queryDeletedUsers = function queryDeletedUsers(params) {
  return axios.post(base + "/query_deleted_users", params);
};
var queryDevices = function queryDevices(params) {
  return axios.post(base + "/device/query", params);
};
var exportDeviceDetail = function exportDeviceDetail(params) {
  return axios.post(base + "/device/export_detail", params);
};
var getDeviceDetail = function getDeviceDetail(params) {
  return axios.get(base + "/device/get_" + params.id, params);
};
var getDeviceStats = function getDeviceStats(params) {
  return axios.post(base + "/device/stats", params);
};
var queryUserDevices = function queryUserDevices(params) {
  return axios.post(base + "/device/query_user", params || {});
};
var removeBlacklistCellphone = function removeBlacklistCellphone(params) {
  return axios.post(base + "/remove_blacklist_cellphone", params);
};
var exportUser = function exportUser(params) {
  return axios.post(base + "/user_export", params);
};
var batchExportUserInfo = function batchExportUserInfo(params) {
  return axios.post(base + "/batch_export_user_info", params);
};
var getUserAccountList = function getUserAccountList(params) {
  return axios.post(base + "/query_user_balance", params);
};
var getUserPointsList = function getUserPointsList(params) {
  return axios.post(base + "/query_points", params);
};
var exportCurrentWithdrawUser = function exportCurrentWithdrawUser(params) {
  return axios.post(base + "/export_current_withdraw", params);
};

var updateUserWorkinfo = function updateUserWorkinfo(params) {
  return axios.post(base + "/edit_user_workinfo_" + params.id, params);
};
var updateUserPhone = function updateUserPhone(params) {
  return axios.post(base + "/edit_user_phone_" + params.id, params);
};
var exportUserById = function exportUserById(params) {
  return axios.post(base + "/batch_jobs/export_user_by_id", params);
};
var exportUserByPhone = function exportUserByPhone(params) {
  return axios.post(base + "/batch_jobs/export_user_by_phone", params);
};
var batchAddUserTagById = function batchAddUserTagById(params) {
  return axios.post(base + "/batch_jobs/add_user_tag_by_id", params);
};
var batchAddUserTagByPhone = function batchAddUserTagByPhone(params) {
  return axios.post(base + "/batch_jobs/add_user_tag_by_phone", params);
};

var getNewbieDefineCondApi = function getNewbieDefineCondApi(params) {
  return axios.get(base + "/setting/get_newbie_define_condition", { params: params });
};

var setNewbieDefineCondApi = function setNewbieDefineCondApi(params) {
  return axios.post(base + "/setting/set_newbie_define_condition", params);
};

var getNewbieMissionCfgApi = function getNewbieMissionCfgApi(params) {
  return axios.get(base + "/setting/get_newbie_mission_cfg", { params: params });
};

var setNewbieMissionCfgApi = function setNewbieMissionCfgApi(params) {
  return axios.post(base + "/setting/set_newbie_mission_cfg", params);
};

var queryRiskUsers = function queryRiskUsers(params) {
  return axios.post(base + "/risk-user/query", params);
};
var getRiskUserStats = function getRiskUserStats(params) {
  return axios.post(base + "/risk-user/stats", params);
};
var getRiskUserDetail = function getRiskUserDetail(params) {
  return axios.get(base + "/risk-user/get_" + params.userid, params);
};
var confirmRiskUser = function confirmRiskUser(params) {
  return axios.post(base + "/risk-user/confirm_" + params.userid, params);
};

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformUsersIndex", function() { return getPlatformUsersIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBasicPlatformUsersIndex", function() { return getBasicPlatformUsersIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformUsersDetail", function() { return getPlatformUsersDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addPlatformUser", function() { return addPlatformUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editPlatformUser", function() { return editPlatformUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePlatformUser", function() { return deletePlatformUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyPlatformUser", function() { return copyPlatformUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserPermissionsAndRoles", function() { return getUserPermissionsAndRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editUserPermissionsAndRoles", function() { return editUserPermissionsAndRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllDepartments", function() { return getAllDepartments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllCustomers", function() { return getAllCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAdminOptions", function() { return getAdminOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AllotPlatformUserMany", function() { return AllotPlatformUserMany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findPermissions", function() { return findPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePermissions", function() { return updatePermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuditLogTableApi", function() { return AuditLogTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchSetAdminRoles", function() { return batchSetAdminRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchSetAdminUIRoles", function() { return batchSetAdminUIRoles; });
var adminBase = window._env_.VUE_APP_ADMIN_HOST;
var baseHost = window._env_.VUE_APP_HOST;

// 平台用户
var getPlatformUsersIndex = function getPlatformUsersIndex(params) {
  return axios.post(adminBase + "/adminuser/query", params);
};
var getBasicPlatformUsersIndex = function getBasicPlatformUsersIndex(params) {
  return axios.post(adminBase + "/basic-info/query_adminuser", params);
};
var getPlatformUsersDetail = function getPlatformUsersDetail(params) {
  if (params && params.host) {
    return axios.get("//" + params.host + "/adminuser/get_" + params.id);
  }
  return axios.get(adminBase + "/adminuser/get_" + params.id);
};
var addPlatformUser = function addPlatformUser(params) {
  if (params && params.host) {
    return axios.post("//" + params.host + "/admin/adminuser/create", params);
  }
  return axios.post(adminBase + "/adminuser/create", params);
};
var editPlatformUser = function editPlatformUser(params) {
  if (params && params.host) {
    return axios.post("//" + params.host + "/admin/adminuser/edit_" + params.id, params);
  }
  return axios.post(adminBase + "/adminuser/edit_" + params.id, params);
};
var deletePlatformUser = function deletePlatformUser(id) {
  return axios.post(adminBase + "/adminuser/delete_" + id);
};
var copyPlatformUser = function copyPlatformUser(id) {
  return axios.post(adminBase + "/adminuser/copy_" + id);
};

var getUserPermissionsAndRoles = function getUserPermissionsAndRoles(params) {
  return axios.get("//" + params.host + "/permissions/user/get_" + params.id);
};
var editUserPermissionsAndRoles = function editUserPermissionsAndRoles(params) {
  return axios.post("//" + params.host + "/permissions/user/edit_" + params.id, params);
};

// 其它设置选项
var getAllDepartments = function getAllDepartments(params) {
  return axios.get(adminBase + "/department/list");
};
var getAllCustomers = function getAllCustomers(params) {
  if (params && params.host) {
    return axios.get("//" + params.host + "/admin/customer/list");
  }
  return axios.get(adminBase + "/customer/list");
};
var getAdminOptions = function getAdminOptions(params) {
  return axios.get(adminBase + "/adminuser/optionlist");
};

// 批量分配客户
var AllotPlatformUserMany = function AllotPlatformUserMany(params) {
  return axios.post(adminBase + "/adminuser/batch_assgin_customers", params);
};
var findPermissions = function findPermissions(route) {
  return axios.get(adminBase + "/permission_" + route);
};
var updatePermissions = function updatePermissions(_ref) {
  var route = _ref.route,
      data = _ref.data;

  return axios.post(adminBase + "/permission_" + route, data);
};

// 审计日志
var AuditLogTableApi = function AuditLogTableApi(params) {
  return axios.post(baseHost + "/oplogs/list", params);
};

// 批量分配管理员角色
var batchSetAdminRoles = function batchSetAdminRoles(params) {
  if (params && params.host) {
    return axios.post("//" + params.host + "/permissions/user/add_roles_" + params.admin_id, params);
  }
  return axios.post(adminBase + "/permissions/user/add_roles_" + params.admin_id, params);
};
var batchSetAdminUIRoles = function batchSetAdminUIRoles(params) {
  return axios.post(adminBase + "/uipermission/user/add_roles_" + params.admin_id, params);
};

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invoiceApply", function() { return invoiceApply; });
// initial state
var state = {
  splitOptions: {
    invoiceStatus: {
      1: '待开票',
      2: '开票中',
      3: '已开票',
      4: '待作废',
      5: '作废中',
      6: '已作废'
    }
  },
  options: {
    status: [{ label: '待审批', value: 1 }, { label: '已放弃', value: 4 }, { label: '已驳回', value: 3, color: '#F56C6C' }, { label: '待开票', value: 2 }, { label: '开票中', value: 5 }, { label: '已开票(未同步金蝶)', value: 15 }, { label: '已开票', value: 6 }, { label: '已签收', value: 7, color: '#67C23A' }, { label: '待作废', value: 8 }, { label: '作废中', value: 13 }, { label: '已作废(未同步金蝶)', value: 16, color: '#F56C6C' }, { label: '已作废', value: 9, color: '#F56C6C' }, { label: '已开红冲', value: 10, color: '#F56C6C' }, { label: '红冲开具中', value: 14, color: '#F56C6C' }, { label: '红冲发票(未同步金蝶)', value: 17, color: '#F56C6C' }, { label: '红冲发票', value: 11, color: '#F56C6C' }],
    issued_type: [{ label: '常规开票', value: '1' }, { label: '预收款开票', value: '2' }],
    // 预收款开票信息的抵扣状态
    deduction_status: [{ label: '未抵扣', value: 1 }, { label: '待审批', value: 2 }, { label: '待抵扣', value: 3 }, { label: '部分抵扣', value: 4 }, { label: '已抵扣', value: 5 }],
    // 预收款开票抵扣信息条目状态,bu审批通过为待抵扣,财务通过为抵扣完成,驳回直接失败
    deduction_detail_status: [{ label: '待审批', value: 1 }, { label: '待抵扣', value: 2 }, { label: '抵扣完成', value: 3, color: '#04D919' }, { label: '抵扣失败', value: 4, color: '#D9001B' }, { label: '已放弃', value: 5 }],
    type: [{ label: '增值税专用发票', value: 1 }, { label: '增值税普通发票', value: 2 }, { label: '形式发票', value: 3 }, { label: '电子发票（增值税专用发票）', value: 4 }, { label: '电子发票（普通发票）', value: 5 }],
    subject: [{ label: '小零', value: 1 }, { label: '数饮', value: 2 }, { label: '零启', value: 3 }],
    currency_type: [{ label: '人民币', value: 1, symbol: '￥' }, { label: '美元', value: 2, symbol: '$' }, { label: '欧元', value: 3, symbol: '€' }],
    cost_type: [{ label: '现代服务*服务费', value: 1 }, { label: '现代服务*技术服务费', value: 7 }, { label: '现代服务*市场调研费', value: 8 }, { label: '现代服务*咨询服务费', value: 3 }, { label: '现代服务*营销服务费', value: 4 }, { label: '现代服务*推广策划服务费', value: 5 }, { label: '现代服务*其他现代服务费', value: 2 }, { label: '经纪代理服务*酬金', value: 6 }, { label: '会展服务*服务费', value: 9 }, { label: '设计服务*电商物料设计', value: 10 }, { label: '信息技术服务*软件开发服务', value: 12 }, { label: '信息技术服务*软件维护服务', value: 13 }, { label: '信息技术服务*软件测试服务', value: 14 }, { label: '信息技术服务*信息系统服务', value: 15 }, { label: '信息技术服务*信息系统增值服务', value: 16 }, { label: '其他咨询服务*技术咨询', value: 17 }, { label: '信息技术服务*业务流程管理服务', value: 18 }, { label: '会展服务*会议服务', value: 19 }, { label: '其他咨询服务*咨询服务', value: 20 }, { label: '企业管理服务*其他企业管理服务', value: 21 }, { label: '现代服务*市场推广', value: 22 }, { label: '设计服务*专业设计服务', value: 23 }, { label: '广告服务*广告代理服务', value: 24 }, { label: '其他技术类开票', value: 25 }, { label: '其他', value: 11 }],
    tax_type: [
    // {label: '无', value: 0},
    { label: '含税金额', value: 1 }, { label: '未税金额', value: 2 }],
    received_payment_status: [{ label: '待回款', value: 0 }, { label: '部分回款', value: 1 }, { label: '已回款', value: 2 }]
  },
  receipt_export_headers: [{
    key: 'subject_name',
    text: '开票主体'
  }, {
    key: 'id',
    text: '开票申请ID'
  }, {
    key: 'issued_type',
    text: '开票类别'
  }, {
    key: 'invoice_full_name',
    text: '开票名称'
  }, {
    key: 'product_num',
    text: '商品编码'
  }, {
    key: 'type',
    text: '发票类别'
  }, {
    key: 'receipt_info_id',
    text: '开票抬头ID'
  }, { key: 'invoice_tax_type_cn', text: '开票金额依据' }, { key: 'buyer_company_name', text: '购买方名称' }, { key: 'buyer_tax_number', text: '购买方纳税人识别号' }, { key: 'invoice_remark', text: '发票备注' }, {
    key: 'pay_condition_name',
    text: '账期'
  }, {
    key: 'project_number',
    text: '项目编号'
  }, {
    key: 'project_name',
    text: '项目名称'
  }, {
    key: 'bu_name',
    text: 'BO审批'
  }, {
    key: 'initiator_name',
    text: '发起人'
  }, {
    key: 'invoice_time',
    text: '开票日期'
  }, { key: 'unit', text: '单位' }, { key: 'quantity', text: '数量' }, {
    key: 'total',
    text: '含税金额'
  }, { key: 'tax_rate', text: '税率' }, {
    key: 'untaxed_amount',
    text: '未税金额'
  }, {
    key: 'tax',
    text: '税额'
  }, {
    key: 'invoice_number',
    text: '发票号码'
  }, {
    key: 'status',
    text: '开票状态'
  }, {
    key: 'customer_name',
    text: '客户名称'
  }, {
    key: 'customer_number',
    text: '客户编号'
  }, {
    key: 'desc',
    text: '申请描述'
  }, {
    key: 'do_number',
    text: 'DO/PO单号'
  }, {
    key: 'memo',
    text: '开票备注'
  }, {
    key: 'created_at',
    text: '添加日期'
  }, {
    key: 'updated_at',
    text: '更新日期'
  }, {
    key: 'finance_name',
    text: '财务审批人'
  }],
  pre_receipt_export_headers: [{
    key: 'id',
    text: '开票申请ID'
  }, {
    key: 'subject',
    text: '开票主体'
  }, {
    key: 'customer_number',
    text: '客户编号'
  }, {
    key: 'customer_name',
    text: '客户名称'
  }, { key: 'buyer_company_name', text: '购买方名称' }, { key: 'buyer_tax_number', text: '购买方纳税人识别号' }, { key: 'invoice_remark', text: '发票备注' }, {
    key: 'bd_name',
    text: 'BD'
  }, {
    key: 'bu_name',
    text: 'BO审批'
  }, {
    key: 'initiator_name',
    text: '发起人'
  }, {
    key: 'virtual_project_number',
    text: '预收款项目编号'
  }, { key: 'unit', text: '单位' }, { key: 'quantity', text: '数量' }, {
    key: 'total',
    text: '含税开票金额'
  }, { key: 'tax_rate', text: '税率' }, {
    key: 'received_amount',
    text: '回款金额'
  }, {
    key: 'project_number',
    text: '抵扣项目编号'
  }, {
    key: 'deduction_amount',
    text: '抵扣含税开票金额'
  }, {
    key: 'available_deduct_amount',
    text: '未抵扣含税金额'
  }, {
    key: 'deduction_status',
    text: '抵扣状态'
  }, {
    key: 'deduction_detail_updated_at',
    text: '抵扣时间'
  }, {
    key: 'invoice_number',
    text: '发票号'
  }, {
    key: 'invoice_time',
    text: '开票时间'
  }, {
    key: 'received_payment_time',
    text: '回款时间'
  }],
  uncollection_export_header: [{
    key: 'receipt_apply_id',
    text: '开票申请ID'
  }, {
    key: 'subject_name',
    text: '开票主体'
  }, {
    key: 'customer_name',
    text: '客户名称'
  }, {
    key: 'customer_number',
    text: '客户编号'
  }, {
    key: 'receipt_info_id',
    text: '开票抬头ID'
  }, {
    key: 'receipt_info_company_name',
    text: '公司名称'
  }, {
    key: 'pay_condition_name',
    text: '账期'
  }, {
    key: 'project_name',
    text: '项目名称'
  }, {
    key: 'project_number',
    text: '项目编号'
  }, {
    key: 'bu_name',
    text: 'BO审批'
  }, {
    key: 'initiator_name',
    text: '发起人'
  }, {
    key: 'invoice_date',
    text: '开票日期'
  }, {
    key: 'invoice_number',
    text: '发票号码'
  }, {
    key: 'remains_received_amount',
    text: '未回款金额'
  }, {
    key: 'issued_type_name',
    text: '开票类别'
  }, {
    key: 'export_time',
    text: '导出时间'
  }],
  collection_export_header: [{
    key: 'receipt_apply_id',
    text: '开票申请ID'
  }, {
    key: 'collection_id',
    text: '回款ID'
  }, {
    key: 'subject_name',
    text: '开票主体'
  }, {
    key: 'customer_name',
    text: '客户名称'
  }, {
    key: 'customer_number',
    text: '客户编号'
  }, {
    key: 'receipt_info_id',
    text: '开票抬头ID'
  }, {
    key: 'receipt_info_company_name',
    text: '公司名称'
  }, {
    key: 'pay_condition_name',
    text: '账期'
  }, {
    key: 'project_name',
    text: '项目名称'
  }, {
    key: 'project_number',
    text: '项目编号'
  }, {
    key: 'bu_name',
    text: 'BO审批'
  }, {
    key: 'initiator_name',
    text: '发起人'
  }, {
    key: 'invoice_date',
    text: '开票日期'
  }, {
    key: 'invoice_number',
    text: '发票号码'
  }, {
    key: 'collection_amount',
    text: '回款金额'
  }, {
    key: 'collection_date',
    text: '回款日期'
  }, {
    key: 'collection_bank',
    text: '收款账户'
  }, {
    key: 'export_time',
    text: '导出时间'
  }]

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var invoiceApply = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutPanel_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4294a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutPanel_vue__ = __webpack_require__(808);
function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutPanel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e4294a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutPanel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGutter_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46784ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGutter_vue__ = __webpack_require__(826);
function injectStyle (ssrContext) {
  __webpack_require__(823)
  __webpack_require__(824)
  this["$style"] = __webpack_require__(825)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46784ee6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonGutter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46784ee6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonGutter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exception_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_436827f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Exception_vue__ = __webpack_require__(833);
function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exception_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_436827f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Exception_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternTableApi", function() { return queryInternTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternLogTableApi", function() { return queryInternLogTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInternApi", function() { return createInternApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternBaseInfoApi", function() { return getInternBaseInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternPrivateInfoApi", function() { return getInternPrivateInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternUserDashboardApi", function() { return getInternUserDashboardApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeInternStatusBaseApi", function() { return activeInternStatusBaseApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAuditInternBaseApi", function() { return updateAuditInternBaseApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAuditInternPrivateApi", function() { return updateAuditInternPrivateApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAuditInternResourceApi", function() { return updateAuditInternResourceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertInternToFulltimeApi", function() { return convertInternToFulltimeApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportInternBaseInfoApi", function() { return exportInternBaseInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportInternFullInfoApi", function() { return exportInternFullInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternMonthlyOnDutyTableApi", function() { return queryInternMonthlyOnDutyTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternDailyOnDutyTableApi", function() { return queryInternDailyOnDutyTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternAuditPerformanceApi", function() { return queryInternAuditPerformanceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "recalculateInternAuditPerformanceApi", function() { return recalculateInternAuditPerformanceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAttendanceNotifyCfgTableApi", function() { return queryAttendanceNotifyCfgTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttendanceNotifyCfgApi", function() { return getAttendanceNotifyCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAttendanceNotifyCfgApi", function() { return createAttendanceNotifyCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editAttendanceNotifyCfgApi", function() { return editAttendanceNotifyCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeAttendanceNotifyCfgApi", function() { return activeAttendanceNotifyCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inactiveAttendanceNotifyCfgApi", function() { return inactiveAttendanceNotifyCfgApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attendanceNotifySentHistoryApi", function() { return attendanceNotifySentHistoryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryProjectAttendanceTargetTableApi", function() { return queryProjectAttendanceTargetTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProjectAttendanceTargetApi", function() { return updateProjectAttendanceTargetApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delProjectAttendanceTargetApi", function() { return delProjectAttendanceTargetApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOssSignedUrlApi", function() { return getOssSignedUrlApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardCoreApiRoleQueryApi", function() { return forwardCoreApiRoleQueryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardCoreApiRoleDetailApi", function() { return forwardCoreApiRoleDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardCoreUiRoleQueryApi", function() { return forwardCoreUiRoleQueryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardCoreUiRoleDetailApi", function() { return forwardCoreUiRoleDetailApi; });
/* global process */
var base = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

var queryInternTableApi = function queryInternTableApi(params) {
  return axios.post(base + "/admin/intern_user/query", params);
};
var queryInternLogTableApi = function queryInternLogTableApi(params) {
  return axios.post(base + "/admin/intern_user/query_log", params);
};
var createInternApi = function createInternApi(params) {
  return axios.post(base + "/admin/intern_user/create", params);
};
var getInternBaseInfoApi = function getInternBaseInfoApi(params) {
  return axios.get(base + "/admin/intern_user/" + params.id + "/base", { params: params });
};
var getInternPrivateInfoApi = function getInternPrivateInfoApi(params) {
  return axios.get(base + "/admin/intern_user/" + params.id + "/private", { params: params });
};
var getInternUserDashboardApi = function getInternUserDashboardApi() {
  return axios.get(base + "/admin/intern_user/dashboard");
};
var activeInternStatusBaseApi = function activeInternStatusBaseApi(params) {
  return axios.post(base + "/admin/intern_user/" + params.id + "/active_status", params);
};
var updateAuditInternBaseApi = function updateAuditInternBaseApi(params) {
  return axios.post(base + "/admin/intern_user/" + params.id + "/edit_base", params);
};
var updateAuditInternPrivateApi = function updateAuditInternPrivateApi(params) {
  return axios.post(base + "/admin/intern_user/" + params.id + "/edit_private", params);
};
var updateAuditInternResourceApi = function updateAuditInternResourceApi(params) {
  return axios.post(base + "/admin/intern_user/" + params.id + "/edit_resource", params);
};
var convertInternToFulltimeApi = function convertInternToFulltimeApi(params) {
  return axios.post(base + "/admin/intern_user/" + params.id + "/convert_to_fulltime", params);
};

var exportInternBaseInfoApi = function exportInternBaseInfoApi(params) {
  return axios.post(base + "/admin/intern_user/export_base", params);
};
var exportInternFullInfoApi = function exportInternFullInfoApi(params) {
  return axios.post(base + "/admin/intern_user/export_full", params);
};
var queryInternMonthlyOnDutyTableApi = function queryInternMonthlyOnDutyTableApi(params) {
  return axios.post(base + "/admin/intern_user_onduty/query_monthly", params);
};
var queryInternDailyOnDutyTableApi = function queryInternDailyOnDutyTableApi(params) {
  return axios.post(base + "/admin/intern_user_onduty/query_daily", params);
};
var queryInternAuditPerformanceApi = function queryInternAuditPerformanceApi(params) {
  return axios.post(base + "/admin/intern_audit_performance/query", params);
};
var recalculateInternAuditPerformanceApi = function recalculateInternAuditPerformanceApi(params) {
  return axios.post(base + "/admin/intern_audit_performance/recalculate", params);
};

var queryAttendanceNotifyCfgTableApi = function queryAttendanceNotifyCfgTableApi(params) {
  return axios.post(base + "/admin/attendance-notify-cfg/query", params);
};
var getAttendanceNotifyCfgApi = function getAttendanceNotifyCfgApi(params) {
  return axios.get(base + "/admin/attendance-notify-cfg/" + params.id, { params: params });
};
var createAttendanceNotifyCfgApi = function createAttendanceNotifyCfgApi(params) {
  return axios.post(base + "/admin/attendance-notify-cfg/create", params);
};
var editAttendanceNotifyCfgApi = function editAttendanceNotifyCfgApi(params) {
  return axios.post(base + "/admin/attendance-notify-cfg/" + params.id + "/edit", params);
};
var activeAttendanceNotifyCfgApi = function activeAttendanceNotifyCfgApi(params) {
  return axios.post(base + "/admin/attendance-notify-cfg/" + params.id + "/active", params);
};
var inactiveAttendanceNotifyCfgApi = function inactiveAttendanceNotifyCfgApi(params) {
  return axios.post(base + "/admin/attendance-notify-cfg/" + params.id + "/inactive", params);
};
var attendanceNotifySentHistoryApi = function attendanceNotifySentHistoryApi(params) {
  return axios.post(base + "/admin/attendance-notify-cfg/" + params.ref_id + "/sent_history", params);
};
var queryProjectAttendanceTargetTableApi = function queryProjectAttendanceTargetTableApi(params) {
  return axios.post(base + "/admin/project-attendance-target/query", params);
};
var updateProjectAttendanceTargetApi = function updateProjectAttendanceTargetApi(params) {
  return axios.post(base + "/admin/project-attendance-target/" + params.id + "/edit", params);
};
var delProjectAttendanceTargetApi = function delProjectAttendanceTargetApi(params) {
  return axios.post(base + "/admin/project-attendance-target/" + params.id + "/del", params);
};

var getOssSignedUrlApi = function getOssSignedUrlApi(params) {
  return axios.post(base + "/admin/oss/get_signed_url", params);
};
var forwardCoreApiRoleQueryApi = function forwardCoreApiRoleQueryApi(params) {
  return axios.post(base + "/admin/core_api/api_role_query", params);
};
var forwardCoreApiRoleDetailApi = function forwardCoreApiRoleDetailApi(params) {
  return axios.get(base + "/admin/core_api/api_role/" + params.id, { params: params });
};
var forwardCoreUiRoleQueryApi = function forwardCoreUiRoleQueryApi(params) {
  return axios.post(base + "/admin/core_api/ui_role_query", params);
};
var forwardCoreUiRoleDetailApi = function forwardCoreUiRoleDetailApi(params) {
  return axios.get(base + "/admin/core_api/ui_role/" + params.id, { params: params });
};

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentCenterList", function() { return getPaymentCenterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentCenterPreview", function() { return getPaymentCenterPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bankPayment", function() { return bankPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentCenterBankCode", function() { return getPaymentCenterBankCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePaymentCenterCompanyBank", function() { return updatePaymentCenterCompanyBank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPaymentReceipt", function() { return uploadPaymentReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushKingdee", function() { return pushKingdee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadPayResult", function() { return downloadPayResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processPayException", function() { return processPayException; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;

var getPaymentCenterList = function getPaymentCenterList(params) {
  return axios.post(base + "/payment-center/list", params);
};

var getPaymentCenterPreview = function getPaymentCenterPreview(params) {
  return axios.post(base + "/payment-center/preview", params);
};

var bankPayment = function bankPayment(params) {
  return axios.post(base + "/payment-center/bank_payment", params);
};

var getPaymentCenterBankCode = function getPaymentCenterBankCode(params) {
  return axios.post(base + "/payment-center/bank_code", params);
};

var updatePaymentCenterCompanyBank = function updatePaymentCenterCompanyBank(id) {
  return axios.put(base + "/payment-center/update_company_bank/" + id);
};

// 手动上传回执，附件仅支持单个文件
var uploadPaymentReceipt = function uploadPaymentReceipt(params) {
  return axios.post(base + "/payment-center/upload_receipt", params);
};

// 推送金蝶
var pushKingdee = function pushKingdee(id) {
  return axios.post(base + "/payment-center/push_kingdee/" + id);
};

// 支付结果附件下载
var downloadPayResult = function downloadPayResult(id) {
  return axios.post(base + "/payment-center/download_pay_result/" + id);
};

// 支付异常处理
var processPayException = function processPayException(id) {
  return axios.post(base + "/payment-center/process_pay_exception/" + id);
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c7cf84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01c7cf84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 求平均值
   *
   * @param array
   * @returns {number}
   */
  average: function average(array) {
    var sum = 0;
    array.forEach(function (obj, index) {
      sum += Number(array[index]);
    });
    return sum / array.length;
  },

  /**
   * 获得四舍五入后的数字字符串
   *
   * @param n
   * @param decimals 保留的小数位数
   * @returns {string}
   */
  toFixed: function toFixed(n) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return _.round(Number(n), decimals); // Number(n).toFixed(decimals)
  },

  /**
   * 返回千位数分隔的数字
   * @param n
   * @returns {string}
   */
  seperateThousands: function seperateThousands(n) {
    return Number(n).toLocaleString('en-US');
  },

  /**
   * 返回千位数分隔的四舍五入后保留decimals小数的数字
   * @param n
   * @param decimals 保留的小数位数
   * @returns {string}
   */
  seperateThousandsToFixed: function seperateThousandsToFixed(n) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return _.round(Number(n), decimals).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,'); // Number(n).toFixed(decimals).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
  }
});

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(68);



/* harmony default export */ __webpack_exports__["a"] = ({
  // 是否有权限
  hasPermission: function hasPermission(value) {
    if (this.superPermission()) {
      return true;
    }
    return this.inPermissions(value);
  },

  // 是否拥有超级用户权限
  superPermission: function superPermission() {
    var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user;
    return user && user.usertype === '1';
  },

  // 是否有财务权限
  financePermission: function financePermission() {
    var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user;
    return user && ['1', '5'].includes(user.usertype + '');
  },

  // 用户是否拥有该权限
  inPermissions: function inPermissions(value) {
    // 存在权限列表
    var permissions = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.permissions;
    if (!permissions) {
      return false;
    }

    // 用户是否拥有该权限
    var hasPermission = false;
    if (value) {
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
        hasPermission = permissions.includes(value);
      } else if (value && value instanceof Array && value.length > 0) {
        hasPermission = permissions.some(function (permission) {
          return value.includes(permission);
        });
      } else {
        throw new Error('hasPermission 的 value 值不合法，必须为数字或者数组，数组不能为空');
      }
    }

    return hasPermission;
  },
  hasApiPermission: function hasApiPermission(value) {
    if (this.superPermission()) {
      return true;
    }
    return this.inApiPermissions(value);
  },

  // 用户是否拥有该API权限
  inApiPermissions: function inApiPermissions(value) {
    // 存在权限列表
    var permissions = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.apiPermissions;
    if (!permissions) {
      return false;
    }

    // 用户是否拥有该权限
    var hasPermission = false;
    if (value) {
      if (_.isString(value)) {
        hasPermission = permissions.includes(value);
      } else if (_.isArray(value) && value.length > 0) {
        hasPermission = permissions.some(function (permission) {
          return value.includes(permission);
        });
      } else {
        throw new Error('hasPermission 的 value 值不合法，必须为字符串或者数组，数组不能为空');
      }
    }

    return hasPermission;
  },
  hasCustomer: function hasCustomer(value) {
    var user = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters && __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.user;
    if (user) {
      // 超管,财务,服务帐号 有全部客户资源
      if (['1', '5', '6'].includes(user.usertype + '')) {
        return true;
      }
      if (user.hasOwnProperty('customerIdArr')) {
        return user.customerIdArr.includes(Number(value));
      } else {
        user.customerIdArr = user.customerid.split(',').map(function (item) {
          return parseInt(item.trim(), 10);
        }).filter(function (item) {
          return !isNaN(item);
        });
        return user.customerIdArr.includes(Number(value));
      }
    }
    return false;
  },
  sjfmarketname: function sjfmarketname(name, type) {
    if (type * 1 === 23) {
      if (!name) return name;

      var parts = name.split('-');

      if (parts.length >= 2) {
        return parts.slice(0, -1).join('-');
      }
    }
    return name;
  }
});

/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(351);
module.exports = __webpack_require__(553);


/***/ }),
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__env__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(68);

/**
 * 环境配置文件
 */


/**
 * 初始化
 */


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */





__WEBPACK_IMPORTED_MODULE_3_vue___default.a.config.productionTip = false;

/* eslint-disable no-new */
global.app = new __WEBPACK_IMPORTED_MODULE_3_vue___default.a({
  router: Router,
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */] },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    clientHeight: function clientHeight(state) {
      return state.clientHeight;
    }
  }), {
    mainHeight: function mainHeight() {
      return this.clientHeight - 50 - 21;
    }
  })
});

global.mountApp = function () {
  global.app.$mount('#app');
};
if (true) {
  if (global.STYLE_READY) {
    global.mountApp();
  }
} else {
  global.mountApp();
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

/* global process */
if (!window._env_) {
  window._env_ = {};
}

for (var key in Object({"VUE_APP_VERSION":"release-v9.11.4-2(06bf950)","VUE_APP_HOST":"https://core-api.dev.slicejobs.com","VUE_APP_AUTH_HOST":"https://auth-api.dev.slicejobs.com","VUE_APP_CLB_HOST":"https://core-api.dev.slicejobs.com/clb","VUE_APP_ADMIN_HOST":"https://core-api.dev.slicejobs.com/admin","VUE_APP_IMGR_HOST":"https://imgr-api-dev.slicejobs.com/admin","VUE_APP_RECRUIT_HOST":"https://recruit-dev.slicejobs.com/admin","VUE_APP_OLD_ADMIN_HOST":"https://admin-dev.slicejobs.com","VUE_APP_SHOP_HOST":"https://shop-api-dev.slicejobs.com/admin","VUE_APP_SITE_HOST":"https://app-site-dev.slicejobs.com","VUE_APP_IMG_FLOW_HOST":"https://imgsvc-dev.slicejobs.com/img_flow","VUE_APP_OPEN_API_HOST":"https://openapi-dev.slicejobs.com//admin","VUE_APP_FIN_CENTER_HOST":"https://fin-center-api.dev.slicejobs.com/admin","VUE_APP_ROBOT_CALL_HOST":"https://robotcall-api.dev.slicejobs.com","VUE_APP_KEY_IN_HOST":"https://keyin-api.dev.slicejobs.com","VUE_APP_KEY_IN_DC_HOST":"https://keyin-dc.dev.slicejobs.com","VUE_APP_KEY_IN_DC_API_HOST":"https://keyin-dc-api.dev.slicejobs.com","VUE_APP_SJF_API_HOST":"http://sjf-api.dev.slicejobs.com","VUE_APP_ORDER_AUDIT_API_HOST":"http://order-audit-api.dev.slicejobs.com","VUE_APP_SILICONFLOW_API_KEY":"","VUE_APP_SILICONFLOW_MODEL":"deepseek-ai/DeepSeek-V3","VUE_APP_COZE_TOKEN":"","VUE_APP_COZE_WORKFLOW_ID":"","VUE_APP_MOCK_API":"false","VUE_APP_NAME":"爱零工管理平台TWO","RUN_SERVER_PORT":"8090","RUN_SERVER_HOST":"localhost","NODE_ENV":"production"})) {
  if (Object({"VUE_APP_VERSION":"release-v9.11.4-2(06bf950)","VUE_APP_HOST":"https://core-api.dev.slicejobs.com","VUE_APP_AUTH_HOST":"https://auth-api.dev.slicejobs.com","VUE_APP_CLB_HOST":"https://core-api.dev.slicejobs.com/clb","VUE_APP_ADMIN_HOST":"https://core-api.dev.slicejobs.com/admin","VUE_APP_IMGR_HOST":"https://imgr-api-dev.slicejobs.com/admin","VUE_APP_RECRUIT_HOST":"https://recruit-dev.slicejobs.com/admin","VUE_APP_OLD_ADMIN_HOST":"https://admin-dev.slicejobs.com","VUE_APP_SHOP_HOST":"https://shop-api-dev.slicejobs.com/admin","VUE_APP_SITE_HOST":"https://app-site-dev.slicejobs.com","VUE_APP_IMG_FLOW_HOST":"https://imgsvc-dev.slicejobs.com/img_flow","VUE_APP_OPEN_API_HOST":"https://openapi-dev.slicejobs.com//admin","VUE_APP_FIN_CENTER_HOST":"https://fin-center-api.dev.slicejobs.com/admin","VUE_APP_ROBOT_CALL_HOST":"https://robotcall-api.dev.slicejobs.com","VUE_APP_KEY_IN_HOST":"https://keyin-api.dev.slicejobs.com","VUE_APP_KEY_IN_DC_HOST":"https://keyin-dc.dev.slicejobs.com","VUE_APP_KEY_IN_DC_API_HOST":"https://keyin-dc-api.dev.slicejobs.com","VUE_APP_SJF_API_HOST":"http://sjf-api.dev.slicejobs.com","VUE_APP_ORDER_AUDIT_API_HOST":"http://order-audit-api.dev.slicejobs.com","VUE_APP_SILICONFLOW_API_KEY":"","VUE_APP_SILICONFLOW_MODEL":"deepseek-ai/DeepSeek-V3","VUE_APP_COZE_TOKEN":"","VUE_APP_COZE_WORKFLOW_ID":"","VUE_APP_MOCK_API":"false","VUE_APP_NAME":"爱零工管理平台TWO","RUN_SERVER_PORT":"8090","RUN_SERVER_HOST":"localhost","NODE_ENV":"production"}).hasOwnProperty(key) && /^VUE_APP_/.test(key)) {
    if (!window._env_.hasOwnProperty(key)) {
      window._env_[key] = Object({"VUE_APP_VERSION":"release-v9.11.4-2(06bf950)","VUE_APP_HOST":"https://core-api.dev.slicejobs.com","VUE_APP_AUTH_HOST":"https://auth-api.dev.slicejobs.com","VUE_APP_CLB_HOST":"https://core-api.dev.slicejobs.com/clb","VUE_APP_ADMIN_HOST":"https://core-api.dev.slicejobs.com/admin","VUE_APP_IMGR_HOST":"https://imgr-api-dev.slicejobs.com/admin","VUE_APP_RECRUIT_HOST":"https://recruit-dev.slicejobs.com/admin","VUE_APP_OLD_ADMIN_HOST":"https://admin-dev.slicejobs.com","VUE_APP_SHOP_HOST":"https://shop-api-dev.slicejobs.com/admin","VUE_APP_SITE_HOST":"https://app-site-dev.slicejobs.com","VUE_APP_IMG_FLOW_HOST":"https://imgsvc-dev.slicejobs.com/img_flow","VUE_APP_OPEN_API_HOST":"https://openapi-dev.slicejobs.com//admin","VUE_APP_FIN_CENTER_HOST":"https://fin-center-api.dev.slicejobs.com/admin","VUE_APP_ROBOT_CALL_HOST":"https://robotcall-api.dev.slicejobs.com","VUE_APP_KEY_IN_HOST":"https://keyin-api.dev.slicejobs.com","VUE_APP_KEY_IN_DC_HOST":"https://keyin-dc.dev.slicejobs.com","VUE_APP_KEY_IN_DC_API_HOST":"https://keyin-dc-api.dev.slicejobs.com","VUE_APP_SJF_API_HOST":"http://sjf-api.dev.slicejobs.com","VUE_APP_ORDER_AUDIT_API_HOST":"http://order-audit-api.dev.slicejobs.com","VUE_APP_SILICONFLOW_API_KEY":"","VUE_APP_SILICONFLOW_MODEL":"deepseek-ai/DeepSeek-V3","VUE_APP_COZE_TOKEN":"","VUE_APP_COZE_WORKFLOW_ID":"","VUE_APP_MOCK_API":"false","VUE_APP_NAME":"爱零工管理平台TWO","RUN_SERVER_PORT":"8090","RUN_SERVER_HOST":"localhost","NODE_ENV":"production"})[key];
    }
  }
}

document.title = window._env_.VUE_APP_NAME;

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_js__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_js__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_directive_title__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_directive_permission__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_directive_api_permission__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directive_perfect_scrollbar__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_interceptors__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(806);
/**
 * 载入样式到全局
 */


/**
 * 载入依赖包到全局
 */



/**
 * 载入自定义事件
 */


/**
 * 全局Vue自定义指令
 */





/**
 * API 拦截器
 */


/**
 * Vue全局组件
 */


/**
 * 载入路由
 */
global.Router = __webpack_require__(827).default;

/**
 * 安装 ElementUI 到Vue
 */
Vue.use(ElementUI);

/**
 * filter 自定义的过滤方法
 * 可以在<template>或全局filter[]中直接调用
 */
global.filter = __webpack_require__(256).default;
for (var key in global.filter) {
  if (global.filter.hasOwnProperty(key)) {
    Vue.filter(key, filter[key]);
  }
}

/**
 * request api预处理器
 */
global.request = __webpack_require__(154).default;

/**
 * Mock.js
 * 生成随机数据，拦截 Ajax 请求
 * 通过覆盖和模拟原生 XMLHttpRequest 的行为来拦截 Ajax 请求
 * http://mockjs.com/
 */
if (false) {
  require('@core/mock');
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_font_scss__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__style_font_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__style_font_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_style_rewrite_element_scss__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_style_rewrite_element_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__core_style_rewrite_element_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_style_layout_scss__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_style_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__core_style_layout_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_style_scrollbar_scss__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_style_scrollbar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__core_style_scrollbar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_layout_scss__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_layout_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__style_layout_scss__);
/**
 * normalize.css
 * 在默认的HTML元素样式上提供了跨浏览器的高度一致性
 */



/**
 * 字体引入
 */


/**
 * element-ui
 */


/**
 * element-ui 样式重写
 * 可以更改一些Element-UI的样式
 */


/**
 * 布局样式
 */


/**
 * 滚动条样式
 */


/**
 * element-ui 样式重写
 * 可以更改一些Element-UI的样式
 */
// @import "./rewrite-element.scss";

/**
 * 布局样式
 */


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */,
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__slicejobs_slicejobs_ui__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__slicejobs_slicejobs_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__slicejobs_slicejobs_ui__);
/**
 * 框架依赖包载入
 */

/**
 * element-ui
 */


/**
 * 提供了一些数据处理的基础方法
 * 中文文档 http://www.css88.com/doc/lodash/
 */



/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */



/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */



/**
 * vuex 状态管理器
 */



/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */



/**
 * Moment.js JavaScript 日期处理类库
 * http://momentjs.cn/
 */



/**
 * slicejobs-ui
 */


/**
 * 安装 SlicejobsUI 到Vue
 */
__WEBPACK_IMPORTED_MODULE_3_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7__slicejobs_slicejobs_ui___default.a);

global._ = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a;
global.$ = global.jQuery = __WEBPACK_IMPORTED_MODULE_2_jquery___default.a;
global.Vue = __WEBPACK_IMPORTED_MODULE_3_vue___default.a;
global.Vuex = __WEBPACK_IMPORTED_MODULE_4_vuex__["default"];
global.ElementUI = __WEBPACK_IMPORTED_MODULE_0_element_ui___default.a;
global.moment = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;
global.axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(65)))

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(43);

/***/ }),
/* 572 */,
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_login_components_LoginBox__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(77);




// 监听浏览器大小的改变
window.onresize = _.throttle(function () {
  // 可见区域高度
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_CLIENT_HEIGHT', document.body.clientHeight);
  // 可见区域高度
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('SET_CLIENT_WIDTH', document.body.clientWidth);
}, 500);

// 登录有效期已满
Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["g" /* onloginExpired */])(__WEBPACK_IMPORTED_MODULE_1__views_login_components_LoginBox__["a" /* default */]);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function readAutoCollapseMenu() {
  var raw = localStorage.getItem('autoCollapseMenu');
  if (raw === null) {
    return true;
  }
  return raw === 'true';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  // 窗口可视大小
  clientHeight: document.body.clientHeight,
  clientWidth: document.body.clientWidth,
  // 加载遮罩
  loadingMain: 0,
  // 菜单折叠
  collapseMenu: false,
  // 点击菜单后自动折叠（持久化到 localStorage）
  autoCollapseMenu: readAutoCollapseMenu()
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CLIENT_HEIGHT", function() { return SET_CLIENT_HEIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CLIENT_WIDTH", function() { return SET_CLIENT_WIDTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPEN_LOADING", function() { return OPEN_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLOSE_LOADING", function() { return CLOSE_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLLAPSE_MENU", function() { return COLLAPSE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_AUTO_COLLAPSE_MENU", function() { return SET_AUTO_COLLAPSE_MENU; });
var SET_CLIENT_HEIGHT = function SET_CLIENT_HEIGHT(state, value) {
  state.clientHeight = value;
};
var SET_CLIENT_WIDTH = function SET_CLIENT_WIDTH(state, value) {
  state.clientWidth = value;
};

/**
 * loading 相关
 */
var OPEN_LOADING = function OPEN_LOADING(state) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  if (count > 0) {
    state.loadingMain += count;
  }
};

var CLOSE_LOADING = function CLOSE_LOADING(state, count) {
  // 有效的关闭数
  if (count > 0 && count <= state.loadingMain) {
    state.loadingMain -= count;
  } else {
    // 否则默认全部关闭
    state.loadingMain = 0;
  }
};

var COLLAPSE_MENU = function COLLAPSE_MENU(state) {
  var collapse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  state.collapseMenu = collapse;
};

var SET_AUTO_COLLAPSE_MENU = function SET_AUTO_COLLAPSE_MENU(state) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  state.autoCollapseMenu = !!value;
  localStorage.setItem('autoCollapseMenu', String(state.autoCollapseMenu));
};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./app-banner/app-banner.store.js": 577,
	"./app-popup/app-popup.store.js": 578,
	"./area/area.store.js": 579,
	"./audit-batchjob/audit-batchjob.store.js": 580,
	"./audit-intern/audit-intern.store.js": 581,
	"./city-map/city-map.store.js": 582,
	"./clb-alipay-flow/clb-alipay-flow.store.js": 583,
	"./clb-product-area/clb-product-area.store.js": 584,
	"./clb-product-category/clb-product-category.store.js": 585,
	"./clb-product/clb-product.store.js": 586,
	"./clb-step-template/clb-step-template.store.js": 587,
	"./clb-task-template/clb-task-template.store.js": 588,
	"./customer-batch/customer-batch.store.js": 589,
	"./customer-project/customer-project.store.js": 590,
	"./customer-projectcost/customer-projectcost.store.js": 591,
	"./customer-receipt/customer-receipt.store.js": 592,
	"./customer-task/customer-task.store.js": 593,
	"./customer/customer.store.js": 594,
	"./executive-budget/executive-budget.store.js": 595,
	"./fair-prize/fairPrize.store.js": 596,
	"./fair-reward/fairReward.store.js": 597,
	"./fair-upload/fairUpload.store.js": 598,
	"./fair/fair.store.js": 599,
	"./finance-config/finance-config.store.js": 600,
	"./finance/finance.store.js": 601,
	"./flbanner/flbanner.store.js": 602,
	"./group-batch/group-batch.store.js": 603,
	"./img-flow-config/img-flow-config.store.js": 604,
	"./img-flow-model/img-flow-model.store.js": 605,
	"./img-flow-order/img-flow-order.store.js": 606,
	"./img-flow-product/img-flow-product.store.js": 607,
	"./intelligent-outbound-call/intelligent-outbound-call.store.js": 608,
	"./invoice-apply/invoice-apply.store.js": 262,
	"./issue/issue.store.js": 609,
	"./launch-page-activity/launch-page-activity.store.js": 610,
	"./login/login.store.js": 611,
	"./market-ng/market-ng.store.js": 613,
	"./market/market.store.js": 614,
	"./midan/midan.store.js": 615,
	"./middle-end-task/middle-end-task.store.js": 616,
	"./occupation-questionnaire/occupation-questionnaire.store.js": 617,
	"./occupation/occupation.store.js": 618,
	"./order-image-recapture-detection/order-image-recapture-detection.store.js": 619,
	"./order-review/order-review.store.js": 620,
	"./order/order.store.js": 633,
	"./pay-conditions/pay-conditions.store.js": 634,
	"./payment-approval-new/payment-approval.store.js": 635,
	"./payment-approval/payment-approval.store.js": 636,
	"./payment-manager-new/payment-manager.store.js": 637,
	"./payment-manager/payment-manager.store.js": 638,
	"./payment-refund/payment-refund.store.js": 639,
	"./permission-apply/permission-apply.store.js": 640,
	"./permission-group/permission-group.store.js": 641,
	"./platform-androidapk-test/platform-androidapk-test.store.js": 642,
	"./platform-department/platform-department.store.js": 643,
	"./platform-role/platform-role.store.js": 644,
	"./platform-user-province/platform-user-province.store.js": 645,
	"./platform-user-whitelist/platform-user-whitelist.store.js": 761,
	"./platform-user/platform-user.store.js": 762,
	"./platform/platform.store.js": 763,
	"./position/position.store.js": 764,
	"./price-batch/price-batch.store.js": 767,
	"./project/project.store.js": 768,
	"./question-error-message/question-error-message.store.js": 769,
	"./received-payment/received-payment.store.js": 770,
	"./resume/resume.store.js": 771,
	"./satisfaction-email/satisfaction-email.store.js": 772,
	"./settings/settings.store.js": 773,
	"./step-template/step-template.store.js": 774,
	"./store-collection/store.collection.store.js": 775,
	"./task-batch/task-batch.store.js": 776,
	"./task-notice/task-notice.store.js": 777,
	"./task-order/task-order.store.js": 778,
	"./task/task.store.js": 779,
	"./teke-customer/tekeCustomer.store.js": 780,
	"./teke-order/tekeOrder.store.js": 781,
	"./teke-tag/tekeTag.store.js": 782,
	"./user-order-stat/userOrderStat.store.js": 783,
	"./user-tag/userTag.store.js": 784,
	"./user-workinfo/user-workinfo.store.js": 785,
	"./users/users.store.js": 786,
	"./work-info-business-type/work-info-business-type.store.js": 787,
	"./work-info-company/work-info-company.store.js": 788,
	"./work-info-work-type/work-info-work-type.store.js": 789
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 576;

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appBanner", function() { return appBanner; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var appBanner = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appPopup", function() { return appPopup; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var appPopup = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return area; });
// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
var state = {
  cascaderAreas: []

  // getters
};var getters = {}
// user: state => state.user


// actions
;var actions = {
  getProvinces: function getProvinces(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    return request.alert('getProvinces', params);
  },
  getCities: function getCities(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return request.alert('getCities', params);
  },
  getDistricts: function getDistricts(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return request.alert('getDistricts', params);
  }
};

// mutations
var mutations = {
  SET_AREA_CASCADER_AREAS: function SET_AREA_CASCADER_AREAS(state, value) {
    state.cascaderAreas = value;
  }
};

var area = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditCrontab", function() { return auditCrontab; });
// initial state
var state = {
  status: [{ value: 1, label: '待执行' }, { value: 2, label: '运行中' }, { value: 3, label: '失败' }, { value: 4, label: '处理结束' }, { value: 5, label: '已取消' }, { value: 6, label: '中断执行' }],
  task_type: [{ value: 1, label: '批量添加实习生' }, { value: 2, label: '批量导出实习生' }, // 目前采用前端导出,此任务不会出现
  { value: 3, label: '批量修改实习生' }, { value: 4, label: '批量导入项目出勤安排' }, { value: 5, label: '批量修改项目出勤安排' }]
};
var getters = {};
var actions = {};
var mutations = {};
var auditCrontab = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditIntern", function() { return auditIntern; });
// initial state
var state = {
  employmentTypeMap: { 1: '实习生', 2: '兼职' },
  educationLevelMap: { 1: '专科', 2: '本科', 3: '研究生' },
  officeLocationMap: {
    1: '临港',
    2: '陆家嘴',
    3: '客户公司',
    4: '线上',
    5: '成都',
    6: '其他'
  },
  gradeLevelMap: {
    1: '大一',
    2: '大二',
    3: '大三',
    4: '大四',
    5: '研一',
    6: '研二',
    7: '研三',
    8: '已毕业'
  },
  statusMap: { 1: '活跃', 2: '待机', 3: '离职' }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var auditIntern = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cityMap", function() { return cityMap; });
// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]

var state = {
  options: {
    levels: [{ label: '一线城市', value: 1 }, { label: '新一线城市', value: 2 }, { label: '二线城市', value: 3 }, { label: '三线城市', value: 4 }, { label: '四线城市', value: 5 }, { label: '五线城市', value: 6 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var cityMap = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbAlipayFlow", function() { return clbAlipayFlow; });
// initial state
var state = {
  tradeStatus: {
    'WAIT_BUYER_PAY': '等待付款', // 交易创建，等待买家付款。
    'TRADE_CLOSED': '已关闭', // 在指定时间段内未支付时关闭的交易；在交易完成全额退款成功时关闭的交易。
    'TRADE_SUCCESS': '充值成功', // 交易成功，且可对该交易做操作，如：多级分润、退款等。
    'TRADE_PENDING': '等待收款', // 等待卖家收款（买家付款后，如果卖家账号被冻结）。
    'TRADE_FINISHED': '交易成功', // 交易成功且结束，即不可再做任何操作。
    'TRADE_ABNORMAL': '交易异常' // 交易异常,支付宝反馈数据与服务器数据不一致。
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var clbAlipayFlow = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbProductArea", function() { return clbProductArea; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var clbProductArea = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbProductCategory", function() { return clbProductCategory; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var clbProductCategory = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbProduct", function() { return clbProduct; });
// initial state
var state = {
  types: {
    0: 'SKU',
    1: '品牌',
    2: '活动'
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var clbProduct = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbStepTemplate", function() { return clbStepTemplate; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var clbStepTemplate = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbTaskTemplate", function() { return clbTaskTemplate; });
// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
var state = {
  typeOptions: [{
    label: '理货',
    value: 0,
    points: 30
  }, {
    label: '招聘',
    value: 1,
    points: 0
  }, {
    label: '促销',
    value: 2,
    points: 0
  }, {
    label: '派发',
    value: 3,
    points: 0
  }, {
    label: '市调',
    value: 4,
    points: 20
  }, {
    label: '数据',
    value: 5,
    points: 35
  }, {
    label: '悬赏',
    value: 6,
    points: 50
  }, {
    label: '审核',
    value: 7,
    points: 0
  }, {
    label: '录入',
    value: 8,
    points: 0
  }, {
    label: '其他',
    value: 10,
    points: 30
  }, {
    label: '扫码',
    value: 14,
    points: 0
  }, {
    label: '活动',
    value: 15,
    points: 0
  }, {
    label: '考试',
    value: 16,
    points: 0
  }]

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var clbTaskTemplate = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerBatch", function() { return customerBatch; });
// initial state
var state = {
  incr_salary: {
    options: {
      status: [{ label: '新创建', value: 0 }, { label: '加值中', value: 1 }, { label: '加值完成', value: 2 }, { label: '恢复中', value: 3 }, { label: '恢复完成', value: 4 }, { label: '无效', value: 5 }],
      type: [{ label: '百分比', value: 1 }, { label: '固定金额', value: 2 }]
    },
    STATUS_CREATED: 0,
    STATUS_PROCESSING: 1,
    STATUS_PROCESSED: 2,
    STATUS_RECOVERING: 3,
    STATUS_RECOVERED: 4,
    STATUS_INVALID: 5
  }

  // getters
};var getters = {};

// actions
var actions = {
  getCustomerBatchTable: function getCustomerBatchTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getCustomerBatchTable', params);
    return promised;
  },
  getCustomerBatchDetail: function getCustomerBatchDetail(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('getCustomerBatchDetail', params);
    return promised;
  },
  createCustomerBatchData: function createCustomerBatchData(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('createCustomerBatchData', params);
    return promised;
  },
  updateCustomerBatchData: function updateCustomerBatchData(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('updateCustomerBatchData', params);
    return promised;
  },
  deleteCustomerBatchData: function deleteCustomerBatchData(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('deleteCustomerBatchData', params);
    return promised;
  }
};

// mutations
var mutations = {};

var customerBatch = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerProject", function() { return customerProject; });
// initial state
var state = {
  TYPE_NORMAL: 1,
  TYPE_CENTER_STAGE: 2,
  type: [{ value: 1, label: '普通项目' }, { value: 2, label: '中台项目' }],
  projectLevel: [{ value: 1, label: 'A' }, { value: 2, label: 'B' }, { value: 3, label: 'C' }, { value: 4, label: 'S' }],
  reviewGroup: [{ value: 1, label: '项目负责人' }, { value: 2, label: '全职审核团队' }, { value: 3, label: '实习生组长' }, { value: 4, label: '无需审单' }],
  distributeType: [
  // 5,6 已经合并至 综合服务-渠道管理
  // 2,3 为历史数据，仅支持查看，修改时不可选择
  // 2021-08-24 [1,4] 取消，仅支持查看，修改时不可选择，同时新增条目，并按照xlsx表格给出的顺序排序
  { value: 13, label: '众包服务-终端观测' }, { value: 14, label: '众包服务-合规保障' }, { value: 15, label: '众包服务-消费体验' }, { value: 16, label: '众包服务-共享理货' }, { value: 17, label: '众包服务-流动拜访' }, { value: 18, label: '众包服务-库存盘点' }, { value: 19, label: '众包服务-商品鉴别' }, { value: 8, label: '数字服务-复杂标注' }, { value: 7, label: '数字服务-智能拓店' }, { value: 20, label: '数字服务-智能识别' }, { value: 21, label: '数字服务-智能排程' }, { value: 22, label: '数字服务-数据清洗' }, { value: 23, label: '数字服务-系统开发' }, { value: 24, label: '数字服务-RPA' }, { value: 25, label: '数字服务-爱数智' }, { value: 9, label: '综合服务-灵活用功' }, { value: 5, label: '综合服务-渠道管理' }, { value: 10, label: '综合服务-零工交付' }, { value: 11, label: '其他服务-非业务用' }, { value: 12, label: '其他服务-其他业务' },

  // 以下部分为废弃部分，历史数据展示需要用到
  { value: 1, label: '众包服务-众包执行' }, { value: 2, label: '渠道发放(带审核)' }, { value: 3, label: '渠道发放(不带审核)' }, { value: 4, label: '众包服务-数据支持' }]

  // getters
};var getters = {};

// actions
var actions = {
  getCustomerProjectTable: function getCustomerProjectTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    return request.alert('getCustomerProjectTable', params);
  }
};

// mutations
var mutations = {};

var customerProject = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerProjectcost", function() { return customerProjectcost; });
// initial state
var projectStatusEnum = {
  OPEN: 1,
  REVIEW: 20,
  ACHIEVEMENT: 30,
  CLOSE: 40,
  BU_APPROVE: 50,
  FIRST_APPROVE: 60,
  SECOND_APPROVE: 70,
  REJECTED: 80

};

var projectArchiveStatusEnum = {
  NO: 0,
  YES: 1
};

var projectNeedApprove = {
  NEED_BU_APPROVE: 1,
  NEED_FIRST_APPROVE: 2,
  NEED_SECOND_APPROVE: 3,
  NEED_FINANCE_APPROVE: 4
};

var state = {
  options: {
    status: [{ label: '开立', value: projectStatusEnum.OPEN }, { label: '审核中', value: projectStatusEnum.REVIEW }, { label: '审核中', value: projectStatusEnum.BU_APPROVE }, { label: '审核中', value: projectStatusEnum.FIRST_APPROVE }, { label: '审核中', value: projectStatusEnum.SECOND_APPROVE }, { label: '完成', value: projectStatusEnum.ACHIEVEMENT }, { label: '关闭', value: projectStatusEnum.CLOSE }, { label: '已驳回', value: projectStatusEnum.REJECTED }],
    approve_status: [{ label: '待BO审批', value: projectNeedApprove.NEED_BU_APPROVE }, { label: '待一级审批', value: projectNeedApprove.NEED_FIRST_APPROVE }, { label: '待二级审批', value: projectNeedApprove.NEED_SECOND_APPROVE }, { label: '待财务审批', value: projectNeedApprove.NEED_FINANCE_APPROVE }],
    archive_status: [{ label: '未归档', value: projectArchiveStatusEnum.NO }, { label: '已归档', value: projectArchiveStatusEnum.YES }],
    project_status: [{ label: '开立', value: [projectStatusEnum.OPEN], key: 1 }, {
      label: '审核中',
      value: [projectStatusEnum.REVIEW, projectStatusEnum.BU_APPROVE, projectStatusEnum.FIRST_APPROVE, projectStatusEnum.SECOND_APPROVE],
      key: 2
    }, { label: '完成', value: [projectStatusEnum.ACHIEVEMENT], key: 3 }, { label: '关闭', value: [projectStatusEnum.CLOSE], key: 4 }, { label: '已驳回', value: [projectStatusEnum.REJECTED], key: 5 }]
  },
  statusEnum: projectStatusEnum

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var customerProjectcost = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerReceipt", function() { return customerReceipt; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var customerReceipt = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerTask", function() { return customerTask; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {
  getCustomerTaskTable: function getCustomerTaskTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getCustomerTaskTable', params);
    return promised;
  }
};

// mutations
var mutations = {};

var customerTask = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customer", function() { return customer; });
// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]

var state = {
  options: {
    showInStatistics: [{ label: '不显示', value: '0' }, { label: '显示', value: '1' }],
    customerRelationshipType: [{ label: '无', value: '0' }, { label: '首次合作', value: '1' }, { label: '常规客户', value: '2' }, { label: '潜在客户', value: '3' }]
  },
  selectedCustomer: null,
  selectedCustomerDetail: null,
  types: [10, // 大客户
  20, // 查理宝客户
  30, // 星火客户
  40, // 标注客户
  50, // TEKE客户
  60, // 健臻客户
  70]

  // getters
};var getters = {}
// user: state => state.user


// actions
;var actions = {
  getCustomerTable: function getCustomerTable(_ref, params) {
    var commit = _ref.commit;

    var promised = request.alert('getCustomerTable', params);
    return promised;
  },
  getCustomerDetail: function getCustomerDetail(_ref2, params) {
    var commit = _ref2.commit;

    var promised = request.alert('getCustomerDetail', params);
    return promised;
  }
};

// mutations
var mutations = {
  SELECTED_CUSTOMER: function SELECTED_CUSTOMER(state, data) {
    state.selectedCustomer = data;
  },
  SELECTED_CUSTOMER_DETAIL: function SELECTED_CUSTOMER_DETAIL(state, data) {
    state.selectedCustomerDetail = data;
  }
};

var customer = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "executiveBudget", function() { return executiveBudget; });
// initial state
var state = {
  options: {
    status: [{ label: '新创建', value: 1 }, { label: '待审批', value: 2 }, { label: '已通过', value: 3 }, { label: '已驳回', value: 4 }],
    approveStatus: [{ label: '新创建', value: 0 }, { label: '待审批', value: 1 }, { label: '已通过', value: 2 }, { label: '已驳回', value: 3 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var executiveBudget = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairPrize", function() { return fairPrize; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getFairPrizeTable: function getFairPrizeTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getFairPrizeTable', params);
    return promised;
  },
  deleteFairPrize: function deleteFairPrize(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('deleteFairPrize', id);
    return promised;
  },
  createFairPrize: function createFairPrize(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('createFairPrize', params);
    return promised;
  },
  editFairPrize: function editFairPrize(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('editFairPrize', params);
    return promised;
  },
  getFairPrizeDetail: function getFairPrizeDetail(_ref5, id) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('getFairPrizeDetail', id);
    return promised;
  },
  getFairPrizeOptions: function getFairPrizeOptions(_ref6) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('getFairPrizeOptions');
    return promised;
  },
  uploadFairPrizeImg: function uploadFairPrizeImg(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('uploadFairPrizeImg', params);
    return promised;
  },
  getFairPrizeLogList: function getFairPrizeLogList(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getFairPrizeLogList', params);
    return promised;
  }
};

// mutations
var mutations = {};

var fairPrize = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairReward", function() { return fairReward; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getFairRewardTable: function getFairRewardTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getFairRewardTable', params);
    return promised;
  },
  addRewardLogistics: function addRewardLogistics(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('addRewardLogistics', params);
    return promised;
  },
  getLogisticsCompany: function getLogisticsCompany(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('getLogisticsCompany', params);
    return promised;
  },
  getRewardLogistics: function getRewardLogistics(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('getRewardLogistics', id);
    return promised;
  }
};

// mutations
var mutations = {};

var fairReward = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairUpload", function() { return fairUpload; });
// initial state
// shape: [{ id, quantity }]
var state = {
  userOptions: []

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getFairDeliverUpload: function getFairDeliverUpload(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getFairDeliverUpload', params);
    return promised;
  },
  downFairSourceFile: function downFairSourceFile(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('downFairSourceFile', params);
    return promised;
  },
  downFairErrorFile: function downFairErrorFile(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('downFairErrorFile', params);
    return promised;
  },
  editRewardLogistics: function editRewardLogistics(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('editRewardLogistics', params);
    return promised;
  },
  uploadFairFile: function uploadFairFile(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('uploadFairFile', params);
    return promised;
  }
};

// mutations
var mutations = {};

var fairUpload = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fair", function() { return fair; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getFairTable: function getFairTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getFairTable', params);
    return promised;
  },
  offlineFair: function offlineFair(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('offlineFair', id);
    return promised;
  },
  releaseFair: function releaseFair(_ref3, id) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('releaseFair', id);
    return promised;
  },
  uploadFair: function uploadFair(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('uploadFair', params);
    return promised;
  },
  createFair: function createFair(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('createFair', params);
    return promised;
  },
  editFair: function editFair(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('editFair', params);
    return promised;
  },
  getFairOptions: function getFairOptions(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('getFairOptions', params);
    return promised;
  },
  getFair: function getFair(_ref8, id) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getFair', id);
    return promised;
  },
  deleteFair: function deleteFair(_ref9, id) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('deleteFair', id);
    return promised;
  },
  getFairPrizeNumber: function getFairPrizeNumber(_ref10, id) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('getFairPrizeNumber', id);
    return promised;
  },
  getFairUserLimit: function getFairUserLimit(_ref11, params) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('getFairUserLimit', params);
    return promised;
  },
  searchUserList: function searchUserList(_ref12, params) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('searchUserList', params);
    return promised;
  },
  getProjectTable: function getProjectTable(_ref13, params) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('getProjectTable', params);
    return promised;
  },
  getProjectDetail: function getProjectDetail(_ref14, params) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var promised = request.alert('getProjectDetail', params);
    return promised;
  },
  getAreaChain: function getAreaChain(_ref15, params) {
    var commit = _ref15.commit,
        state = _ref15.state;

    var promised = request.alert('getAreaChain', params);
    return promised;
  }
};

// mutations
var mutations = {};

var fair = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "financeConfig", function() { return financeConfig; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var financeConfig = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finance", function() { return finance; });
// initial state
// shape: [{ id, quantity }]
var state = {
  userOptions: [],
  options: {
    status: [{ label: '入账', value: 0 }, { label: '提现处理中', value: 1 }, { label: '财务处理中', value: 2 }, { label: '提现操作完成', value: 3 }, { label: '提现操作被驳回', value: 4 }, { label: '退回赏金', value: 5 }, { label: '购物消费', value: 80 }, { label: '消费退款', value: 81 }, { label: '交易冲正', value: 82 }, { label: '兑换', value: 99 }],
    withdrawtype: [{ label: '银行卡', value: 0 }, { label: '支付宝', value: 1 }, { label: '批量提现（银行卡）', value: 2 }, { label: '批量提现（银行卡 全部）', value: 3 }, { label: '批量提现（支付宝）', value: 4 }, { label: '批量提现（支付宝 全部）', value: 5 }, { label: '微信', value: 6 }],
    withdraw_type: [{ value: '-1', label: '未知' }, { value: '0', label: '银行卡自主' }, { value: '1', label: '支付宝自主' }, { value: '2', label: '批量银行卡' }, { value: '3', label: '批量银行卡全部' }, { value: '4', label: '批量支付宝' }, { value: '5', label: '批量支付宝全部' }, { value: '6', label: '微信提现打款' }]
  }

  // getters
};var getters = {
  // demoTable: state => state.table
};

var actions = {
  submitBatchWithdraw: function submitBatchWithdraw(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('submitBatchWithdraw', params);
    return promised;
  },
  batchWithdrawList: function batchWithdrawList(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('batchWithdrawList', params);
    return promised;
  },
  downBatchSourceFile: function downBatchSourceFile(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('downBatchSourceFile', params);
    return promised;
  },
  batchWithdrawBatchList: function batchWithdrawBatchList(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('batchWithdrawBatchList', params);
    return promised;
  },
  batchWithdrawBatchDetail: function batchWithdrawBatchDetail(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('batchWithdrawBatchDetail', params);
    return promised;
  },
  batchWithdrawBatchConfirm: function batchWithdrawBatchConfirm(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('batchWithdrawBatchConfirm', params);
    return promised;
  },
  batchWithdrawBatchRollback: function batchWithdrawBatchRollback(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('batchWithdrawBatchRollback', params);
    return promised;
  },
  batchWithdrawBatchSummary: function batchWithdrawBatchSummary(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('batchWithdrawBatchSummary', params);
    return promised;
  }
};

// mutations
var mutations = {};

var finance = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flbanner", function() { return flbanner; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getFlBannerTable: function getFlBannerTable(_ref, id) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getFlBannerTable', id);
    return promised;
  },
  deleteFlBanner: function deleteFlBanner(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('deleteFlBanner', id);
    return promised;
  },
  createFlBanner: function createFlBanner(_ref3, id) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('createFlBanner', id);
    return promised;
  },
  editFlBanner: function editFlBanner(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('editFlBanner', id);
    return promised;
  },
  getFlBanner: function getFlBanner(_ref5, id) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('getFlBanner', id);
    return promised;
  },
  uploadFlBanner: function uploadFlBanner(_ref6, id) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('uploadFlBanner', id);
    return promised;
  },
  getFlBannerLogTable: function getFlBannerLogTable(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('getFlBannerLogTable', params);
    return promised;
  }
};

// mutations
var mutations = {};

var flbanner = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBatch", function() { return groupBatch; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var groupBatch = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowConfig", function() { return imgFlowConfig; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var imgFlowConfig = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowModel", function() { return imgFlowModel; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var imgFlowModel = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowOrder", function() { return imgFlowOrder; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var imgFlowOrder = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowProduct", function() { return imgFlowProduct; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var imgFlowProduct = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intelligentOutboundCall", function() { return intelligentOutboundCall; });
// initial state
var state = {
  status: {
    1: '新创建',
    2: '进行中',
    3: '已完成'
  },
  callStatus: {
    1: '待呼叫',
    2: '不呼叫',
    3: '已接通',
    4: '未接通',
    5: '失败'
  },
  recordStatus: {
    1: '等待通知',
    2: '接通',
    3: '未接通',
    4: '拨打失败'
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var intelligentOutboundCall = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "issue", function() { return issue; });
// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getIssueDetail: function getIssueDetail(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getIssueDetail', params);
    return promised;
  },
  getIssueLogs: function getIssueLogs(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('getIssueLogs', params);
    return promised;
  },
  createIssue: function createIssue(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('createIssue', params);
    return promised;
  },
  updateIssueUser: function updateIssueUser(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('updateIssueUser', params);
    return promised;
  },
  updateIssueOpen: function updateIssueOpen(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('updateIssueOpen', params);
    return promised;
  },
  updateIssueFinish: function updateIssueFinish(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('updateIssueFinish', params);
    return promised;
  },
  updateIssueFinishAndOrderNotPassed: function updateIssueFinishAndOrderNotPassed(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('updateIssueFinishAndOrderNotPassed', params);
    return promised;
  },
  updateIssueWait: function updateIssueWait(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('updateIssueWait', params);
    return promised;
  },
  addIssueComment: function addIssueComment(_ref9, params) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('addIssueComment', params);
    return promised;
  }
};

// mutations
var mutations = {};

var issue = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "launchPageActivity", function() { return launchPageActivity; });
// initial state
var state = {
  options: {
    status: [{ label: '新创建', value: 0 }, { label: '上线', value: 1 }, { label: '下线', value: 2 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var launchPageActivity = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(77);



// initial state
// shape: [{ id, quantity }]
var state = {
  // 自动获取已登录的用户信息
  user: Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["e" /* login */])() || {},
  permissions: JSON.parse(localStorage.getItem('permissions') || '[]'),
  apiPermissions: JSON.parse(localStorage.getItem('apiPermissions') || '[]')

  // getters
};var getters = {
  user: function user(state) {
    return state.user;
  },
  permissions: function permissions(state) {
    return state.permissions;
  },
  apiPermissions: function apiPermissions(state) {
    return state.apiPermissions;
  }

  // actions
};var actions = {
  login: function login(_ref, params) {
    var commit = _ref.commit;

    var promised = request.alert('login', params);
    return promised;
  },
  refreshToken: function refreshToken(_ref2, params) {
    var commit = _ref2.commit;

    var promised = request.alert('refreshToken', params);
    return promised;
  },
  getPermission: function getPermission(_ref3, params) {
    var commit = _ref3.commit;

    var promised = request.alert('getPermission', params);
    return promised;
  },
  getApiPermission: function getApiPermission(_ref4, params) {
    var commit = _ref4.commit;

    var promised = request.alert('getApiPermission', params);
    return promised;
  }
};

// mutations
var mutations = {
  LOGIN: function LOGIN(state, token) {
    // 解析用户信息
    var userInfo = Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["e" /* login */])(token);
    // 获取到用户信息
    if (userInfo) {
      // 置入用户信息
      userInfo.customerIdArr = userInfo.customerid.split(',').map(function (item) {
        return parseInt(item.trim(), 10);
      }).filter(function (item) {
        return !isNaN(item);
      });
      state.user = userInfo;
    }
  },
  LOGOUT: function LOGOUT(state) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["f" /* logout */])();
    state.user = {};
  },
  SET_PERMISSIONS: function SET_PERMISSIONS(state, data) {
    state.permissions = data.map(function (val) {
      return Number(val);
    });
    localStorage.setItem('permissions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.permissions));
  },
  SET_API_PERMISSIONS: function SET_API_PERMISSIONS(state, data) {
    var apiPermissions = [];
    if (data.roles && data.roles.length > 0) {
      apiPermissions = _.map(data.roles, 'permissions');
      apiPermissions = apiPermissions.reduce(function (res, cur) {
        return res.concat(cur);
      });
      apiPermissions = _.map(apiPermissions, 'as');
    }
    if (data.permissions && data.permissions.length > 0) {
      apiPermissions = apiPermissions.concat(_.map(data.permissions, 'as'));
    }

    apiPermissions = _.union(apiPermissions);
    state.apiPermissions = apiPermissions;
    localStorage.setItem('apiPermissions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.apiPermissions));
  }
};

var login = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 612 */,
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "marketNg", function() { return marketNg; });
var state = {
  options: {
    status: [{ value: 1, label: '门店更名' }, { value: 2, label: '店名一致但门店闭店/装修/歇业' }, { value: 3, label: '该区域/地址没有指定门店' }]
  }
};

var getters = {};
var actions = {};
var mutations = {};

var marketNg = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "market", function() { return market; });
// initial state
// shape: [{ id, quantity }]
var state = {
  options: {
    city_level: [{ label: '一线城市', value: 1 }, { label: '新一线城市', value: 2 }, { label: '二线城市', value: 3 }, { label: '三线城市', value: 4 }, { label: '四线城市', value: 5 }, { label: '五线城市', value: 6 }],
    market_size: [{ label: '大卖场', value: 1 }, { label: '大型超市', value: 2 }, { label: '小超市', value: 3 }, { label: '便利店', value: 4 }, { label: '其他', value: 5 }],
    is_chain: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
    map_type: [{ label: '百度', value: 0 }, { label: '高德', value: 1 }],
    status: [{ label: '正常营业', value: 1 }, { label: '闭店', value: 10 }, { label: '查无此店', value: 20 }],
    isee: [{ label: '否', value: 0 }, { label: '是', value: 10 }],
    markettype: [{ label: 'NKA', value: 10, disabled: true }, { label: '大型连锁综合超市', value: 11 }, { label: '大型独立综合超市', value: 12 }, { label: 'LKA', value: 70, disabled: true }, { label: '精品超市', value: 80 }, { label: '中型超市', value: 20 }, { label: '生鲜超市', value: 21 }, { label: '小型超市', value: 22 }, { label: '连锁便利店', value: 30 }, { label: '日用食杂店', value: 31 }, { label: '水果店', value: 32 }, { label: '粮油店', value: 33 }, { label: '烟酒专卖店', value: 34 }, { label: '快时尚百货', value: 35 }, { label: '母婴店', value: 40 }, { label: '加油站便利店', value: 50 }, { label: '百货商场', value: 100 }, { label: '休闲娱乐场所', value: 150, disabled: true }, { label: '酒吧', value: 151 }, { label: '网吧', value: 152 }, { label: 'KTV', value: 153 }, { label: '服装饰品', value: 154 }, { label: '文具用品', value: 165 }, { label: '医药用品店', value: 90 }, { label: '私营小店', value: 130, disabled: true }, { label: '餐饮店', value: 180 }, { label: '宠物店', value: 200 }, { label: '数码家电', value: 210 }, { label: '美妆护理店', value: 220 }, { label: '私营卖场', value: 230, disabled: true }, { label: '健身场所', value: 240 }, { label: '汽配修理', value: 250 }, { label: '楼宇大厦', value: 260 }, { label: '宴席(2)', value: 92 }, { label: '其他', value: 60 }],
    gatherinfo_status: [{ label: '不收集', value: 1 }, { label: '待收集', value: 2 }, { label: '收集中', value: 3 }, { label: '收集完成', value: 4 }, { label: '信息确认', value: 5, disabled: true }],
    areatype: [{ label: '未知', value: 0 }, { label: '1000-2000m²', value: 1 }, { label: '500-1000m²', value: 2 }, { label: '300-500m²', value: 3 }, { label: '小于300m²', value: 4 }],
    freezerStatus: [{ label: '未知', value: 0 }, { label: '两者都有', value: 1 }, { label: '有冷柜无冷藏', value: 2 }, { label: '有冷藏无冷柜', value: 3 }, { label: '两者都无', value: 4 }],
    storeStatus: [{ label: '未知', value: 0 }, { label: '天猫小店', value: 1 }, { label: '苏宁小店', value: 2 }, { label: '京东便利店', value: 3 }, { label: '其他', value: 4 }]
  }

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {};

// mutations
var mutations = {};

var market = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "midan", function() { return midan; });
// initial state
var state = {
  options: {
    status: {
      0: '已关闭',
      1: '已开启'
    },
    type: [{ label: '批次配置', value: 1 }, { label: '项目配置', value: 0 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var midan = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "middleEndTask", function() { return middleEndTask; });
var state = {
  approveStatus: [{ label: '待审批', value: 0 }, { label: '已通过', value: 1 }, { label: '已驳回', value: 2 }]

  // mutations
};var mutations = {};

var middleEndTask = {
  namespaced: true,
  state: state,
  mutations: mutations
};

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "occupationQuestionnaire", function() { return occupationQuestionnaire; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var occupationQuestionnaire = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "occupation", function() { return occupation; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var occupation = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderImageRecaptureDetection", function() { return orderImageRecaptureDetection; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var orderImageRecaptureDetection = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderReview", function() { return orderReview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_order_order_api_js__ = __webpack_require__(153);

// import * as types from '@store/mutation-types'


// initial state
// shape: [{ id, quantity }]
var state = {
  orderDetail: {},
  questionContainerElement: null,
  photoCount: 0,
  cacheAnswers: null,
  errorMessages: [],
  isHistoryAnswer: false,

  // sjf 业务
  sjfOrderDetail: {},

  // 任务审核参照数据
  taskAuditReference: null,

  // 工单 ASR 风险检查结果
  asrCheckResult: null,
  // 点击风险标签后待跳转：{ recordUrl, beginMs, alias }
  asrCheckSeek: null,
  // 工单对应的申诉单（含 status 等），由 fetchOrderAppeal 统一拉取，避免重复请求
  orderAppeal: null,
  orderAppealLoading: false

  // getters
};var getters = {
  isReviewPermission: function isReviewPermission(state, getters, rootState, rootGetters) {
    var user = rootState.login.user;
    var permissions = rootGetters.permissions;
    // 用户审核权限
    return user.usertype === '1' || permissions.includes(20) || permissions.includes(21);
  },
  allowOrderReview: function allowOrderReview(state, getters, rootState, rootGetters) {
    var detail = state.orderDetail;
    return !detail.locked && // 锁定工单
    detail.status === '4' && // 工单状态: 待审核
    getters.isReviewPermission && // 用户审核权限
    !state.isHistoryAnswer; // 查看历史审核答案
  },
  allowUserModifyAnswer: function allowUserModifyAnswer(state, getters, rootState, rootGetters) {
    var detail = state.orderDetail;
    var user = rootState.login.user;
    var permissions = rootGetters.permissions;
    return !detail.locked && detail.status === '5' && !getters.allowLiveOrderReview && (user.usertype === '1' || permissions.includes(222)) && detail.type !== '8';
  },
  allowModifyAnswer: function allowModifyAnswer(state, getters, rootState, rootGetters) {
    return getters.allowUserModifyAnswer || getters.allowOrderReview;
  },
  // 工单申诉审核：申诉中(status 20)的工单允许编辑证据
  allowOrderAppealReview: function allowOrderAppealReview(state, getters, rootState, rootGetters) {
    var detail = state.orderDetail;
    return !detail.locked && String(detail.status) === '20' && getters.isReviewPermission && !state.isHistoryAnswer;
  },
  allowLiveOrderReview: function allowLiveOrderReview(state, getters, rootState, rootGetters) {
    var detail = state.orderDetail;
    return detail.type === '19';
  }

  // actions
};var actions = {
  getOrderDetail: {
    handler: function handler(_ref, params) {
      var commit = _ref.commit,
          state = _ref.state;

      var promised = request.alert('getOrderDetail', params);
      return promised;
    }
  },
  setOrderDetail: {
    root: true,
    handler: function handler(_ref2, params) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          state = _ref2.state;

      var promised = dispatch('getOrderDetail', params);
      promised.then(function (res) {
        commit('SET_ORDER_DETAIL_DATA', res.data);
      }, Function.prototype);
      return promised;
    }
  },
  updateOrderReviewAnswer: {
    root: true,
    handler: function handler(_ref3, params) {
      var commit = _ref3.commit,
          state = _ref3.state;

      var promised = request.alert('updateOrderReviewAnswer', params);
      return promised;
    }
  },
  uploadOrderReviewFile: {
    root: true,
    handler: function handler(_ref4, params) {
      var commit = _ref4.commit,
          state = _ref4.state;

      var promised = request.alert('uploadOrderReviewDirectFile', params);
      return promised;
    }
  },
  reviewOrderPass: {
    root: true,
    handler: function handler(_ref5, params) {
      var commit = _ref5.commit,
          state = _ref5.state;

      var promised = request.alert('reviewOrderPass', params);
      return promised;
    }
  },
  reviewOrderNotPass: {
    root: true,
    handler: function handler(_ref6, params) {
      var commit = _ref6.commit,
          state = _ref6.state;

      var promised = request.alert('reviewOrderNotPass', params);
      return promised;
    }
  },
  lockOrder: {
    root: true,
    handler: function handler(_ref7, params) {
      var commit = _ref7.commit,
          state = _ref7.state;

      var promised = request.alert('lockOrder', params);
      return promised;
    }
  },
  findRecognitionResults: {
    root: true,
    handler: function handler(_ref8, params) {
      var commit = _ref8.commit,
          state = _ref8.state;

      var promised = request.alert('findRecognitionResults', params);
      return promised;
    }
  },
  reviewClbOrderPass: {
    root: true,
    handler: function handler(_ref9, params) {
      var commit = _ref9.commit,
          state = _ref9.state;

      var promised = request.alert('reviewClbOrderPass', params);
      return promised;
    }
  },
  checkOrderStatus: {
    root: true,
    handler: function handler(_ref10, params) {
      var commit = _ref10.commit,
          state = _ref10.state;

      var promised = request.alert('checkOrderStatus', params);
      return promised;
    }
  },
  // 拉取工单对应的申诉单（申诉审核页与申诉详情面板共享，只请求一次）
  fetchOrderAppeal: {
    handler: function handler(_ref11, _ref12) {
      var commit = _ref11.commit,
          state = _ref11.state;
      var id = _ref12.id;

      if (!id) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
      commit('SET_ORDER_APPEAL_LOADING', true);
      return Object(__WEBPACK_IMPORTED_MODULE_1__views_order_order_api_js__["getOrderAppealByOrderIdApi"])({ id: id }).then(function (res) {
        var body = res && (res.data || res.detail) || {};
        var appeal = body.detail ? body.detail : body;
        // 申诉单关闭后接口可能不再返回该记录，保留已加载的数据，避免面板闪现“暂无申诉信息”
        if (appeal && appeal.status !== undefined) {
          commit('SET_ORDER_APPEAL', appeal);
        }
        return appeal;
      }).catch(function () {
        // 网络异常也保留已加载数据
      }).finally(function () {
        commit('SET_ORDER_APPEAL_LOADING', false);
      });
    }
  }

  // mutations
};var mutations = {
  SET_ORDER_DETAIL_DATA: function SET_ORDER_DETAIL_DATA(state, data) {
    data.locked = data.locked === '1';
    state.orderDetail = data;
    state.isHistoryAnswer = false;
  },

  // sjf 业务
  SET_SJF_ORDER_DETAIL_DATA: function SET_SJF_ORDER_DETAIL_DATA(state, data) {
    state.sjfOrderDetail = data;
  },
  SET_TASK_AUDIT_REFERENCE: function SET_TASK_AUDIT_REFERENCE(state, data) {
    state.taskAuditReference = data || null;
  },
  LOCK_ORDER: function LOCK_ORDER(state) {
    state.orderDetail.locked = !state.orderDetail.locked;
  },
  SET_QUESTION_CONTAINER_ELEMENT: function SET_QUESTION_CONTAINER_ELEMENT(state, value) {
    state.questionContainerElement = value;
  },
  SET_CACHE_ANSWERS: function SET_CACHE_ANSWERS(state, value) {
    state.cacheAnswers = value;
  },
  SET_HISTORY_ANSWERS: function SET_HISTORY_ANSWERS(state, value) {
    state.cacheAnswers = value;
    state.isHistoryAnswer = true;
  },
  SET_PHOTO_COUNT: function SET_PHOTO_COUNT(state, value) {
    state.photoCount = value;
  },
  SET_ERROR_MESSAGES: function SET_ERROR_MESSAGES(state, value) {
    state.errorMessages = value;
  },
  SET_ASR_CHECK_RESULT: function SET_ASR_CHECK_RESULT(state, value) {
    state.asrCheckResult = value || null;
  },
  SET_ASR_CHECK_SEEK: function SET_ASR_CHECK_SEEK(state, value) {
    state.asrCheckSeek = value || null;
  },
  SET_ORDER_APPEAL: function SET_ORDER_APPEAL(state, data) {
    state.orderAppeal = data;
  },
  SET_ORDER_APPEAL_LOADING: function SET_ORDER_APPEAL_LOADING(state, value) {
    state.orderAppealLoading = value;
  }
};

var orderReview = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "order", function() { return order; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

// initial state
var state = {
  options: {
    type: [{ label: '检查', value: 4, desc: '(常规检查)' }, { label: '理货', value: 0, desc: '(理货盘库)', disabledForCreate: true, deprecated: true },
    // {label: '招聘', value: 1},
    // {label: '促销', value: 2},
    // {label: '派发', value: 3},
    // {label: '数据', value: 5},
    { label: '悬赏', value: 6, desc: '(销售)', disabledForCreate: true, deprecated: true },
    // {label: '审核', value: 7},
    { label: '录入', value: 8, desc: '(考试)', disabledForCreate: true }, { label: '其他', value: 10, desc: '(录入)', disabledForCreate: true, deprecated: true },
    // {label: '体验', value: 11},
    // {label: '互动', value: 12},
    // {label: '分享', value: 13},
    // {label: '扫码', value: 14},
    { label: '活动', value: 15, desc: '', disabledForCreate: true, deprecated: true }, { label: '考试', value: 16 }, { label: '推广', value: 18, desc: '(无法归入上述任一类型)', disabledForCreate: true, deprecated: true }, { label: '直播', value: 19, disabledForCreate: true, deprecated: true }, { label: '门店验证', value: 20 }, { label: '爱数智', value: 21, desc: '', disabledForCreate: true }, { label: '米单', value: 127 }, { label: '信息流', value: 22 }, { label: '宴席', value: 23, disabledForCreate: true }, { label: '理货', value: 24, desc: '' }, { label: '盘库', value: 25, desc: '' }, { label: '人员', value: 26, desc: '' }, { label: '神访', value: 27, desc: '' }, { label: '体验', value: 28, desc: '' }, { label: '推广', value: 29, desc: '' }, { label: '宴席(2)', value: 30, disabledForCreate: true }],
    allType: [{ label: '理货', value: 0 }, { label: '招聘', value: 1 }, { label: '促销', value: 2 }, { label: '派发', value: 3 }, { label: '检查', value: 4 }, { label: '数据', value: 5 }, { label: '悬赏', value: 6 }, { label: '审核', value: 7 }, { label: '录入', value: 8 }, { label: '其他', value: 10 }, { label: '体验', value: 11 }, { label: '互动', value: 12 }, { label: '分享', value: 13 }, { label: '扫码', value: 14 }, { label: '活动', value: 15 }, { label: '考试', value: 16 }, { label: 'Teke', value: 17 }, { label: '推广', value: 18 }, { label: '直播', value: 19 }, { label: '检查-门店验证', value: 20 }, { label: '爱数智', value: 21 }, { label: '米单', value: 127 }, { label: '信息流', value: 22 }, { label: '宴席', value: 23 }, { label: '理货', value: 24 }, { label: '盘库', value: 25 }, { label: '人员', value: 26 }, { label: '神访', value: 27 }, { label: '体验', value: 28 }, { label: '推广', value: 29 }, { label: '宴席(2)', value: 30 }],
    status: [{ label: '订单新创建', value: 0 }, { label: '等待抢单', value: 1 }, { label: '已抢单', value: 2 }, { label: '进行中', value: 3 }, { label: '待审核', value: 4 }, { label: '管理员复审', value: 40 }, { label: '审核通过', value: 5 }, { label: '已关闭', value: -1 }, { label: '审核未通过', value: -2 }, { label: '已删除', value: -3 }, { label: '已下线', value: 10 }, { label: '申诉中', value: 20 }],
    taskstatus: [{ label: '订单新创建', value: 0 }, { label: '等待抢单', value: 1 }, { label: '已抢单', value: 2 }, { label: '已关闭', value: -1 }, { label: '已下线', value: 10 }],
    orderstatus: [{ label: '已抢单', value: 2 }, { label: '进行中', value: 3 }, { label: '待审核', value: 4 }, { label: '管理员复审', value: 40 }, { label: '审核通过', value: 5 }, { label: '已关闭', value: -1 }, { label: '审核未通过', value: -2 },
    // {label: '已下线', value: 10},
    { label: '申诉中', value: 20 }],
    cstaskstatus: [{ label: '未创建', value: 0 }, { label: '已创建', value: 1 }, { label: '冲突', value: 2 }, { label: '通过', value: 3 }, { label: '未通过', value: 4 }, { label: '无照片', value: 5 }, { label: '复核通过', value: 6 }, { label: '复核未通过', value: 7 }],
    taskmarketareaid: [{ label: '进口区', value: 1 }, { label: '休食区', value: 2 }, { label: '乳品区', value: 3 }, { label: '调料区', value: 4 }, { label: '冻品区', value: 5 }, { label: '饮料区', value: 6 }, { label: '粮油区', value: 7 }, { label: '纸品区', value: 8 }, { label: '日化区', value: 9 }, { label: '育婴区', value: 10 }, { label: '散货区', value: 11 }, { label: '百货区', value: 12 }, { label: '服装区', value: 13 }, { label: '鞋帽区', value: 14 }, { label: '生鲜区', value: 15 }, { label: '果蔬区', value: 16 }, { label: '酒水区', value: 17 }, { label: '其他区', value: 18 }, { label: '全卖场', value: 19 }],
    locked: [{ label: '锁定', value: 1 }, { label: '未锁定', value: 10 }],
    cacheuploadstatus: [{ label: '任务直接上传', value: 0 }, { label: '任务缓存上传开始', value: 10 }, { label: '任务缓存上传结束', value: 20 }],
    gpsCheck: [{ label: '验证', value: 1 }, { label: '不验证', value: 0 }],
    priority: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
    nearby: [{ label: '准许', value: 1 }, { label: '不准许', value: 0 }],
    inhouseprior: [{ label: '优先', value: 1 }, { label: '不优先', value: 0 }],
    superuserprior: [{ label: '优先', value: 1 }, { label: '不优先', value: 0 }],
    multitimes: [{ label: '允许', value: 1 }, { label: '不允许', value: 0 }],
    rejectuserrepeat: [{ label: '允许', value: 1 }, { label: '不允许', value: 0 }],
    rejecttaskrepeat: [{ label: '允许', value: 1 }, { label: '不允许', value: 0 }],
    ostype: [{ label: '全部', value: 0 }, { label: 'Android平台', value: 10 }, { label: 'iOS平台', value: 20 }],
    platformtype: [{ label: '全选', value: 9 }, { label: '爱零工', value: 0 }, { label: '查理宝', value: 8 }],
    onlynearby: [{ label: '全部位置', value: 0 }, { label: '仅周边赚', value: 1 }],
    isInAudit: [{ label: '审核中', value: true }, { label: '未审核', value: false }],
    allow_coupon: [{ label: '允许', value: 1 }, { label: '不允许', value: 0 }],
    use_servercache: [{ label: '开启', value: 1 }, { label: '关闭', value: 0 }],
    personface_verify: [{ label: '开启', value: 1 }, { label: '关闭', value: 0 }],
    face_verified: [{ label: '未验证', value: 0 }, { label: '通过', value: 1 }, { label: '不通过', value: 2 }],
    addto_taskgroup_target_num: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
    app_type_list: [{ label: '爱零工', value: 1 }, { label: '查理宝', value: 2 }]
  }

  // getters
};var getters = {
  getSortedTaskTypes: function getSortedTaskTypes(state) {
    var taskTypes = _.cloneDeep(state.options.type);
    return taskTypes.sort(function (a, b) {
      return (a.deprecated ? 1 : 0) - (b.deprecated ? 1 : 0);
    }).map(function (item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, { label: item.deprecated ? item.label + '(\u5DF2\u5F03\u7528)' : item.label });
    });
  }

  // actions
};var actions = {};

// mutations
var mutations = {};

var order = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "payConditions", function() { return payConditions; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var payConditions = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentApprovalNew", function() { return paymentApprovalNew; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var paymentApprovalNew = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentApproval", function() { return paymentApproval; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var paymentApproval = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentManagerNew", function() { return paymentManagerNew; });
// initial state
var state = {
  // 付款类型：
  type: {
    1: '员工报销',
    2: '对公付款',
    3: '预付费用',
    4: '批量付款',
    5: '爱绩效发放'
  },
  // 一级科目
  firstSubjects: {
    1: '库存商品-wip',
    2: '管理费用',
    3: '销售费用',
    4: '主营业务收入',
    5: '财务费用',
    6: '营业外支出',
    7: '应交税费',
    8: '预付账款',
    9: '其他应收账款'
  },
  // 二级科目
  secondSubjects: {
    1: '供应商货款',
    2: '零工服务费',
    3: '快递费',
    4: '交通费',
    5: '住宿费',
    6: '餐费',
    7: '客情费',
    8: '房屋租金',
    9: '物业费',
    10: '水电费',
    11: '办公费',
    12: '固定资产',
    13: '研发费',
    14: '咨询和审计费',
    15: '会议费',
    16: '装潢修理费',
    17: '员工福利费',
    18: '推广费',
    19: '销售退回',
    20: '贷款利息',
    21: '工资',
    22: '绩效工资',
    23: '实习生工资',
    24: '年终奖',
    25: '社保',
    26: '公积金',
    27: '违约金',
    28: '滞纳金',
    29: '进项税额',
    30: '销项税额',
    31: '个人所得税',
    32: '个人借款备用金',
    33: '租赁保证金',
    34: '比稿保证金',
    35: '往来款',
    36: '其他'
  },
  // 付款公司：
  paymentCompanys: {
    1: '小零',
    2: '零启',
    3: '数饮',
    4: '蹦蹦兔',
    5: '小零北京分公司',
    6: '强仝',
    7: '碧于蓝'
  },
  // 付款渠道类型
  paymentChannelTypes: {
    1: '单笔付款',
    2: '零工提现'
  },
  // 付款账户类型
  paymentAccountTypes: {
    1: '银行卡',
    2: '支付宝',
    3: '微信'
  },
  // 发票类型
  invoiceType: {
    1: '普票',
    2: '专票',
    3: '其他'
  },
  taxRateType: {
    1: '1%',
    3: '3%',
    5: '5%',
    6: '6%',
    9: '9%',
    13: '13%'
  },
  status: {
    1: '待一级审批',
    2: '待二级审批',
    3: '待三级审批',
    4: '待四级审批',
    5: '待费用会计审批',
    6: '待财务经理审批',
    7: '待付款',
    8: '已付款',
    9: '付款失败',
    10: '已部分付款',
    11: '待修改',
    12: '已放弃',
    13: '待部门领导审批',
    14: '待特批审批',
    15: '拒付',
    16: '支付中',
    17: '支付异常'
    // 财务审批
    // 会计审批
  },
  searchPaymentStatus: [{ key: '7', label: '待付款' }, { key: '15', label: '拒付' }, { key: '8', label: '已付款' }, { key: '9', label: '付款失败' }, { key: '10', label: '已部分付款' }, { key: '11', label: '待修改' }, { key: '12', label: '已放弃' }, { key: '16', label: '支付中' }, { key: '17', label: '支付异常' }],
  searchApproveStatus: [{ key: '13', label: '待部门领导审批' }, { key: '1', label: '待一级审批' }, { key: '2', label: '待二级审批' }, { key: '3', label: '待三级审批' }, { key: '4', label: '待四级审批' }, { key: '14', label: '待特批人审批' }, { key: '5', label: '待费用会计审批' }, { key: '6', label: '待财务经理审批' }],
  writeOffStatus: {
    // 0: '无需冲销',
    1: '未冲销',
    2: '部分冲销',
    3: '已冲销'
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var paymentManagerNew = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentManager", function() { return paymentManager; });
// initial state
var state = {
  // 付款类型：
  type: {
    1: '员工报销',
    2: '对公付款',
    3: '预付费用',
    4: '批量付款',
    5: '爱绩效发放'
  },
  // 一级科目
  firstSubjects: {
    1: '库存商品-wip',
    2: '管理费用',
    3: '销售费用',
    4: '主营业务收入',
    5: '财务费用',
    6: '营业外支出',
    7: '应交税费',
    8: '预付账款',
    9: '其他应收账款'
  },
  // 二级科目
  secondSubjects: {
    1: '供应商货款',
    2: '零工服务费',
    3: '快递费',
    4: '交通费',
    5: '住宿费',
    6: '餐费',
    7: '客情费',
    8: '房屋租金',
    9: '物业费',
    10: '水电费',
    11: '办公费',
    12: '固定资产',
    13: '研发费',
    14: '咨询和审计费',
    15: '会议费',
    16: '装潢修理费',
    17: '员工福利费',
    18: '推广费',
    19: '销售退回',
    20: '贷款利息',
    21: '工资',
    22: '绩效工资',
    23: '实习生工资',
    24: '年终奖',
    25: '社保',
    26: '公积金',
    27: '违约金',
    28: '滞纳金',
    29: '进项税额',
    30: '销项税额',
    31: '个人所得税',
    32: '个人借款备用金',
    33: '租赁保证金',
    34: '比稿保证金',
    35: '往来款',
    36: '其他'
  },
  // 付款公司：
  paymentCompanys: {
    1: '小零',
    2: '零启',
    3: '数饮',
    4: '蹦蹦兔',
    5: '小零北京分公司',
    6: '强仝',
    7: '碧于蓝'
  },
  // 发票类型
  invoiceType: {
    1: '普票',
    2: '专票',
    3: '其他'
  },
  taxRateType: {
    1: '1%',
    3: '3%',
    5: '5%',
    6: '6%',
    9: '9%',
    13: '13%'
  },
  status: {
    1: '待一级审批',
    2: '待二级审批',
    3: '待三级审批',
    4: '待四级审批',
    5: '待费用会计审批',
    6: '待财务经理审批',
    7: '待付款',
    8: '已付款',
    9: '付款失败',
    10: '已部分付款',
    11: '待修改',
    12: '已放弃',
    13: '待部门领导审批',
    14: '待特批审批',
    15: '拒付'
    // 财务审批
    // 会计审批
  },
  searchPaymentStatus: [{ key: '7', label: '待付款' }, { key: '15', label: '拒付' }, { key: '8', label: '已付款' }, { key: '9', label: '付款失败' }, { key: '10', label: '已部分付款' }, { key: '11', label: '待修改' }, { key: '12', label: '已放弃' }],
  searchApproveStatus: [{ key: '13', label: '待部门领导审批' }, { key: '1', label: '待一级审批' }, { key: '2', label: '待二级审批' }, { key: '3', label: '待三级审批' }, { key: '4', label: '待四级审批' }, { key: '14', label: '待特批人审批' }, { key: '5', label: '待费用会计审批' }, { key: '6', label: '待财务经理审批' }],
  writeOffStatus: {
    // 0: '无需冲销',
    1: '未冲销',
    2: '部分冲销',
    3: '已冲销'
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var paymentManager = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentRefund", function() { return paymentRefund; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var paymentRefund = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissionApply", function() { return permissionApply; });
// initial state
var state = {
  options: {
    status: [{ label: '待审批', value: 1 }, { label: '通过', value: 2 }, { label: '不通过', value: 3 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var permissionApply = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissionGroup", function() { return permissionGroup; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {
  getPermissionTable: function getPermissionTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getPermissionTable', params);
    return promised;
  },
  getPermissionGroupTable: function getPermissionGroupTable(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('getPermissionGroupTable', params);
    return promised;
  },
  getPermissionGroupDetail: function getPermissionGroupDetail(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('getPermissionGroupDetail', params);
    return promised;
  },
  exportPermissionGroupData: function exportPermissionGroupData(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('exportPermissionGroupData', params);
    return promised;
  },
  createPermissionGroupData: function createPermissionGroupData(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('createPermissionGroupData', params);
    return promised;
  },
  updatePermissionGroupData: function updatePermissionGroupData(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('updatePermissionGroupData', params);
    return promised;
  },
  deletePermissionGroupData: function deletePermissionGroupData(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('deletePermissionGroupData', params);
    return promised;
  },
  savePermissionGroupData: function savePermissionGroupData(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('savePermissionGroupData', params);
    return promised;
  }
};

// mutations
var mutations = {};

var permissionGroup = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformAndroidapkTest", function() { return platformAndroidapkTest; });
// initial state
var state = {
  options: {
    status: [{ label: '是', value: 0 }, { label: '否', value: 1 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var platformAndroidapkTest = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformDepartment", function() { return platformDepartment; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getDepartmentsIndex: function getDepartmentsIndex(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('getDepartmentsIndex', params);
  },
  getAllDepartments: function getAllDepartments(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('getAllDepartments', params);
  },
  getDepartmentDetail: function getDepartmentDetail(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('getDepartmentDetail', params);
  },
  addDepartment: function addDepartment(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;
    return request.alert('addDepartment', params);
  },
  editDepartment: function editDepartment(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return request.alert('editDepartment', params);
  },
  deleteDepartment: function deleteDepartment(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return request.alert('deleteDepartment', params);
  }

  // mutations
};var mutations = {};

var platformDepartment = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformRole", function() { return platformRole; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getRolesIndex: function getRolesIndex(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('getRolesIndex', params);
  },
  getRoleDetail: function getRoleDetail(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('getRoleDetail', params);
  },
  addRole: function addRole(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('addRole', params);
  },
  editRole: function editRole(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;
    return request.alert('editRole', params);
  },
  copyRole: function copyRole(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return request.alert('copyRole', params);
  },
  deleteRole: function deleteRole(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return request.alert('deleteRole', params);
  }

  // mutations
};var mutations = {};

var platformRole = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUserProvince", function() { return platformUserProvince; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(646);


// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {
  updatePlatformUserProvince: function updatePlatformUserProvince(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].updatePlatformUserProvince(params);
    return promised;
  },
  getPlatformUsersProvince: function getPlatformUsersProvince(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getPlatformUsersProvince(params);
    return promised;
  }
};

// mutations
var mutations = {};

var platformUserProvince = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 载入 views 目录下所有文件模块
var api = __webpack_require__(96).requires(__webpack_require__(214));

/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppBannerTable", function() { return getAppBannerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppBannerDetail", function() { return getAppBannerDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportAppBannerData", function() { return exportAppBannerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAppBannerData", function() { return createAppBannerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAppBannerData", function() { return updateAppBannerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAppBannerData", function() { return deleteAppBannerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppBannerLogs", function() { return getAppBannerLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadAppBanner", function() { return uploadAppBanner; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getAppBannerTable = function getAppBannerTable(params) {
  return axios.post(base + "/app_banner/query", params);
};
var getAppBannerDetail = function getAppBannerDetail(params) {
  return axios.get(base + "/app_banner/get_" + params.id, { params: params });
};
var exportAppBannerData = function exportAppBannerData(params) {
  return axios.get(base + "/exportAppBannerData/" + params.id, { params: params });
};
var createAppBannerData = function createAppBannerData(params) {
  return axios.post(base + "/app_banner/create", params);
};
var updateAppBannerData = function updateAppBannerData(params) {
  return axios.post(base + "/app_banner/edit_" + params.id, params);
};
var deleteAppBannerData = function deleteAppBannerData(params) {
  return axios.post(base + "/app_banner/delete_" + params.id, params);
};
var getAppBannerLogs = function getAppBannerLogs(params) {
  return axios.post(base + "/app_banner/op_logs_" + params.id, params);
};

var uploadAppBanner = function uploadAppBanner(params) {
  return axios.post(base + "/app_banner/upload", params);
};

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppPopupTable", function() { return getAppPopupTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppPopupDetail", function() { return getAppPopupDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportAppPopupData", function() { return exportAppPopupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAppPopupData", function() { return createAppPopupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAppPopupData", function() { return updateAppPopupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeStatus", function() { return changeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadImgFile", function() { return uploadImgFile; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getAppPopupTable = function getAppPopupTable(params) {
  return axios.post(base + "/popup/query", params);
};
var getAppPopupDetail = function getAppPopupDetail(params) {
  return axios.get(base + "/popup/get_" + params.id, { params: params });
};
var exportAppPopupData = function exportAppPopupData(params) {
  return axios.get(base + "/popup/query/" + params.id, { params: params });
};
var createAppPopupData = function createAppPopupData(params) {
  return axios.post(base + "/popup/create", params);
};
var updateAppPopupData = function updateAppPopupData(params) {
  return axios.post(base + "/popup/edit_" + params.id, params);
};
var changeStatus = function changeStatus(params) {
  return axios.post(base + "/popup/changeStatus", params);
};
var uploadImgFile = function uploadImgFile(params) {
  return axios.post(base + "/popup/uploadImgFile", params);
};

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProvinces", function() { return getProvinces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCities", function() { return getCities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDistricts", function() { return getDistricts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryCitymap", function() { return queryCitymap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAllFormatted", function() { return queryAllFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCityList", function() { return getCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProvinceList", function() { return getProvinceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAreaChain", function() { return getAreaChain; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getProvinces = function getProvinces(params) {
  return axios.get(base + "/provincelist", { params: params });
};

var getCities = function getCities(params) {
  return axios.get(base + "/citylist_" + params.pid, { params: params });
};

var getDistricts = function getDistricts(params) {
  return axios.get(base + "/arealist_" + params.pid, { params: params });
};

var queryCitymap = function queryCitymap(params) {
  return axios.get(base + "/query_citymap", { params: params });
};

var queryAllFormatted = function queryAllFormatted(params) {
  return axios.get(base + "/query_all_formatted_citymap", { params: params });
};

/**
 *
 *
 * @param id
 * @returns {*}
 */
var getCityList = function getCityList(id) {
  return axios.get(base + "/citylist_" + id);
};
/**
 *
 *
 * @param params
 * @returns {*}
 */
var getProvinceList = function getProvinceList(params) {
  return axios.get(base + "/provincelist");
};

/**
 * 根据区域id获取父级区域链
 *
 * @deprecated
 * @param id
 * @returns {*}
 */
var getAreaChain = function getAreaChain(id) {
  return axios.get(base + "/get_area_info_" + id);
};

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAudioAsrCheckTemplate", function() { return queryAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAudioAsrCheckTemplateSelect", function() { return queryAudioAsrCheckTemplateSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAudioAsrCheckTemplate", function() { return getAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAudioAsrCheckTemplate", function() { return createAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAudioAsrCheckTemplate", function() { return updateAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAudioAsrCheckTemplate", function() { return deleteAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyAudioAsrCheckTemplate", function() { return copyAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAudioAsrCheckPromptConfig", function() { return getAudioAsrCheckPromptConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "previewAudioAsrCheckPrompt", function() { return previewAudioAsrCheckPrompt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAudioAsrCheckBindBySubstep", function() { return getAudioAsrCheckBindBySubstep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listAudioAsrCheckBindByTemplate", function() { return listAudioAsrCheckBindByTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindAudioAsrCheckTemplate", function() { return bindAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unbindAudioAsrCheckTemplate", function() { return unbindAudioAsrCheckTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAudioAsrCheckOrderResult", function() { return queryAudioAsrCheckOrderResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAudioAsrCheckOrderResultSummary", function() { return queryAudioAsrCheckOrderResultSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "recheckAudioAsrCheckOrderResult", function() { return recheckAudioAsrCheckOrderResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryAudioAsrCheckProjectStats", function() { return queryAudioAsrCheckProjectStats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetAudioAsrCheckProjectLlm", function() { return resetAudioAsrCheckProjectLlm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);

var base = window._env_.VUE_APP_ADMIN_HOST;

var queryAudioAsrCheckTemplate = function queryAudioAsrCheckTemplate(params) {
  return axios.post(base + "/audio_asr_check_template/query", params);
};

var queryAudioAsrCheckTemplateSelect = function queryAudioAsrCheckTemplateSelect(params) {
  return axios.post(base + "/audio_asr_check_template/query_select", params);
};

var getAudioAsrCheckTemplate = function getAudioAsrCheckTemplate(params) {
  return axios.get(base + "/audio_asr_check_template/get_" + params.id, { params: params });
};

var createAudioAsrCheckTemplate = function createAudioAsrCheckTemplate(params) {
  return axios.post(base + "/audio_asr_check_template/create", params);
};

var updateAudioAsrCheckTemplate = function updateAudioAsrCheckTemplate(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ["id"]);

  return axios.post(base + "/audio_asr_check_template/edit_" + id, rest);
};


var deleteAudioAsrCheckTemplate = function deleteAudioAsrCheckTemplate(id) {
  return axios.post(base + "/audio_asr_check_template/delete_" + id);
};

var copyAudioAsrCheckTemplate = function copyAudioAsrCheckTemplate(id) {
  return axios.post(base + "/audio_asr_check_template/copy_" + id);
};

var getAudioAsrCheckPromptConfig = function getAudioAsrCheckPromptConfig(params) {
  return axios.post(base + "/audio_asr_check_template/prompt_config", params || {});
};

var previewAudioAsrCheckPrompt = function previewAudioAsrCheckPrompt(params) {
  return axios.post(base + "/audio_asr_check_template/preview_prompt", params);
};

var getAudioAsrCheckBindBySubstep = function getAudioAsrCheckBindBySubstep(params) {
  return axios.get(base + "/audio_asr_check_template_bind/get_by_substep_" + params.substepid, { params: params });
};

var listAudioAsrCheckBindByTemplate = function listAudioAsrCheckBindByTemplate(params) {
  return axios.get(base + "/audio_asr_check_template_bind/list_by_template_" + params.id, { params: params });
};

var bindAudioAsrCheckTemplate = function bindAudioAsrCheckTemplate(params) {
  return axios.post(base + "/audio_asr_check_template_bind/bind", params);
};

var unbindAudioAsrCheckTemplate = function unbindAudioAsrCheckTemplate(substepid) {
  return axios.post(base + "/audio_asr_check_template_bind/unbind_" + substepid);
};

var queryAudioAsrCheckOrderResult = function queryAudioAsrCheckOrderResult(params) {
  return axios.post(base + "/audio_asr_check_order_result/query", params);
};

var queryAudioAsrCheckOrderResultSummary = function queryAudioAsrCheckOrderResultSummary(params) {
  return axios.post(base + "/audio_asr_check_order_result/summary", params);
};

var recheckAudioAsrCheckOrderResult = function recheckAudioAsrCheckOrderResult(params) {
  return axios.post(base + "/audio_asr_check_order_result/recheck_" + params.orderid, params);
};

var queryAudioAsrCheckProjectStats = function queryAudioAsrCheckProjectStats(params) {
  return axios.post(base + "/audio_asr_check_project_stats/query", params);
};

var resetAudioAsrCheckProjectLlm = function resetAudioAsrCheckProjectLlm(params) {
  return axios.post(base + "/audio_asr_check_project_stats/reset_llm", params);
};

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryCrontabJobsApi", function() { return queryCrontabJobsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchExportAuditInternApi", function() { return batchExportAuditInternApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCreateInternApi", function() { return batchCreateInternApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchEditInternApi", function() { return batchEditInternApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchAddProjectAttendTargetApi", function() { return batchAddProjectAttendTargetApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchEditProjectAttendTargetApi", function() { return batchEditProjectAttendTargetApi; });
/* global process */
var base = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

var queryCrontabJobsApi = function queryCrontabJobsApi(params) {
  return axios.post(base + "/admin/crontab_jobs/query", params);
};
var batchExportAuditInternApi = function batchExportAuditInternApi(params) {
  return axios.post(base + "/admin/crontab_jobs/export_intern_user", params);
};
var batchCreateInternApi = function batchCreateInternApi(params) {
  return axios.post(base + "/admin/crontab_jobs/add_intern_user", params);
};
var batchEditInternApi = function batchEditInternApi(params) {
  return axios.post(base + "/admin/crontab_jobs/edit_intern_user", params);
};
var batchAddProjectAttendTargetApi = function batchAddProjectAttendTargetApi(params) {
  return axios.post(base + "/admin/crontab_jobs/add_project_attend_target", params);
};
var batchEditProjectAttendTargetApi = function batchEditProjectAttendTargetApi(params) {
  return axios.post(base + "/admin/crontab_jobs/edit_project_attend_target", params);
};

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["queryExamTaskTable"] = queryExamTaskTable;
/* harmony export (immutable) */ __webpack_exports__["queryAuditTaskSetting"] = queryAuditTaskSetting;
/* harmony export (immutable) */ __webpack_exports__["getExamTaskDetail"] = getExamTaskDetail;
/* harmony export (immutable) */ __webpack_exports__["createAuditTaskSetting"] = createAuditTaskSetting;
/* harmony export (immutable) */ __webpack_exports__["updateAuditTaskSetting"] = updateAuditTaskSetting;
/* harmony export (immutable) */ __webpack_exports__["deleteAuditTaskSetting"] = deleteAuditTaskSetting;
/* harmony export (immutable) */ __webpack_exports__["getAuditTaskSetting"] = getAuditTaskSetting;
/* harmony export (immutable) */ __webpack_exports__["enableAuditTaskSetting"] = enableAuditTaskSetting;
/* harmony export (immutable) */ __webpack_exports__["disableAuditTaskSetting"] = disableAuditTaskSetting;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


/* global process */


var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

// exam_task 列表，用于审单系统配置中选择 exam_task_cfg_id
function queryExamTaskTable(params, config) {
  // 兼容 remote-select 的输入：keyword 仅用于 id 精确匹配（数字时才下发）
  var keyword = params && (params.keyword || params.key || params.q);
  var id = keyword && String(keyword).match(/^\d+$/) ? Number(keyword) : undefined;
  var body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, params || {});
  body.id = id;
  body.current_page = body.current_page || 1;
  body.per_page = body.per_page || 50;
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/exam_task/query', body, config);
}

function queryAuditTaskSetting(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/audit_task_setting/query', params, config);
}

function getExamTaskDetail(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(orderAuditBase + '/admin/exam_task/get_' + params.id, config);
}

function createAuditTaskSetting(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/audit_task_setting/create', params, config);
}

function updateAuditTaskSetting(params, config) {
  var _ref = params || {},
      id = _ref.id,
      body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id']);

  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/audit_task_setting/update_' + id, body, config);
}

function deleteAuditTaskSetting(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/audit_task_setting/delete_' + params.id, {}, config);
}

function getAuditTaskSetting(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(orderAuditBase + '/admin/audit_task_setting/get_' + params.id, config);
}

function enableAuditTaskSetting(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/audit_task_setting/enable_' + params.id, {}, config);
}

function disableAuditTaskSetting(params, config) {
  return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(orderAuditBase + '/admin/audit_task_setting/disable_' + params.id, {}, config);
}

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryReturnOrderEvaluationTableApi", function() { return queryReturnOrderEvaluationTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryReturnOrderEvalEvaluatorOptionsApi", function() { return queryReturnOrderEvalEvaluatorOptionsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryReturnOrderEvalReturnAdminOptionsApi", function() { return queryReturnOrderEvalReturnAdminOptionsApi; });
/* global process */

var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

var queryReturnOrderEvaluationTableApi = function queryReturnOrderEvaluationTableApi(params) {
  return axios.post(orderAuditBase + "/admin/return-order-eval/query", params);
};

var queryReturnOrderEvalEvaluatorOptionsApi = function queryReturnOrderEvalEvaluatorOptionsApi(params) {
  return axios.get(orderAuditBase + "/admin/return-order-eval/evaluator-options", { params: params });
};

var queryReturnOrderEvalReturnAdminOptionsApi = function queryReturnOrderEvalReturnAdminOptionsApi(params) {
  return axios.get(orderAuditBase + "/admin/return-order-eval/return-admin-options", { params: params });
};

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["queryAuditTask"] = queryAuditTask;
/* harmony export (immutable) */ __webpack_exports__["createAuditTask"] = createAuditTask;
/* harmony export (immutable) */ __webpack_exports__["unlockAuditTask"] = unlockAuditTask;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

function queryAuditTask(params, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(orderAuditBase + '/admin/audit_task/query', params, config);
}

function createAuditTask(params, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(orderAuditBase + '/admin/audit_task/create', params, config);
}

function unlockAuditTask(params, config) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(orderAuditBase + '/admin/audit_task/unlock_' + params.id, {}, config);
}

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banquetTaskImportConfig", function() { return banquetTaskImportConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banquetTaskImport", function() { return banquetTaskImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banquetTaskQuery", function() { return banquetTaskQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banquetTaskGet", function() { return banquetTaskGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banquetTaskByTask", function() { return banquetTaskByTask; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var banquetTaskImportConfig = function banquetTaskImportConfig() {
  return axios.get(base + "/banquet_task/import_config");
};

var banquetTaskImport = function banquetTaskImport(params) {
  return axios.post(base + "/batch_jobs/batch_import_banquet_task", params);
};

var banquetTaskQuery = function banquetTaskQuery(params) {
  return axios.post(base + "/banquet_task/query", params);
};

var banquetTaskGet = function banquetTaskGet(id) {
  return axios.get(base + "/banquet_task/" + id);
};

var banquetTaskByTask = function banquetTaskByTask(params) {
  return axios.get(base + "/banquet_task/by_task_" + params.id);
};

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryWaitProcessJobsApi", function() { return queryWaitProcessJobsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryFinanceExportJobsApi", function() { return queryFinanceExportJobsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCollectionListApi", function() { return exportCollectionListApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCollectionDetailApi", function() { return exportCollectionDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportReceiptListApi", function() { return exportReceiptListApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPreReceiptListApi", function() { return exportPreReceiptListApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportReceiptCollectionApi", function() { return exportReceiptCollectionApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUnReceiptCollectionApi", function() { return exportUnReceiptCollectionApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportFinancePaymentListApi", function() { return exportFinancePaymentListApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportFinancePaymentDetailApi", function() { return exportFinancePaymentDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportFinanceWriteOffDetailApi", function() { return exportFinanceWriteOffDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportFinanceWriteOffStatusApi", function() { return exportFinanceWriteOffStatusApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "approveBatchJob", function() { return approveBatchJob; });
var base = window._env_.VUE_APP_ADMIN_HOST;
var finBase = window._env_.VUE_APP_FIN_CENTER_HOST;

var queryWaitProcessJobsApi = function queryWaitProcessJobsApi(params) {
  return axios.post(base + "/batch_jobs/all_batch_jobs", params);
};

var queryFinanceExportJobsApi = function queryFinanceExportJobsApi(params) {
  return axios.post(finBase + "/batch_jobs/query", params);
};

var exportCollectionListApi = function exportCollectionListApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_collection_list", params);
};

var exportCollectionDetailApi = function exportCollectionDetailApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_collection_detail", params);
};

var exportReceiptListApi = function exportReceiptListApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_receipt_list", params);
};
var exportPreReceiptListApi = function exportPreReceiptListApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_pre_receipt_list", params);
};

var exportReceiptCollectionApi = function exportReceiptCollectionApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_receipt_collection", params);
};
var exportUnReceiptCollectionApi = function exportUnReceiptCollectionApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_receipt_uncollection", params);
};
var exportFinancePaymentListApi = function exportFinancePaymentListApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_payment_list", params);
};
var exportFinancePaymentDetailApi = function exportFinancePaymentDetailApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_payment_detail", params);
};
var exportFinanceWriteOffDetailApi = function exportFinanceWriteOffDetailApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_payment_writeoff_detail", params);
};
var exportFinanceWriteOffStatusApi = function exportFinanceWriteOffStatusApi(params) {
  return axios.post(finBase + "/batch_jobs/finance/export_payment_writeoff_status", params);
};

var approveBatchJob = function approveBatchJob(params) {
  return axios.post(base + "/batch_jobs/approve_batch_job", params);
};

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchTable", function() { return getBatchTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchDetail", function() { return getBatchDetail; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getBatchTable = function getBatchTable(params) {
  return axios.post(base + "/query_batch", params);
};
var getBatchDetail = function getBatchDetail(params) {
  return axios.get(base + "/batch_" + params.id);
};

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBigDataResult", function() { return getBigDataResult; });
var base = window._env_.VUE_APP_ADMIN_HOST;
var getBigDataResult = function getBigDataResult(params) {
  return axios.post(base + "/data_screen/query_kanban_result", params);
};

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCitymapTable", function() { return getCitymapTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCitymapDetail", function() { return getCitymapDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCitymap", function() { return createCitymap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCitymap", function() { return updateCitymap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCitymap", function() { return deleteCitymap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCitySalary", function() { return getCitySalary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCitySalary", function() { return updateCitySalary; });
// /* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getCitymapTable = function getCitymapTable(params) {
  return axios.post(base + "/citymap/query", params);
};
var getCitymapDetail = function getCitymapDetail(params) {
  return axios.get(base + "/citymap/get_" + params.id);
};
var createCitymap = function createCitymap(params) {
  return axios.post(base + "/citymap/create", params);
};
var updateCitymap = function updateCitymap(params) {
  return axios.post(base + "/citymap/edit_" + params.id, params);
};
var deleteCitymap = function deleteCitymap(params) {
  return axios.post(base + "/citymap/delete_" + params.id, params);
};
var getCitySalary = function getCitySalary(params) {
  return axios.get(base + "/citymap/city_salary_" + params.id);
};
var updateCitySalary = function updateCitySalary(params) {
  return axios.post(base + "/citymap/save_city_salary_" + params.id, params);
};

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbAlipayFlowTable", function() { return getClbAlipayFlowTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbAlipayFlowDetail", function() { return getClbAlipayFlowDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportClbAlipayFlowData", function() { return exportClbAlipayFlowData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClbAlipayFlowData", function() { return createClbAlipayFlowData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClbAlipayFlowData", function() { return updateClbAlipayFlowData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClbAlipayFlowData", function() { return deleteClbAlipayFlowData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST + '/clb';
var getClbAlipayFlowTable = function getClbAlipayFlowTable(params) {
  return axios.post(base + '/query_alipay_flow', params);
};
var getClbAlipayFlowDetail = function getClbAlipayFlowDetail(params) {
  return axios.get(base + '/getClbAlipayFlowDetail/' + params.id, { params: params });
};
var exportClbAlipayFlowData = function exportClbAlipayFlowData(params) {
  return axios.get(base + '/exportClbAlipayFlowData/' + params.id, { params: params });
};
var createClbAlipayFlowData = function createClbAlipayFlowData(params) {
  return axios.post(base + '/createClbAlipayFlowData', params);
};
var updateClbAlipayFlowData = function updateClbAlipayFlowData(params) {
  return axios.post(base + '/updateClbAlipayFlowData/' + params.id, params);
};
var deleteClbAlipayFlowData = function deleteClbAlipayFlowData(params) {
  return axios.post(base + '/deleteClbAlipayFlowData/' + params.id, params);
};

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbProductAreaTable", function() { return getClbProductAreaTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbProductAreaDetail", function() { return getClbProductAreaDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClbProductAreaData", function() { return createClbProductAreaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClbProductAreaData", function() { return updateClbProductAreaData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClbProductAreaData", function() { return deleteClbProductAreaData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST + '/clb';
var getClbProductAreaTable = function getClbProductAreaTable(params) {
  return axios.post(base + '/query_product_class', params);
};
var getClbProductAreaDetail = function getClbProductAreaDetail(params) {
  return axios.get(base + '/get_product_class_' + params.id, { params: params });
};
// export const exportClbProductAreaData = params => {
//   return axios.get(`${base}/query_product_class_${params.id}`, {params})
// }
var createClbProductAreaData = function createClbProductAreaData(params) {
  return axios.post(base + '/create_product_class', params);
};
var updateClbProductAreaData = function updateClbProductAreaData(params) {
  return axios.post(base + '/modify_product_class_' + params.id, params);
};
var deleteClbProductAreaData = function deleteClbProductAreaData(params) {
  return axios.post(base + '/delete_product_class_' + params.id, params);
};

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbProductCategoryTable", function() { return getClbProductCategoryTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbProductCategoryDetail", function() { return getClbProductCategoryDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClbProductCategoryData", function() { return createClbProductCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClbProductCategoryData", function() { return updateClbProductCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClbProductCategoryData", function() { return deleteClbProductCategoryData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST + '/clb';
var getClbProductCategoryTable = function getClbProductCategoryTable(params) {
  return axios.post(base + '/query_product_category', params);
};
var getClbProductCategoryDetail = function getClbProductCategoryDetail(params) {
  return axios.get(base + '/get_product_category_' + params.id, { params: params });
};
// export const exportClbProductCategoryData = params => {
//   return axios.get(`${base}/exportClbProductCategoryData_${params.id}`, {params})
// }
var createClbProductCategoryData = function createClbProductCategoryData(params) {
  return axios.post(base + '/create_product_category', params);
};
var updateClbProductCategoryData = function updateClbProductCategoryData(params) {
  return axios.post(base + '/modify_product_category_' + params.id, params);
};
var deleteClbProductCategoryData = function deleteClbProductCategoryData(params) {
  return axios.post(base + '/delete_product_category_' + params.id, params);
};

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbProductTable", function() { return getClbProductTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbProductDetail", function() { return getClbProductDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportClbProductData", function() { return exportClbProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClbProductData", function() { return createClbProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClbProductData", function() { return updateClbProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClbProductData", function() { return deleteClbProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "moveClbProductTo", function() { return moveClbProductTo; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST + '/clb';
var getClbProductTable = function getClbProductTable(params) {
  return axios.post(base + '/query_product', params);
};
var getClbProductDetail = function getClbProductDetail(params) {
  return axios.get(base + '/getClbProductDetail/' + params.id, { params: params });
};
var exportClbProductData = function exportClbProductData(params) {
  return axios.get(base + '/exportClbProductData/' + params.id, { params: params });
};
var createClbProductData = function createClbProductData(params) {
  return axios.post(base + '/createClbProductData', params);
};
var updateClbProductData = function updateClbProductData(params) {
  return axios.post(base + '/updateClbProductData/' + params.id, params);
};
var deleteClbProductData = function deleteClbProductData(params) {
  return axios.post(base + '/deleteClbProductData/' + params.id, params);
};
var moveClbProductTo = function moveClbProductTo(params) {
  return axios.post(base + '/move_product', params);
};

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbStepTemplateTable", function() { return getClbStepTemplateTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbStepTemplateDetail", function() { return getClbStepTemplateDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportClbStepTemplateData", function() { return exportClbStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClbStepTemplateData", function() { return createClbStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClbStepTemplateData", function() { return updateClbStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClbStepTemplateData", function() { return deleteClbStepTemplateData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST + '/clb';
var getClbStepTemplateTable = function getClbStepTemplateTable(params) {
  return axios.post(base + '/query_substep', params);
};
var getClbStepTemplateDetail = function getClbStepTemplateDetail(params) {
  return axios.get(base + '/get_substep_' + params.id, { params: params });
};
var exportClbStepTemplateData = function exportClbStepTemplateData(params) {
  return axios.get(base + '/exportClbStepTemplateData/' + params.id, { params: params });
};
var createClbStepTemplateData = function createClbStepTemplateData(params) {
  return axios.post(base + '/create_substep', params);
};
var updateClbStepTemplateData = function updateClbStepTemplateData(params) {
  return axios.post(base + '/modify_substep_' + params.id, params);
};
var deleteClbStepTemplateData = function deleteClbStepTemplateData(params) {
  return axios.post(base + '/delete_substep_' + params.id, params);
};

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbTaskTemplateTable", function() { return getClbTaskTemplateTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClbTaskTemplate", function() { return createClbTaskTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getClbTaskTemplate", function() { return getClbTaskTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateClbTaskTemplate", function() { return updateClbTaskTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyClbTaskTemplateTable", function() { return copyClbTaskTemplateTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteClbTaskTemplateData", function() { return deleteClbTaskTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyClbTaskTemplateData", function() { return copyClbTaskTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showClbTaskTemplateData", function() { return showClbTaskTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideClbTaskTemplateData", function() { return hideClbTaskTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getClbTaskTemplateTable = function getClbTaskTemplateTable(params) {
  return axios.post(base + "/query_tasktpl", params);
};
var createClbTaskTemplate = function createClbTaskTemplate(params) {
  params.json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params.json);
  return axios.post(base + "/create_tasktpl", params);
};
var getClbTaskTemplate = function getClbTaskTemplate(params) {
  return axios.get(base + "/tasktpl_" + params.id);
};
var updateClbTaskTemplate = function updateClbTaskTemplate(params) {
  params.json = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params.json);
  return axios.post(base + "/modify_tasktpl_" + params.id, params);
};
var copyClbTaskTemplateTable = function copyClbTaskTemplateTable(params) {
  return axios.post(base + "/query_tasktpl", params);
};
var deleteClbTaskTemplateData = function deleteClbTaskTemplateData(params) {
  return axios.post(base + "/delete_tasktpl_" + params.id, params);
};
var copyClbTaskTemplateData = function copyClbTaskTemplateData(params) {
  return axios.post(base + "/copy_tasktpl_" + params.id, params);
};
var showClbTaskTemplateData = function showClbTaskTemplateData(params) {
  return axios.post(base + "/show_tasktpl_" + params.id, params);
};
var hideClbTaskTemplateData = function hideClbTaskTemplateData(params) {
  return axios.post(base + "/hide_tasktpl_" + params.id, params);
};

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyBankAccountTable", function() { return getCompanyBankAccountTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyBankAccountForSearch", function() { return getCompanyBankAccountForSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyBankAccountById", function() { return getCompanyBankAccountById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableCompanyBankAccount", function() { return enableCompanyBankAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableCompanyBankAccount", function() { return disableCompanyBankAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCompanyBankAccount", function() { return createCompanyBankAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCompanyBankAccount", function() { return updateCompanyBankAccount; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;
var getCompanyBankAccountTable = function getCompanyBankAccountTable(params) {
  return axios.post(base + "/company-accounts/list", params);
};

var getCompanyBankAccountForSearch = function getCompanyBankAccountForSearch(params) {
  return axios.post(base + "/company-accounts/query_remote_select", params);
};

var getCompanyBankAccountById = function getCompanyBankAccountById(params) {
  return axios.get(base + "/company-accounts/" + params.id, { params: params });
};

// 移除删除接口
// export const delCompanyBankAccountById = params => {
//   return axios.delete(`${base}/company-accounts/${params.id}`, {params})
// }

var enableCompanyBankAccount = function enableCompanyBankAccount(params) {
  return axios.post(base + "/company-accounts/" + params.id + "/enable", params);
};

var disableCompanyBankAccount = function disableCompanyBankAccount(params) {
  return axios.post(base + "/company-accounts/" + params.id + "/disable", params);
};

var createCompanyBankAccount = function createCompanyBankAccount(params) {
  return axios.post(base + "/company-accounts", params);
};

var updateCompanyBankAccount = function updateCompanyBankAccount(params) {
  return axios.put(base + "/company-accounts/" + params.id, params);
};

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCoverBatch", function() { return createCoverBatch; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var createCoverBatch = function createCoverBatch(params) {
  return axios.post(base + "/cover_estimate_upload", params);
};

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerBatchTable", function() { return getCustomerBatchTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCustomerBatchLog", function() { return exportCustomerBatchLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerBatchDetail", function() { return getCustomerBatchDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomerBatchData", function() { return createCustomerBatchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCustomerBatchData", function() { return updateCustomerBatchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomerBatchData", function() { return deleteCustomerBatchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerBatchPeriodTable", function() { return getCustomerBatchPeriodTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryCustomBatchTag", function() { return queryCustomBatchTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomBatchTag", function() { return createCustomBatchTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomBatchTag", function() { return deleteCustomBatchTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteBatchData", function() { return deleteBatchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindBatchTrainingInstruction", function() { return bindBatchTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querySalaryIncreasingCityTable", function() { return querySalaryIncreasingCityTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querySalaryIncreasingTable", function() { return querySalaryIncreasingTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSalaryIncreasingDetail", function() { return getSalaryIncreasingDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countSalaryIncreasingTask", function() { return countSalaryIncreasingTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "predictSalaryIncreasingTaskCost", function() { return predictSalaryIncreasingTaskCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectFrozenAmount", function() { return getProjectFrozenAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AddSalaryIncreasing", function() { return AddSalaryIncreasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editSalaryIncreasing", function() { return editSalaryIncreasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSalaryIncreasing", function() { return deleteSalaryIncreasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startSalaryIncreasing", function() { return startSalaryIncreasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startSalaryIncreasingMultiple", function() { return startSalaryIncreasingMultiple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restartSalaryIncreasing", function() { return restartSalaryIncreasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "recoverySalaryIncreasing", function() { return recoverySalaryIncreasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querySalaryIncreasingLogTable", function() { return querySalaryIncreasingLogTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryCityList", function() { return queryCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchPersonnelRequirementAPI", function() { return batchPersonnelRequirementAPI; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var getCustomerBatchTable = function getCustomerBatchTable(params) {
  return axios.post(base + "/statistic_projectbatch", params);
};
var exportCustomerBatchLog = function exportCustomerBatchLog(params) {
  return axios.post(base + "/export_batch_log", params);
};
var getCustomerBatchDetail = function getCustomerBatchDetail(params) {
  return axios.get(base + "/batch_" + params.id);
};
var createCustomerBatchData = function createCustomerBatchData(params) {
  return axios.post(base + "/create_batch", params);
};
var updateCustomerBatchData = function updateCustomerBatchData(params) {
  return axios.post(base + "/edit_batch_" + params.id, params);
};
var deleteCustomerBatchData = function deleteCustomerBatchData(params) {
  return axios.post(base + "/deleteCustomerBatchData/" + params.id, params);
};
var getCustomerBatchPeriodTable = function getCustomerBatchPeriodTable(params) {
  return axios.post(base + "/statistic_projectbatch_period_" + params.id, params);
};
var queryCustomBatchTag = function queryCustomBatchTag(params) {
  return axios.post(base + "/query_custom_batch_tag", params);
};
var createCustomBatchTag = function createCustomBatchTag(params) {
  return axios.post(base + "/create_custom_batch_tag", params);
};
var deleteCustomBatchTag = function deleteCustomBatchTag(params) {
  return axios.post(base + "/delete_custom_batch_tag_" + params.id, params);
};
var deleteBatchData = function deleteBatchData(params) {
  return axios.post(base + "/delete_batch_" + params.id);
};
var bindBatchTrainingInstruction = function bindBatchTrainingInstruction(params) {
  return axios.post(base + "/training_instruction/bind_batch_" + params.id, params);
};

var querySalaryIncreasingCityTable = function querySalaryIncreasingCityTable(params) {
  return axios.post(base + "/incr_salary/city_list", params);
};
var querySalaryIncreasingTable = function querySalaryIncreasingTable(params) {
  return axios.post(base + "/incr_salary/query", params);
};
var getSalaryIncreasingDetail = function getSalaryIncreasingDetail(params) {
  return axios.get(base + "/incr_salary/get_" + params.id);
};
var countSalaryIncreasingTask = function countSalaryIncreasingTask(params) {
  return axios.post(base + "/incr_salary/count_task", params);
};
var predictSalaryIncreasingTaskCost = function predictSalaryIncreasingTaskCost(params) {
  return axios.post(base + "/incr_salary/predict_cost", params);
};
var getProjectFrozenAmount = function getProjectFrozenAmount(params) {
  return axios.post(base + "/incr_salary/project_frozen_amount", params);
};
var AddSalaryIncreasing = function AddSalaryIncreasing(params) {
  return axios.post(base + "/incr_salary/create", params);
};
var editSalaryIncreasing = function editSalaryIncreasing(params) {
  return axios.post(base + "/incr_salary/edit_" + params.id, params);
};
var deleteSalaryIncreasing = function deleteSalaryIncreasing(params) {
  return axios.post(base + "/incr_salary/delete_" + params.id, params);
};
var startSalaryIncreasing = function startSalaryIncreasing(params) {
  return axios.post(base + "/incr_salary/start_" + params.id, params);
};
var startSalaryIncreasingMultiple = function startSalaryIncreasingMultiple(params) {
  return axios.post(base + "/incr_salary/start", params);
};
var restartSalaryIncreasing = function restartSalaryIncreasing(params) {
  return axios.post(base + "/incr_salary/restart_" + params.id, params);
};
var recoverySalaryIncreasing = function recoverySalaryIncreasing(params) {
  return axios.post(base + "/incr_salary/recovery_" + params.id, params);
};
var querySalaryIncreasingLogTable = function querySalaryIncreasingLogTable(params) {
  return axios.post(base + "/incr_salary/query_log", params);
};
var queryCityList = function queryCityList(params) {
  return axios.post(base + "/query_citylist", params);
};
var batchPersonnelRequirementAPI = function batchPersonnelRequirementAPI(params) {
  return axios.post(base + "/batch_jobs/batch_sync_personnel_requirement_to_task", params);
};

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerProjectReportTable", function() { return getCustomerProjectReportTable; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;

var getCustomerProjectReportTable = function getCustomerProjectReportTable(params) {
  return axios.post(base + "/receipt-applications/query_project_report", params);
};

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerProjectTable", function() { return getCustomerProjectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomerProject", function() { return createCustomerProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCustomerProject", function() { return updateCustomerProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCustomerProjectBeforeAudit", function() { return updateCustomerProjectBeforeAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProjectStatus", function() { return updateProjectStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProjectData", function() { return deleteProjectData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProjectFinanceData", function() { return updateProjectFinanceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectFinanceDetail", function() { return getProjectFinanceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProjectBudget", function() { return updateProjectBudget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProjectBudget4Ajx", function() { return updateProjectBudget4Ajx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectBudgetTable", function() { return getProjectBudgetTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectBudgetUseDetail", function() { return getProjectBudgetUseDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectFlowTable", function() { return getProjectFlowTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadProjectFile", function() { return uploadProjectFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectDefaultConfig", function() { return getProjectDefaultConfig; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var finBase = window._env_.VUE_APP_FIN_CENTER_HOST;

var getCustomerProjectTable = function getCustomerProjectTable(params) {
  return axios.post(base + "/statistic_project", params);
};
var createCustomerProject = function createCustomerProject(params) {
  return axios.post(base + "/create_project", params);
};
var updateCustomerProject = function updateCustomerProject(params) {
  return axios.post(base + "/edit_project_" + params.id, params);
};
var updateCustomerProjectBeforeAudit = function updateCustomerProjectBeforeAudit(params) {
  return axios.post(base + "/edit_project_unaudited_" + params.id, params);
};

var updateProjectStatus = function updateProjectStatus(params) {
  return axios.post(base + "/edit_project_status_" + params.id, params);
};
var deleteProjectData = function deleteProjectData(params) {
  return axios.post(base + "/delete_project_" + params.id);
};

// 财务信息
var updateProjectFinanceData = function updateProjectFinanceData(params) {
  return axios.post(base + "/edit_project_finance_" + params.id, params);
};
var getProjectFinanceDetail = function getProjectFinanceDetail(params) {
  return axios.get(base + "/get_project_finance_" + params.id, { params: params });
};

// 预算调整
var updateProjectBudget = function updateProjectBudget(params) {
  return axios.post(base + "/edit_project_budget_" + params.id, params);
};
var updateProjectBudget4Ajx = function updateProjectBudget4Ajx(params) {
  return axios.post(base + "/ajx/edit_project_budget_" + params.id, params);
};
var getProjectBudgetTable = function getProjectBudgetTable(params) {
  return axios.post(base + "/query_project_budget_" + params.projectid, params);
};

// 预算使用详情
var getProjectBudgetUseDetail = function getProjectBudgetUseDetail(params) {
  return axios.get(finBase + "/project/" + params.projectid + "/budget/statistic", { params: params });
};

// 项目明细
var getProjectFlowTable = function getProjectFlowTable(params) {
  return axios.post(base + "/query_project_flow_" + params.projectid, params);
};

// 项目明细
var uploadProjectFile = function uploadProjectFile(params) {
  return axios.post(base + "/project/uploadfile", params);
};

// 创建项目时获取默认配置（审批人，收件人等）
var getProjectDefaultConfig = function getProjectDefaultConfig(params) {
  // return axios.get(`${base}/get_project_default_config`, {params})
  return axios.get(base + "/setting/get_project_config", { params: params });
};

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerProjectcostTable", function() { return getCustomerProjectcostTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCustomerProjectcostData", function() { return exportCustomerProjectcostData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getCustomerProjectcostTable = function getCustomerProjectcostTable(params) {
  return axios.post(base + "/query_projectcost", params);
};
var exportCustomerProjectcostData = function exportCustomerProjectcostData(params) {
  return axios.get(base + "/exportCustomerProjectcostData/" + params.id, { params: params });
};

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerReceiptTable", function() { return getCustomerReceiptTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiptInfoForRemoteSearch", function() { return receiptInfoForRemoteSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerReceiptDetail", function() { return getCustomerReceiptDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCustomerReceiptData", function() { return exportCustomerReceiptData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomerReceiptData", function() { return createCustomerReceiptData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateReceiptInfoData", function() { return updateReceiptInfoData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomerReceiptData", function() { return deleteCustomerReceiptData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCustomerReceiptTable", function() { return exportCustomerReceiptTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCustomerReceiptAttachedFile", function() { return uploadCustomerReceiptAttachedFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableCustomerReceipt", function() { return enableCustomerReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableCustomerReceipt", function() { return disableCustomerReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerTableForSearch", function() { return getCustomerTableForSearch; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;
var getCustomerReceiptTable = function getCustomerReceiptTable(params) {
  return axios.post(base + "/receipt-applications/receipt_info/lists", params);
};
// 远程搜索使用的接口，支持 抬头名称/抬头ID 搜索
var receiptInfoForRemoteSearch = function receiptInfoForRemoteSearch(params) {
  return axios.post(base + "/receipt-applications/receipt_info/query_for_search", params);
};

var getCustomerReceiptDetail = function getCustomerReceiptDetail(params) {
  return axios.get(base + "/receipt-applications/receipt_info/" + params.id, { params: params });
};
var exportCustomerReceiptData = function exportCustomerReceiptData(params) {
  return axios.get(base + "/exportCustomerReceiptData/" + params.id, { params: params });
};
var createCustomerReceiptData = function createCustomerReceiptData(params) {
  return axios.post(base + "/receipt-applications/receipt_info/create", params);
};
var updateReceiptInfoData = function updateReceiptInfoData(params) {
  return axios.post(base + "/receipt-applications/receipt_info/" + params.id + "/edit", params);
};
var deleteCustomerReceiptData = function deleteCustomerReceiptData(params) {
  return axios.post(base + "/deleteCustomerReceiptData/" + params.id, params);
};

var exportCustomerReceiptTable = function exportCustomerReceiptTable(params) {
  return axios.post(base + "/receipt-applications/receipt_info/export", params);
};

var uploadCustomerReceiptAttachedFile = function uploadCustomerReceiptAttachedFile(params) {
  return axios.post(base + "/receipt-applications/receipt_info/upload", params);
};

var enableCustomerReceipt = function enableCustomerReceipt(params) {
  return axios.post(base + "/receipt-applications/receipt_info/" + params.id + "/enable", params);
};

var disableCustomerReceipt = function disableCustomerReceipt(params) {
  return axios.post(base + "/receipt-applications/receipt_info/" + params.id + "/disable", params);
};

var getCustomerTableForSearch = function getCustomerTableForSearch(params) {
  return axios.post(base + "/forward/customer", params);
};

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerTaskTable", function() { return getCustomerTaskTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomerTask", function() { return createCustomerTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerTaskOptions", function() { return getCustomerTaskOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateUniqueAbbr", function() { return validateUniqueAbbr; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var getCustomerTaskTable = function getCustomerTaskTable(params) {
  return axios.post(base + "/statistic_customer", params);
};
var createCustomerTask = function createCustomerTask(params) {
  return axios.post(base + "/create_customer", params);
};
var getCustomerTaskOptions = function getCustomerTaskOptions(params) {
  return axios.get(base + "/options_customer", params);
};

var validateUniqueAbbr = function validateUniqueAbbr(params) {
  return axios.post(base + "/validate_customer_abbr", params);
};

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerTable", function() { return getCustomerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerDetail", function() { return getCustomerDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBasicCustomerTable", function() { return getBasicCustomerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBasicCustomerDetail", function() { return getBasicCustomerDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerBalanceDetail", function() { return getCustomerBalanceDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomerData", function() { return deleteCustomerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCustomerData", function() { return updateCustomerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerBalanceFlowTable", function() { return getCustomerBalanceFlowTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerRelationshipDetail", function() { return getCustomerRelationshipDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCustomerRelationshipData", function() { return updateCustomerRelationshipData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStatisticProjectAudit", function() { return getStatisticProjectAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerOrderReviewTableApi", function() { return getCustomerOrderReviewTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectOrderReviewTable", function() { return getProjectOrderReviewTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchOrderReviewTable", function() { return getBatchOrderReviewTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerReceiptInfo", function() { return getCustomerReceiptInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceiptInfo", function() { return getReceiptInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerReceiptOptions", function() { return getCustomerReceiptOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableCustomerReceiptInfo", function() { return disableCustomerReceiptInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableCustomerReceiptInfo", function() { return enableCustomerReceiptInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceiptInfoCollectList", function() { return getReceiptInfoCollectList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCreateCustomerReceiptInfo", function() { return batchCreateCustomerReceiptInfo; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var finBase = window._env_.VUE_APP_FIN_CENTER_HOST;
var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;
var getCustomerTable = function getCustomerTable(params) {
  return axios.post(base + "/query_customer", params);
};
var getCustomerDetail = function getCustomerDetail(params) {
  return axios.get(base + "/customer_" + params.id);
};
var getBasicCustomerTable = function getBasicCustomerTable(params) {
  return axios.post(base + "/basic-info/query_customer", params);
};
var getBasicCustomerDetail = function getBasicCustomerDetail(params) {
  return axios.get(base + "/basic-info/customer_" + params.id);
};
var getCustomerBalanceDetail = function getCustomerBalanceDetail(params) {
  return axios.get(base + "/customer_balance_" + params.id);
};
var deleteCustomerData = function deleteCustomerData(params) {
  return axios.post(base + "/delete_customer_" + params.id);
};
var updateCustomerData = function updateCustomerData(params) {
  return axios.post(base + "/edit_customer_" + params.id, params);
};
var getCustomerBalanceFlowTable = function getCustomerBalanceFlowTable(params) {
  return axios.post(base + "/customer_balance_flow", params);
};

var getCustomerRelationshipDetail = function getCustomerRelationshipDetail(params) {
  return axios.get(base + "/get_customer_relationship_" + params.id);
};

var updateCustomerRelationshipData = function updateCustomerRelationshipData(params) {
  return axios.post(base + "/edit_customer_relationship_" + params.id, params);
};

// 项目审单统计（管理端统计页等直连 core）
var getStatisticProjectAudit = function getStatisticProjectAudit(params) {
  return axios.post(base + "/statistic_project_audit", params);
};

var getCustomerOrderReviewTableApi = function getCustomerOrderReviewTableApi(params) {
  return axios.post(orderAuditBase + "/admin/statistic_customer_audit", params);
};

// 项目审单管理列表（经由 order-audit-api 转发 core）
var getProjectOrderReviewTable = function getProjectOrderReviewTable(params) {
  return axios.post(orderAuditBase + "/admin/statistic_project_audit", params);
};

// 项目审单管理列表（经由 order-audit-api 转发 core）
var getBatchOrderReviewTable = function getBatchOrderReviewTable(params) {
  return axios.post(orderAuditBase + "/admin/statistic_batch_audit", params);
};

/** ======= 财务系统 - 开票信息(抬头) ======== **/

// 获取客户开票信息(抬头)
var getCustomerReceiptInfo = function getCustomerReceiptInfo(params) {
  return axios.post(finBase + "/receipt-applications/receipt_info/customer/" + params.customerid + "/lists");
};

var getReceiptInfo = function getReceiptInfo(params) {
  return axios.get(finBase + "/receipt-applications/receipt_info/" + params.id);
};

var getCustomerReceiptOptions = function getCustomerReceiptOptions(params) {
  return axios.post(finBase + "/receipt-applications/receipt_info/customer/" + params.customerid + "/lists");
};

var disableCustomerReceiptInfo = function disableCustomerReceiptInfo(params) {
  return axios.post(finBase + "/receipt-applications/receipt_info/" + params.id + "/disable", params);
};

var enableCustomerReceiptInfo = function enableCustomerReceiptInfo(params) {
  return axios.post(finBase + "/receipt-applications/receipt_info/" + params.id + "/enable", params);
};

var getReceiptInfoCollectList = function getReceiptInfoCollectList(params) {
  return axios.post(finBase + "/receipt-applications/receipt_info/" + params.id + "/collect_list", params);
};

// 批量更新开票信息
var batchCreateCustomerReceiptInfo = function batchCreateCustomerReceiptInfo(params) {
  return axios.post(base + "/receipt-apply/batch_edit_receipt_info", params);
};

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExecutiveBudgetTable", function() { return getExecutiveBudgetTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExecutiveBudgetDetail", function() { return getExecutiveBudgetDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editExecutiveBudgetStatus", function() { return editExecutiveBudgetStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateExecutiveBudgetAudit", function() { return updateExecutiveBudgetAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editExecutiveBudget", function() { return editExecutiveBudget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExecutiveApproveTable", function() { return getExecutiveApproveTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExecutiveAllowance", function() { return getExecutiveAllowance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "executiveAllowanceApply", function() { return executiveAllowanceApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editExecutiveAuditStatus", function() { return editExecutiveAuditStatus; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getExecutiveBudgetTable = function getExecutiveBudgetTable(params) {
  return axios.post(base + "/executive-budget/query_project", params);
};
var getExecutiveBudgetDetail = function getExecutiveBudgetDetail(params) {
  return axios.post(base + "/executive-budget/query_province", params);
};
var editExecutiveBudgetStatus = function editExecutiveBudgetStatus(params) {
  return axios.post(base + "/executive-budget/edit_status_pass_" + params.id, params);
};
var updateExecutiveBudgetAudit = function updateExecutiveBudgetAudit(params) {
  return axios.post(base + "/executive-budget/edit_status_audit_" + params.id, params);
};
var editExecutiveBudget = function editExecutiveBudget(params) {
  return axios.post(base + "/executive-budget/edit_province_" + params.id, params);
};

// 执行审批页
var getExecutiveApproveTable = function getExecutiveApproveTable(params) {
  return axios.post(base + "/executive-audit/query_audit", params);
};

// 执行补贴验证和获取剩余预算
var getExecutiveAllowance = function getExecutiveAllowance(params) {
  return axios.post(base + "/executive-audit/get_subsidise_user", params);
};
// 执行补贴申请
var executiveAllowanceApply = function executiveAllowanceApply(params) {
  return axios.post(base + "/executive-audit/subsidise_user", params);
};

var editExecutiveAuditStatus = function editExecutiveAuditStatus(params) {
  return axios.post(base + "/executive-audit/edit_status_" + params.id, params);
};

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairPrizeTable", function() { return getFairPrizeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteFairPrize", function() { return deleteFairPrize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFairPrize", function() { return createFairPrize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editFairPrize", function() { return editFairPrize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairPrizeDetail", function() { return getFairPrizeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairPrizeOptions", function() { return getFairPrizeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFairPrizeImg", function() { return uploadFairPrizeImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairPrizeLogList", function() { return getFairPrizeLogList; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

// 获得奖品管理列表
var getFairPrizeTable = function getFairPrizeTable(params) {
  return axios.post(base + '/query_fairprize', params);
};
// 删除奖品
var deleteFairPrize = function deleteFairPrize(id) {
  return axios.post(base + '/delete_fairprize_' + id);
};
// 创建奖品
var createFairPrize = function createFairPrize(params) {
  return axios.post(base + '/create_fairprize', params);
};
// 修改奖品
var editFairPrize = function editFairPrize(params) {
  return axios.post(base + '/edit_fairprize_' + params.id, params.data);
};
// 获取奖品详情
var getFairPrizeDetail = function getFairPrizeDetail() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return axios.get(base + '/get_fairprize_' + id);
};
// 获取活动奖品/券类型
var getFairPrizeOptions = function getFairPrizeOptions() {
  return axios.get(base + '/fairprize_options');
};
// 上传奖品图片
var uploadFairPrizeImg = function uploadFairPrizeImg(params) {
  return axios.post(base + '/fairprize_option', params);
};

// 获取奖品记录列表
var getFairPrizeLogList = function getFairPrizeLogList(params) {
  return axios.post(base + '/query_fairprize_log', params);
};

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairRewardTable", function() { return getFairRewardTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRewardLogistics", function() { return addRewardLogistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLogisticsCompany", function() { return getLogisticsCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRewardLogistics", function() { return getRewardLogistics; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var shopBase = window._env_.VUE_APP_SHOP_HOST;
var getFairRewardTable = function getFairRewardTable(params) {
  return axios.post(base + "/query_fair_reward_log", params);
};
var addRewardLogistics = function addRewardLogistics(params) {
  return axios.post(base + "/add_reward_deliver", params);
};
var getLogisticsCompany = function getLogisticsCompany(params) {
  return axios.get(shopBase + "/core/delivers", { params: params });
};
var getRewardLogistics = function getRewardLogistics(id) {
  return axios.get(base + "/get_reward_deliver_" + id);
};

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairStockTable", function() { return getFairStockTable; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getFairStockTable = function getFairStockTable(params) {
  return axios.get(base + "/get_fairstock_" + params.fairid, params);
};

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairDeliverUpload", function() { return getFairDeliverUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downFairSourceFile", function() { return downFairSourceFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downFairErrorFile", function() { return downFairErrorFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editRewardLogistics", function() { return editRewardLogistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFairFile", function() { return uploadFairFile; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getFairDeliverUpload = function getFairDeliverUpload(params) {
  return axios.post(base + "/excel/query_upload", params);
};

var downFairSourceFile = function downFairSourceFile(id) {
  window.location.href = base + "/excel/down_sourc_file_" + id;
};

var downFairErrorFile = function downFairErrorFile(id) {
  window.location.href = base + "/excel/down_error_file_" + id;
};

var editRewardLogistics = function editRewardLogistics(params) {
  return axios.post(base + "/edit_reward_deliver_" + params.id, params);
};
var uploadFairFile = function uploadFairFile(params) {
  return axios.post(base + "/batch_add_fair_deliver", params);
};

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairTable", function() { return getFairTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineFair", function() { return offlineFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "releaseFair", function() { return releaseFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFair", function() { return uploadFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFair", function() { return createFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editFair", function() { return editFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairOptions", function() { return getFairOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFair", function() { return getFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteFair", function() { return deleteFair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairPrizeNumber", function() { return getFairPrizeNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFairUserLimit", function() { return getFairUserLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportFairCouponHistory", function() { return exportFairCouponHistory; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getFairTable = function getFairTable(params) {
  return axios.post(base + "/query_fair", params);
};
var offlineFair = function offlineFair(id) {
  return axios.post(base + "/offline_fair_" + id);
};
var releaseFair = function releaseFair(id) {
  return axios.post(base + "/publish_fair_" + id);
};
var uploadFair = function uploadFair(params) {
  return axios.post(base + "/upload_fair", params);
};
var createFair = function createFair(params) {
  return axios.post(base + "/create_fair", params);
};
var editFair = function editFair(params) {
  return axios.post(base + "/edit_fair_" + params.id, params.data);
};
var getFairOptions = function getFairOptions(params) {
  return axios.get(base + "/fair_options");
};
var getFair = function getFair(id) {
  return axios.get(base + "/get_fair_" + id);
};
var deleteFair = function deleteFair(id) {
  return axios.post(base + "/delete_fair_" + id);
};
var getFairPrizeNumber = function getFairPrizeNumber(params) {
  return axios.get(base + "/get_prize_number_" + params.fairid);
};
var getFairUserLimit = function getFairUserLimit(params) {
  return axios.post(base + "/get_fair_reward_user_limit_" + params.fairid, params);
};
var exportFairCouponHistory = function exportFairCouponHistory(params) {
  return axios.post(base + "/export_fair_coupon_history_" + params.fairid, params);
};

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subjectFirstLists", function() { return subjectFirstLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSubjectFirst", function() { return createSubjectFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableSubjectFirst", function() { return enableSubjectFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableSubjectFirst", function() { return disableSubjectFirst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subjectSecondLists", function() { return subjectSecondLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSubjectSecond", function() { return createSubjectSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableSubjectSecond", function() { return enableSubjectSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableSubjectSecond", function() { return disableSubjectSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinanceConfigTable", function() { return getFinanceConfigTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subjectRelationshipLists", function() { return subjectRelationshipLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSubjectRelationship", function() { return getSubjectRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSubjectRelationship", function() { return createSubjectRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editSubjectRelationship", function() { return editSubjectRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchEditSubjectRelationship", function() { return batchEditSubjectRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableSubjectRelationship", function() { return disableSubjectRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMineManagedCompaniesApi", function() { return getMineManagedCompaniesApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ourCompaniesLists", function() { return ourCompaniesLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOurCompanyDetail", function() { return getOurCompanyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOurCompany", function() { return createOurCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOurCompany", function() { return updateOurCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableCompany", function() { return enableCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableCompany", function() { return disableCompany; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invoiceNameLists", function() { return invoiceNameLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceName", function() { return getInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInvoiceName", function() { return createInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editInvoiceName", function() { return editInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableInvoiceName", function() { return enableInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableInvoiceName", function() { return disableInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCreateInvoiceName", function() { return batchCreateInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allEnabledInvoiceName", function() { return allEnabledInvoiceName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invoiceNameTypeLists", function() { return invoiceNameTypeLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceNameType", function() { return getInvoiceNameType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInvoiceNameType", function() { return createInvoiceNameType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableInvoiceNameType", function() { return enableInvoiceNameType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableInvoiceNameType", function() { return disableInvoiceNameType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "departmentLists", function() { return departmentLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDepartmentJobLists", function() { return getDepartmentJobLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDepartmentJobDetail", function() { return getDepartmentJobDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDepartmentJob", function() { return createDepartmentJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCreateDepartmentJob", function() { return batchCreateDepartmentJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateDepartmentJob", function() { return updateDepartmentJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDepartmentJob", function() { return enableDepartmentJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableDepartmentJob", function() { return disableDepartmentJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportDepartmentJobList", function() { return exportDepartmentJobList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDepartment", function() { return createDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDepartment", function() { return enableDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableDepartment", function() { return disableDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyAccountManagementTable", function() { return getCompanyAccountManagementTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyAccountManagementDetail", function() { return getCompanyAccountManagementDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOurCompanyAccount", function() { return createOurCompanyAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOurCompanyAccount", function() { return updateOurCompanyAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableOurCompanyAccount", function() { return enableOurCompanyAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableOurCompanyAccount", function() { return disableOurCompanyAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBankTable", function() { return getBankTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBankDetail", function() { return getBankDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveBaiWangCfg", function() { return saveBaiWangCfg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaiWangCfg", function() { return getBaiWangCfg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinanceEmailNotifyCfg", function() { return getFinanceEmailNotifyCfg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveFinanceEmailNotifyCfg", function() { return saveFinanceEmailNotifyCfg; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;

// 付款科目管理
// 一级
var subjectFirstLists = function subjectFirstLists(params) {
  return axios.post(base + "/subject/first/lists", params);
};

var createSubjectFirst = function createSubjectFirst(params) {
  return axios.post(base + "/subject/first/create", params);
};

var enableSubjectFirst = function enableSubjectFirst(params) {
  return axios.post(base + "/subject/first/" + params.id + "/enable", params);
};

var disableSubjectFirst = function disableSubjectFirst(params) {
  return axios.post(base + "/subject/first/" + params.id + "/disable", params);
};

// 二级
var subjectSecondLists = function subjectSecondLists(params) {
  return axios.post(base + "/subject/second/lists", params);
};
var createSubjectSecond = function createSubjectSecond(params) {
  return axios.post(base + "/subject/second/create", params);
};

var enableSubjectSecond = function enableSubjectSecond(params) {
  return axios.post(base + "/subject/second/" + params.id + "/enable", params);
};

var disableSubjectSecond = function disableSubjectSecond(params) {
  return axios.post(base + "/subject/second/" + params.id + "/disable", params);
};

var getFinanceConfigTable = function getFinanceConfigTable(params) {
  return axios.post(base + "/subject/first/lists", params);
};

// 科目关系
var subjectRelationshipLists = function subjectRelationshipLists(params) {
  return axios.post(base + "/subject/relationship/lists", params);
};

var getSubjectRelationship = function getSubjectRelationship(params) {
  return axios.get(base + "/subject/relationship/" + params.id, params);
};

var createSubjectRelationship = function createSubjectRelationship(params) {
  return axios.post(base + "/subject/relationship/create", params);
};

var editSubjectRelationship = function editSubjectRelationship(params) {
  return axios.post(base + "/subject/relationship/" + params.id + "/edit", params);
};

var batchEditSubjectRelationship = function batchEditSubjectRelationship(params) {
  return axios.post(base + "/subject/relationship/batch_edit", params);
};

var disableSubjectRelationship = function disableSubjectRelationship(params) {
  return axios.post(base + "/subject/relationship/" + params.id + "/disable", params);
};

var getMineManagedCompaniesApi = function getMineManagedCompaniesApi(params) {
  return axios.get(base + "/our_companies/mine_managed", { params: params });
};
// 公司账户管理
var ourCompaniesLists = function ourCompaniesLists(params) {
  return axios.post(base + "/our_companies/lists", params);
};

var getOurCompanyDetail = function getOurCompanyDetail(params) {
  return axios.get(base + "/our_companies/" + params.id);
};

var createOurCompany = function createOurCompany(params) {
  return axios.post(base + "/our_companies/create", params);
};

var updateOurCompany = function updateOurCompany(params) {
  return axios.put(base + "/our_companies/" + params.id, params);
};

var enableCompany = function enableCompany(params) {
  return axios.post(base + "/our_companies/" + params.id + "/enable", params);
};

var disableCompany = function disableCompany(params) {
  return axios.post(base + "/our_companies/" + params.id + "/disable", params);
};

// 开票名称管理
var invoiceNameLists = function invoiceNameLists(params) {
  return axios.post(base + "/receipt-applications/invoice_name/lists", params);
};

var getInvoiceName = function getInvoiceName(params) {
  return axios.get(base + "/receipt-applications/invoice_name/" + params.id);
};

var createInvoiceName = function createInvoiceName(params) {
  return axios.post(base + "/receipt-applications/invoice_name/create", params);
};

var editInvoiceName = function editInvoiceName(params) {
  return axios.post(base + "/receipt-applications/invoice_name/" + params.id + "/edit", params);
};

var enableInvoiceName = function enableInvoiceName(params) {
  return axios.post(base + "/receipt-applications/invoice_name/" + params.id + "/enable", params);
};

var disableInvoiceName = function disableInvoiceName(params) {
  return axios.post(base + "/receipt-applications/invoice_name/" + params.id + "/disable", params);
};

var batchCreateInvoiceName = function batchCreateInvoiceName(params) {
  return axios.post(base + "/receipt-applications/invoice_name/batch_create", params);
};
var allEnabledInvoiceName = function allEnabledInvoiceName(params) {
  return axios.get(base + "/receipt-applications/invoice_name/all_enable", { params: params });
};

// 开票名称列表管理 API
var invoiceNameTypeLists = function invoiceNameTypeLists(params) {
  return axios.post(base + "/receipt-applications/invoice_name/type/lists", params);
};
var getInvoiceNameType = function getInvoiceNameType(params) {
  return axios.get(base + "/receipt-applications/invoice_name/type/" + params.id);
};
var createInvoiceNameType = function createInvoiceNameType(params) {
  return axios.post(base + "/receipt-applications/invoice_name/type/create", params);
};
var enableInvoiceNameType = function enableInvoiceNameType(params) {
  return axios.post(base + "/receipt-applications/invoice_name/type/" + params.id + "/enable", params);
};
var disableInvoiceNameType = function disableInvoiceNameType(params) {
  return axios.post(base + "/receipt-applications/invoice_name/type/" + params.id + "/disable", params);
};
// 开票名称列表管理 API 结束

// 部门管理
var departmentLists = function departmentLists(params) {
  return axios.post(base + "/departments/list", params);
};

var getDepartmentJobLists = function getDepartmentJobLists(params) {
  return axios.post(base + "/departments/department_job/list", params);
};

var getDepartmentJobDetail = function getDepartmentJobDetail(params) {
  return axios.get(base + "/departments/department_job/" + params.id);
};

var createDepartmentJob = function createDepartmentJob(params) {
  return axios.post(base + "/departments/department_job/create", params);
};

var batchCreateDepartmentJob = function batchCreateDepartmentJob(params) {
  return axios.post(base + "/departments/department_job/batch_create", params);
};

var updateDepartmentJob = function updateDepartmentJob(params) {
  return axios.put(base + "/departments/department_job/" + params.id, params);
};

var enableDepartmentJob = function enableDepartmentJob(params) {
  return axios.post(base + "/departments/department_job/" + params.id + "/enable", params);
};

var disableDepartmentJob = function disableDepartmentJob(params) {
  return axios.post(base + "/departments/department_job/" + params.id + "/disable", params);
};

var exportDepartmentJobList = function exportDepartmentJobList(params) {
  return axios.post(base + "/departments/export_jobs", params);
};

var createDepartment = function createDepartment(params) {
  return axios.post(base + "/departments/create", params);
};

var enableDepartment = function enableDepartment(params) {
  return axios.post(base + "/departments/" + params.id + "/enable", params);
};

var disableDepartment = function disableDepartment(params) {
  return axios.post(base + "/departments/" + params.id + "/disable", params);
};

// 账户相关
var getCompanyAccountManagementTable = function getCompanyAccountManagementTable(params) {
  return axios.post(base + "/our_companies/bank_account/lists", params);
};

var getCompanyAccountManagementDetail = function getCompanyAccountManagementDetail(params) {
  return axios.get(base + "/our_companies/bank_account/" + params.id, params);
};

var createOurCompanyAccount = function createOurCompanyAccount(params) {
  return axios.post(base + "/our_companies/bank_account/create", params);
};

var updateOurCompanyAccount = function updateOurCompanyAccount(params) {
  return axios.put(base + "/our_companies/bank_account/" + params.id, params);
};

var enableOurCompanyAccount = function enableOurCompanyAccount(params) {
  return axios.post(base + "/our_companies/bank_account/" + params.id + "/enable", params);
};

var disableOurCompanyAccount = function disableOurCompanyAccount(params) {
  return axios.post(base + "/our_companies/bank_account/" + params.id + "/disable", params);
};

// 公司银行账户 - 银行相关
var getBankTable = function getBankTable(params) {
  return axios.get(base + "/banks/all");
};

var getBankDetail = function getBankDetail(params) {
  return axios.get(base + "/banks/" + params.id, params);
};

// 百旺开票配置项设置
var saveBaiWangCfg = function saveBaiWangCfg(params) {
  return axios.post(base + "/settings/bai_wang/save_cfg", params);
};
var getBaiWangCfg = function getBaiWangCfg(params) {
  return axios.get(base + "/settings/bai_wang/get_cfg");
};

// 财务邮件通知设置
var getFinanceEmailNotifyCfg = function getFinanceEmailNotifyCfg(params) {
  return axios.get(base + "/settings/finance_email_notify/get_cfg", { params: params });
};
var saveFinanceEmailNotifyCfg = function saveFinanceEmailNotifyCfg(params) {
  return axios.post(base + "/settings/finance_email_notify/save_cfg", params);
};

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitBatchWithdraw", function() { return submitBatchWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawList", function() { return batchWithdrawList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downBatchSourceFile", function() { return downBatchSourceFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawBatchList", function() { return batchWithdrawBatchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawBatchDetail", function() { return batchWithdrawBatchDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawBatchDetailByUser", function() { return batchWithdrawBatchDetailByUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawBatchConfirm", function() { return batchWithdrawBatchConfirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawBatchRollback", function() { return batchWithdrawBatchRollback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchRollbackTable", function() { return batchRollbackTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadBatchRollback", function() { return uploadBatchRollback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchWithdrawBatchSummary", function() { return batchWithdrawBatchSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWithdrawList", function() { return getWithdrawList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withdrawGenExcel", function() { return withdrawGenExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelWithdraw", function() { return cancelWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCancelWithdraw", function() { return batchCancelWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withdrawDetail", function() { return withdrawDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withdrawWx", function() { return withdrawWx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inactiveUserList", function() { return inactiveUserList; });
var base = window._env_.VUE_APP_ADMIN_HOST;

var submitBatchWithdraw = function submitBatchWithdraw(params) {
  return axios.post(base + "/batch_withdraw/upload", params);
};

var batchWithdrawList = function batchWithdrawList(params) {
  return axios.post(base + "/excel/query_upload", params);
};

var downBatchSourceFile = function downBatchSourceFile(params) {
  return axios.get(base + "/batch_withdraw/batch_download_" + params.id, { params: params });
};
var batchWithdrawBatchList = function batchWithdrawBatchList(params) {
  return axios.get(base + "/batch_withdraw/batch_list", { params: params });
};
var batchWithdrawBatchDetail = function batchWithdrawBatchDetail(id) {
  return axios.get(base + "/batch_withdraw/batch_detail_" + id);
};
var batchWithdrawBatchDetailByUser = function batchWithdrawBatchDetailByUser(params) {
  return axios.get(base + "/batch_withdraw/batch_detail_" + params.id, { params: params });
};
var batchWithdrawBatchConfirm = function batchWithdrawBatchConfirm(params) {
  return axios.post(base + "/batch_withdraw/batch_confirm_" + params.id, params);
};
var batchWithdrawBatchRollback = function batchWithdrawBatchRollback(params) {
  return axios.post(base + "/batch_withdraw/batch_rollback_" + params.id, params);
};
var batchRollbackTable = function batchRollbackTable(params) {
  return axios.get(base + "/batch_withdraw/batch_rollback_upload_list", { params: params });
};
var uploadBatchRollback = function uploadBatchRollback(params) {
  return axios.post(base + "/batch_withdraw/batch_rollback_upload_" + params.id, params.data);
};
var batchWithdrawBatchSummary = function batchWithdrawBatchSummary(id) {
  return axios.get(base + "/batch_withdraw/batch_summary_" + id);
};

var getWithdrawList = function getWithdrawList(params) {
  return axios.post(base + "/batch_withdraw/withdraw_list", params);
};
var withdrawGenExcel = function withdrawGenExcel(params) {
  return axios.post(base + "/batch_withdraw/withdraw_gen_excel", params);
};
var cancelWithdraw = function cancelWithdraw(params) {
  return axios.post(base + "/batch_withdraw/cancel_withdraw_" + params.id, params);
};
// 批量驳回
var batchCancelWithdraw = function batchCancelWithdraw(params) {
  return axios.post(base + "/batch_withdraw/batch_cancel_withdraw", params);
};
var withdrawDetail = function withdrawDetail(params) {
  return axios.post(base + "/batch_withdraw/withdraw_detail_" + params.id, params);
};
var withdrawWx = function withdrawWx(params) {
  return axios.post(base + "/batch_withdraw/batch_withdraw_wx_" + params.id, params);
};
var inactiveUserList = function inactiveUserList(params) {
  return axios.post(base + "/query_inactive_user", params);
};

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlBannerTable", function() { return getFlBannerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteFlBanner", function() { return deleteFlBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFlBanner", function() { return createFlBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editFlBanner", function() { return editFlBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlBanner", function() { return getFlBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFlBanner", function() { return uploadFlBanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFlBannerLogTable", function() { return getFlBannerLogTable; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getFlBannerTable = function getFlBannerTable(params) {
  return axios.post(base + "/query_flbanner", params);
};
var deleteFlBanner = function deleteFlBanner(id) {
  return axios.post(base + "/delete_flbanner_" + id);
};
var createFlBanner = function createFlBanner(params) {
  return axios.post(base + "/create_flbanner", params);
};
var editFlBanner = function editFlBanner(params) {
  return axios.post(base + "/edit_flbanner_" + params.id, params);
};
var getFlBanner = function getFlBanner(id) {
  return axios.get(base + "/flbanner_" + id);
};
var uploadFlBanner = function uploadFlBanner(params) {
  return axios.post(base + "/flbanner_upload_file", params);
};
var getFlBannerLogTable = function getFlBannerLogTable(params) {
  return axios.post(base + "/query_flbanner_log", params);
};

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupBatchTable", function() { return getGroupBatchTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupBatchDetail", function() { return getGroupBatchDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupBatchData", function() { return createGroupBatchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateGroupBatchData", function() { return updateGroupBatchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupBatchTargetNumTable", function() { return getGroupBatchTargetNumTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateGroupBatchTargetNum", function() { return updateGroupBatchTargetNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupBatchRelationMarkets", function() { return getGroupBatchRelationMarkets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupBatchRelationTasks", function() { return getGroupBatchRelationTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskGroupEventQueueStatus", function() { return getTaskGroupEventQueueStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openTaskGroupBySearch", function() { return openTaskGroupBySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeTaskGroupBySearch", function() { return closeTaskGroupBySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupBatchLogTable", function() { return getGroupBatchLogTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchOpenGroupBatch", function() { return batchOpenGroupBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCloseGroupBatch", function() { return batchCloseGroupBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGroupMarketTable", function() { return getGroupMarketTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createGroupMarket", function() { return createGroupMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteGroupBatchByCustomerId", function() { return deleteGroupBatchByCustomerId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateGroupMarket", function() { return updateGroupMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importMarketGroupRelation", function() { return importMarketGroupRelation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "giveupMarketGroupRelationConflictApi", function() { return giveupMarketGroupRelationConflictApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retryMarketGroupRelationConflictApi", function() { return retryMarketGroupRelationConflictApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importMarketGroupTargetNum", function() { return importMarketGroupTargetNum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importMarketGroupTargetNumStatus", function() { return importMarketGroupTargetNumStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editTaskLimitStatus", function() { return editTaskLimitStatus; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var getGroupBatchTable = function getGroupBatchTable(params) {
  return axios.post(base + "/group-batch/query", params);
};
var getGroupBatchDetail = function getGroupBatchDetail(params) {
  return axios.get(base + "/group-batch/get_" + params.id, { params: params });
};
var createGroupBatchData = function createGroupBatchData(params) {
  return axios.post(base + "/group-batch/create", params);
};
var updateGroupBatchData = function updateGroupBatchData(params) {
  return axios.post(base + "/group-batch/edit_" + params.id, params);
};
var getGroupBatchTargetNumTable = function getGroupBatchTargetNumTable(params) {
  return axios.post(base + "/group-batch/target_number_" + params.id, params);
};

var updateGroupBatchTargetNum = function updateGroupBatchTargetNum(params) {
  return axios.post(base + "/group-batch/update_target_number_" + params.id, params);
};

var getGroupBatchRelationMarkets = function getGroupBatchRelationMarkets(params) {
  return axios.post(base + "/group-batch/relation_markets_" + params.id, params);
};

var getGroupBatchRelationTasks = function getGroupBatchRelationTasks(params) {
  return axios.post(base + "/group-batch/relation_tasks_" + params.id, params);
};

var getTaskGroupEventQueueStatus = function getTaskGroupEventQueueStatus(params) {
  return axios.get(base + "/group-batch/task_group_event_queue_status", { params: params });
};

var openTaskGroupBySearch = function openTaskGroupBySearch(params) {
  return axios.post(base + "/batch_jobs/open_task_group_by_search", params);
};

var closeTaskGroupBySearch = function closeTaskGroupBySearch(params) {
  return axios.post(base + "/batch_jobs/close_task_group_by_search", params);
};

var getGroupBatchLogTable = function getGroupBatchLogTable(params) {
  return axios.post(base + "/group-batch/query_log_" + params.id, params);
};

var batchOpenGroupBatch = function batchOpenGroupBatch(params) {
  return axios.post(base + "/group-batch/open_group", params);
};

var batchCloseGroupBatch = function batchCloseGroupBatch(params) {
  return axios.post(base + "/group-batch/close_group", params);
};

var getGroupMarketTable = function getGroupMarketTable(params) {
  return axios.post(base + "/group-batch/group_markets/query", params);
};
var createGroupMarket = function createGroupMarket(params) {
  return axios.post(base + "/group-batch/group_markets/create", params);
};
var deleteGroupBatchByCustomerId = function deleteGroupBatchByCustomerId(params) {
  return axios.post(base + "/group-batch/group_markets/delete_by_customerid", params);
};
var updateGroupMarket = function updateGroupMarket(params) {
  return axios.post(base + "/group-batch/group_markets/update_" + params.id, params);
};
var importMarketGroupRelation = function importMarketGroupRelation(params) {
  return axios.post(base + "/batch_jobs/import_market_group_relation", params);
};
var giveupMarketGroupRelationConflictApi = function giveupMarketGroupRelationConflictApi(params) {
  return axios.post(base + "/batch_jobs/giveup_market_group_relation_conflict_" + params.id);
};
var retryMarketGroupRelationConflictApi = function retryMarketGroupRelationConflictApi(params) {
  return axios.post(base + "/batch_jobs/retry_market_group_relation_conflict_" + params.id);
};
var importMarketGroupTargetNum = function importMarketGroupTargetNum(params) {
  return axios.post(base + "/batch_jobs/import_target_number", params);
};
var importMarketGroupTargetNumStatus = function importMarketGroupTargetNumStatus(params) {
  return axios.post(base + "/batch_jobs/import_target_number_status", params);
};

var editTaskLimitStatus = function editTaskLimitStatus(id, status) {
  return axios.post(base + "/group-batch/switch_redundant_taskcnt_restrict_" + id, status);
};

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeList", function() { return getEmployeeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEmployee", function() { return addEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editEmployee", function() { return editEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeDetail", function() { return getEmployeeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEmployee", function() { return deleteEmployee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importEmployees", function() { return importEmployees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportEmployeeGreetings", function() { return exportEmployeeGreetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addBirthdayGreetings", function() { return addBirthdayGreetings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBirthdayGreetingsRecord", function() { return getBirthdayGreetingsRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelBirthdayGreetings", function() { return cancelBirthdayGreetings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);

var base = window._env_.VUE_APP_ADMIN_HOST;

// 员工列表
var getEmployeeList = function getEmployeeList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios.post(base + '/employees/query', params);
};

// 新增员工
var addEmployee = function addEmployee(params) {
  return axios.post(base + '/employees/create', params);
};

// 编辑员工
var editEmployee = function editEmployee() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/employees/edit_' + id, rest);
};

// 员工详情

var getEmployeeDetail = function getEmployeeDetail(id) {
  return axios.get(base + '/employees/get_' + id);
};

// 删除员工
var deleteEmployee = function deleteEmployee(id) {
  return axios.post(base + '/employees/delete_' + id);
};

// 导入员工数据
var importEmployees = function importEmployees() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios.post(base + '/employees/import', params);
};

// 导出邮件记录
// params: { type: 1|2, start_at: "YYYY-MM-DD", end_at: "YYYY-MM-DD" }
// type: 1=周年, 2=生日
var exportEmployeeGreetings = function exportEmployeeGreetings() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios.post(base + '/employees/export_greetings', params, {
    responseType: 'blob'
  });
};

// 保存生日礼物
// params: { employee_id: 1, gift: "" }
var addBirthdayGreetings = function addBirthdayGreetings() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios.post(base + '/employees/add_birthday_greetings', params);
};

// 查询生日发送记录
// params: { name: "", status: "" }
// status: 0=待发送, 1=已发送, 2=发送失败, 3=已取消
var getBirthdayGreetingsRecord = function getBirthdayGreetingsRecord() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios.post(base + '/employees/birthday_greetings_record', params);
};

// 取消生日发送
// params: { record_id: 1 }
var cancelBirthdayGreetings = function cancelBirthdayGreetings() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return axios.post(base + '/employees/cancel_birthday_greetings', params);
};

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowConfigTable", function() { return getImgFlowConfigTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowConfigDetail", function() { return getImgFlowConfigDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createImgFlowConfigData", function() { return createImgFlowConfigData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateImgFlowConfigData", function() { return updateImgFlowConfigData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteImgFlowConfigData", function() { return deleteImgFlowConfigData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyImgFlowConfig", function() { return copyImgFlowConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeImgFlowConfig", function() { return closeImgFlowConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openImgFlowConfig", function() { return openImgFlowConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetImgFlowConfig", function() { return resetImgFlowConfig; });
/* global process */
var base = window._env_.VUE_APP_IMG_FLOW_HOST;
var getImgFlowConfigTable = function getImgFlowConfigTable(params) {
  return axios.get(base + "/read_flow_list", { params: params });
};
var getImgFlowConfigDetail = function getImgFlowConfigDetail(params) {
  return axios.get(base + "/read_flow_detail/" + params.id, { params: params });
};
var createImgFlowConfigData = function createImgFlowConfigData(params) {
  return axios.post(base + "/create_flow", params);
};
var updateImgFlowConfigData = function updateImgFlowConfigData(params) {
  return axios.post(base + "/update_flow/" + params.id, params);
};
var deleteImgFlowConfigData = function deleteImgFlowConfigData(params) {
  return axios.post(base + "/deleteImgFlowConfigData/" + params.id, params);
};
var copyImgFlowConfig = function copyImgFlowConfig(params) {
  return axios.post(base + "/create_flow/copy/" + params.id, params);
};
var closeImgFlowConfig = function closeImgFlowConfig(params) {
  return axios.post(base + "/update_flow/close/" + params.id, params);
};
var openImgFlowConfig = function openImgFlowConfig(params) {
  return axios.post(base + "/update_flow/open/" + params.id, params);
};
var resetImgFlowConfig = function resetImgFlowConfig(params) {
  return axios.post(base + "/update_flow/reset_result/" + params.id, params);
};

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowModelTable", function() { return getImgFlowModelTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowModelDetail", function() { return getImgFlowModelDetail; });
/* global process */
var base = window._env_.VUE_APP_IMG_FLOW_HOST;
var getImgFlowModelTable = function getImgFlowModelTable(params) {
  return axios.get(base + "/read_model_list", params);
};
var getImgFlowModelDetail = function getImgFlowModelDetail(params) {
  return axios.get(base + "/read_model_detail/" + params.id, { params: params });
};
// export const exportImgFlowModelData = params => {
//   return axios.get(`${base}/exportImgFlowModelData/${params.id}`, {params})
// }
// export const createImgFlowModelData = params => {
//   return axios.post(`${base}/createImgFlowModelData`, params)
// }
// export const updateImgFlowModelData = params => {
//   return axios.post(`${base}/updateImgFlowModelData/${params.id}`, params)
// }
// export const deleteImgFlowModelData = params => {
//   return axios.post(`${base}/deleteImgFlowModelData/${params.id}`, params)
// }

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowOrderTable", function() { return getImgFlowOrderTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetImgFlowOrder", function() { return resetImgFlowOrder; });
/* global process */
var base = window._env_.VUE_APP_IMG_FLOW_HOST;
var getImgFlowOrderTable = function getImgFlowOrderTable(params) {
  return axios.get(base + "/read_order_list", { params: params });
};
// export const getImgFlowOrderDetail = params => {
//   return axios.get(`${base}/getImgFlowOrderDetail/${params.id}`, {params})
// }
// export const exportImgFlowOrderData = params => {
//   return axios.get(`${base}/exportImgFlowOrderData/${params.id}`, {params})
// }
// export const createImgFlowOrderData = params => {
//   return axios.post(`${base}/createImgFlowOrderData`, params)
// }
// export const updateImgFlowOrderData = params => {
//   return axios.post(`${base}/updateImgFlowOrderData/${params.id}`, params)
// }
// export const deleteImgFlowOrderData = params => {
//   return axios.post(`${base}/deleteImgFlowOrderData/${params.id}`, params)
// }
var resetImgFlowOrder = function resetImgFlowOrder(params) {
  return axios.post(base + "/update_order_list/reset_result/" + params.id, params);
};

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowProductTable", function() { return getImgFlowProductTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getImgFlowProductDetail", function() { return getImgFlowProductDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateImgFlowProductData", function() { return updateImgFlowProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBatchImgFlowProductData", function() { return updateBatchImgFlowProductData; });
/* global process */
var base = window._env_.VUE_APP_IMG_FLOW_HOST;
var getImgFlowProductTable = function getImgFlowProductTable(params) {
  return axios.get(base + "/read_product_list", { params: params });
};
var getImgFlowProductDetail = function getImgFlowProductDetail(params) {
  return axios.get(base + "/read_product_detail/" + params.id, { params: params });
};
// export const exportImgFlowProductData = params => {
//   return axios.get(`${base}/exportImgFlowProductData/${params.id}`, {params})
// }
// export const createImgFlowProductData = params => {
//   return axios.post(`${base}/createImgFlowProductData`, params)
// }
var updateImgFlowProductData = function updateImgFlowProductData(params) {
  return axios.post(base + "/update_product/change_alias/" + params.id, params);
};
var updateBatchImgFlowProductData = function updateBatchImgFlowProductData(params) {
  return axios.post(base + "/update_product/change_alias/batch", params);
};
// export const deleteImgFlowProductData = params => {
//   return axios.post(`${base}/deleteImgFlowProductData/${params.id}`, params)
// }

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntelligentCustomerServiceConfig", function() { return getIntelligentCustomerServiceConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setIntelligentCustomerServiceConfig", function() { return setIntelligentCustomerServiceConfig; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getIntelligentCustomerServiceConfig = function getIntelligentCustomerServiceConfig(params) {
  return axios.get(base + "/setting/get_intelligent_customer_service");
};
var setIntelligentCustomerServiceConfig = function setIntelligentCustomerServiceConfig(params) {
  return axios.post(base + "/setting/set_intelligent_customer_service", params);
};

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntelligentOutboundCallTable", function() { return getIntelligentOutboundCallTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntelligentOutboundCallDetail", function() { return getIntelligentOutboundCallDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntelligentOutboundCallDetailTable", function() { return getIntelligentOutboundCallDetailTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCallDetailData", function() { return exportCallDetailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportIntelligentOutboundCallData", function() { return exportIntelligentOutboundCallData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createIntelligentOutboundCallData", function() { return createIntelligentOutboundCallData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIntelligentOutboundCallData", function() { return updateIntelligentOutboundCallData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteIntelligentOutboundCallData", function() { return deleteIntelligentOutboundCallData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "robotCallqueryBatchUpload", function() { return robotCallqueryBatchUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startCallTask", function() { return startCallTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suspendCallTask", function() { return suspendCallTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importCallDetailAdd", function() { return importCallDetailAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importCallDetailChange", function() { return importCallDetailChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "robotCalldownSourceFile", function() { return robotCalldownSourceFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "robotCalldownErrorFile", function() { return robotCalldownErrorFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "robotcallSetting", function() { return robotcallSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntelligentOutboundCallRecordTable", function() { return getIntelligentOutboundCallRecordTable; });
/* global process */
var base = window._env_.VUE_APP_ROBOT_CALL_HOST;
var getIntelligentOutboundCallTable = function getIntelligentOutboundCallTable(params) {
  return axios.post(base + "/admin/calltask/list", params);
};
var getIntelligentOutboundCallDetail = function getIntelligentOutboundCallDetail(params) {
  return axios.get(base + "/admin/calltask/" + params.id, params);
};
var getIntelligentOutboundCallDetailTable = function getIntelligentOutboundCallDetailTable(params) {
  return axios.post(base + "/admin/calldetail/list", params);
};
var exportCallDetailData = function exportCallDetailData(params) {
  return axios.post(base + "/admin/calldetail/export", params);
};
var exportIntelligentOutboundCallData = function exportIntelligentOutboundCallData(params) {
  return axios.get(base + "/exportIntelligentOutboundCallData/" + params.id, { params: params });
};
var createIntelligentOutboundCallData = function createIntelligentOutboundCallData(params) {
  return axios.post(base + "/admin/calltask", params);
};
var updateIntelligentOutboundCallData = function updateIntelligentOutboundCallData(params) {
  return axios.post(base + "/admin/calltask/" + params.id, params.formData);
};
var deleteIntelligentOutboundCallData = function deleteIntelligentOutboundCallData(params) {
  return axios.post(base + "/deleteIntelligentOutboundCallData/" + params.id, params);
};
var robotCallqueryBatchUpload = function robotCallqueryBatchUpload(params) {
  return axios.post(base + "/admin/batch-jobs/list", params);
};

var startCallTask = function startCallTask(params) {
  return axios.put(base + "/admin/calltask/" + params.id + "/status/started", params);
};

var suspendCallTask = function suspendCallTask(params) {
  return axios.put(base + "/admin/calltask/" + params.id + "/status/suspended", params);
};

var importCallDetailAdd = function importCallDetailAdd(params) {
  return axios.post(base + "/admin/calldetail/import/add", params);
};

var importCallDetailChange = function importCallDetailChange(params) {
  return axios.post(base + "/admin/calldetail/import/update", params);
};

var robotCalldownSourceFile = function robotCalldownSourceFile(id) {
  return base + "/admin/batch-jobs/" + id + "/source.xlsx";
};
var robotCalldownErrorFile = function robotCalldownErrorFile(id) {
  return base + "/admin/batch-jobs/" + id + "/error.xlsx";
};

var robotcallSetting = function robotcallSetting(params) {
  return axios.post(base + "/admin/settings", params);
};

var getIntelligentOutboundCallRecordTable = function getIntelligentOutboundCallRecordTable(params) {
  return axios.post(base + "/admin/calldetail/" + params.id + "/records", params);
};

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceApplyTable", function() { return getInvoiceApplyTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceApplyDetail", function() { return getInvoiceApplyDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "retrySyncKingDeeApi", function() { return retrySyncKingDeeApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInvoiceApplyData", function() { return createInvoiceApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateInvoiceApplyData", function() { return updateInvoiceApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeInvoiceStatus", function() { return changeInvoiceStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadReportFile", function() { return uploadReportFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadAttachedFile", function() { return uploadAttachedFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadInvoiceApplyFile", function() { return uploadInvoiceApplyFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceApplyFileUrl", function() { return getInvoiceApplyFileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadInvoiceDetailPdf", function() { return downloadInvoiceDetailPdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchDownloadInvoicePdfs", function() { return batchDownloadInvoicePdfs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceProjectFinance", function() { return getInvoiceProjectFinance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExportApproveTable", function() { return getExportApproveTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "completeReceivedPayment", function() { return completeReceivedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newCompleteReceivedPayment", function() { return newCompleteReceivedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addReceivedPayment", function() { return addReceivedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceivedPaymentLogTable", function() { return getReceivedPaymentLogTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceivedPaymentDetail", function() { return getReceivedPaymentDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportReceivedPayment", function() { return exportReceivedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceivedPaymentTable", function() { return getReceivedPaymentTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPaymentAttachedFile", function() { return uploadPaymentAttachedFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceAmountTotal", function() { return getInvoiceAmountTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceivedSummary", function() { return getReceivedSummary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceByIdsApi", function() { return getInvoiceByIdsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendPayDaysApi", function() { return extendPayDaysApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExportPreReceivedApproveTable", function() { return getExportPreReceivedApproveTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPrepareInvoiceAmountTotal", function() { return getPrepareInvoiceAmountTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buApprovePassReceiptApply", function() { return buApprovePassReceiptApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buApproveRejectReceiptApply", function() { return buApproveRejectReceiptApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "financeApprovePassReceiptApply", function() { return financeApprovePassReceiptApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "financeApproveRejectReceiptApply", function() { return financeApproveRejectReceiptApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceApproveTable", function() { return getInvoiceApproveTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "completeInvoiceApply", function() { return completeInvoiceApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerReceivedInvoice", function() { return customerReceivedInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelReceiptApply", function() { return cancelReceiptApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "returnInvoiceApply", function() { return returnInvoiceApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rejectReturnInvoiceApply", function() { return rejectReturnInvoiceApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passReturnInvoiceApply", function() { return passReturnInvoiceApply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRedFlushTicket", function() { return createRedFlushTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deductItemBuPass", function() { return deductItemBuPass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deductItemBuReject", function() { return deductItemBuReject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deductItemFinancePass", function() { return deductItemFinancePass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deductItemFinanceReject", function() { return deductItemFinanceReject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deductItemApproveAbandon", function() { return deductItemApproveAbandon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateReceiptDeductList", function() { return updateReceiptDeductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInvoiceApplyDefaultConfig", function() { return getInvoiceApplyDefaultConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invoiceReceivedAssociation", function() { return invoiceReceivedAssociation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInvoiceCollectAssocApi", function() { return removeInvoiceCollectAssocApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiptApplicationsUnCollection", function() { return receiptApplicationsUnCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receiptApplicationsCollection", function() { return receiptApplicationsCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaiWangQueryXml", function() { return getBaiWangQueryXml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleBaiWangXml", function() { return handleBaiWangXml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaiOpenTicketXml", function() { return getBaiOpenTicketXml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "querySplitReceiptTable", function() { return querySplitReceiptTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveSplitTicketInfo", function() { return saveSplitTicketInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editSplitReceiptInfo", function() { return editSplitReceiptInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatusToInvoicing", function() { return setStatusToInvoicing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatusToVoiding", function() { return setStatusToVoiding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "manualSaveTicketSuccess", function() { return manualSaveTicketSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "manualVoidTicket", function() { return manualVoidTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backToPreviewStatus", function() { return backToPreviewStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "returnSplitTicket", function() { return returnSplitTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReceiptSplitData", function() { return createReceiptSplitData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRedFlushReceiptSplitData", function() { return createRedFlushReceiptSplitData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var finBase = window._env_.VUE_APP_FIN_CENTER_HOST;

var getInvoiceApplyTable = function getInvoiceApplyTable(params) {
  return axios.post(finBase + "/receipt-applications/lists", params);
};
// export const getInvoiceApplyDetail = params => {
//   return axios.get(`${base}/receipt-apply/get_${params.id}`, {params})
// }
var getInvoiceApplyDetail = function getInvoiceApplyDetail(params) {
  return axios.get(finBase + "/receipt-applications/" + params.id, { params: params });
};
// 重试同步金蝶
var retrySyncKingDeeApi = function retrySyncKingDeeApi(params) {
  return axios.get(finBase + "/receipt-applications/" + params.id + "/sync_kingdee", { params: params });
};

// export const exportInvoiceApplyData = params => {
//   return axios.get(`${base}/exportInvoiceApplyData/${params.id}`, {params})
// }
// export const createInvoiceApplyData = params => {
//   return axios.post(`${base}/receipt-apply/create`, params)
// }
var createInvoiceApplyData = function createInvoiceApplyData(params) {
  return axios.post(finBase + "/receipt-applications/create", params);
};
// export const updateInvoiceApplyData = params => {
//   return axios.post(`${base}/receipt-apply/edit_${params.id}`, params)
// }
var updateInvoiceApplyData = function updateInvoiceApplyData(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/edit", params);
};

var changeInvoiceStatus = function changeInvoiceStatus(params) {
  return axios.post(base + "/receipt-apply/update_status_" + params.id, params);
};

// export const uploadReportFile = params => {
//   return axios.post(`${base}/receipt-apply/upload_report`, params)
// }
var uploadReportFile = function uploadReportFile(params) {
  return axios.post(finBase + "/receipt-applications/detail/attached_files", params);
};

// export const completeInvoiceApply = params => {
//   return axios.post(`${base}/receipt-apply/complete_receipt_${params.id}`, params)
// }

var uploadAttachedFile = function uploadAttachedFile(params) {
  return axios.post(base + "/receipt-apply/upload_attached_file", params);
};
var uploadInvoiceApplyFile = function uploadInvoiceApplyFile(params) {
  return axios.post(finBase + "/receipt-applications/attached_files", params);
};

// export const getInvoiceApplyFile = params => {
//   return axios.get(`${base}/oss_file_url`, {params})
// }

var getInvoiceApplyFileUrl = function getInvoiceApplyFileUrl(params) {
  return base + "/receipt-apply/attached_file?download=1&name=" + params.name + "&type=" + params.type + "&url=" + params.url;
};

// 下载详情pdf文件
var downloadInvoiceDetailPdf = function downloadInvoiceDetailPdf(params) {
  return finBase + "/receipt-applications/" + params.id + "/pdf";
};
var batchDownloadInvoicePdfs = function batchDownloadInvoicePdfs(params) {
  return axios.post(finBase + "/receipt-applications/batch_pdfs", params);
};

var getInvoiceProjectFinance = function getInvoiceProjectFinance(params) {
  return axios.get(base + "/receipt-apply/project_finance_info_" + params.id, { params: params });
};

// export const getInvoiceApproveTable = params => {
//   return axios.post(`${base}/receipt-apply/query_approve`, params)
// }
// 导出开票审批列表
// export const getExportApproveTable = params => {
//   return axios.post(`${base}/receipt-apply/export_approve_list`, params)
// }
var getExportApproveTable = function getExportApproveTable(params) {
  return axios.post(finBase + "/receipt-applications/lists/export", params);
};

// 开票完成回款
var completeReceivedPayment = function completeReceivedPayment(params) {
  return axios.post(finBase + "/received-payment-old/detail/" + params.id + "/force_completed", params);
};
var newCompleteReceivedPayment = function newCompleteReceivedPayment(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/force_complete_collection", params);
};
// 开票回款记录日志
// export const addReceivedPayment = params => {
//   return axios.post(`${base}/receipt-apply/receive_payment`, params)
// }
var addReceivedPayment = function addReceivedPayment(params) {
  return axios.post(finBase + "/received-payment-old/detail/" + params.receipt_apply_detail_id + "/collection", params);
};

// 开票回款日志列表
// export const getReceivedPaymentLogTable = params => {
//   return axios.post(`${base}/receipt-apply/received_payment_log`, params)
// }
var getReceivedPaymentLogTable = function getReceivedPaymentLogTable(params) {
  return axios.post(finBase + "/received-payment-old/detail/" + params.id + "/log/lists", params);
};
// 开票回款查看
// export const getReceivedPaymentDetail = params => {
//   return axios.post(`${base}/receipt-apply/query_received_payment_detail`, params)
// }
var getReceivedPaymentDetail = function getReceivedPaymentDetail(params) {
  return axios.post(finBase + "/received-payment-old/" + params.id + "/detail/lists", params);
};
// 开票回款导出
var exportReceivedPayment = function exportReceivedPayment(params) {
  return axios.post(finBase + "/received-payment-old/lists/export", params);
};
// 开票回款列表
// export const getReceivedPaymentTable = params => {
//   return axios.post(`${base}/receipt-apply/query_received_payment`, params)
// }
var getReceivedPaymentTable = function getReceivedPaymentTable(params) {
  return axios.post(finBase + "/received-payment-old/lists", params);
};

// export const uploadPaymentAttachedFile = params => {
//   return axios.post(`${base}/receipt-apply/upload_payment_attached_file`, params)
// }
var uploadPaymentAttachedFile = function uploadPaymentAttachedFile(params) {
  return axios.post(finBase + "/received-payment-old/detail/upload_file", params);
};

// 开票管理按搜索结果汇总
// export const getInvoiceAmountTotal = params => {
//   return axios.post(`${base}/receipt-apply/get_receipt_amount_total`, params)
// }
var getInvoiceAmountTotal = function getInvoiceAmountTotal(params) {
  return axios.post(finBase + "/receipt-applications/summary", params);
};

var getReceivedSummary = function getReceivedSummary(params) {
  return axios.post(finBase + "/received-payment-old/summary", params);
};

var getInvoiceByIdsApi = function getInvoiceByIdsApi(params) {
  return axios.post(finBase + "/receipt-applications/get_by_ids", params);
};

var extendPayDaysApi = function extendPayDaysApi(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/extend_pay_days", params);
};

// export const getInvoiceApplyDefaultConfig = params => {
//   return axios.get(`${base}/receipt-apply/get_default_config`, {params})
// }

// export const deductItemApprovePass = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/pass_approve_${params.id}`, params)
// }

// export const deductItemApproveReject = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/reject_approve_${params.id}`, params)
// }

// export const deductItemApproveAbandon = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/abandon_apply_${params.id}`, params)
// }

// export const updateReceiptDeductList = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/edit_list_${params.id}`, params)
// }

// 导出预收款开票审批列表
// export const getExportPreReceivedApproveTable = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/export_approve_list`, params)
// }
var getExportPreReceivedApproveTable = function getExportPreReceivedApproveTable(params) {
  return axios.post(finBase + "/receipt-applications/advances/lists/export", params);
};
// 预收款开票按搜索结果汇总
var getPrepareInvoiceAmountTotal = function getPrepareInvoiceAmountTotal(params) {
  return axios.post(finBase + "/receipt-applications/advances/summary", params);
};

// NEW API
var buApprovePassReceiptApply = function buApprovePassReceiptApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/bu/pass", params);
};
var buApproveRejectReceiptApply = function buApproveRejectReceiptApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/bu/reject", params);
};
var financeApprovePassReceiptApply = function financeApprovePassReceiptApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/finance/pass", params);
};
var financeApproveRejectReceiptApply = function financeApproveRejectReceiptApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/finance/reject", params);
};
var getInvoiceApproveTable = function getInvoiceApproveTable(params) {
  return axios.post(finBase + "/receipt-applications/finance/lists", params);
};
var completeInvoiceApply = function completeInvoiceApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/complete_receipt", params);
};
var customerReceivedInvoice = function customerReceivedInvoice(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/customer_received", params);
};
var cancelReceiptApply = function cancelReceiptApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/cancel_apply", params);
};
var returnInvoiceApply = function returnInvoiceApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/return_ticket/apply", params);
};
var rejectReturnInvoiceApply = function rejectReturnInvoiceApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/return_ticket/approve/reject", params);
};
var passReturnInvoiceApply = function passReturnInvoiceApply(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/return_ticket/approve/pass", params);
};
var createRedFlushTicket = function createRedFlushTicket(params) {
  return axios.post(finBase + "/receipt-applications/" + params.id + "/return_ticket/approve/red_flush", params);
};
var deductItemBuPass = function deductItemBuPass(params) {
  return axios.post(finBase + "/receipt-applications/advances/deduct_items/" + params.id + "/bu/pass", params);
};
var deductItemBuReject = function deductItemBuReject(params) {
  return axios.post(finBase + "/receipt-applications/advances/deduct_items/" + params.id + "/bu/reject", params);
};
var deductItemFinancePass = function deductItemFinancePass(params) {
  return axios.post(finBase + "/receipt-applications/advances/deduct_items/" + params.id + "/finance/pass", params);
};
var deductItemFinanceReject = function deductItemFinanceReject(params) {
  return axios.post(finBase + "/receipt-applications/advances/deduct_items/" + params.id + "/finance/reject", params);
};
var deductItemApproveAbandon = function deductItemApproveAbandon(params) {
  return axios.post(finBase + "/receipt-applications/advances/deduct_items/" + params.id + "/abandon", params);
};
var updateReceiptDeductList = function updateReceiptDeductList(params) {
  return axios.post(finBase + "/receipt-applications/advances/" + params.id + "/deduct_lists", params);
};
var getInvoiceApplyDefaultConfig = function getInvoiceApplyDefaultConfig(params) {
  // return axios.get(`${finBase}/receipt-applications/default_config`, {params})
  return axios.get(base + "/setting/get_receipt_apply_config", { params: params });
};

// 回款与开票详情进行关联
var invoiceReceivedAssociation = function invoiceReceivedAssociation(params) {
  return axios.post(finBase + "/received-payment/receipt_detail/" + params.row_id + "/received/" + params.received_id + "/assoc", params);
};
// 删除回款与开票详情的关联关系
var removeInvoiceCollectAssocApi = function removeInvoiceCollectAssocApi(params) {
  return axios.post(finBase + "/received-payment/assocId/" + params.id + "/remove_assoc", params);
};

// 导出开票回款明细
var receiptApplicationsUnCollection = function receiptApplicationsUnCollection(params) {
  return axios.post(finBase + "/receipt-applications/un_collection/export", params);
};

// 导出开票未回款明细
var receiptApplicationsCollection = function receiptApplicationsCollection(params) {
  return axios.post(finBase + "/receipt-applications/collection/export", params);
};

// 获取百旺接口的xml数据参数
var getBaiWangQueryXml = function getBaiWangQueryXml(params) {
  return axios.post(finBase + "/receipt_split/get_bw_xml", params);
};
// 服务器解析 xml
var handleBaiWangXml = function handleBaiWangXml(params) {
  return axios.post(finBase + "/receipt_split/handle_bw_xml", params);
};
var getBaiOpenTicketXml = function getBaiOpenTicketXml(params) {
  return axios.post(finBase + "/receipt_split/get_ticket_xml", params);
};
var querySplitReceiptTable = function querySplitReceiptTable(params) {
  return axios.post(finBase + "/receipt_split/lists", params);
};
var saveSplitTicketInfo = function saveSplitTicketInfo(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/save_ticket", params);
};
var editSplitReceiptInfo = function editSplitReceiptInfo(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/edit", params);
};
var setStatusToInvoicing = function setStatusToInvoicing(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/status_to_invoicing", params);
};
var setStatusToVoiding = function setStatusToVoiding(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/status_to_voiding", params);
};
var manualSaveTicketSuccess = function manualSaveTicketSuccess(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/manual_save_ticket", params);
};
var manualVoidTicket = function manualVoidTicket(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/manual_void", params);
};
var backToPreviewStatus = function backToPreviewStatus(params) {
  return axios.post(finBase + "/receipt_split/" + params.id + "/back_status", params);
};
var returnSplitTicket = function returnSplitTicket(params) {
  return axios.post(finBase + "/receipt_split/return_ticket", params);
};

var createReceiptSplitData = function createReceiptSplitData(params) {
  return axios.post(finBase + "/receipt_split/create", params);
};

var createRedFlushReceiptSplitData = function createRedFlushReceiptSplitData(params) {
  return axios.post(finBase + "/receipt_split/create_red_flush", params);
};

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIssueDetail", function() { return getIssueDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIssueLogs", function() { return getIssueLogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createIssue", function() { return createIssue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIssueUser", function() { return updateIssueUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIssueOpen", function() { return updateIssueOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIssueFinish", function() { return updateIssueFinish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIssueFinishAndOrderNotPassed", function() { return updateIssueFinishAndOrderNotPassed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateIssueWait", function() { return updateIssueWait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addIssueComment", function() { return addIssueComment; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getIssueDetail = function getIssueDetail(params) {
  return axios.get(base + "/issue_" + params.id, params);
};
var getIssueLogs = function getIssueLogs(params) {
  return axios.get(base + "/issuelog_" + params.id, params);
};
var createIssue = function createIssue(params) {
  return axios.post(base + "/create_issue_" + params.order_id, params);
};
var updateIssueUser = function updateIssueUser(params) {
  return axios.post(base + "/accept_issue_" + params.id, params);
};
var updateIssueOpen = function updateIssueOpen(params) {
  return axios.post(base + "/redeal_issue_" + params.id, params);
};
var updateIssueFinish = function updateIssueFinish(params) {
  return axios.post(base + "/finish_issue_" + params.id, params);
};
var updateIssueFinishAndOrderNotPassed = function updateIssueFinishAndOrderNotPassed(params) {
  return axios.post(base + "/giveup_issue_" + params.id, params);
};
var updateIssueWait = function updateIssueWait(params) {
  return axios.post(base + "/suspend_issue_" + params.id, params);
};
var addIssueComment = function addIssueComment(params) {
  return axios.post(base + "/addcomment_issue_" + params.id, params);
};

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLaunchPageActivityTable", function() { return getLaunchPageActivityTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLaunchPageActivityDetail", function() { return getLaunchPageActivityDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLaunchPageActivityData", function() { return createLaunchPageActivityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateLaunchPageActivityData", function() { return updateLaunchPageActivityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteLaunchPageActivityData", function() { return deleteLaunchPageActivityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlineLaunchPageActivityData", function() { return onlineLaunchPageActivityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineLaunchPageActivityData", function() { return offlineLaunchPageActivityData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getLaunchPageActivityTable = function getLaunchPageActivityTable(params) {
  return axios.post(base + "/launch_page_activity/query", params);
};
var getLaunchPageActivityDetail = function getLaunchPageActivityDetail(params) {
  return axios.get(base + "/launch_page_activity/get_" + params.id, { params: params });
};
var createLaunchPageActivityData = function createLaunchPageActivityData(params) {
  return axios.post(base + "/launch_page_activity/create", params);
};
var updateLaunchPageActivityData = function updateLaunchPageActivityData(params) {
  return axios.post(base + "/launch_page_activity/edit_" + params.id, params);
};
var deleteLaunchPageActivityData = function deleteLaunchPageActivityData(params) {
  return axios.post(base + "/launch_page_activity/delete_" + params.id, params);
};
var onlineLaunchPageActivityData = function onlineLaunchPageActivityData(params) {
  return axios.post(base + "/launch_page_activity/online_" + params.id, params);
};
var offlineLaunchPageActivityData = function offlineLaunchPageActivityData(params) {
  return axios.post(base + "/launch_page_activity/offline_" + params.id, params);
};

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermission", function() { return getPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getApiPermission", function() { return getApiPermission; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCaptchaCode", function() { return fetchCaptchaCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refreshToken", function() { return refreshToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVersion", function() { return getVersion; });
var base = window._env_.VUE_APP_AUTH_HOST;
var admin = window._env_.VUE_APP_ADMIN_HOST;
var login = function login(params) {
  if (params.captchacode) {
    var headers = {
      'SJ-CaptchaCode-Token': params.captchaCodeToken
    };
    delete params.captchaCodeToken;
    return axios.post(base + '/login', params, { headers: headers });
  }
  return axios.post(base + '/login', params);
};
var getPermission = function getPermission(params) {
  return axios.get(admin + '/permission');
};
var getApiPermission = function getApiPermission(params) {
  return axios.get(admin + '/api_permissions');
};
var fetchCaptchaCode = function fetchCaptchaCode(params) {
  return axios.get(base + '/captchacode');
};
var refreshToken = function refreshToken(params) {
  return axios.post(base + '/refresh', params);
};
var getVersion = function getVersion(params) {
  return axios.get(admin + '/version', params);
};

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMapCommentFeedbackTable", function() { return getMapCommentFeedbackTable; });
var adminBase = window._env_.VUE_APP_ADMIN_HOST;

var getMapCommentFeedbackTable = function getMapCommentFeedbackTable(params) {
  return axios.post(adminBase + "/query_market_map_comments", params);
};

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryMarketNg", function() { return queryMarketNg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportMarketNg", function() { return exportMarketNg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryMarketNgDetail", function() { return queryMarketNgDetail; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var queryMarketNg = function queryMarketNg(params) {
  return axios.post(base + "/market-ng/query", params);
};
var exportMarketNg = function exportMarketNg(params) {
  return axios.post(base + "/market-ng/export", params);
};
var queryMarketNgDetail = function queryMarketNgDetail(params) {
  return axios.post(base + "/market-ng/query_detail", params);
};

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryMarketCsLocationLog", function() { return queryMarketCsLocationLog; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var queryMarketCsLocationLog = function queryMarketCsLocationLog(params) {
  return axios.post(base + "/market-cs-location-log/query", params);
};

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryMarket", function() { return queryMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarketDetail", function() { return getMarketDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBasicMarketTable", function() { return getBasicMarketTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBasicMarketDetail", function() { return getBasicMarketDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarketUpload", function() { return getMarketUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadCreateMarket", function() { return batchUploadCreateMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadUpdateAllRightMarket", function() { return batchUploadUpdateAllRightMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadUpdateMarket", function() { return batchUploadUpdateMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportMarket", function() { return exportMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMarket", function() { return deleteMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadMarketPhoto", function() { return uploadMarketPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateMarketData", function() { return updateMarketData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTaskByMarket", function() { return updateTaskByMarket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMarketData", function() { return createMarketData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryMarketLog", function() { return queryMarketLog; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var queryMarket = function queryMarket(params) {
  return axios.post(base + "/query_market", params);
};
var getMarketDetail = function getMarketDetail(params) {
  return axios.get(base + "/market_" + params.id, params);
};
var getBasicMarketTable = function getBasicMarketTable(params) {
  return axios.post(base + "/basic-info/query_market", params);
};
var getBasicMarketDetail = function getBasicMarketDetail(params) {
  return axios.get(base + "/basic-info/market_" + params.id);
};
var getMarketUpload = function getMarketUpload(params) {
  return axios.post(base + "/query_market_upload", params);
};
var batchUploadCreateMarket = function batchUploadCreateMarket(params) {
  return axios.post(base + "/batch_create_market_upload", params);
};
var batchUploadUpdateAllRightMarket = function batchUploadUpdateAllRightMarket(params) {
  return axios.post(base + "/batch_update_market_all_right_upload", params);
};
var batchUploadUpdateMarket = function batchUploadUpdateMarket(params) {
  return axios.post(base + "/batch_update_market_upload", params);
};
var exportMarket = function exportMarket(params) {
  return axios.post(base + "/export_market", params);
};
var deleteMarket = function deleteMarket(params) {
  return axios.post(base + "/delete_market_" + params.id, params);
};
var uploadMarketPhoto = function uploadMarketPhoto(params) {
  return axios.post(base + "/upload_market_photos", params);
};
var updateMarketData = function updateMarketData(params) {
  return axios.post(base + "/update_market_" + params.id, params);
};
var updateTaskByMarket = function updateTaskByMarket(params) {
  return axios.post(base + "/update_task_by_market_" + params.id, params);
};
var createMarketData = function createMarketData(params) {
  return axios.post(base + "/create_market", params);
};
var queryMarketLog = function queryMarketLog(params) {
  return axios.post(base + "/query_market_log_" + params.id, params);
};

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMidanTable", function() { return getMidanTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMidanDetail", function() { return getMidanDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMidanData", function() { return createMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "previewMidanData", function() { return previewMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateMidanData", function() { return updateMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateDynamicsettingMidanData", function() { return updateDynamicsettingMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "previewDynamicsettingMidanData", function() { return previewDynamicsettingMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startMidanData", function() { return startMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopMidanData", function() { return stopMidanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "previewInfo", function() { return previewInfo; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getMidanTable = function getMidanTable(params) {
  return axios.post(base + "/midan/query", params);
};
var getMidanDetail = function getMidanDetail(params) {
  return axios.get(base + "/midan/get/" + params.id, { params: params });
};
var createMidanData = function createMidanData(params) {
  return axios.post(base + "/midan/create", params);
};
var previewMidanData = function previewMidanData(params) {
  return axios.post(base + "/midan/preview", params);
};
var updateMidanData = function updateMidanData(params) {
  return axios.post(base + "/midan/edit/" + params.id, params);
};
var updateDynamicsettingMidanData = function updateDynamicsettingMidanData(params) {
  return axios.post(base + "/midan/dynamicsetting/change/" + params.id, params);
};
var previewDynamicsettingMidanData = function previewDynamicsettingMidanData(params) {
  return axios.post(base + "/midan/dynamicsetting/preview/" + params.id, params);
};
var startMidanData = function startMidanData(params) {
  return axios.post(base + "/midan/start/" + params.id, params);
};
var stopMidanData = function stopMidanData(params) {
  return axios.post(base + "/midan/stop/" + params.id, params);
};

var previewInfo = function previewInfo(params) {
  return axios.post(base + "/midan/preview", params);
};

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMiddleEndTask", function() { return createMiddleEndTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarketSalary", function() { return getMarketSalary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMiddleEndTaskBatchjob", function() { return getMiddleEndTaskBatchjob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateAvgSalary", function() { return validateAvgSalary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMiddleEndAudit", function() { return createMiddleEndAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editMiddleEndAudit", function() { return editMiddleEndAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMiddleEndAudit", function() { return getMiddleEndAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMiddleEndApproveTable", function() { return getMiddleEndApproveTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editMiddleEndApproveStatus", function() { return editMiddleEndApproveStatus; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var createMiddleEndTask = function createMiddleEndTask(params) {
  return axios.post(base + "/middle-end-task/create", params);
};

var getMarketSalary = function getMarketSalary(params) {
  return axios.get(base + "/middle-end-task/get_market_salary_" + params.marketId, { params: params });
};

var getMiddleEndTaskBatchjob = function getMiddleEndTaskBatchjob(params) {
  return axios.get(base + "/middle-end-task/get_job_" + params.id);
};

var validateAvgSalary = function validateAvgSalary(params) {
  return axios.post(base + "/middle-end-task/validate_avg_salary", params);
};

var createMiddleEndAudit = function createMiddleEndAudit(params) {
  return axios.post(base + "/middle-end-task/create_audit", params);
};

var editMiddleEndAudit = function editMiddleEndAudit(params) {
  return axios.post(base + "/middle-end-task/edit_audit_" + params.id, params);
};

var getMiddleEndAudit = function getMiddleEndAudit(params) {
  return axios.get(base + "/middle-end-task/get_" + params.id);
};

var getMiddleEndApproveTable = function getMiddleEndApproveTable(params) {
  return axios.post(base + "/middle-end-task/query_audit", params);
};

var editMiddleEndApproveStatus = function editMiddleEndApproveStatus(params) {
  return axios.post(base + "/middle-end-task/edit_status_" + params.id, params);
};

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupationQuestionnaireTable", function() { return getOccupationQuestionnaireTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupationQuestionnaireDetail", function() { return getOccupationQuestionnaireDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "previewOccupationQuestionnaire", function() { return previewOccupationQuestionnaire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOccupationQuestionnaireData", function() { return createOccupationQuestionnaireData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOccupationQuestionnaireData", function() { return updateOccupationQuestionnaireData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOccupationQuestionnaireStatus", function() { return setOccupationQuestionnaireStatus; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getOccupationQuestionnaireTable = function getOccupationQuestionnaireTable(params) {
  return axios.post(base + "/occupation/questionnaire/query", params);
};
var getOccupationQuestionnaireDetail = function getOccupationQuestionnaireDetail(params) {
  return axios.get(base + "/occupation/questionnaire/get_" + params.id, { params: params });
};
var previewOccupationQuestionnaire = function previewOccupationQuestionnaire(params) {
  return axios.get(base + "/occupation/questionnaire/preview_" + params.id, { params: params });
};
var createOccupationQuestionnaireData = function createOccupationQuestionnaireData(params) {
  return axios.post(base + "/occupation/questionnaire/create", params);
};
var updateOccupationQuestionnaireData = function updateOccupationQuestionnaireData(params) {
  return axios.post(base + "/occupation/questionnaire/edit_" + params.id, params);
};
var setOccupationQuestionnaireStatus = function setOccupationQuestionnaireStatus(params) {
  return axios.post(base + "/occupation/questionnaire/set_status_" + params.id, params);
};

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupationTable", function() { return getOccupationTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupationDetail", function() { return getOccupationDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOccupationData", function() { return exportOccupationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOccupationData", function() { return createOccupationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOccupationData", function() { return updateOccupationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOccupationData", function() { return deleteOccupationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOccupationUser", function() { return deleteOccupationUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOccupationUser", function() { return addOccupationUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOccupationUserList", function() { return getOccupationUserList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadOccupationFile", function() { return uploadOccupationFile; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getOccupationTable = function getOccupationTable(params) {
  return axios.post(base + "/occupation/query", params);
};
var getOccupationDetail = function getOccupationDetail(params) {
  return axios.get(base + "/occupation/get_" + params.id, { params: params });
};
var exportOccupationData = function exportOccupationData(params) {
  return axios.get(base + "/exportOccupationData/" + params.id, { params: params });
};
var createOccupationData = function createOccupationData(params) {
  return axios.post(base + "/occupation/create", params);
};
var updateOccupationData = function updateOccupationData(params) {
  return axios.post(base + "/occupation/edit_" + params.id, params);
};
var deleteOccupationData = function deleteOccupationData(params) {
  return axios.post(base + "/deleteOccupationData/" + params.id, params);
};
var deleteOccupationUser = function deleteOccupationUser(params) {
  return axios.post(base + "/occupation/remove_user_" + params.id + "_" + params.userid, params);
};
var addOccupationUser = function addOccupationUser(params) {
  return axios.post(base + "/occupation/add_user_" + params.id + "_" + params.userid, params);
};
var getOccupationUserList = function getOccupationUserList(params) {
  return axios.post(base + "/occupation/query_user", params);
};
var uploadOccupationFile = function uploadOccupationFile(params, config) {
  return axios.post(base + "/occupation/uploadfile", params, config);
};

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderImageRecaptureDetectionCustomerSummaryTable", function() { return getOrderImageRecaptureDetectionCustomerSummaryTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderImageRecaptureDetectionProjectSummaryTable", function() { return getOrderImageRecaptureDetectionProjectSummaryTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderImageRecaptureDetectionBatchSummaryTable", function() { return getOrderImageRecaptureDetectionBatchSummaryTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderImageRecaptureDetectionImageTable", function() { return getOrderImageRecaptureDetectionImageTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderImageRecaptureDetectionImageDetail", function() { return getOrderImageRecaptureDetectionImageDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOrderImageRecaptureDetectionImageStatus", function() { return setOrderImageRecaptureDetectionImageStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOrderImageRecaptureDetectionImageStatusBySearch", function() { return setOrderImageRecaptureDetectionImageStatusBySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportOrderImageRecaptureDetectionData", function() { return exportOrderImageRecaptureDetectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrderImageRecaptureDetectionData", function() { return createOrderImageRecaptureDetectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateOrderImageRecaptureDetectionData", function() { return updateOrderImageRecaptureDetectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOrderImageRecaptureDetectionData", function() { return deleteOrderImageRecaptureDetectionData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getOrderImageRecaptureDetectionCustomerSummaryTable = function getOrderImageRecaptureDetectionCustomerSummaryTable(params) {
  return axios.post(base + "/image-recapture-detection/query_customer_summary", params);
};
var getOrderImageRecaptureDetectionProjectSummaryTable = function getOrderImageRecaptureDetectionProjectSummaryTable(params) {
  return axios.post(base + "/image-recapture-detection/query_project_summary", params);
};
var getOrderImageRecaptureDetectionBatchSummaryTable = function getOrderImageRecaptureDetectionBatchSummaryTable(params) {
  return axios.post(base + "/image-recapture-detection/query_batch_summary", params);
};
var getOrderImageRecaptureDetectionImageTable = function getOrderImageRecaptureDetectionImageTable(params) {
  return axios.post(base + "/image-recapture-detection/query_image", params);
};
var getOrderImageRecaptureDetectionImageDetail = function getOrderImageRecaptureDetectionImageDetail(params) {
  return axios.get(base + "/image-recapture-detection/image_" + params.id);
};
var setOrderImageRecaptureDetectionImageStatus = function setOrderImageRecaptureDetectionImageStatus(params) {
  return axios.post(base + "/image-recapture-detection/set_image_status", params);
};
var setOrderImageRecaptureDetectionImageStatusBySearch = function setOrderImageRecaptureDetectionImageStatusBySearch(params) {
  return axios.post(base + "/image-recapture-detection/set_image_status_by_search", params);
};
var exportOrderImageRecaptureDetectionData = function exportOrderImageRecaptureDetectionData(params) {
  return axios.get(base + "/exportOrderImageRecaptureDetectionData/" + params.id, { params: params });
};
var createOrderImageRecaptureDetectionData = function createOrderImageRecaptureDetectionData(params) {
  return axios.post(base + "/createOrderImageRecaptureDetectionData", params);
};
var updateOrderImageRecaptureDetectionData = function updateOrderImageRecaptureDetectionData(params) {
  return axios.post(base + "/updateOrderImageRecaptureDetectionData/" + params.id, params);
};
var deleteOrderImageRecaptureDetectionData = function deleteOrderImageRecaptureDetectionData(params) {
  return axios.post(base + "/deleteOrderImageRecaptureDetectionData/" + params.id, params);
};

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTargetSettingTable", function() { return getTargetSettingTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTargetSetting", function() { return createTargetSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTargetValueTable", function() { return getTargetValueTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTargetValue", function() { return createTargetValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCreateTargetValue", function() { return batchCreateTargetValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTargetValue", function() { return updateTargetValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTargetInternUserDetail", function() { return getTargetInternUserDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryKeyin", function() { return getQueryKeyin; });
/* global process */
var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

// 获取目标设定列表
var getTargetSettingTable = function getTargetSettingTable(params) {
  return axios.get(orderAuditBase + "/admin/audit-project-range/query", { params: params });
};

// 创建目标设定
var createTargetSetting = function createTargetSetting(params) {
  return axios.post(orderAuditBase + "/admin/audit-project-range/create", params);
};

// 获取目标值列表
var getTargetValueTable = function getTargetValueTable(params) {
  return axios.get(orderAuditBase + "/admin/intern-audit-daily-plan/query", { params: params });
};

// 创建目标值
var createTargetValue = function createTargetValue(params) {
  return axios.post(orderAuditBase + "/admin/intern-audit-daily-plan/create", params);
};

// 批量创建目标值
var batchCreateTargetValue = function batchCreateTargetValue(params) {
  return axios.post(orderAuditBase + "/admin/intern-audit-daily-plan/batch-create", params);
};

// 更新目标值
var updateTargetValue = function updateTargetValue(params) {
  return axios.post(orderAuditBase + "/admin/intern-audit-daily-plan/update/" + params.id, params);
};
// 获取实习生详情：复用 audit-intern 中的实习生基础信息风格
var getTargetInternUserDetail = function getTargetInternUserDetail(params) {
  return axios.get(orderAuditBase + "/admin/intern_user/" + params.id + "/base", { params: params });
};

// KeyIn 异常工单反馈列表查询
var getQueryKeyin = function getQueryKeyin(params) {
  return axios.get(orderAuditBase + "/admin/review-task/query-keyin", { params: params });
};

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSignedOssUrl", function() { return getSignedOssUrl; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

/**
 * 通用 OSS 上传签名
 * @param {{file_name:string, ext:string, content_type:string, biz?:string}} params
 * @returns {Promise} detail: {signedUrl, url, content_type}
 */
var getSignedOssUrl = function getSignedOssUrl(params) {
  return axios.post(base + "/get_signed_oss_url", params);
};

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryPayCondition", function() { return queryPayCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPayCondition", function() { return getPayCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPayCondition", function() { return createPayCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePayCondition", function() { return updatePayCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enablePayCondition", function() { return enablePayCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disablePayCondition", function() { return disablePayCondition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPayConditionFile", function() { return uploadPayConditionFile; });
/* global process */
var finDomain = window._env_.VUE_APP_FIN_CENTER_HOST;
var queryPayCondition = function queryPayCondition(params) {
  return axios.post(finDomain + "/pay_condition/lists", params);
};
var getPayCondition = function getPayCondition(params) {
  return axios.get(finDomain + "/pay_condition/" + params.id);
};
var createPayCondition = function createPayCondition(params) {
  return axios.post(finDomain + "/pay_condition/create", params);
};
var updatePayCondition = function updatePayCondition(params) {
  return axios.post(finDomain + "/pay_condition/" + params.id + "/edit", params);
};
var enablePayCondition = function enablePayCondition(params) {
  return axios.post(finDomain + "/pay_condition/" + params.id + "/enable", params);
};
var disablePayCondition = function disablePayCondition(params) {
  return axios.post(finDomain + "/pay_condition/" + params.id + "/disable", params);
};
var uploadPayConditionFile = function uploadPayConditionFile(params) {
  return axios.post(finDomain + "/pay_condition/upload", params);
};

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getpaymentManagerNewDetail", function() { return getpaymentManagerNewDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "accountantReviewPaymentApplicationNew", function() { return accountantReviewPaymentApplicationNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "managerReviewPaymentApplicationNew", function() { return managerReviewPaymentApplicationNew; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;

// 获取付款详情
var getpaymentManagerNewDetail = function getpaymentManagerNewDetail(params) {
  return axios.get(base + "/payment-applications/" + params.id, { params: params });
};

// 会计审批（新）
var accountantReviewPaymentApplicationNew = function accountantReviewPaymentApplicationNew(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/accountant/status/v2", params);
};

// 财务经理审批（新）
var managerReviewPaymentApplicationNew = function managerReviewPaymentApplicationNew(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/manager/status/v2", params);
};

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentApprovalTable", function() { return getPaymentApprovalTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentApprovalDetail", function() { return getPaymentApprovalDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentApprovalData", function() { return exportPaymentApprovalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPaymentApprovalData", function() { return createPaymentApprovalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePaymentApprovalData", function() { return updatePaymentApprovalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePaymentApprovalData", function() { return deletePaymentApprovalData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getPaymentApprovalTable = function getPaymentApprovalTable(params) {
  return axios.post(base + "/getPaymentApprovalTable", params);
};
var getPaymentApprovalDetail = function getPaymentApprovalDetail(params) {
  return axios.get(base + "/getPaymentApprovalDetail/" + params.id, { params: params });
};
var exportPaymentApprovalData = function exportPaymentApprovalData(params) {
  return axios.get(base + "/exportPaymentApprovalData/" + params.id, { params: params });
};
var createPaymentApprovalData = function createPaymentApprovalData(params) {
  return axios.post(base + "/createPaymentApprovalData", params);
};
var updatePaymentApprovalData = function updatePaymentApprovalData(params) {
  return axios.post(base + "/updatePaymentApprovalData/" + params.id, params);
};
var deletePaymentApprovalData = function deletePaymentApprovalData(params) {
  return axios.post(base + "/deletePaymentApprovalData/" + params.id, params);
};

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPaymentManagerDataNew", function() { return createPaymentManagerDataNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePaymentManagerDataNew", function() { return updatePaymentManagerDataNew; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;

// 付款管理新增(新)
var createPaymentManagerDataNew = function createPaymentManagerDataNew(params) {
  return axios.post(base + "/payment-applications/v2", params);
};

// 付款管理修改(新)
var updatePaymentManagerDataNew = function updatePaymentManagerDataNew(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/v2", params);
};

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentManagerTable", function() { return getPaymentManagerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentManagerDetail", function() { return getPaymentManagerDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentDetailFinanceApi", function() { return getPaymentDetailFinanceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentManagerData", function() { return exportPaymentManagerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPaymentManagerData", function() { return createPaymentManagerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePaymentManagerData", function() { return updatePaymentManagerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePaymentManagerData", function() { return deletePaymentManagerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportTableData", function() { return exportTableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportDetailTableData", function() { return exportDetailTableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportWriteOffDetailTableData", function() { return exportWriteOffDetailTableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportWriteOffStatusData", function() { return exportWriteOffStatusData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportExportSearchAggregateData", function() { return exportExportSearchAggregateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getuserAccountDetailByUserID", function() { return getuserAccountDetailByUserID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "abandonPaymentApplication", function() { return abandonPaymentApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewPaymentApplication", function() { return reviewPaymentApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "accountantReviewPaymentApplication", function() { return accountantReviewPaymentApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "managerReviewPaymentApplication", function() { return managerReviewPaymentApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentApplication", function() { return paymentApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rejectedPayment", function() { return rejectedPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeOffApplication", function() { return writeOffApplication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editPaidAmountAfterPaid", function() { return editPaidAmountAfterPaid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "refundPayment", function() { return refundPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentApplicationPDF", function() { return exportPaymentApplicationPDF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadRefundFiles", function() { return uploadRefundFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finCenterUploadPaymentRefundFile", function() { return finCenterUploadPaymentRefundFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finCenterUploadPaymentApplyFile", function() { return finCenterUploadPaymentApplyFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterFileUrl", function() { return getFinCenterFileUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterFileUrlForDownload", function() { return getFinCenterFileUrlForDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentApplicationsBatchPdfs", function() { return exportPaymentApplicationsBatchPdfs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterConfigs", function() { return getFinCenterConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFinCenterConfigs", function() { return setFinCenterConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchApproverRealName", function() { return fetchApproverRealName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPaymentWriteOffData", function() { return createPaymentWriteOffData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePaymentWriteOffData", function() { return updatePaymentWriteOffData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "approverPassPaymentWriteOffData", function() { return approverPassPaymentWriteOffData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finAccountantPassPaymentWriteOffData", function() { return finAccountantPassPaymentWriteOffData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finManagerPassPaymentWriteOffData", function() { return finManagerPassPaymentWriteOffData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rejectPaymentWriteOffData", function() { return rejectPaymentWriteOffData; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;
var getPaymentManagerTable = function getPaymentManagerTable(params) {
  return axios.post(base + "/payment-applications/list", params);
};

var getPaymentManagerDetail = function getPaymentManagerDetail(params) {
  return axios.get(base + "/payment-applications/" + params.id, { params: params });
};
var getPaymentDetailFinanceApi = function getPaymentDetailFinanceApi(params) {
  return axios.get(base + "/payment-applications/" + params.id + "/finance", { params: params });
};
var exportPaymentManagerData = function exportPaymentManagerData(params) {
  return axios.get(base + "/exportPaymentManagerData/" + params.id, { params: params });
};
var createPaymentManagerData = function createPaymentManagerData(params) {
  return axios.post(base + "/payment-applications", params);
};
var updatePaymentManagerData = function updatePaymentManagerData(params) {
  return axios.put(base + "/payment-applications/" + params.id, params);
};
var deletePaymentManagerData = function deletePaymentManagerData(params) {
  return axios.post(base + "/deletePaymentManagerData/" + params.id, params);
};

var exportTableData = function exportTableData(params) {
  return axios.post(base + "/payment-applications/list/export", params);
};

var exportDetailTableData = function exportDetailTableData(params) {
  return axios.post(base + "/payment-applications/list/export/detail", params);
};

var exportWriteOffDetailTableData = function exportWriteOffDetailTableData(params) {
  return axios.post(base + "/payment-applications/list/export/write_off_detail", params);
};

var exportWriteOffStatusData = function exportWriteOffStatusData(params) {
  return axios.post(base + "/payment-applications/list/export/write_off_status", params);
};

var exportExportSearchAggregateData = function exportExportSearchAggregateData(params) {
  return axios.post(base + "/payment-applications/summary", params);
};

var getuserAccountDetailByUserID = function getuserAccountDetailByUserID(params) {
  return axios.get(base + "/user-accounts/" + params.id + "/user", { params: params });
};

// 放弃付款申请
var abandonPaymentApplication = function abandonPaymentApplication(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/abandon", params);
};

// 审核 is_rejected 0 通过，1 驳回请求 reason
var reviewPaymentApplication = function reviewPaymentApplication(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/status", params);
};

// 会计审批
var accountantReviewPaymentApplication = function accountantReviewPaymentApplication(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/accountant/status", params);
};

// 财务审批
var managerReviewPaymentApplication = function managerReviewPaymentApplication(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/manager/status", params);
};

// 财务付款
var paymentApplication = function paymentApplication(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/payment", params);
};

// 财务拒绝付款
var rejectedPayment = function rejectedPayment(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/reject", params);
};

// 财务冲销
var writeOffApplication = function writeOffApplication(params) {
  return axios.post(base + "/payment-applications/" + params.id + "/write_off", params);
};

// 财务修改实付金额
var editPaidAmountAfterPaid = function editPaidAmountAfterPaid(params) {
  return axios.put(base + "/payment-applications/" + params.id + "/finance/paid_amount", params);
};

// 退款
var refundPayment = function refundPayment(params) {
  return axios.post(base + "/payment-applications/" + params.id + "/finance/refund", params);
};

var exportPaymentApplicationPDF = function exportPaymentApplicationPDF(params) {
  return base + "/payment-applications/" + params.id + "/pdf";
};

var uploadRefundFiles = function uploadRefundFiles(params) {
  return axios.post(base + "/payment-applications/" + params.id + "/finance/refund", params);
};

// 付款管理退款附件上传
var finCenterUploadPaymentRefundFile = function finCenterUploadPaymentRefundFile(params) {
  return axios.post(base + "/payment-refund/attached_files", params);
};

// 付款管理上传附件
var finCenterUploadPaymentApplyFile = function finCenterUploadPaymentApplyFile(params) {
  return axios.post(base + "/payment-applications/attached_files", params);
};

// 获取访问资源 url
var getFinCenterFileUrl = function getFinCenterFileUrl(params) {
  return axios.get(base + "/oss_file_url", { params: params });
};

// 获取下载url
var getFinCenterFileUrlForDownload = function getFinCenterFileUrlForDownload(params) {
  return base + "/oss_file_download?name=file&type=" + params.type + "&url=" + params.url;
};

// 批量下载附件
var exportPaymentApplicationsBatchPdfs = function exportPaymentApplicationsBatchPdfs(params) {
  return axios.post(base + "/payment-applications/batch/pdfs", params);
};

var getFinCenterConfigs = function getFinCenterConfigs(params) {
  return axios.get(base + "/payment/settings", { params: params });
};

var setFinCenterConfigs = function setFinCenterConfigs(params) {
  return axios.post(base + "/payment/settings", params);
};

// 获取审批人真实姓名
var fetchApproverRealName = function fetchApproverRealName(params) {
  return axios.post(base + "/user-accounts/query_userinfo", params);
};

// 7.0.0 财务新增接口
// 添加新的冲销申请
var createPaymentWriteOffData = function createPaymentWriteOffData(params) {
  return axios.post(base + "/payment-applications/write_off/create", params);
};

// 编辑冲销申请
var updatePaymentWriteOffData = function updatePaymentWriteOffData(params) {
  return axios.post(base + "/payment-applications/write_off/" + params.id + "/edit", params);
};

// 审批人通过审批
var approverPassPaymentWriteOffData = function approverPassPaymentWriteOffData(params) {
  return axios.post(base + "/payment-applications/write_off/" + params.id + "/approver_pass", params);
};

// 财务会计通过
var finAccountantPassPaymentWriteOffData = function finAccountantPassPaymentWriteOffData(params) {
  return axios.post(base + "/payment-applications/write_off/" + params.id + "/finance/accountant_pass", params);
};

// 财务经理通过
var finManagerPassPaymentWriteOffData = function finManagerPassPaymentWriteOffData(params) {
  return axios.post(base + "/payment-applications/write_off/" + params.id + "/finance/manager_pass", params);
};

// 审批驳回
var rejectPaymentWriteOffData = function rejectPaymentWriteOffData(params) {
  return axios.post(base + "/payment-applications/write_off/" + params.id + "/reject", params);
};

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentRefundTable", function() { return getPaymentRefundTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentRefundDetail", function() { return getPaymentRefundDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentRefundTableData", function() { return exportPaymentRefundTableData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentRefundDetailData", function() { return exportPaymentRefundDetailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadRefundPdfFile", function() { return downloadRefundPdfFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadRefundPdfsFiles", function() { return downloadRefundPdfsFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadPdfFileFromServer", function() { return downloadPdfFileFromServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPaymentRefundSummaryData", function() { return exportPaymentRefundSummaryData; });
/* global process */
var finBase = window._env_.VUE_APP_FIN_CENTER_HOST;

var getPaymentRefundTable = function getPaymentRefundTable(params) {
  return axios.post(finBase + "/payment-refund/lists", params);
};
var getPaymentRefundDetail = function getPaymentRefundDetail(params) {
  return axios.get(finBase + "/payment-refund/" + params.id, { params: params });
};
var exportPaymentRefundTableData = function exportPaymentRefundTableData(params) {
  return axios.post(finBase + "/payment-refund/export/lists", params);
};
var exportPaymentRefundDetailData = function exportPaymentRefundDetailData(params) {
  return axios.post(finBase + "/payment-refund/export/detail", params);
};
var downloadRefundPdfFile = function downloadRefundPdfFile(params) {
  return finBase + "/payment-refund/" + params.id + "/pdf";
};
var downloadRefundPdfsFiles = function downloadRefundPdfsFiles(params) {
  return axios.post(finBase + "/payment-refund/batch/pdfs", params);
};
var downloadPdfFileFromServer = function downloadPdfFileFromServer(params) {
  return finBase + "/download_pdf?file=" + params.filename;
};

var exportPaymentRefundSummaryData = function exportPaymentRefundSummaryData(params) {
  return axios.post(finBase + "/payment-refund/summary", params);
};

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissionApplyTable", function() { return getPermissionApplyTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPermissionApplyData", function() { return exportPermissionApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPermissionApplyData", function() { return createPermissionApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passPermissionApplyData", function() { return passPermissionApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "failPassPermissionApplyData", function() { return failPassPermissionApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchPassPermissionApplyData", function() { return batchPassPermissionApplyData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissionApplyCustomerInfo", function() { return getPermissionApplyCustomerInfo; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getPermissionApplyTable = function getPermissionApplyTable(params) {
  return axios.post(base + "/permission_apply/query", params);
};
var exportPermissionApplyData = function exportPermissionApplyData(params) {
  return axios.get(base + "/exportPermissionApplyData/" + params.id, { params: params });
};
var createPermissionApplyData = function createPermissionApplyData(params) {
  return axios.post(base + "/permission_apply/create", params);
};

var passPermissionApplyData = function passPermissionApplyData(params) {
  return axios.post(base + "/permission_apply/pass_" + params.id, params);
};

var failPassPermissionApplyData = function failPassPermissionApplyData(params) {
  return axios.post(base + "/permission_apply/fail_" + params.id, params);
};
var batchPassPermissionApplyData = function batchPassPermissionApplyData(params) {
  return axios.post(base + "/permission_apply/batch_pass", params);
};
var getPermissionApplyCustomerInfo = function getPermissionApplyCustomerInfo(params) {
  return axios.get(base + "/permission_apply/get_admin_" + params.id, { params: params });
};

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissionTable", function() { return getPermissionTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissionGroupTable", function() { return getPermissionGroupTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissionGroupDetail", function() { return getPermissionGroupDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPermissionGroupData", function() { return exportPermissionGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPermissionGroupData", function() { return createPermissionGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePermissionGroupData", function() { return updatePermissionGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePermissionGroupData", function() { return deletePermissionGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "savePermissionGroupData", function() { return savePermissionGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPermissionPlatformlist", function() { return getPermissionPlatformlist; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__permission_config_host__ = __webpack_require__(215);


var getPermissionTable = function getPermissionTable(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/permissions/query', params);
};
var getPermissionGroupTable = function getPermissionGroupTable(params) {
  return axios.get(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/permissions/group/list', { params: params });
};
var getPermissionGroupDetail = function getPermissionGroupDetail(params) {
  return axios.get(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/getPermissionGroupDetail/' + params.id, { params: params });
};
var exportPermissionGroupData = function exportPermissionGroupData(params) {
  return axios.get(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/exportPermissionGroupData/' + params.id, { params: params });
};
var createPermissionGroupData = function createPermissionGroupData(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/permissions/group/add', params);
};
var updatePermissionGroupData = function updatePermissionGroupData(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/permissions/group/edit_' + params.id, params);
};
var deletePermissionGroupData = function deletePermissionGroupData(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/permissions/group/remove_' + params.id, params);
};
var savePermissionGroupData = function savePermissionGroupData(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/permissions/group/batch_edit', params);
};
var getPermissionPlatformlist = function getPermissionPlatformlist(params) {
  return axios.get(Object(__WEBPACK_IMPORTED_MODULE_0__permission_config_host__["a" /* permissionhost */])(params) + '/admin/adminuser/platformlist', { params: params });
};

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformAndroidapkTestTable", function() { return getPlatformAndroidapkTestTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformAndroidapkTestDetail", function() { return getPlatformAndroidapkTestDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPlatformAndroidapkTestData", function() { return exportPlatformAndroidapkTestData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatformAndroidapkTestData", function() { return createPlatformAndroidapkTestData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePlatformAndroidapkTestData", function() { return updatePlatformAndroidapkTestData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePlatformAndroidapkTestData", function() { return deletePlatformAndroidapkTestData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadApkFile", function() { return uploadApkFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAndroidApkSignedUrl", function() { return getAndroidApkSignedUrl; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getPlatformAndroidapkTestTable = function getPlatformAndroidapkTestTable(params) {
  return axios.post(base + "/query_android_apk", params);
};
var getPlatformAndroidapkTestDetail = function getPlatformAndroidapkTestDetail(params) {
  return axios.get(base + "/get_android_apk_" + params.id, { params: params });
};
var exportPlatformAndroidapkTestData = function exportPlatformAndroidapkTestData(params) {
  return axios.get(base + "/exportPlatformAndroidapkTestData/" + params.id, { params: params });
};
var createPlatformAndroidapkTestData = function createPlatformAndroidapkTestData(params) {
  return axios.post(base + "/creat_android_apk", params);
};
var updatePlatformAndroidapkTestData = function updatePlatformAndroidapkTestData(params) {
  return axios.post(base + "/edit_android_apk_" + params.id, params);
};
var deletePlatformAndroidapkTestData = function deletePlatformAndroidapkTestData(params) {
  return axios.post(base + "/delete_android_apk_" + params.id, params);
};
var uploadApkFile = function uploadApkFile(params) {
  return axios.post(base + "/upload_android_apk", params);
};
var getAndroidApkSignedUrl = function getAndroidApkSignedUrl(params) {
  return axios.post(base + "/get_android_apk_signed_url", params);
};

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDepartmentsIndex", function() { return getDepartmentsIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDepartmentDetail", function() { return getDepartmentDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addDepartment", function() { return addDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editDepartment", function() { return editDepartment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteDepartment", function() { return deleteDepartment; });
var adminBase = window._env_.VUE_APP_ADMIN_HOST;

var getDepartmentsIndex = function getDepartmentsIndex(params) {
  return axios.post(adminBase + "/department/query", params);
};
var getDepartmentDetail = function getDepartmentDetail(id) {
  return axios.get(adminBase + "/department/get_" + id);
};
var addDepartment = function addDepartment(params) {
  return axios.post(adminBase + "/department/create", params);
};
var editDepartment = function editDepartment(params) {
  return axios.post(adminBase + "/department/edit_" + params.id, params);
};
var deleteDepartment = function deleteDepartment(id) {
  return axios.post(adminBase + "/department/delete_" + id);
};

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRolesIndex", function() { return getRolesIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRoleDetail", function() { return getRoleDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addRole", function() { return addRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editRole", function() { return editRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyRole", function() { return copyRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteRole", function() { return deleteRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUiRolesIndex", function() { return getUiRolesIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUiRolePermissionsIndex", function() { return getUiRolePermissionsIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUiRoleDetail", function() { return getUiRoleDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUiRole", function() { return createUiRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUiRole", function() { return updateUiRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyUiRole", function() { return copyUiRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUiRole", function() { return deleteUiRole; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__ = __webpack_require__(215);

var base = window._env_.VUE_APP_ADMIN_HOST;

var getRolesIndex = function getRolesIndex(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__["a" /* permissionhost */])(params) + '/permissions/role/query', params);
};
var getRoleDetail = function getRoleDetail(params) {
  return axios.get(Object(__WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__["a" /* permissionhost */])(params) + '/permissions/role/get_' + params.id);
};
var addRole = function addRole(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__["a" /* permissionhost */])(params) + '/permissions/role/add', params);
};
var editRole = function editRole(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__["a" /* permissionhost */])(params) + '/permissions/role/edit_' + params.id, params);
};
var copyRole = function copyRole(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__["a" /* permissionhost */])(params) + '/permissions/role/copy_' + params.id);
};
var deleteRole = function deleteRole(params) {
  return axios.post(Object(__WEBPACK_IMPORTED_MODULE_0__views_permission_group_permission_config_host__["a" /* permissionhost */])(params) + '/permissions/role/remove_' + params.id);
};

// UI permissions
var getUiRolesIndex = function getUiRolesIndex(params) {
  return axios.post(base + '/uipermission/role/query', params);
};
var getUiRolePermissionsIndex = function getUiRolePermissionsIndex(params) {
  return axios.post(base + '/uipermission/role/query_permission', params);
};
var getUiRoleDetail = function getUiRoleDetail(params) {
  return axios.get(base + '/uipermission/role/get_' + params.id);
};
var createUiRole = function createUiRole(params) {
  return axios.post(base + '/uipermission/role/create', params);
};
var updateUiRole = function updateUiRole(params) {
  return axios.post(base + '/uipermission/role/update_' + params.id, params);
};
var copyUiRole = function copyUiRole(params) {
  return axios.post(base + '/uipermission/role/copy_' + params.id, params);
};
var deleteUiRole = function deleteUiRole(params) {
  return axios.post(base + '/uipermission/role/delete_' + params.id, params);
};

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadAddRole", function() { return batchUploadAddRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadDelRole", function() { return batchUploadDelRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadUpdateEmail", function() { return batchUploadUpdateEmail; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var batchUploadAddRole = function batchUploadAddRole(params) {
  return axios.post(base + "/adminuser/batch_add_role", params);
};
var batchUploadDelRole = function batchUploadDelRole(params) {
  return axios.post(base + "/adminuser/batch_del_role", params);
};
var batchUploadUpdateEmail = function batchUploadUpdateEmail(params) {
  return axios.post(base + "/adminuser/batch_update_email", params);
};

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePlatformUserProvince", function() { return updatePlatformUserProvince; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformUsersProvince", function() { return getPlatformUsersProvince; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var updatePlatformUserProvince = function updatePlatformUserProvince(params) {
  return axios.post(base + "/adminuser/edit_adminuser_province/" + params.id, params);
};
var getPlatformUsersProvince = function getPlatformUsersProvince(id) {
  return axios.get(base + "/adminuser/getprovince/" + id);
};

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatformUserWhitelistTable", function() { return getPlatformUserWhitelistTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportPlatformUserWhitelistData", function() { return exportPlatformUserWhitelistData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryPlatformUserWhitelistData", function() { return queryPlatformUserWhitelistData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePlatformUserWhitelistData", function() { return deletePlatformUserWhitelistData; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getPlatformUserWhitelistTable = function getPlatformUserWhitelistTable(params) {
  return axios.post(base + "/query_user", params);
};
var exportPlatformUserWhitelistData = function exportPlatformUserWhitelistData(params) {
  return axios.get(base + "/exportPlatformUserWhitelistData/" + params.id, { params: params });
};
var queryPlatformUserWhitelistData = function queryPlatformUserWhitelistData(params) {
  return axios.get(base + "/get_grayrelease_tag", params);
};
var deletePlatformUserWhitelistData = function deletePlatformUserWhitelistData(params) {
  return axios.post(base + "/delete_user_batch_tag", params);
};

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEducationTable", function() { return getEducationTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editEducation", function() { return editEducation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEducation", function() { return createEducation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editEducationLevel", function() { return editEducationLevel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFile", function() { return uploadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEducation", function() { return deleteEducation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHotTag", function() { return getHotTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEducation", function() { return getEducation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteHotTag", function() { return deleteHotTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addHotTag", function() { return addHotTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHomeModuleTable", function() { return getHomeModuleTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createModule", function() { return createModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editModule", function() { return editModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAvailableModule", function() { return getAvailableModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModuleOperateLog", function() { return getModuleOperateLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrderCommentTable", function() { return getOrderCommentTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarketInvalidFeedbackTable", function() { return getMarketInvalidFeedbackTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMarketInvalidFeedbackDetail", function() { return getMarketInvalidFeedbackDetail; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getEducationTable = function getEducationTable(params) {
  return axios.get(base + "/education", { params: params });
};
var editEducation = function editEducation(params) {
  return axios.post(base + "/education_update", params);
};
var createEducation = function createEducation(params) {
  return axios.post(base + "/education_create", params);
};
var editEducationLevel = function editEducationLevel(params) {
  return axios.post(base + "/education_priorityLevel", params);
};
var uploadFile = function uploadFile(params) {
  return axios.post(base + "/helpcenter_upload_file", params);
};
var deleteEducation = function deleteEducation(id) {
  return axios.post(base + "/education_delete_" + id);
};
var getHotTag = function getHotTag(id) {
  return axios.get(base + "/hotsearchlabel_list");
};
var getEducation = function getEducation(id) {
  return axios.get(base + "/education_" + id);
};
var deleteHotTag = function deleteHotTag(id) {
  return axios.post(base + "/hotsearchlabel_delete_" + id);
};
var addHotTag = function addHotTag(params) {
  return axios.post(base + "/hotsearchlabel_create", params);
};
var getHomeModuleTable = function getHomeModuleTable(params) {
  return axios.get(base + "/appmodule/query", { params: params });
};
var createModule = function createModule(params) {
  return axios.post(base + "/appmodule/create", params);
};
var editModule = function editModule(params) {
  return axios.post(base + "/appmodule/edit_" + params.id, params);
};
var getAvailableModule = function getAvailableModule(params) {
  return axios.get(base + "/appmodule/types");
};
var getModuleOperateLog = function getModuleOperateLog(params) {
  return axios.get(base + "/appmodule/query_log_" + params.id, { params: params });
};
var getOrderCommentTable = function getOrderCommentTable(params) {
  return axios.post(base + "/query_order_comment", params);
};
var getMarketInvalidFeedbackTable = function getMarketInvalidFeedbackTable(params) {
  return axios.post(base + "/market-invalid-feedback/query", params);
};
var getMarketInvalidFeedbackDetail = function getMarketInvalidFeedbackDetail(feedbackId) {
  return axios.post(base + "/market-invalid-feedback/detail_" + feedbackId);
};

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deductPoint", function() { return deductPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addPoint", function() { return addPoint; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var deductPoint = function deductPoint(params) {
  return axios.post(base + "/deduct_point_" + params.userid, params);
};
var addPoint = function addPoint(params) {
  return axios.post(base + "/add_point_" + params.userid, params);
};

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPositionTable", function() { return getPositionTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "topPosition", function() { return topPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "releasePosition", function() { return releasePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePosition", function() { return deletePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchDeletePosition", function() { return batchDeletePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchTopPosition", function() { return batchTopPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchReleasePosition", function() { return batchReleasePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPostionForm", function() { return getPostionForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modifyPostion", function() { return modifyPostion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editPostionOptions", function() { return editPostionOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPositionFile", function() { return uploadPositionFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchJobTable", function() { return getBatchJobTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlinePosition", function() { return offlinePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchOfflinePosition", function() { return batchOfflinePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchJobSample", function() { return batchJobSample; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchJobDown", function() { return batchJobDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchJobError", function() { return batchJobError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forceOfflinePosition", function() { return forceOfflinePosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lockPosition", function() { return lockPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unlockPosition", function() { return unlockPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "passAuditPosition", function() { return passAuditPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "failAuditPosition", function() { return failAuditPosition; });
var base = window._env_.VUE_APP_RECRUIT_HOST;
var getPositionTable = function getPositionTable(params) {
  return axios.post(base + "/query_position", params);
};
var topPosition = function topPosition(id) {
  return axios.post(base + "/top_position_" + id);
};
var releasePosition = function releasePosition(id) {
  return axios.post(base + "/release_position_" + id);
};
var deletePosition = function deletePosition(id) {
  return axios.post(base + "/delete_position_" + id);
};
var batchDeletePosition = function batchDeletePosition(ids) {
  return axios.post(base + "/batch_delete_position", ids);
};
var batchTopPosition = function batchTopPosition(ids) {
  return axios.post(base + "/batch_top_position", ids);
};
var batchReleasePosition = function batchReleasePosition(ids) {
  return axios.post(base + "/batch_release_position", ids);
};
var getPostionForm = function getPostionForm(id) {
  return axios.get(base + "/position_" + id);
};
var modifyPostion = function modifyPostion(params) {
  return axios.post(base + "/modify_position_" + params.id, params);
};
var editPostionOptions = function editPostionOptions(params) {
  return axios.get(base + "/edit_position_options");
};
var uploadPositionFile = function uploadPositionFile(params) {
  return axios.post(base + "/upload_position_file", params);
};
var getBatchJobTable = function getBatchJobTable(params) {
  return axios.post(base + "/query_batch_job", params);
};
var offlinePosition = function offlinePosition(id) {
  return axios.post(base + "/offline_position_" + id);
};
var batchOfflinePosition = function batchOfflinePosition(params) {
  return axios.post(base + "/batch_offline_position", params);
};
var batchJobSample = function batchJobSample(params) {
  return axios.get(base + "/batch_job_sample");
};
var batchJobDown = function batchJobDown(id) {
  return axios.get(base + "/batch_job_down_" + id);
};
var batchJobError = function batchJobError(id) {
  return axios.get(base + "/batch_job_error_" + id);
};
var forceOfflinePosition = function forceOfflinePosition(id) {
  return axios.post(base + "/force_offline_position_" + id);
};
var lockPosition = function lockPosition(id) {
  return axios.post(base + "/lock_position_" + id);
};
var unlockPosition = function unlockPosition(id) {
  return axios.post(base + "/unlock_position_" + id);
};
var passAuditPosition = function passAuditPosition(id) {
  return axios.post(base + "/pass_audit_position_" + id);
};
var failAuditPosition = function failAuditPosition(params) {
  return axios.post(base + "/fail_audit_position_" + params.position_id, params);
};

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPriceBatchTable", function() { return getPriceBatchTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPriceBatch", function() { return createPriceBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchPriceBatchItems", function() { return searchPriceBatchItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadPriceBatch", function() { return downloadPriceBatch; });
var base = window._env_.VUE_APP_ADMIN_HOST;

var getPriceBatchTable = function getPriceBatchTable(params) {
  return axios.get(base + "/task_dynamic_salary/query", params);
};
var createPriceBatch = function createPriceBatch(params) {
  return axios.post(base + "/task_dynamic_salary/create", params);
};
var searchPriceBatchItems = function searchPriceBatchItems(params) {
  return axios.get(base + "/task_dynamic_salary/search_info", { params: params });
};
var downloadPriceBatch = function downloadPriceBatch(id) {
  return base + "/excel/down_sourc_file_" + id;
};

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryProjectTaskPackageProjects", function() { return queryProjectTaskPackageProjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectTaskPackageConfig", function() { return getProjectTaskPackageConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveProjectTaskPackageConfig", function() { return saveProjectTaskPackageConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryProjectTaskPackageFlag", function() { return queryProjectTaskPackageFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createProjectTaskPackageFlag", function() { return createProjectTaskPackageFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProjectTaskPackageFlag", function() { return deleteProjectTaskPackageFlag; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var queryProjectTaskPackageProjects = function queryProjectTaskPackageProjects(params) {
  return axios.post(base + "/query_project_task_package_projects", params);
};

var getProjectTaskPackageConfig = function getProjectTaskPackageConfig(params) {
  return axios.get(base + "/project-task-package/config_" + (params.projectId || params.id));
};

var saveProjectTaskPackageConfig = function saveProjectTaskPackageConfig(params) {
  var projectId = params.projectId || params.id;
  return axios.post(base + "/project-task-package/save_config_" + projectId, params);
};

var queryProjectTaskPackageFlag = function queryProjectTaskPackageFlag(params) {
  return axios.post(base + "/project_task_package_flag/query", params || {});
};

var createProjectTaskPackageFlag = function createProjectTaskPackageFlag(params) {
  return axios.post(base + "/project_task_package_flag/create", params);
};

var deleteProjectTaskPackageFlag = function deleteProjectTaskPackageFlag(params) {
  return axios.post(base + "/project_task_package_flag/delete_" + params.id);
};

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectTable", function() { return getProjectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaiscProjectTable", function() { return getBaiscProjectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllProjectTable", function() { return getAllProjectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportProjectTable", function() { return exportProjectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectDetail", function() { return getProjectDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectName", function() { return getProjectName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceiptVirtualProjectTable", function() { return getReceiptVirtualProjectTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceiptVirtualProjectDetail", function() { return getReceiptVirtualProjectDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryProjectProgressTableApi", function() { return queryProjectProgressTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryProjectNodeSnapshotApi", function() { return queryProjectNodeSnapshotApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportProjectProgressTableApi", function() { return exportProjectProgressTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectProgressDetailApi", function() { return getProjectProgressDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editProgressShowStatusApi", function() { return editProgressShowStatusApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCustomerListApi", function() { return uploadCustomerListApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addProjectCostConfirmApi", function() { return addProjectCostConfirmApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditPassProjectCostApi", function() { return auditPassProjectCostApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditRejectProjectCostApi", function() { return auditRejectProjectCostApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectCostApi", function() { return getProjectCostApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addKickoffMeetingTimeApi", function() { return addKickoffMeetingTimeApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadCleanedFilesApi", function() { return uploadCleanedFilesApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addShareMeetingTimeApi", function() { return addShareMeetingTimeApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadProjectReportApi", function() { return uploadProjectReportApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addReviewMeetingTimeApi", function() { return addReviewMeetingTimeApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveBoHeaderScoreApi", function() { return saveBoHeaderScoreApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveFirstScoreApi", function() { return saveFirstScoreApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveSecondScoreApi", function() { return saveSecondScoreApi; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var finBase = window._env_.VUE_APP_FIN_CENTER_HOST;

var getProjectTable = function getProjectTable(params) {
  return axios.post(base + "/query_project", params);
};
var getBaiscProjectTable = function getBaiscProjectTable(params) {
  return axios.post(base + "/basic-info/query_project", params);
};
var getAllProjectTable = function getAllProjectTable(params) {
  return axios.post(base + "/query_all_project", params);
};
var exportProjectTable = function exportProjectTable(params) {
  return axios.post(base + "/export_project", params);
};
var getProjectDetail = function getProjectDetail(params) {
  return axios.get(base + "/project_" + params.id);
};
var getProjectName = function getProjectName(params) {
  return axios.post(base + "/project_base_on_name", params);
};

// 查询预收款开票虚拟项目信息列表
// export const getReceiptVirtualProjectTable = params => {
//   return axios.post(`${base}/receipt-apply/pre_received/query_virtual_project`, params)
// }
var getReceiptVirtualProjectTable = function getReceiptVirtualProjectTable(params) {
  return axios.post(finBase + "/receipt-applications/advances/virtual-projects/lists", params);
};
// 查询预收款开票虚拟项目信息详情
// export const getReceiptVirtualProjectDetail = params => {
//   return axios.get(`${base}/receipt-apply/pre_received/virtual_project_${params.id}`, {params})
// }
var getReceiptVirtualProjectDetail = function getReceiptVirtualProjectDetail(params) {
  return axios.get(finBase + "/receipt-applications/advances/virtual-projects/" + params.id, { params: params });
};

var queryProjectProgressTableApi = function queryProjectProgressTableApi(params) {
  return axios.post(base + "/project_progress/query", params);
};
var queryProjectNodeSnapshotApi = function queryProjectNodeSnapshotApi(params) {
  return axios.post(base + "/project_progress/snapshots", params);
};
var exportProjectProgressTableApi = function exportProjectProgressTableApi(params) {
  return axios.post(base + "/project_progress/export", params);
};
var getProjectProgressDetailApi = function getProjectProgressDetailApi(params) {
  return axios.get(base + "/project_progress/get_by_project/" + params.id, { params: params });
};
var editProgressShowStatusApi = function editProgressShowStatusApi(params) {
  return axios.post(base + "/project_progress/edit_show_status/" + params.id, params);
};
// 上传客户清单
var uploadCustomerListApi = function uploadCustomerListApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/upload_customer_clear_files", params);
};
// 成本确认
var addProjectCostConfirmApi = function addProjectCostConfirmApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/add_project_cost_confirm", params);
};
var auditPassProjectCostApi = function auditPassProjectCostApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/audit_pass_project_cost", params);
};
var auditRejectProjectCostApi = function auditRejectProjectCostApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/audit_reject_project_cost", params);
};
var getProjectCostApi = function getProjectCostApi(params) {
  return axios.get(base + "/project_progress/" + params.id + "/get_project_cost", { params: params });
};
// 添加启动会时间
var addKickoffMeetingTimeApi = function addKickoffMeetingTimeApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/add_kickoff_meeting", params);
};
// 上传清洗后的文件
var uploadCleanedFilesApi = function uploadCleanedFilesApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/upload_cleaned_files", params);
};
// 添加进度分享会时间
var addShareMeetingTimeApi = function addShareMeetingTimeApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/add_progress_share_meeting", params);
};
// 上传报告附件
var uploadProjectReportApi = function uploadProjectReportApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/upload_project_report", params);
};
// 添加复盘会时间
var addReviewMeetingTimeApi = function addReviewMeetingTimeApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/add_review_meeting", params);
};
// 保存BO Header评分
var saveBoHeaderScoreApi = function saveBoHeaderScoreApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/save_bo_header_score", params);
};
var saveFirstScoreApi = function saveFirstScoreApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/save_first_audit_score", params);
};
var saveSecondScoreApi = function saveSecondScoreApi(params) {
  return axios.post(base + "/project_progress/" + params.id + "/save_second_audit_score", params);
};

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQuestionNotPassMessageDetail", function() { return getQuestionNotPassMessageDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveQuestionNotPassMessageData", function() { return saveQuestionNotPassMessageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveBatchErrorMsgMultiple", function() { return saveBatchErrorMsgMultiple; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getQuestionNotPassMessageDetail = function getQuestionNotPassMessageDetail(params) {
  return axios.get(base + "/get_batch_error_msg/" + params.batch_id, { params: params });
};
var saveQuestionNotPassMessageData = function saveQuestionNotPassMessageData(params) {
  return axios.post(base + "/save_batch_error_msg/" + params.batch_id, params);
};

var saveBatchErrorMsgMultiple = function saveBatchErrorMsgMultiple(params) {
  return axios.post(base + "/save_batch_error_msg_multiple", params);
};

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewReceivedPaymentTable", function() { return getNewReceivedPaymentTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewReceivedPaymentDetail", function() { return getNewReceivedPaymentDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportCollectionRelatedDetail", function() { return exportCollectionRelatedDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReceivedPaymentData", function() { return createReceivedPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateReceivedPaymentData", function() { return updateReceivedPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteReceivedPaymentData", function() { return deleteReceivedPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forceFinishCollection", function() { return forceFinishCollection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceivedPaymentSummary", function() { return getReceivedPaymentSummary; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;
var getNewReceivedPaymentTable = function getNewReceivedPaymentTable(params) {
  return axios.post(base + "/received-payment/lists", params);
};
var getNewReceivedPaymentDetail = function getNewReceivedPaymentDetail(params) {
  return axios.get(base + "/received-payment/" + params.id, { params: params });
};
var exportCollectionRelatedDetail = function exportCollectionRelatedDetail(params) {
  return axios.post(base + "/received-payment/related/export", params);
};
var createReceivedPaymentData = function createReceivedPaymentData(params) {
  return axios.post(base + "/received-payment/create", params);
};
var updateReceivedPaymentData = function updateReceivedPaymentData(params) {
  return axios.post(base + "/received-payment/" + params.id + "/edit", params);
};
var deleteReceivedPaymentData = function deleteReceivedPaymentData(params) {
  return axios.post(base + "/deleteReceivedPaymentData/" + params.id, params);
};
var forceFinishCollection = function forceFinishCollection(params) {
  return axios.post(base + "/received-payment/" + params.id + "/force_finish", params);
};

// 回款数据汇总
var getReceivedPaymentSummary = function getReceivedPaymentSummary(params) {
  return axios.post(base + "/received-payment/summary", params);
};

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResumeTable", function() { return getResumeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResumeForm", function() { return getResumeForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportResume", function() { return exportResume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportResumes", function() { return exportResumes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appliedResume", function() { return appliedResume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendResumes", function() { return sendResumes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadResume", function() { return downloadResume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResumeOptions", function() { return getResumeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResumeAllTable", function() { return getResumeAllTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getResumeCity", function() { return getResumeCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editResume", function() { return editResume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadResumeImg", function() { return uploadResumeImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryCity", function() { return queryCity; });
var base = window._env_.VUE_APP_RECRUIT_HOST;
var getResumeTable = function getResumeTable(params) {
  return axios.post(base + "/applied_resume_" + params.position_id, params);
};
var getResumeForm = function getResumeForm(id) {
  return axios.get(base + "/resume_" + id);
};
var exportResume = function exportResume(params) {
  return axios.post(base + "/export_resume_" + params.position_id, params);
};
var exportResumes = function exportResumes(params) {
  return axios.post(base + "/export_resume", params);
};

var appliedResume = function appliedResume(params) {
  return axios.post(base + "/applied_" + params.positionId + "_resume_" + params.id, params);
};
var sendResumes = function sendResumes(params) {
  return axios.post(base + "/send_resumes", params);
};
var downloadResume = function downloadResume(path) {
  window.location.href = base + "/download_resume_" + path;
};
var getResumeOptions = function getResumeOptions(params) {
  return axios.get(base + "/resume_options");
};
var getResumeAllTable = function getResumeAllTable(params) {
  return axios.get(base + "/query_resumes", { params: params });
};
var getResumeCity = function getResumeCity(params) {
  return axios.post(base + "/query_resumes_city");
};
var editResume = function editResume(params) {
  return axios.post(base + "/edit_resume_" + params.id, params);
};
var uploadResumeImg = function uploadResumeImg(params) {
  return axios.post(base + "/upload_avatar", params);
};
var queryCity = function queryCity(params) {
  return axios.post(base + "/query_city", params);
};

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSatisfactionEmailTable", function() { return getSatisfactionEmailTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSatisfactionEmailDetail", function() { return getSatisfactionEmailDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSatisfactionEmailData", function() { return createSatisfactionEmailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSatisfactionEmailData", function() { return updateSatisfactionEmailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSatisfactionEmailLogTable", function() { return getSatisfactionEmailLogTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSatisfactionEmailPushLogTable", function() { return getSatisfactionEmailPushLogTable; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getSatisfactionEmailTable = function getSatisfactionEmailTable(params) {
  return axios.post(base + "/satisfaction_mail/query", params);
};
var getSatisfactionEmailDetail = function getSatisfactionEmailDetail(params) {
  return axios.get(base + "/satisfaction_mail/get_" + params.id, { params: params });
};

var createSatisfactionEmailData = function createSatisfactionEmailData(params) {
  return axios.post(base + "/satisfaction_mail/create", params);
};
var updateSatisfactionEmailData = function updateSatisfactionEmailData(params) {
  return axios.post(base + "/satisfaction_mail/edit_" + params.id, params);
};

var getSatisfactionEmailLogTable = function getSatisfactionEmailLogTable(params) {
  return axios.post(base + "/satisfaction_mail/query_log_" + params.id, params);
};
var getSatisfactionEmailPushLogTable = function getSatisfactionEmailPushLogTable(params) {
  return axios.post(base + "/satisfaction_mail/query_push_log_" + params.id, params);
};

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reinforcesWitch", function() { return reinforcesWitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProjectConfig", function() { return setProjectConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProjectConfig", function() { return getProjectConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReceiptApplyConfig", function() { return setReceiptApplyConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReceiptApplyConfig", function() { return getReceiptApplyConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadSJIdCardRegionFileApi", function() { return uploadSJIdCardRegionFileApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSJIdCardRegionFileApi", function() { return getSJIdCardRegionFileApi; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var authAPI = window._env_.VUE_APP_AUTH_HOST;

var changePassword = function changePassword(params) {
  return axios.post(base + "/change_password", params);
};

var reinforcesWitch = function reinforcesWitch(params) {
  return axios.get(authAPI + "/reinforceswitch", params);
};

var setProjectConfig = function setProjectConfig(params) {
  return axios.post(base + "/setting/set_project_config", params);
};
var getProjectConfig = function getProjectConfig(params) {
  return axios.get(base + "/setting/get_project_config", { params: params });
};
var setReceiptApplyConfig = function setReceiptApplyConfig(params) {
  return axios.post(base + "/setting/set_receipt_apply_config", params);
};
var getReceiptApplyConfig = function getReceiptApplyConfig(params) {
  return axios.get(base + "/setting/get_receipt_apply_config", { params: params });
};
var uploadSJIdCardRegionFileApi = function uploadSJIdCardRegionFileApi(params) {
  return axios.post(base + "/setting/upload_sjidcard_region", params);
};
var getSJIdCardRegionFileApi = function getSJIdCardRegionFileApi(params) {
  return axios.get(base + "/setting/get_sjidcard_region", { params: params });
};

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["createCityGroup"] = createCityGroup;
/* harmony export (immutable) */ __webpack_exports__["updateCityGroup"] = updateCityGroup;
/* harmony export (immutable) */ __webpack_exports__["getCityGroupDetail"] = getCityGroupDetail;
/* harmony export (immutable) */ __webpack_exports__["getList"] = getList;

var base = window._env_.VUE_APP_ADMIN_HOST;

/**
 * 创建省份分组
 * @param {Object} data - 分组数据
 * @param {string} data.split_name - 分组名称
 * @param {number} data.provinceid - 省份ID
 * @param {string[]} data.cityids - 城市ID数组
 * @returns {Promise} - 返回Promise对象
 */
function createCityGroup(data) {
  // 转换参数格式以匹配后端接口
  var params = {
    provinceid: data.provinceId,
    split_name: data.split_name,
    cityids: data.cityIds.map(function (id) {
      return id.toString();
    }) // 确保城市ID是字符串类型
  };

  return axios.post(base + "/data_screen/province_split/create", params);
}

/**
 * 更新省份分组
 * @param {number} id - 分组ID
 * @param {Object} data - 更新的分组数据
 * @param {string} data.name - 分组名称
 * @param {number} data.provinceId - 省份ID
 * @param {number[]} data.cityIds - 城市ID数组
 * @returns {Promise} - 返回Promise对象
 */
function updateCityGroup(id, data) {
  // 转换参数格式以匹配后端接口
  var params = {
    provinceid: data.provinceId,
    split_name: data.split_name,
    cityids: data.cityIds.map(function (id) {
      return id.toString();
    }) // 确保城市ID是字符串类型
  };

  return axios.post(base + "/data_screen/province_split/update_" + id, params);
}

/**
 * 获取省份分组详情
 * @param {number} id - 分组ID
 * @returns {Promise} - 返回Promise对象
 */
function getCityGroupDetail(id) {
  return axios.get(base + "/data_screen/province_split/get_" + id);
}

function getList(params) {
  return axios.post(base + "/data_screen/province_split/query", params);
}

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getPromoterList"] = getPromoterList;
/* harmony export (immutable) */ __webpack_exports__["getPromoterDetail"] = getPromoterDetail;
/* harmony export (immutable) */ __webpack_exports__["createPromoter"] = createPromoter;
/* harmony export (immutable) */ __webpack_exports__["updatePromoter"] = updatePromoter;
/* harmony export (immutable) */ __webpack_exports__["deletePromoter"] = deletePromoter;
/* harmony export (immutable) */ __webpack_exports__["exportPromoterList"] = exportPromoterList;
/* harmony export (immutable) */ __webpack_exports__["getPromoterProvinces"] = getPromoterProvinces;
var base = window._env_.VUE_APP_ADMIN_HOST;

/**
 * 获取推广人员列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} params.member_name - 姓名
 * @param {string} params.member_admin_name - 账号名称
 * @param {number} params.provinceid - 区域ID
 * @returns {Promise} - 返回Promise对象
 */
function getPromoterList(params) {
  return axios.post(base + '/data_screen/member_admin/query', params);
}

/**
 * 获取推广人员详情
 * @param {number} id - 推广人员ID
 * @returns {Promise} - 返回Promise对象
 */
function getPromoterDetail(id) {
  return axios.get(base + '/data_screen/member_admin/get_' + id);
}

/**
 * 创建推广人员
 * @param {Object} data - 推广人员数据
 * @param {number} data.member_adminid - 账号ID
 * @param {string} data.member_name - 用户名
 * @param {number} data.provinceid - 区域ID
 * @returns {Promise} - 返回Promise对象
 */
function createPromoter(params) {
  return axios.post(base + '/data_screen/member_admin/create', params);
}

/**
 * 更新推广人员
 * @param {number} id - 推广人员ID
 * @param {Object} data - 更新的推广人员数据
 * @param {number} data.member_adminid - 账号ID
 * @param {string} data.member_name - 用户名
 * @param {number} data.provinceid - 区域ID
 * @returns {Promise} - 返回Promise对象
 */
function updatePromoter(id, params) {
  return axios.post(base + '/data_screen/member_admin/update_' + id, params);
}

/**
 * 删除推广人员
 * @param {number} id - 推广人员ID
 * @returns {Promise} - 返回Promise对象
 */
function deletePromoter(id) {
  return axios.post(base + '/data_screen/member_admin/delete_' + id);
}

/**
 * 导出推广人员列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回Promise对象
 */
function exportPromoterList(params) {
  return axios.post(base + '/promoter/export', params, {
    responseType: 'blob'
  });
}

/**
 * 获取省份列表（用于推广员）
 * @returns {Promise} - 返回Promise对象
 */
function getPromoterProvinces() {
  return axios.post(base + '/data_screen/query_provinces');
}

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getScreenProjectList"] = getScreenProjectList;
/* harmony export (immutable) */ __webpack_exports__["batchUpdateScreenProject"] = batchUpdateScreenProject;
/* harmony export (immutable) */ __webpack_exports__["exportScreenProjectList"] = exportScreenProjectList;
/* harmony export (immutable) */ __webpack_exports__["getDisplaySettings"] = getDisplaySettings;
/* harmony export (immutable) */ __webpack_exports__["saveDisplaySettings"] = saveDisplaySettings;
/* harmony export (immutable) */ __webpack_exports__["getScreenProjectDetail"] = getScreenProjectDetail;
/* harmony export (immutable) */ __webpack_exports__["createScreenProject"] = createScreenProject;
/* harmony export (immutable) */ __webpack_exports__["updateScreenProject"] = updateScreenProject;
/* harmony export (immutable) */ __webpack_exports__["getProjectCityList"] = getProjectCityList;
/* harmony export (immutable) */ __webpack_exports__["getProjectCityDetail"] = getProjectCityDetail;
/* harmony export (immutable) */ __webpack_exports__["updateProjectCity"] = updateProjectCity;
/* harmony export (immutable) */ __webpack_exports__["getAuditScreenConfig"] = getAuditScreenConfig;
/* harmony export (immutable) */ __webpack_exports__["saveAuditScreenConfig"] = saveAuditScreenConfig;
var base = window._env_.VUE_APP_ADMIN_HOST;

/**
 * 获取大屏项目列表
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页条数
 * @param {string} params.projectNumber - 项目编号
 * @param {string} params.executionTimeStart - 执行时间开始
 * @param {string} params.executionTimeEnd - 执行时间结束
 * @param {number} params.provinceId - 省份ID
 * @param {number} params.cityId - 城市ID
 * @returns {Promise} - 返回Promise对象
 */
function getScreenProjectList(params) {
  return axios.post(base + '/screen_project/query', params);
}

/**
 * 批量修改大屏项目
 * @param {Object} data - 批量修改数据
 * @param {number[]} data.ids - 项目ID数组
 * @param {Object} data.data - 要修改的数据
 * @returns {Promise} - 返回Promise对象
 */
function batchUpdateScreenProject(data) {
  return axios.post(base + '/screen_project/batch_update', data);
}

/**
 * 导出大屏项目列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回Promise对象
 */
function exportScreenProjectList(params) {
  return axios.post(base + '/screen_project/export', params, {
    responseType: 'blob'
  });
}

/**
 * 获取大屏展示设置列表
 * @returns {Promise} - 返回Promise对象
 */
function getDisplaySettings() {
  return axios.get(base + '/data_screen/project/get_all');
}

/**
 * 保存大屏展示设置
 * @param {Object} data - 展示设置数据
 * @param {Array} data.projects - 项目列表
 * @param {number} data.projects[].customerid - 客户ID
 * @param {number} data.projects[].projectid - 项目ID
 * @param {string} data.projects[].startdate - 开始日期
 * @param {string} data.projects[].enddate - 结束日期
 * @param {number} data.projects[].sort_priority - 排序优先级
 * @returns {Promise} - 返回Promise对象
 */
function saveDisplaySettings(data) {
  return axios.post(base + '/data_screen/project/save_all', data);
}

/**
 * 获取大屏项目详情
 * @param {number} id - 项目ID
 * @returns {Promise} - 返回Promise对象
 */
function getScreenProjectDetail(id) {
  return axios.get(base + '/screen_project/get_' + id);
}

/**
 * 创建大屏项目配置
 * @param {Object} data - 项目配置数据
 * @returns {Promise} - 返回Promise对象
 */
function createScreenProject(data) {
  return axios.post(base + '/screen_project/create', data);
}

/**
 * 更新大屏项目配置
 * @param {number} id - 项目ID
 * @param {Object} data - 项目配置数据
 * @returns {Promise} - 返回Promise对象
 */
function updateScreenProject(id, data) {
  return axios.post(base + '/screen_project/update/' + id, data);
}

/**
 * 获取项目城市列表
 * @param {Object} params - 查询参数
 * @param {number} params.projectId - 项目ID
 * @returns {Promise} - 返回Promise对象
 */
function getProjectCityList(params) {
  return axios.post(base + '/data_screen/project/project_city/query', params);
}

/**
 * 获取项目城市详情
 * @param {number} id - 项目城市ID
 * @returns {Promise} - 返回Promise对象
 */
function getProjectCityDetail(id) {
  return axios.get(base + '/data_screen/project/project_city/get_' + id);
}

/**
 * 更新项目城市配置
 * @param {number} id - 项目城市ID
 * @param {Object} data - 项目城市配置数据
 * @returns {Promise} - 返回Promise对象
 */
function updateProjectCity(id, data) {
  return axios.post(base + '/data_screen/project/project_city/update_' + id, data);
}

/**
 * 获取审单大屏配置
 * @returns {Promise} - 返回Promise对象
 */
function getAuditScreenConfig() {
  return axios.get(base + '/data_screen/audit_screen_project/get_all');
}

/**
 * 保存审单大屏配置
 * @param {Object} data - 审单大屏配置数据
 * @param {Array} data.projects - 项目列表
 * @param {number} data.projects[].customerid - 客户ID
 * @param {number} data.projects[].projectid - 项目ID
 * @param {string} data.projects[].startdate - 开始日期
 * @param {string} data.projects[].enddate - 结束日期
 * @param {number} data.projects[].sort_priority - 排序优先级
 * @param {number} data.projects[].target_quantity - 目标单量
 * @returns {Promise} - 返回Promise对象
 */
function saveAuditScreenConfig(data) {
  return axios.post(base + '/data_screen/audit_screen_project/save_all', data);
}

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStepTemplateTable", function() { return getStepTemplateTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStepTemplateDetail", function() { return getStepTemplateDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportStepTemplateData", function() { return exportStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStepTemplateData", function() { return createStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateStepTemplateData", function() { return updateStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadStepTemplateFile", function() { return uploadStepTemplateFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteStepTemplateData", function() { return deleteStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyStepTemplateData", function() { return copyStepTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUpdateTaskByStepTemplate", function() { return batchUpdateTaskByStepTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStepTemplateLog", function() { return getStepTemplateLog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addQuestionToStepTemplate", function() { return addQuestionToStepTemplate; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getStepTemplateTable = function getStepTemplateTable(params) {
  return axios.post(base + "/query_substep", params);
};
var getStepTemplateDetail = function getStepTemplateDetail(params) {
  return axios.get(base + "/substep_" + params.id, params);
};
var exportStepTemplateData = function exportStepTemplateData(params) {
  return axios.get(base + "/exportStepTemplateData/" + params.id, { params: params });
};
var createStepTemplateData = function createStepTemplateData(params) {
  return axios.post(base + "/create_substep", params);
};
var updateStepTemplateData = function updateStepTemplateData(params) {
  return axios.post(base + "/modify_substep_" + params.id, params);
};
var uploadStepTemplateFile = function uploadStepTemplateFile(params, config) {
  return axios.post(base + "/substep/uploadfile", params, config);
};
var deleteStepTemplateData = function deleteStepTemplateData(params) {
  return axios.post(base + "/delete_substep_" + params.id, params);
};
var copyStepTemplateData = function copyStepTemplateData(params) {
  return axios.post(base + "/copy_substep_" + params.id, params);
};
var batchUpdateTaskByStepTemplate = function batchUpdateTaskByStepTemplate(params) {
  return axios.post(base + "/update_based_on_substep_" + params.id, params);
};
var getStepTemplateLog = function getStepTemplateLog(params) {
  return axios.get(base + "/substep/log_" + params.id, params);
};
var addQuestionToStepTemplate = function addQuestionToStepTemplate(params) {
  return axios.post(base + "/add_question_substep_" + params.substep_id, params);
};

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStoreCollectionTable", function() { return getStoreCollectionTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportStoreCollectionTable", function() { return exportStoreCollectionTable; });
var adminBase = window._env_.VUE_APP_ADMIN_HOST;

var getStoreCollectionTable = function getStoreCollectionTable(params) {
  return axios.get(adminBase + "/market_gatherinfo/query", { params: params });
};
var exportStoreCollectionTable = function exportStoreCollectionTable(params) {
  return axios.get(adminBase + "/market_gatherinfo/export", { params: params });
};

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryBatchUpload", function() { return queryBatchUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchUpload", function() { return getBatchUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downSourceFile", function() { return downSourceFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doDownSourceFile", function() { return doDownSourceFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downErrorFile", function() { return downErrorFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downUnprocessFile", function() { return downUnprocessFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downExportFile", function() { return downExportFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downEncryptExportFile", function() { return downEncryptExportFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downCompleteFile", function() { return downCompleteFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelTaskBatch", function() { return cancelTaskBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pauseTaskBatch", function() { return pauseTaskBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "continueTaskBatch", function() { return continueTaskBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTaskBatch", function() { return createTaskBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createExecuteTaskBatch", function() { return createExecuteTaskBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchExportCityMaps", function() { return batchExportCityMaps; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var queryBatchUpload = function queryBatchUpload(params) {
  return axios.post(base + '/excel/query_upload', params);
};
var getBatchUpload = function getBatchUpload(params) {
  return axios.get(base + '/excel/get_' + params.id);
};
var downSourceFile = function downSourceFile(id) {
  return base + '/excel/down_sourc_file_' + id;
};
var doDownSourceFile = function doDownSourceFile(id) {
  return axios.get(downSourceFile(id), { responseType: 'blob' });
};
var downErrorFile = function downErrorFile(id) {
  return base + '/excel/down_error_file_' + id;
};
var downUnprocessFile = function downUnprocessFile(id) {
  return base + '/excel/down_unprocess_file_' + id;
};
var downExportFile = function downExportFile(id) {
  return base + '/excel/down_export_file_' + id;
};
var downEncryptExportFile = function downEncryptExportFile(id) {
  return base + '/batch_jobs/down_encrypt_export_file_' + id + '.7z';
};
var downCompleteFile = function downCompleteFile(id) {
  return base + '/excel/down_complete_file_' + id;
};
var cancelTaskBatch = function cancelTaskBatch(params) {
  return axios.post(base + '/excel/cancel_' + params.id, params);
};
var pauseTaskBatch = function pauseTaskBatch(params) {
  return axios.post(base + '/excel/pause_' + params.id, params);
};
var continueTaskBatch = function continueTaskBatch(params) {
  return axios.post(base + '/excel/continue_' + params.id, params);
};
var createTaskBatch = function createTaskBatch(params) {
  return axios.post(base + '/excel/create_upload', params);
};
var createExecuteTaskBatch = function createExecuteTaskBatch(params) {
  return axios.post(base + '/excel/create_execute_upload', params);
};
var batchExportCityMaps = function batchExportCityMaps(params) {
  return axios.post(base + '/citymap/export', params);
};

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskNoticeTable", function() { return getTaskNoticeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskNoticeDetail", function() { return getTaskNoticeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportTaskNoticeData", function() { return exportTaskNoticeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTaskNoticeData", function() { return createTaskNoticeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTaskNoticeData", function() { return updateTaskNoticeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOnlineTaskNoticeData", function() { return setOnlineTaskNoticeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTaskNoticeData", function() { return deleteTaskNoticeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadTaskNoticeFile", function() { return uploadTaskNoticeFile; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getTaskNoticeTable = function getTaskNoticeTable(params) {
  return axios.post(base + "/task-notice/query", params);
};
var getTaskNoticeDetail = function getTaskNoticeDetail(params) {
  return axios.get(base + "/task-notice/get_" + params.id, { params: params });
};
var exportTaskNoticeData = function exportTaskNoticeData(params) {
  return axios.get(base + "/exportTaskNoticeData/" + params.id, { params: params });
};
var createTaskNoticeData = function createTaskNoticeData(params) {
  return axios.post(base + "/task-notice/create", params);
};
var updateTaskNoticeData = function updateTaskNoticeData(params) {
  return axios.post(base + "/task-notice/edit_" + params.id, params);
};
var setOnlineTaskNoticeData = function setOnlineTaskNoticeData(params) {
  return axios.post(base + "/task-notice/set_oneline_" + params.id, params);
};
var deleteTaskNoticeData = function deleteTaskNoticeData(params) {
  return axios.post(base + "/deleteTaskNoticeData/" + params.id, params);
};
var uploadTaskNoticeFile = function uploadTaskNoticeFile(params, config) {
  return axios.post(base + "/task-notice/uploadfile", params, config);
};

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskOrderTable", function() { return getTaskOrderTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportTaskOrderData", function() { return exportTaskOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskOrderDetail", function() { return getTaskOrderDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTaskOrderData", function() { return createTaskOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTaskOrderData", function() { return updateTaskOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTaskOrderData", function() { return deleteTaskOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportRecordRemark", function() { return exportRecordRemark; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getTaskOrderTable = function getTaskOrderTable(params) {
  return axios.post(base + "/task-order/query", params);
};
var exportTaskOrderData = function exportTaskOrderData(params) {
  return axios.post(base + "/task-order/export", params);
};
var getTaskOrderDetail = function getTaskOrderDetail(params) {
  return axios.get(base + "/getTaskOrderDetail/" + params.id, { params: params });
};
var createTaskOrderData = function createTaskOrderData(params) {
  return axios.post(base + "/createTaskOrderData", params);
};
var updateTaskOrderData = function updateTaskOrderData(params) {
  return axios.post(base + "/updateTaskOrderData/" + params.id, params);
};
var deleteTaskOrderData = function deleteTaskOrderData(params) {
  return axios.post(base + "/deleteTaskOrderData/" + params.id, params);
};
var exportRecordRemark = function exportRecordRemark(params) {
  return axios.post(base + "/batch_jobs/batch_export_record_remark", params);
};

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHomeTaskPackageTable", function() { return getHomeTaskPackageTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHomeTaskPackageDetail", function() { return getHomeTaskPackageDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHomeTaskPackage", function() { return createHomeTaskPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateHomeTaskPackage", function() { return updateHomeTaskPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteHomeTaskPackage", function() { return deleteHomeTaskPackage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHomeTaskPackageTypeOptions", function() { return getHomeTaskPackageTypeOptions; });
var adminBase = window._env_.VUE_APP_ADMIN_HOST;

var getHomeTaskPackageTable = function getHomeTaskPackageTable(params) {
  return axios.post(adminBase + "/batchtaskpackage/query", params);
};
var getHomeTaskPackageDetail = function getHomeTaskPackageDetail(id) {
  return axios.get(adminBase + "/batchtaskpackage/get_" + id);
};
var createHomeTaskPackage = function createHomeTaskPackage(params) {
  return axios.post(adminBase + "/batchtaskpackage/create", params);
};
var updateHomeTaskPackage = function updateHomeTaskPackage(params) {
  return axios.post(adminBase + "/batchtaskpackage/edit_" + params.id, params);
};
var deleteHomeTaskPackage = function deleteHomeTaskPackage(id) {
  return axios.post(adminBase + "/batchtaskpackage/delete_" + id);
};

var getHomeTaskPackageTypeOptions = function getHomeTaskPackageTypeOptions(params) {
  return axios.get(adminBase + "/batchtaskpackage/options");
};

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryReviewPlanTable", function() { return queryReviewPlanTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReviewPlan", function() { return createReviewPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateReviewPlan", function() { return updateReviewPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteReviewPlan", function() { return deleteReviewPlan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReviewPlan", function() { return getReviewPlan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/* global process */


// 与 alg-admin2/.env 中 VUE_APP_ORDER_AUDIT_API_HOST 对齐；避免运行时未注入 _env_ 时拼出 "undefined/admin/..." 导致列表请求失败
var orderAuditBase = window._env_ && window._env_.VUE_APP_ORDER_AUDIT_API_HOST || '//order-audit-api.local.slicejobs.com';

// 复核目标管理 - 列表/新增/修改
var queryReviewPlanTable = function queryReviewPlanTable(params) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(orderAuditBase + '/admin/review_plan/query', params);
};

var createReviewPlan = function createReviewPlan(params) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(orderAuditBase + '/admin/review_plan/create', params);
};

var updateReviewPlan = function updateReviewPlan(params) {
  var _ref = params || {},
      id = _ref.id,
      body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id']);

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(orderAuditBase + '/admin/review_plan/update_' + id, body);
};


var deleteReviewPlan = function deleteReviewPlan(params) {
  var _ref2 = params || {},
      id = _ref2.id;

  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(orderAuditBase + '/admin/review_plan/delete_' + id, {});
};

var getReviewPlan = function getReviewPlan(params) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(orderAuditBase + '/admin/review_plan/get_' + params.id);
};

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryReviewTaskTableApi", function() { return queryReviewTaskTableApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewAuditQualityApi", function() { return reviewAuditQualityApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReviewAuditQualityApi", function() { return getReviewAuditQualityApi; });
/* global process */

var orderAuditBase = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

// 工单复核相关API
var queryReviewTaskTableApi = function queryReviewTaskTableApi(params) {
  return axios.post(orderAuditBase + "/admin/review-task/query", params);
};
var reviewAuditQualityApi = function reviewAuditQualityApi(params) {
  return axios.post(orderAuditBase + "/admin/review-task/review-quality/" + params.id, params);
};
var getReviewAuditQualityApi = function getReviewAuditQualityApi(params) {
  return axios.get(orderAuditBase + "/admin/review-task/get-result/" + params.id, { params: params });
};

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskTable", function() { return getTaskTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTaskTable", function() { return queryTaskTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTaskArchivedTable", function() { return queryTaskArchivedTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskDetail", function() { return getTaskDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTaskData", function() { return createTaskData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTaskData", function() { return updateTaskData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchPublish", function() { return batchPublish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchDelete", function() { return batchDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyTask", function() { return copyTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCopyTask", function() { return batchCopyTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskDelete", function() { return taskDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskPublishOnSearch", function() { return taskPublishOnSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskPublishOnSearchInfo", function() { return getTaskPublishOnSearchInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskPublish", function() { return taskPublish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportTask", function() { return exportTask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportTaskArchived", function() { return exportTaskArchived; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCopyTaskInfo", function() { return getCopyTaskInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkTaskSalary", function() { return checkTaskSalary; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadTaskFile", function() { return uploadTaskFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskPreviewUrl", function() { return taskPreviewUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskNearbyUsers", function() { return taskNearbyUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMiDanTaskTable", function() { return getMiDanTaskTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTaskBatchJob", function() { return createTaskBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTaskWithTemplateBatchJob", function() { return createTaskWithTemplateBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editTaskBatchJob", function() { return editTaskBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTaskBatchJob", function() { return deleteTaskBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reactivateTaskBatchJob", function() { return reactivateTaskBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "importTaskAuditReferenceBatchJob", function() { return importTaskAuditReferenceBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskAvailableTimeBatchJob", function() { return taskAvailableTimeBatchJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUserCoverageApi", function() { return exportUserCoverageApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "suggestPriceCreateTaskApi", function() { return suggestPriceCreateTaskApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryTasks", function() { return mapsearchQueryTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryUsers", function() { return mapsearchQueryUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryCustomers", function() { return mapsearchQueryCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryIdcardCoveredUsers", function() { return mapsearchQueryIdcardCoveredUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryOrderCoveredUsers", function() { return mapsearchQueryOrderCoveredUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryTasksMap", function() { return mapsearchQueryTasksMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapsearchQueryUsersMap", function() { return mapsearchQueryUsersMap; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var appBase = window._env_.VUE_APP_SITE_HOST;
var getTaskTable = function getTaskTable(params) {
  return axios.post(base + "/query_task", params);
};
var queryTaskTable = function queryTaskTable(params) {
  return axios.post(base + "/task/query", params);
};
var queryTaskArchivedTable = function queryTaskArchivedTable(params) {
  return axios.post(base + "/task/query_archived", params);
};
var getTaskDetail = function getTaskDetail(params) {
  return axios.get(base + "/task/get_" + params.id, params);
};
var createTaskData = function createTaskData(params) {
  return axios.post(base + "/create_task", params);
};
var updateTaskData = function updateTaskData(params) {
  return axios.post(base + "/edit_task_" + params.id, params);
};
var batchPublish = function batchPublish(params) {
  return axios.post(base + "/task/bulk_publish", params);
};
var batchDelete = function batchDelete(params) {
  return axios.post(base + "/task/bulk_delete", params);
};
var copyTask = function copyTask(params) {
  return axios.post(base + "/task/copy", params);
};
var batchCopyTask = function batchCopyTask(params) {
  return axios.post(base + "/task/bulk_copy", params);
};
var taskDelete = function taskDelete(params) {
  return axios.post(base + "/delete_task_" + params.taskid, params);
};
var taskPublishOnSearch = function taskPublishOnSearch(params) {
  return axios.post(base + "/task/publish_search_result", params);
};
var getTaskPublishOnSearchInfo = function getTaskPublishOnSearchInfo(params) {
  return axios.post(base + "/task/publish_search_result_info", params);
};
var taskPublish = function taskPublish(params) {
  return axios.post(base + "/publish_task_" + params.taskid, params);
};
var exportTask = function exportTask(params) {
  return axios.post(base + "/task/export", params);
};
var exportTaskArchived = function exportTaskArchived(params) {
  return axios.post(base + "/task/export_archived", params);
};
var getCopyTaskInfo = function getCopyTaskInfo(params) {
  return axios.get(base + "/task/copy_info_" + params.id, params);
};
/**
 * 验证任务金额
 *
 * @param params
 * @param params.projectid
 * @param params.totalSalary
 * @returns {AxiosPromise<any>}
 */
var checkTaskSalary = function checkTaskSalary(params) {
  return axios.post(base + "/task/check_amount", params);
};
var uploadTaskFile = function uploadTaskFile(params) {
  return axios.post(base + "/task/uploadfile", params);
};
var taskPreviewUrl = function taskPreviewUrl(params) {
  return appBase + "/index.html?page=/private/build8.1.3/modules/task-steps.js&isOpenThroughrecord=false&taskStepMode=preview_task&currentEndTime=&delaymins=&rfversion=1";
};
var taskNearbyUsers = function taskNearbyUsers(params) {
  return axios.post(base + "/task/" + params.taskid + "/nearby_users", params);
};

var getMiDanTaskTable = function getMiDanTaskTable(params) {
  return axios.get(base + "/midan/tasklist/" + params.id, { params: params });
};

var createTaskBatchJob = function createTaskBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_create_task", params);
};

var createTaskWithTemplateBatchJob = function createTaskWithTemplateBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_create_task_with_template", params);
};

var editTaskBatchJob = function editTaskBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_update_task", params);
};

var deleteTaskBatchJob = function deleteTaskBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_delete_task", params);
};

var reactivateTaskBatchJob = function reactivateTaskBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_reactivate_task", params);
};

var importTaskAuditReferenceBatchJob = function importTaskAuditReferenceBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_import_task_audit_reference", params);
};

var taskAvailableTimeBatchJob = function taskAvailableTimeBatchJob(params) {
  return axios.post(base + "/batch_jobs/batch_set_task_available_time", params);
};
var exportUserCoverageApi = function exportUserCoverageApi(params) {
  return axios.post(base + "/batch_jobs/export_user_coverage", params);
};
var suggestPriceCreateTaskApi = function suggestPriceCreateTaskApi(params) {
  return axios.post(base + "/batch_jobs/suggest_price_create_task", params);
};

// 地图相关
// post mapsearch/query_tasks
var mapsearchQueryTasks = function mapsearchQueryTasks(params) {
  return axios.post(base + "/mapsearch/query_tasks", params);
};

// mapsearch/query_users
var mapsearchQueryUsers = function mapsearchQueryUsers(params) {
  return axios.post(base + "/mapsearch/query_users", params);
};

// mapsearch/query_customers
var mapsearchQueryCustomers = function mapsearchQueryCustomers(params) {
  return axios.post(base + "/mapsearch/query_customers", params);
};

// POST /admin/mapsearch/nearby/query_idcard_covered_users
var mapsearchQueryIdcardCoveredUsers = function mapsearchQueryIdcardCoveredUsers(params) {
  return axios.post(base + "/mapsearch/nearby/query_idcard_covered_users", params);
};

// POST /admin/mapsearch/nearby/query_order_covered_users
var mapsearchQueryOrderCoveredUsers = function mapsearchQueryOrderCoveredUsers(params) {
  return axios.post(base + "/mapsearch/nearby/query_order_covered_users", params);
};

// POST /admin/mapsearch/query_tasks_map - 基于viewport的地图任务查询
var mapsearchQueryTasksMap = function mapsearchQueryTasksMap(params) {
  return axios.post(base + "/mapsearch/query_tasks_map", params);
};

// POST /admin/mapsearch/query_users_map - 基于viewport的地图用户查询
var mapsearchQueryUsersMap = function mapsearchQueryUsersMap(params) {
  return axios.post(base + "/mapsearch/query_users_map", params);
};

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomerTable", function() { return getTekeCustomerTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPlatformFee", function() { return setPlatformFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTekeCustomer", function() { return deleteTekeCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeMemberTable", function() { return getTekeMemberTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomer", function() { return createCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editTekeCustomer", function() { return editTekeCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomer", function() { return getTekeCustomer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchEditPlatformFee", function() { return batchEditPlatformFee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomerMember", function() { return createCustomerMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editCustomerMember", function() { return editCustomerMember; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomerDetail", function() { return getTekeCustomerDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomerBalance", function() { return getTekeCustomerBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomerRechargeTable", function() { return getTekeCustomerRechargeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCustomeRecharge", function() { return createCustomeRecharge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomerBalanceTable", function() { return getTekeCustomerBalanceTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadTekeFile", function() { return UploadTekeFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeCustomerMember", function() { return getTekeCustomerMember; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getTekeCustomerTable = function getTekeCustomerTable(params) {
  return axios.post(base + "/teke/query_customer", params);
};
var setPlatformFee = function setPlatformFee(params) {
  return axios.post(base + "/teke/set_platform_fee", params);
};
var deleteTekeCustomer = function deleteTekeCustomer(id) {
  return axios.post(base + "/teke/delete_customer_" + id);
};
var getTekeMemberTable = function getTekeMemberTable(params) {
  return axios.post(base + "/teke/query_customer_member_" + params.customerid, params);
};
var createCustomer = function createCustomer(params) {
  return axios.post(base + "/teke/create_customer", params);
};
var editTekeCustomer = function editTekeCustomer(params) {
  return axios.post(base + "/teke/edit_customer_" + params.id, params);
};
var getTekeCustomer = function getTekeCustomer(id) {
  return axios.get(base + "/teke/customers_" + id);
};
var batchEditPlatformFee = function batchEditPlatformFee(params) {
  return axios.post(base + "/teke/batch_edit_platform_fee", params);
};
var createCustomerMember = function createCustomerMember(params) {
  return axios.post(base + "/teke/create_pfmaccount", params);
};
var editCustomerMember = function editCustomerMember(params) {
  return axios.post(base + "/teke/edit_pfmaccount_" + params.id, params);
};
var getTekeCustomerDetail = function getTekeCustomerDetail(id) {
  return axios.get(base + "/teke/customer_detail_" + id);
};
var getTekeCustomerBalance = function getTekeCustomerBalance(id) {
  return axios.get(base + "/teke/customer_balance_" + id);
};
var getTekeCustomerRechargeTable = function getTekeCustomerRechargeTable(params) {
  return axios.post(base + "/teke/query_customer_recharge_" + params.customerid, params);
};
var createCustomeRecharge = function createCustomeRecharge(params) {
  return axios.post(base + "/teke/create_customer_recharge_" + params.customerid, params);
};
var getTekeCustomerBalanceTable = function getTekeCustomerBalanceTable(params) {
  return axios.post(base + "/teke/query_customer_balance_" + params.customerId, params);
};
var UploadTekeFile = function UploadTekeFile(params) {
  return axios.post(base + "/teke/upload_file", params);
};
var getTekeCustomerMember = function getTekeCustomerMember(id) {
  return axios.get(base + "/teke/customer_member_" + id);
};

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeOrderTable", function() { return getTekeOrderTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCompleteTekeOrder", function() { return batchCompleteTekeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCancelTekeOrder", function() { return batchCancelTekeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reviewTekeOrderPass", function() { return reviewTekeOrderPass; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getTekeOrderTable = function getTekeOrderTable(params) {
  return axios.post(base + "/teke/query_order", params);
};

var batchCompleteTekeOrder = function batchCompleteTekeOrder(params) {
  return axios.post(base + "/teke/batch_complete_orders", params);
};

var batchCancelTekeOrder = function batchCancelTekeOrder(params) {
  return axios.post(base + "/teke/batch_cancel_orders", params);
};

var reviewTekeOrderPass = function reviewTekeOrderPass(params) {
  return axios.post(base + "/teke/pass_audit_order_" + params.id, params);
};

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeTagTable", function() { return getTekeTagTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTekeTag", function() { return createTekeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editTekeTag", function() { return editTekeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTekeTag", function() { return deleteTekeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeInfiniteTagTable", function() { return getTekeInfiniteTagTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTekeInfiniteTag", function() { return createTekeInfiniteTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editTekeInfiniteTag", function() { return editTekeInfiniteTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeTag", function() { return getTekeTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchAddTeke", function() { return batchAddTeke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchDeleteTeke", function() { return batchDeleteTeke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTekeInfiniteTagUpload", function() { return getTekeInfiniteTagUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downTekeSourceFile", function() { return downTekeSourceFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downTekeErrorFile", function() { return downTekeErrorFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadTekeTagEdit", function() { return batchUploadTekeTagEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchUploadTekeTagLib", function() { return batchUploadTekeTagLib; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadAllTagFile", function() { return downloadAllTagFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBatchjobOnGoingNumber", function() { return getBatchjobOnGoingNumber; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getTekeTagTable = function getTekeTagTable(params) {
  return axios.post(base + "/teke/query_tag", params);
};

var createTekeTag = function createTekeTag(params) {
  return axios.post(base + "/teke/create_tag", params);
};

var editTekeTag = function editTekeTag(params) {
  return axios.post(base + "/teke/edit_tag_" + params.id, params);
};

var deleteTekeTag = function deleteTekeTag(id) {
  return axios.post(base + "/teke/delete_tag_" + id);
};

var getTekeInfiniteTagTable = function getTekeInfiniteTagTable(params) {
  return axios.post(base + "/teke/query_infinite_tag_" + params.pid, params);
};

var createTekeInfiniteTag = function createTekeInfiniteTag(params) {
  return axios.post(base + "/teke/create_infinite_tag_" + params.pid, params);
};

var editTekeInfiniteTag = function editTekeInfiniteTag(params) {
  return axios.post(base + "/teke/edit_infinite_tag_" + params.id, params);
};

var getTekeTag = function getTekeTag(id) {
  return axios.get(base + "/teke/tag_" + id);
};

var batchAddTeke = function batchAddTeke(params) {
  return axios.post(base + "/teke/batch_add_tag", params);
};

var batchDeleteTeke = function batchDeleteTeke(params) {
  return axios.post(base + "/teke/batch_delete_tag", params);
};

var getTekeInfiniteTagUpload = function getTekeInfiniteTagUpload(params) {
  return axios.post(base + "/excel/query_upload", params);
};

var downTekeSourceFile = function downTekeSourceFile(id) {
  window.location.href = base + "/excel/down_sourc_file_" + id;
};

var downTekeErrorFile = function downTekeErrorFile(id) {
  window.location.href = base + "/excel/down_error_file_" + id;
};

var batchUploadTekeTagEdit = function batchUploadTekeTagEdit(params) {
  return axios.post(base + "/teke/batch_edit_tag_upload", params);
};

var batchUploadTekeTagLib = function batchUploadTekeTagLib(params) {
  return axios.post(base + "/teke/batch_tag_lib_upload", params);
};

var downloadAllTagFile = function downloadAllTagFile(params) {
  return axios.post(base + "/teke/download_all_tag_file", params);
};
var getBatchjobOnGoingNumber = function getBatchjobOnGoingNumber(params) {
  return axios.get(base + "/excel/query_ongoing_number");
};

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingInstruction", function() { return queryTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingInstructionSelect", function() { return queryTrainingInstructionSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingInstruction", function() { return getTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTrainingInstruction", function() { return createTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrainingInstruction", function() { return updateTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableTrainingInstruction", function() { return enableTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableTrainingInstruction", function() { return disableTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTrainingInstruction", function() { return deleteTrainingInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingInstructionBatchHistory", function() { return queryTrainingInstructionBatchHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingInstructionRecord", function() { return queryTrainingInstructionRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingInstructionExamRecord", function() { return queryTrainingInstructionExamRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingInstructionExamRecord", function() { return getTrainingInstructionExamRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingInstructionGroupAll", function() { return queryTrainingInstructionGroupAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingInstructionGroup", function() { return getTrainingInstructionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTrainingInstructionGroup", function() { return deleteTrainingInstructionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingKnowledge", function() { return queryTrainingKnowledge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingKnowledgeTable", function() { return getTrainingKnowledgeTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingKnowledgeDetail", function() { return getTrainingKnowledgeDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingKnowledge", function() { return getTrainingKnowledge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrainingKnowledge", function() { return updateTrainingKnowledge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTrainingKnowledge", function() { return createTrainingKnowledge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banTrainingKnowledge", function() { return banTrainingKnowledge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTrainingKnowledge", function() { return activeTrainingKnowledge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryUserTrainingCourse", function() { return queryUserTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingCourse", function() { return getTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTrainingCourse", function() { return createTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrainingCourse", function() { return updateTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlineTrainingCourse", function() { return onlineTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineTrainingCourse", function() { return offlineTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banTrainingCourse", function() { return banTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTrainingCourse", function() { return activeTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternTrainingCourse", function() { return queryInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInternTrainingCourse", function() { return createInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateInternTrainingCourse", function() { return updateInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternTrainingCourse", function() { return getInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlineInternTrainingCourse", function() { return onlineInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineInternTrainingCourse", function() { return offlineInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banInternTrainingCourse", function() { return banInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeInternTrainingCourse", function() { return activeInternTrainingCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadInternAssignment", function() { return uploadInternAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelfTrainingCourses", function() { return getSelfTrainingCourses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingSignedOssUrl", function() { return getTrainingSignedOssUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingExamination", function() { return queryTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingExamination", function() { return getTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingExaminationIntern", function() { return getTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingExaminationInternRecord", function() { return queryTrainingExaminationInternRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingExaminationInternRecord", function() { return getTrainingExaminationInternRecord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelfTrainingExams", function() { return getSelfTrainingExams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startSelfTrainingExam", function() { return startSelfTrainingExam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelfTrainingExam", function() { return getSelfTrainingExam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSelfTrainingExamResult", function() { return getSelfTrainingExamResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveSelfTrainingExamDraft", function() { return saveSelfTrainingExamDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSelfTrainingExam", function() { return submitSelfTrainingExam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternTrainingExamination", function() { return queryInternTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternTrainingExamination", function() { return getInternTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTrainingExaminationIntern", function() { return createTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrainingExaminationIntern", function() { return updateTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlineTrainingExaminationIntern", function() { return onlineTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineTrainingExaminationIntern", function() { return offlineTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banTrainingExaminationIntern", function() { return banTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTrainingExaminationIntern", function() { return activeTrainingExaminationIntern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadInternExaminationAssignment", function() { return uploadInternExaminationAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryTrainingQuestion", function() { return queryTrainingQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrainingQuestion", function() { return getTrainingQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTrainingQuestion", function() { return createTrainingQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrainingQuestion", function() { return updateTrainingQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banTrainingQuestion", function() { return banTrainingQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTrainingQuestion", function() { return activeTrainingQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTrainingExamination", function() { return createTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateTrainingExamination", function() { return updateTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlineTrainingExamination", function() { return onlineTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offlineTrainingExamination", function() { return offlineTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banTrainingExamination", function() { return banTrainingExamination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTrainingExamination", function() { return activeTrainingExamination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);

var base = window._env_.VUE_APP_ADMIN_HOST;

// ========== 培训管理 ==========
var queryTrainingInstruction = function queryTrainingInstruction(params) {
  return axios.post(base + '/training_instruction/query', params);
};

var queryTrainingInstructionSelect = function queryTrainingInstructionSelect(params) {
  return axios.post(base + '/training_instruction/query_select', params);
};

var getTrainingInstruction = function getTrainingInstruction(params) {
  return axios.get(base + '/training_instruction/get_' + params.id, { params: params });
};

var createTrainingInstruction = function createTrainingInstruction(params) {
  return axios.post(base + '/training_instruction/create', params);
};

var updateTrainingInstruction = function updateTrainingInstruction(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/training_instruction/update_' + id, rest);
};


var enableTrainingInstruction = function enableTrainingInstruction(id) {
  return axios.post(base + '/training_instruction/enable_' + id);
};

var disableTrainingInstruction = function disableTrainingInstruction(id) {
  return axios.post(base + '/training_instruction/disable_' + id);
};

var deleteTrainingInstruction = function deleteTrainingInstruction(id) {
  return axios.post(base + '/training_instruction/delete_' + id);
};

var queryTrainingInstructionBatchHistory = function queryTrainingInstructionBatchHistory(params) {
  return axios.post(base + '/training_instruction/query_batch_history', params);
};

var queryTrainingInstructionRecord = function queryTrainingInstructionRecord(params) {
  return axios.post(base + '/training_instruction_record/query', params);
};

var queryTrainingInstructionExamRecord = function queryTrainingInstructionExamRecord(params) {
  return axios.post(base + '/training_instruction_exam_record/query', params);
};

var getTrainingInstructionExamRecord = function getTrainingInstructionExamRecord(params) {
  return axios.get(base + '/training_instruction_exam_record/get_' + params.id, { params: params });
};

// ========== 培训分组 ==========
var queryTrainingInstructionGroupAll = function queryTrainingInstructionGroupAll(params) {
  return axios.post(base + '/training_instruction_group/query_all', params);
};

var getTrainingInstructionGroup = function getTrainingInstructionGroup(params) {
  return axios.get(base + '/training_instruction_group/get_' + params.id, { params: params });
};

var deleteTrainingInstructionGroup = function deleteTrainingInstructionGroup(id) {
  return axios.post(base + '/training_instruction_group/delete_' + id);
};

// ========== 知识库 ==========
var queryTrainingKnowledge = function queryTrainingKnowledge(params) {
  return axios.post(base + '/training_knowledge/query', params);
};

var getTrainingKnowledgeTable = function getTrainingKnowledgeTable(params) {
  return axios.post(base + '/training_knowledge/query', params);
};

var getTrainingKnowledgeDetail = function getTrainingKnowledgeDetail(params) {
  return axios.get(base + '/training_knowledge/get_' + params.id, params);
};

var getTrainingKnowledge = function getTrainingKnowledge(params) {
  return axios.get(base + '/training_knowledge/get_' + params.id, { params: params });
};

var updateTrainingKnowledge = function updateTrainingKnowledge(params) {
  return axios.post(base + '/training_knowledge/edit_' + params.id, params);
};

var createTrainingKnowledge = function createTrainingKnowledge(params) {
  return axios.post(base + '/training_knowledge/create', params);
};

var banTrainingKnowledge = function banTrainingKnowledge(id) {
  return axios.post(base + '/training_knowledge/ban_' + id);
};

var activeTrainingKnowledge = function activeTrainingKnowledge(id) {
  return axios.post(base + '/training_knowledge/active_' + id);
};

// ========== 教程 ==========
var queryUserTrainingCourse = function queryUserTrainingCourse(params) {
  return axios.post(base + '/training_course/query', params);
};

var getTrainingCourse = function getTrainingCourse(params) {
  return axios.get(base + '/training_course/get_' + params.id, { params: params });
};

var createTrainingCourse = function createTrainingCourse(params) {
  return axios.post(base + '/training_course/create', params);
};

var updateTrainingCourse = function updateTrainingCourse(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/training_course/edit_' + id, rest);
};


var onlineTrainingCourse = function onlineTrainingCourse(id) {
  return axios.post(base + '/training_course/online_' + id);
};

var offlineTrainingCourse = function offlineTrainingCourse(id) {
  return axios.post(base + '/training_course/offline_' + id);
};

var banTrainingCourse = function banTrainingCourse(id) {
  return axios.post(base + '/training_course/ban_' + id);
};

var activeTrainingCourse = function activeTrainingCourse(id) {
  return axios.post(base + '/training_course/active_' + id);
};

// ========== 实习生教程 ==========

var queryInternTrainingCourse = function queryInternTrainingCourse(params) {
  return axios.post(base + '/training_course_intern/query', params);
};

var createInternTrainingCourse = function createInternTrainingCourse(params) {
  return axios.post(base + '/training_course_intern/create', params);
};

var updateInternTrainingCourse = function updateInternTrainingCourse(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/training_course_intern/edit_' + id, rest);
};


var getInternTrainingCourse = function getInternTrainingCourse(params) {
  return axios.get(base + '/training_course_intern/get_' + params.id, { params: params });
};

var onlineInternTrainingCourse = function onlineInternTrainingCourse(id) {
  return axios.post(base + '/training_course_intern/online_' + id);
};

var offlineInternTrainingCourse = function offlineInternTrainingCourse(id) {
  return axios.post(base + '/training_course_intern/offline_' + id);
};

var banInternTrainingCourse = function banInternTrainingCourse(id) {
  return axios.post(base + '/training_course_intern/ban_' + id);
};

var activeInternTrainingCourse = function activeInternTrainingCourse(id) {
  return axios.post(base + '/training_course_intern/active_' + id);
};

var uploadInternAssignment = function uploadInternAssignment(params) {
  var formData = new FormData();
  formData.append('mode', params.mode);
  formData.append('file', params.file);
  return axios.post(base + '/training_course_intern/upload_intern_assignment', formData);
};

var getSelfTrainingCourses = function getSelfTrainingCourses(params) {
  return axios.post(base + '/training_course_intern/get_self_courses', params);
};

var getTrainingSignedOssUrl = function getTrainingSignedOssUrl(params) {
  return axios.post(base + '/training/get_signed_oss_url', params);
};

// ========== 零工考试 ==========
var queryTrainingExamination = function queryTrainingExamination(params) {
  return axios.post(base + '/training_examination/query', params);
};

var getTrainingExamination = function getTrainingExamination(params) {
  return axios.get(base + '/training_examination/get_' + params.id, { params: params });
};
// ========== 实习生考试 ==========
var getTrainingExaminationIntern = function getTrainingExaminationIntern(params) {
  return axios.get(base + '/training_examination_intern/get_' + params.id, { params: params });
};

var queryTrainingExaminationInternRecord = function queryTrainingExaminationInternRecord(params) {
  return axios.post(base + '/training_examination_intern_record/query', params);
};

var getTrainingExaminationInternRecord = function getTrainingExaminationInternRecord(params) {
  return axios.get(base + '/training_examination_intern_record/get_' + params.id);
};

var getSelfTrainingExams = function getSelfTrainingExams(params) {
  return axios.post(base + '/training_examination_intern/get_self_exams', params);
};

var startSelfTrainingExam = function startSelfTrainingExam(params) {
  return axios.post(base + '/training_examination_intern/start_' + params.id);
};

// 获取考试会话信息
var getSelfTrainingExam = function getSelfTrainingExam(params) {
  return axios.post(base + '/training_examination_intern/get_exam_' + (params.id || params.exam_id), params);
};

var getSelfTrainingExamResult = function getSelfTrainingExamResult(params) {
  return axios.post(base + '/training_examination_intern/get_result_' + params.record_id, params);
};

var saveSelfTrainingExamDraft = function saveSelfTrainingExamDraft(params) {
  return axios.post(base + '/training_examination_intern/save_draft', params);
};

var submitSelfTrainingExam = function submitSelfTrainingExam(params) {
  return axios.post(base + '/training_examination_intern/submit', params);
};

var queryInternTrainingExamination = function queryInternTrainingExamination(params) {
  return axios.post(base + '/training_examination_intern/query', params);
};

var getInternTrainingExamination = function getInternTrainingExamination(params) {
  return axios.get(base + '/training_examination_intern/get_' + params.id, { params: params });
};

var createTrainingExaminationIntern = function createTrainingExaminationIntern(params) {
  return axios.post(base + '/training_examination_intern/create', params);
};

var updateTrainingExaminationIntern = function updateTrainingExaminationIntern(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/training_examination_intern/edit_' + id, rest);
};


var onlineTrainingExaminationIntern = function onlineTrainingExaminationIntern(id) {
  return axios.post(base + '/training_examination_intern/online_' + id);
};

var offlineTrainingExaminationIntern = function offlineTrainingExaminationIntern(id) {
  return axios.post(base + '/training_examination_intern/offline_' + id);
};

var banTrainingExaminationIntern = function banTrainingExaminationIntern(id) {
  return axios.post(base + '/training_examination_intern/ban_' + id);
};

var activeTrainingExaminationIntern = function activeTrainingExaminationIntern(id) {
  return axios.post(base + '/training_examination_intern/active_' + id);
};

var uploadInternExaminationAssignment = function uploadInternExaminationAssignment(params) {
  var formData = new FormData();
  formData.append('mode', params.mode);
  formData.append('file', params.file);
  return axios.post(base + '/training_examination_intern/upload_intern_assignment', formData);
};
// ========== 题目 ==========
var queryTrainingQuestion = function queryTrainingQuestion(params) {
  return axios.post(base + '/training_question/query', params);
};

var getTrainingQuestion = function getTrainingQuestion(params) {
  return axios.get(base + '/training_question/get_' + params.id, { params: params });
};

var createTrainingQuestion = function createTrainingQuestion(params) {
  return axios.post(base + '/training_question/create', params);
};

var updateTrainingQuestion = function updateTrainingQuestion(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/training_question/edit_' + id, rest);
};


var banTrainingQuestion = function banTrainingQuestion(id) {
  return axios.post(base + '/training_question/ban_' + id);
};

var activeTrainingQuestion = function activeTrainingQuestion(id) {
  return axios.post(base + '/training_question/active_' + id);
};

var createTrainingExamination = function createTrainingExamination(params) {
  return axios.post(base + '/training_examination/create', params);
};

var updateTrainingExamination = function updateTrainingExamination(params) {
  var id = params.id,
      rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(params, ['id']);

  return axios.post(base + '/training_examination/edit_' + id, rest);
};


var onlineTrainingExamination = function onlineTrainingExamination(id) {
  return axios.post(base + '/training_examination/online_' + id);
};

var offlineTrainingExamination = function offlineTrainingExamination(id) {
  return axios.post(base + '/training_examination/offline_' + id);
};

var banTrainingExamination = function banTrainingExamination(id) {
  return axios.post(base + '/training_examination/ban_' + id);
};

var activeTrainingExamination = function activeTrainingExamination(id) {
  return axios.post(base + '/training_examination/active_' + id);
};

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserBankAccountTable", function() { return getUserBankAccountTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserBankAccountById", function() { return getUserBankAccountById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delUserBankAccountById", function() { return delUserBankAccountById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterDepartmentTableList", function() { return getFinCenterDepartmentTableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterDepartmentDetail", function() { return getFinCenterDepartmentDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterOurCompaniesTable", function() { return getFinCenterOurCompaniesTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFinCenterOurCompaniesDetail", function() { return getFinCenterOurCompaniesDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUserBankAccount", function() { return createUserBankAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchCreateUserBankAccount", function() { return batchCreateUserBankAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchEditUserBankAccount", function() { return batchEditUserBankAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserBankAccount", function() { return updateUserBankAccount; });
/* global process */
var base = window._env_.VUE_APP_FIN_CENTER_HOST;
var getUserBankAccountTable = function getUserBankAccountTable(params) {
  return axios.post(base + "/user-accounts/list", params);
};

var getUserBankAccountById = function getUserBankAccountById(params) {
  return axios.get(base + "/user-accounts/" + params.id, { params: params });
};

var delUserBankAccountById = function delUserBankAccountById(params) {
  return axios.delete(base + "/user-accounts/" + params.id, { params: params });
};
var getFinCenterDepartmentTableList = function getFinCenterDepartmentTableList(params) {
  return axios.post(base + "/departments/list", params);
};
var getFinCenterDepartmentDetail = function getFinCenterDepartmentDetail(params) {
  return axios.get(base + "/departments/" + params.id, { params: params });
};

var getFinCenterOurCompaniesTable = function getFinCenterOurCompaniesTable(params) {
  return axios.post(base + "/our_companies/lists", params);
};
var getFinCenterOurCompaniesDetail = function getFinCenterOurCompaniesDetail(params) {
  return axios.get(base + "/our_companies/" + params.id, { params: params });
};

var createUserBankAccount = function createUserBankAccount(params) {
  return axios.post(base + "/user-accounts", params);
};

var batchCreateUserBankAccount = function batchCreateUserBankAccount(params) {
  return axios.post(base + "/user-accounts/batch/create", params);
};

var batchEditUserBankAccount = function batchEditUserBankAccount(params) {
  return axios.post(base + "/user-accounts/batch/edit", params);
};

var updateUserBankAccount = function updateUserBankAccount(params) {
  return axios.put(base + "/user-accounts/" + params.id, params);
};

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addUserBatchTag", function() { return addUserBatchTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delUserBatchTag", function() { return delUserBatchTag; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var addUserBatchTag = function addUserBatchTag(params) {
  return axios.post(base + "/add_user_batch_tag", params);
};
var delUserBatchTag = function delUserBatchTag(params) {
  return axios.post(base + "/delete_user_batch_tag", params);
};

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserCoverTable", function() { return getUserCoverTable; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getUserCoverTable = function getUserCoverTable(params) {
  return axios.post(base + "/usercover_search", params);
};

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserCredit", function() { return updateUserCredit; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var updateUserCredit = function updateUserCredit(params) {
  return axios.post(base + "/add_crerdit_" + params.userid, params);
};

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryUserOderStatApi", function() { return queryUserOderStatApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserOderStatDetailApi", function() { return getUserOderStatDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userAddTagBySearchApi", function() { return userAddTagBySearchApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userDelTagBySearchApi", function() { return userDelTagBySearchApi; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var queryUserOderStatApi = function queryUserOderStatApi(params) {
  return axios.post(base + "/user_order_stat/query", params);
};
var getUserOderStatDetailApi = function getUserOderStatDetailApi(params) {
  return axios.get(base + "/user_order_stat/" + params.id, { params: params });
};

var userAddTagBySearchApi = function userAddTagBySearchApi(params) {
  return axios.post(base + "/user_order_stat/add_tag_by_search", params);
};

var userDelTagBySearchApi = function userDelTagBySearchApi(params) {
  return axios.post(base + "/user_order_stat/del_tag_by_search", params);
};

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserTagTable", function() { return getUserTagTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserGroupTagTable", function() { return getUserGroupTagTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserNormalTagTable", function() { return getUserNormalTagTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserTagDetail", function() { return getUserTagDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUsertag", function() { return createUsertag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUsertag", function() { return updateUsertag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUsertag", function() { return deleteUsertag; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getUserTagTable = function getUserTagTable(params) {
  return axios.post(base + "/query_tag", params);
};
var getUserGroupTagTable = function getUserGroupTagTable(params) {
  params.is_group = 1;
  return axios.post(base + "/query_tag", params);
};
var getUserNormalTagTable = function getUserNormalTagTable(params) {
  params.is_normal_tag = 0;
  return axios.post(base + "/query_tag", params);
};
var getUserTagDetail = function getUserTagDetail(params) {
  return axios.get(base + "/tag_" + params.id, { params: params });
};
var createUsertag = function createUsertag(params) {
  return axios.post(base + "/create_tag", params);
};
var updateUsertag = function updateUsertag(params) {
  return axios.post(base + "/update_tag_" + params.id, params);
};
var deleteUsertag = function deleteUsertag(params) {
  return axios.post(base + "/delete_tag_" + params.id, params);
};

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserWorkInfoTable", function() { return getUserWorkInfoTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserWorkInfoDetail", function() { return getUserWorkInfoDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditUserWorkInfoData", function() { return auditUserWorkInfoData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextAuditWorkInfoId", function() { return getNextAuditWorkInfoId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchRejectWorkInfoApi", function() { return batchRejectWorkInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchExpireWorkInfoApi", function() { return batchExpireWorkInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryWorkInfoSnapshotApi", function() { return queryWorkInfoSnapshotApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLatestWorkInfoApi", function() { return getUserLatestWorkInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exportUserAuditWorkInfoApi", function() { return exportUserAuditWorkInfoApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryWorkInfoCompany", function() { return queryWorkInfoCompany; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;
var getUserWorkInfoTable = function getUserWorkInfoTable(params) {
  return axios.post(base + "/user_work_info_audit/query", params);
};
var getUserWorkInfoDetail = function getUserWorkInfoDetail(params) {
  return axios.get(base + "/user_work_info_audit/" + params.id, { params: params });
};
var auditUserWorkInfoData = function auditUserWorkInfoData(params) {
  return axios.post(base + "/user_work_info_audit/" + params.id + "/audit", params);
};
var getNextAuditWorkInfoId = function getNextAuditWorkInfoId(params) {
  return axios.get(base + "/user_work_info_audit/next_audit_id", {});
};
var batchRejectWorkInfoApi = function batchRejectWorkInfoApi(params) {
  return axios.post(base + "/batch_jobs/batch_reject_user_workinfo", params);
};
var batchExpireWorkInfoApi = function batchExpireWorkInfoApi(params) {
  return axios.post(base + "/batch_jobs/batch_expire_user_workinfo", params);
};
var queryWorkInfoSnapshotApi = function queryWorkInfoSnapshotApi(params) {
  return axios.post(base + "/user_work_info_audit/query_snapshot", params);
};
var getUserLatestWorkInfoApi = function getUserLatestWorkInfoApi(params) {
  return axios.get(base + "/user_work_info_audit/get_latest_workinfo_" + params.userid, { params: params });
};
var exportUserAuditWorkInfoApi = function exportUserAuditWorkInfoApi(params) {
  return axios.post(base + "/batch_jobs/batch_export_user_audit_workinfo", params);
};
var queryWorkInfoCompany = function queryWorkInfoCompany(params) {
  return axios.post(base + "/work_info_company/query", params);
};

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertTypeQuery", function() { return violationAlertTypeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertTypeOptions", function() { return violationAlertTypeOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertTypeCreate", function() { return violationAlertTypeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertTypeEdit", function() { return violationAlertTypeEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertTypeGet", function() { return violationAlertTypeGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertTypeChangeStatus", function() { return violationAlertTypeChangeStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordQuery", function() { return violationAlertRecordQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordGet", function() { return violationAlertRecordGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordCreate", function() { return violationAlertRecordCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordResolveUsers", function() { return violationAlertRecordResolveUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordQueryDetails", function() { return violationAlertRecordQueryDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordResendFailed", function() { return violationAlertRecordResendFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordCheckRecall", function() { return violationAlertRecordCheckRecall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlertRecordRecall", function() { return violationAlertRecordRecall; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var violationAlertTypeQuery = function violationAlertTypeQuery(params) {
  return axios.post(base + "/violation_alert_type/query", params);
};

var violationAlertTypeOptions = function violationAlertTypeOptions(params) {
  return axios.get(base + "/violation_alert_type/options", { params: params });
};

var violationAlertTypeCreate = function violationAlertTypeCreate(params) {
  return axios.post(base + "/violation_alert_type/create", params);
};

var violationAlertTypeEdit = function violationAlertTypeEdit(params) {
  return axios.post(base + "/violation_alert_type/" + params.id + "/edit", params);
};

var violationAlertTypeGet = function violationAlertTypeGet(id) {
  return axios.get(base + "/violation_alert_type/" + id);
};

var violationAlertTypeChangeStatus = function violationAlertTypeChangeStatus(params) {
  return axios.post(base + "/violation_alert_type/change_status", params);
};

var violationAlertRecordQuery = function violationAlertRecordQuery(params) {
  return axios.post(base + "/violation_alert_record/query", params);
};

var violationAlertRecordGet = function violationAlertRecordGet(id) {
  return axios.get(base + "/violation_alert_record/" + id);
};

var violationAlertRecordCreate = function violationAlertRecordCreate(params) {
  return axios.post(base + "/violation_alert_record/create", params);
};

var violationAlertRecordResolveUsers = function violationAlertRecordResolveUsers(params) {
  return axios.post(base + "/violation_alert_record/resolve_users", params);
};

var violationAlertRecordQueryDetails = function violationAlertRecordQueryDetails(params) {
  return axios.post(base + "/violation_alert_record/" + params.id + "/query_details", params);
};

var violationAlertRecordResendFailed = function violationAlertRecordResendFailed(params) {
  return axios.post(base + "/violation_alert_record/" + params.id + "/resend_failed", params);
};

var violationAlertRecordCheckRecall = function violationAlertRecordCheckRecall(params) {
  return axios.post(base + "/violation_alert_record/" + params.id + "/check_recall", params);
};

var violationAlertRecordRecall = function violationAlertRecordRecall(params) {
  return axios.post(base + "/violation_alert_record/" + params.id + "/recall", params);
};

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllWecomDepartmentsApi", function() { return getAllWecomDepartmentsApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllActiveUsersApi", function() { return getAllActiveUsersApi; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var getAllWecomDepartmentsApi = function getAllWecomDepartmentsApi(params) {
  return axios.get(base + "/wecom/get_all_departments", { params: params });
};

var getAllActiveUsersApi = function getAllActiveUsersApi(params) {
  return axios.get(base + "/wecom/get_all_active_users", { params: params });
};

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessTypeQuery", function() { return workInfoBusinessTypeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessTypeCreate", function() { return workInfoBusinessTypeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessTypeEdit", function() { return workInfoBusinessTypeEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessTypeGet", function() { return workInfoBusinessTypeGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessTypeDelete", function() { return workInfoBusinessTypeDelete; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var workInfoBusinessTypeQuery = function workInfoBusinessTypeQuery(params) {
  return axios.post(base + "/work_info_business_type/query", params);
};

var workInfoBusinessTypeCreate = function workInfoBusinessTypeCreate(params) {
  return axios.post(base + "/work_info_business_type/create", params);
};

var workInfoBusinessTypeEdit = function workInfoBusinessTypeEdit(params) {
  return axios.post(base + "/work_info_business_type/" + params.id + "/edit", params);
};

var workInfoBusinessTypeGet = function workInfoBusinessTypeGet(id) {
  return axios.get(base + "/work_info_business_type/" + id);
};

var workInfoBusinessTypeDelete = function workInfoBusinessTypeDelete(id) {
  return axios.post(base + "/work_info_business_type/" + id + "/delete");
};

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompanyQuery", function() { return workInfoCompanyQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompanyCreate", function() { return workInfoCompanyCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompanyEdit", function() { return workInfoCompanyEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompanyGet", function() { return workInfoCompanyGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompanyDelete", function() { return workInfoCompanyDelete; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var workInfoCompanyQuery = function workInfoCompanyQuery(params) {
  return axios.post(base + "/work_info_company/query", params);
};

var workInfoCompanyCreate = function workInfoCompanyCreate(params) {
  return axios.post(base + "/work_info_company/create", params);
};

var workInfoCompanyEdit = function workInfoCompanyEdit(params) {
  return axios.post(base + "/work_info_company/" + params.id + "/edit", params);
};

var workInfoCompanyGet = function workInfoCompanyGet(id) {
  return axios.get(base + "/work_info_company/" + id);
};

var workInfoCompanyDelete = function workInfoCompanyDelete(id) {
  return axios.post(base + "/work_info_company/" + id + "/delete");
};

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkTypeQuery", function() { return workInfoWorkTypeQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkTypeCreate", function() { return workInfoWorkTypeCreate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkTypeEdit", function() { return workInfoWorkTypeEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkTypeGet", function() { return workInfoWorkTypeGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkTypeDelete", function() { return workInfoWorkTypeDelete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkTypeChangeStatus", function() { return workInfoWorkTypeChangeStatus; });
/* global process */
var base = window._env_.VUE_APP_ADMIN_HOST;

var workInfoWorkTypeQuery = function workInfoWorkTypeQuery(params) {
  return axios.post(base + "/work_info_work_type/query", params);
};

var workInfoWorkTypeCreate = function workInfoWorkTypeCreate(params) {
  return axios.post(base + "/work_info_work_type/create", params);
};

var workInfoWorkTypeEdit = function workInfoWorkTypeEdit(params) {
  return axios.post(base + "/work_info_work_type/" + params.id + "/edit", params);
};

var workInfoWorkTypeGet = function workInfoWorkTypeGet(id) {
  return axios.get(base + "/work_info_work_type/" + id);
};

var workInfoWorkTypeDelete = function workInfoWorkTypeDelete(id) {
  return axios.post(base + "/work_info_work_type/" + id + "/delete");
};

var workInfoWorkTypeChangeStatus = function workInfoWorkTypeChangeStatus(params) {
  return axios.post(base + "/work_info_work_type/" + params.id + "/status", { status: params.status });
};

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternAttendancePlanApi", function() { return getInternAttendancePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveInternAttendancePlanApi", function() { return saveInternAttendancePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearInternAttendancePlanApi", function() { return clearInternAttendancePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternAttendancePlanMonthlyApi", function() { return queryInternAttendancePlanMonthlyApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "queryInternAttendancePlanDetailApi", function() { return queryInternAttendancePlanDetailApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInternAttendancePlanMonthlyDetailApi", function() { return getInternAttendancePlanMonthlyDetailApi; });
/* global axios */
var base = window._env_.VUE_APP_ORDER_AUDIT_API_HOST;

var getInternAttendancePlanApi = function getInternAttendancePlanApi(params) {
  return axios.get(base + "/admin/intern-attendance-plan/month", { params: params });
};

var saveInternAttendancePlanApi = function saveInternAttendancePlanApi(params) {
  return axios.post(base + "/admin/intern-attendance-plan/save", params);
};

var clearInternAttendancePlanApi = function clearInternAttendancePlanApi(params) {
  return axios.post(base + "/admin/intern-attendance-plan/clear", params);
};

var queryInternAttendancePlanMonthlyApi = function queryInternAttendancePlanMonthlyApi(params) {
  return axios.post(base + "/admin/intern-attendance-plan/query_list", params);
};

var queryInternAttendancePlanDetailApi = function queryInternAttendancePlanDetailApi(params) {
  return axios.post(base + "/admin/intern-attendance-plan/query_detail", params);
};

var getInternAttendancePlanMonthlyDetailApi = function getInternAttendancePlanMonthlyDetailApi(params) {
  return axios.get(base + "/admin/intern-attendance-plan/detail", { params: params });
};

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUserWhitelist", function() { return platformUserWhitelist; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var platformUserWhitelist = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUser", function() { return platformUser; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getPlatformUsersIndex: function getPlatformUsersIndex(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('getPlatformUsersIndex', params);
  },
  getPlatformUsersDetail: function getPlatformUsersDetail(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('getPlatformUsersDetail', params);
  },
  addPlatformUser: function addPlatformUser(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('addPlatformUser', params);
  },
  editPlatformUser: function editPlatformUser(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;
    return request.alert('editPlatformUser', params);
  },
  deletePlatformUser: function deletePlatformUser(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return request.alert('deletePlatformUser', params);
  },
  copyPlatformUser: function copyPlatformUser(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return request.alert('copyPlatformUser', params);
  },

  getAllCustomers: function getAllCustomers(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;
    return request.alert('getAllCustomers', params);
  },
  getAdminOptions: function getAdminOptions(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;
    return request.alert('getAdminOptions', params);
  }

  // mutations
};var mutations = {};

var platformUser = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platform", function() { return platform; });
// initial state
// shape: [{ id, quantity }]
var state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0
  }

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getEducationTable: function getEducationTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getEducationTable', params);
    return promised;
  },
  createEducation: function createEducation(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('createEducation', params);
    return promised;
  },
  editEducation: function editEducation(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('editEducation', params);
    return promised;
  },
  editEducationLevel: function editEducationLevel(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('editEducationLevel', params);
    return promised;
  },
  uploadFile: function uploadFile(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('uploadFile', params);
    return promised;
  },
  deleteEducation: function deleteEducation(_ref6, id) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('deleteEducation', id);
    return promised;
  },
  getHotTag: function getHotTag(_ref7, id) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('getHotTag', id);
    return promised;
  },
  getEducation: function getEducation(_ref8, id) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getEducation', id);
    return promised;
  },
  deleteHotTag: function deleteHotTag(_ref9, id) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('deleteHotTag', id);
    return promised;
  },
  addHotTag: function addHotTag(_ref10, params) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('addHotTag', params);
    return promised;
  },
  getHomeModuleTable: function getHomeModuleTable(_ref11, params) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('getHomeModuleTable', params);
    return promised;
  },
  createModule: function createModule(_ref12, params) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('createModule', params);
    return promised;
  },
  editModule: function editModule(_ref13, params) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('editModule', params);
    return promised;
  },
  getAvailableModule: function getAvailableModule(_ref14, params) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var promised = request.alert('getAvailableModule', params);
    return promised;
  },
  getModuleOperateLog: function getModuleOperateLog(_ref15, params) {
    var commit = _ref15.commit,
        state = _ref15.state;

    var promised = request.alert('getModuleOperateLog', params);
    return promised;
  }
};

// mutations
var mutations = {};

var platform = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "position", function() { return position; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(97);


var _mutations;



// initial state
// shape: [{ id, quantity }]
var state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0
  }

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getPositionTable: function getPositionTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getPositionTable', params);
    return promised;
  },
  topPosition: function topPosition(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('topPosition', id);
    return promised;
  },
  releasePosition: function releasePosition(_ref3, id) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('releasePosition', id);
    return promised;
  },
  deletePosition: function deletePosition(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('deletePosition', id);
    return promised;
  },
  batchDeletePosition: function batchDeletePosition(_ref5, ids) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('batchDeletePosition', ids);
    return promised;
  },
  batchTopPosition: function batchTopPosition(_ref6, ids) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('batchTopPosition', ids);
    return promised;
  },
  batchReleasePosition: function batchReleasePosition(_ref7, ids) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('batchReleasePosition', ids);
    return promised;
  },
  getPostionForm: function getPostionForm(_ref8, id) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getPostionForm', id);
    return promised;
  },
  modifyPostion: function modifyPostion(_ref9, params) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('modifyPostion', params);
    return promised;
  },
  editPostionOptions: function editPostionOptions(_ref10) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('editPostionOptions');
    return promised;
  },
  uploadPositionFile: function uploadPositionFile(_ref11, params) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('uploadPositionFile', params);
    return promised;
  },
  getBatchJobTable: function getBatchJobTable(_ref12, params) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('getBatchJobTable', params);
    return promised;
  },
  offlinePosition: function offlinePosition(_ref13, params) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('offlinePosition', params);
    return promised;
  },
  batchOfflinePosition: function batchOfflinePosition(_ref14, params) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var promised = request.alert('batchOfflinePosition', params);
    return promised;
  },
  batchJobSample: function batchJobSample(_ref15, params) {
    var commit = _ref15.commit,
        state = _ref15.state;

    var promised = request.alert('batchJobSample', params);
    return promised;
  },
  batchJobDown: function batchJobDown(_ref16, id) {
    var commit = _ref16.commit,
        state = _ref16.state;

    var promised = request.alert('batchJobDown', id);
    return promised;
  },
  batchJobError: function batchJobError(_ref17, id) {
    var commit = _ref17.commit,
        state = _ref17.state;

    var promised = request.alert('batchJobError', id);
    return promised;
  },
  forceOfflinePosition: function forceOfflinePosition(_ref18, id) {
    var commit = _ref18.commit,
        state = _ref18.state;

    var promised = request.alert('forceOfflinePosition', id);
    return promised;
  },
  lockPosition: function lockPosition(_ref19, id) {
    var commit = _ref19.commit,
        state = _ref19.state;

    var promised = request.alert('lockPosition', id);
    return promised;
  },
  unlockPosition: function unlockPosition(_ref20, id) {
    var commit = _ref20.commit,
        state = _ref20.state;

    var promised = request.alert('unlockPosition', id);
    return promised;
  },
  passAuditPosition: function passAuditPosition(_ref21, id) {
    var commit = _ref21.commit,
        state = _ref21.state;

    var promised = request.alert('passAuditPosition', id);
    return promised;
  },
  failAuditPosition: function failAuditPosition(_ref22, id) {
    var commit = _ref22.commit,
        state = _ref22.state;

    var promised = request.alert('failAuditPosition', id);
    return promised;
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["d" /* SET_USER_TABLE */], function (state, table) {
  state.table = table;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["b" /* SET_USER_PAGINATION */], function (state, pagination) {
  state.pagination.current_page = Number(pagination.current_page);
  state.pagination.per_page = Number(pagination.per_page);
  state.pagination.total = Number(pagination.total);
}), _mutations);

var position = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 765 */,
/* 766 */,
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "priceBatchForm", function() { return priceBatchForm; });
// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getPriceBatchTable: function getPriceBatchTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('getPriceBatchTable', params);
  },
  createPriceBatch: function createPriceBatch(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('createPriceBatch', params);
  },
  searchPriceBatchItems: function searchPriceBatchItems(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('searchPriceBatchItems', params);
  }

  // mutations
};var mutations = {};

var priceBatchForm = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "project", function() { return project; });
// initial state
var state = {
  options: {
    type: [{ label: '普通项目', value: '1' }, { label: '中台项目', value: '2' }],
    projectProgressLabel: {
      1: '进行中',
      2: '已完成'
    },
    clearFileUploadStatusLabel: {
      1: '待清洗',
      2: '已清洗',
      3: '无需清洗'
    }
  }

  // getters
};var getters = {};

// actions
var actions = {
  getReceiptVirtualProjectTable: function getReceiptVirtualProjectTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('getReceiptVirtualProjectTable', params);
  },
  getReceiptVirtualProjectDetail: function getReceiptVirtualProjectDetail(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('getReceiptVirtualProjectDetail', params);
  }

  // mutations
};var mutations = {};

var project = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "questionNotPassMessage", function() { return questionNotPassMessage; });
// initial state
var state = {
  messages: []

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var questionNotPassMessage = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedPayment", function() { return receivedPayment; });
// initial state
var state = {
  receiptRelatedStatus: {
    0: '未核销',
    1: '部分核销',
    2: '已核销'
  },
  collectionTypeText: {
    1: '销售收款',
    2: '预收款'
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var receivedPayment = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resume", function() { return resume; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(97);


var _mutations;



// initial state
// shape: [{ id, quantity }]
var state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0
  }

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getResumeTable: function getResumeTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getResumeTable', params);
    return promised;
  },
  getResumeForm: function getResumeForm(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('getResumeForm', id);
    return promised;
  },
  exportResume: function exportResume(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('exportResume', params);
    return promised;
  },
  exportResumes: function exportResumes(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('exportResumes', params);
    return promised;
  },
  appliedResume: function appliedResume(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('appliedResume', params);
    return promised;
  },
  sendResumes: function sendResumes(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('sendResumes', params);
    return promised;
  },
  downloadResume: function downloadResume(_ref7, path) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('downloadResume', path);
    return promised;
  },
  getResumeOptions: function getResumeOptions(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getResumeOptions');
    return promised;
  },
  getResumeAllTable: function getResumeAllTable(_ref9, params) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('getResumeAllTable', params);
    return promised;
  },
  getResumeCity: function getResumeCity(_ref10, params) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('getResumeCity', params);
    return promised;
  },
  editResume: function editResume(_ref11, params) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('editResume', params);
    return promised;
  },
  uploadResumeImg: function uploadResumeImg(_ref12, params) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('uploadResumeImg', params);
    return promised;
  },
  queryCity: function queryCity(_ref13, params) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('queryCity', params);
    return promised;
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["d" /* SET_USER_TABLE */], function (state, table) {
  state.table = table;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["b" /* SET_USER_PAGINATION */], function (state, pagination) {
  state.pagination.current_page = Number(pagination.current_page);
  state.pagination.per_page = Number(pagination.per_page);
  state.pagination.total = Number(pagination.total);
}), _mutations);

var resume = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "satisfactionEmail", function() { return satisfactionEmail; });
// initial state
var state = {
  options: {
    type: [{ label: '首次合作', value: 1 }, { label: '常规客户', value: 2 }, { label: '潜在客户', value: 3 }, { label: '客户采购', value: 4 }],
    status: [{ label: '无效', value: 0 }, { label: '有效', value: 1 }],
    pushStatus: [{ label: '投递失败', value: 0 }, { label: '投递成功', value: 1 }]
  }

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var satisfactionEmail = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 773 */
/***/ (function(module, exports) {



/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stepTemplate", function() { return stepTemplate; });
// initial state
var state = {
  types: {
    info: '文字题',
    text: '填空题',
    multitext: '多项填空题',
    select: '单选题',
    multiselect: '多选题',
    imageMultiselect: '图片多选题'
  },
  focusQuestionIndex: null,
  focusOptionIndex: null,
  evidenceType: [{ label: '照片', value: 'photo' }, { label: '二维码', value: 'qrcode' }, { label: '视频', value: 'video' }, { label: '录音', value: 'record' }],
  evidenceQuality: [{ label: '低品质', value: '1' }, { label: '中品质', value: '2' }, { label: '高品质', value: '3' }, { label: '极高品质', value: '4' }],
  inputType: [{ label: '文本', value: 'text' }, { label: '数字(整数)', value: 'numberInt' }, { label: '数字(浮点数)', value: 'numberFloat' }, { label: '日期', value: 'date' }],
  clarity: [{ label: '不检测', value: '0' }, { label: '低品质', value: '0.2' }, { label: '中品质', value: '0.4' }, { label: '高品质', value: '0.6' }, { label: '极高品质', value: '1' }],
  imageRecognitionType: [{ label: '近景', value: '1' }, { label: '货架（正面）', value: '2' }, { label: '货架（倾斜）', value: '3' }],
  takePhotoAuxiliaryLineType: [{ label: '未开启', value: 0 }, { label: '地堆', value: 1 }, { label: '包柱', value: 2 }, { label: '端架', value: 3 }, { label: '主货架', value: 4 }, { label: '立柜', value: 5 }]

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {
  setFocusIndex: function setFocusIndex(state, _ref) {
    var questionIndex = _ref.questionIndex,
        optionIndex = _ref.optionIndex;

    state.focusQuestionIndex = questionIndex;
    state.focusOptionIndex = optionIndex;
  }
};

var stepTemplate = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeCollection", function() { return storeCollection; });
var state = {
  STATUS_NOT_COLLECT: 1,
  STATUS_COLLECT_WAIT: 2,
  STATUS_COLLECTING: 3,
  STATUS_COLLECTED: 4,
  STATUS_CONFIRMED: 5
};
var getters = {};
var actions = {};
var mutations = {};

var storeCollection = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskBatch", function() { return taskBatch; });
// initial state
var state = {
  status: [{ value: 1, label: '等待开始' }, { value: 2, label: '进行中' }, { value: 3, label: '处理完成' }, { value: 4, label: '撤回' }, { value: -1, label: '已取消' }, { value: -2, label: '失败' }, { value: -3, label: '已删除' }, { value: -4, label: '取消中' }, { value: -5, label: '暂停中' }, { value: -6, label: '已暂停' }],
  approvalStatus: [{ value: 0, label: '无需审批' }, { value: 1, label: '待审批' }, { value: 2, label: '已通过' }, { value: 3, label: '已驳回' }, { value: 4, label: '已放弃' }]
};

var taskBatch = {
  state: state
};

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskNotice", function() { return taskNotice; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var taskNotice = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskOrder", function() { return taskOrder; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var taskOrder = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "task", function() { return task; });
// initial state
var state = {
  options: {
    sex: [{ label: '男', value: 1 }, { label: '女', value: 2 }],
    age: [{ label: '<20', value: 1 }, { label: '20-25', value: 2 }, { label: '26-35', value: 3 }, { label: '36-45', value: 4 }, { label: '>45', value: 5 }],
    education: [{ label: '小学', value: 1 }, { label: '初中', value: 2 }, { label: '高中', value: 3 }, { label: '大专', value: 4 }, { label: '本科', value: 5 }, { label: '本科以上', value: 6 }],
    marriage: [{ label: '已婚已育', value: 1 }, { label: '已婚未育', value: 2 }, { label: '未婚', value: 3 }],
    height: [{ label: '<160', value: 1 }, { label: '160-165', value: 2 }, { label: '166-170', value: 3 }, { label: '171-175', value: 4 }, { label: '>176', value: 5 }],
    weight: [{ label: '<100', value: 1 }, { label: '101-150', value: 2 }, { label: '151-180', value: 3 }, { label: '>180', value: 4 }],
    transport_mode: [{ label: '需要有车', value: 1 }]
  },
  platformTypes: [0, // 主平台任务
  1, // 查理宝任务
  2, // 标注任务
  3, // TEKE平台任务
  6]

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var task = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tekeCustomer", function() { return tekeCustomer; });
// initial state
// shape: [{ id, quantity }]
var state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0
  }

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getTekeCustomerTable: function getTekeCustomerTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getTekeCustomerTable', params);
    return promised;
  },
  setPlatformFee: function setPlatformFee(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('setPlatformFee', params);
    return promised;
  },
  deleteTekeCustomer: function deleteTekeCustomer(_ref3, id) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('deleteTekeCustomer', id);
    return promised;
  },
  getTekeMemberTable: function getTekeMemberTable(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('getTekeMemberTable', params);
    return promised;
  },
  createCustomer: function createCustomer(_ref5, id) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('createCustomer', id);
    return promised;
  },
  editTekeCustomer: function editTekeCustomer(_ref6, id) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('editTekeCustomer', id);
    return promised;
  },
  getTekeCustomer: function getTekeCustomer(_ref7, id) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('getTekeCustomer', id);
    return promised;
  },
  batchEditPlatformFee: function batchEditPlatformFee(_ref8, params) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('batchEditPlatformFee', params);
    return promised;
  },
  createCustomerMember: function createCustomerMember(_ref9, params) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('createCustomerMember', params);
    return promised;
  },
  editCustomerMember: function editCustomerMember(_ref10, params) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('editCustomerMember', params);
    return promised;
  },
  getTekeCustomerDetail: function getTekeCustomerDetail(_ref11, id) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('getTekeCustomerDetail', id);
    return promised;
  },
  getTekeCustomerBalance: function getTekeCustomerBalance(_ref12, id) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('getTekeCustomerBalance', id);
    return promised;
  },
  getTekeCustomerRechargeTable: function getTekeCustomerRechargeTable(_ref13, id) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('getTekeCustomerRechargeTable', id);
    return promised;
  },
  createCustomeRecharge: function createCustomeRecharge(_ref14, id) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var promised = request.alert('createCustomeRecharge', id);
    return promised;
  },
  getTekeCustomerBalanceTable: function getTekeCustomerBalanceTable(_ref15, params) {
    var commit = _ref15.commit,
        state = _ref15.state;

    var promised = request.alert('getTekeCustomerBalanceTable', params);
    return promised;
  },
  UploadTekeFile: function UploadTekeFile(_ref16, params) {
    var commit = _ref16.commit,
        state = _ref16.state;

    var promised = request.alert('UploadTekeFile', params);
    return promised;
  },
  getTekeCustomerMember: function getTekeCustomerMember(_ref17, id) {
    var commit = _ref17.commit,
        state = _ref17.state;

    var promised = request.alert('getTekeCustomerMember', id);
    return promised;
  }
};

// mutations
var mutations = {};

var tekeCustomer = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tekeOrder", function() { return tekeOrder; });
// initial state
// shape: [{ id, quantity }]
var state = {
  userOptions: []

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getTekeOrderTable: function getTekeOrderTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getTekeOrderTable', params);
    return promised;
  },
  batchCompleteTekeOrder: function batchCompleteTekeOrder(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('batchCompleteTekeOrder', params);
    return promised;
  },
  batchCancelTekeOrder: function batchCancelTekeOrder(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('batchCancelTekeOrder', params);
    return promised;
  },
  reviewTekeOrderPass: function reviewTekeOrderPass(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('reviewTekeOrderPass', params);
    return promised;
  }
};

// mutations
var mutations = {};

var tekeOrder = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tekeTag", function() { return tekeTag; });
// initial state
// shape: [{ id, quantity }]
var state = {
  userOptions: []

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getTekeTagTable: function getTekeTagTable(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getTekeTagTable', params);
    return promised;
  },
  createTekeTag: function createTekeTag(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.alert('createTekeTag', params);
    return promised;
  },
  editTekeTag: function editTekeTag(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('editTekeTag', params);
    return promised;
  },
  deleteTekeTag: function deleteTekeTag(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('deleteTekeTag', id);
    return promised;
  },
  getTekeInfiniteTagTable: function getTekeInfiniteTagTable(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('getTekeInfiniteTagTable', params);
    return promised;
  },
  createTekeInfiniteTag: function createTekeInfiniteTag(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('createTekeInfiniteTag', params);
    return promised;
  },
  editTekeInfiniteTag: function editTekeInfiniteTag(_ref7, params) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('editTekeInfiniteTag', params);
    return promised;
  },
  getTekeTag: function getTekeTag(_ref8, id) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getTekeTag', id);
    return promised;
  },
  batchAddTeke: function batchAddTeke(_ref9, id) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('batchAddTeke', id);
    return promised;
  },
  batchDeleteTeke: function batchDeleteTeke(_ref10, id) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('batchDeleteTeke', id);
    return promised;
  },
  getTekeInfiniteTagUpload: function getTekeInfiniteTagUpload(_ref11, params) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('getTekeInfiniteTagUpload', params);
    return promised;
  },
  downTekeSourceFile: function downTekeSourceFile(_ref12, id) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('downTekeSourceFile', id);
    return promised;
  },
  downTekeErrorFile: function downTekeErrorFile(_ref13, id) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('downTekeErrorFile', id);
    return promised;
  },
  batchUploadTekeTagEdit: function batchUploadTekeTagEdit(_ref14, params) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var promised = request.alert('batchUploadTekeTagEdit', params);
    return promised;
  },
  batchUploadTekeTagLib: function batchUploadTekeTagLib(_ref15, params) {
    var commit = _ref15.commit,
        state = _ref15.state;

    var promised = request.alert('batchUploadTekeTagLib', params);
    return promised;
  },
  downloadAllTagFile: function downloadAllTagFile(_ref16, params) {
    var commit = _ref16.commit,
        state = _ref16.state;

    var promised = request.alert('downloadAllTagFile', params);
    return promised;
  },
  getBatchjobOnGoingNumber: function getBatchjobOnGoingNumber(_ref17, params) {
    var commit = _ref17.commit,
        state = _ref17.state;

    var promised = request.alert('getBatchjobOnGoingNumber', params);
    return promised;
  }
};

// mutations
var mutations = {};

var tekeTag = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userOrderStat", function() { return userOrderStat; });
var state = {
  evidenceTypeMap: {
    1: '录音',
    2: '视频'
  }
};

var userOrderStat = {
  state: state
};

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userTag", function() { return userTag; });
// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
var state = {};

// getters
var getters = {}
// user: state => state.user


// actions
;var actions = {
  getUserTagTable: function getUserTagTable(_ref, params) {
    var commit = _ref.commit;

    var promised = request.alert('getUserTagTable', params);
    return promised;
  }
};

// mutations
var mutations = {};

var userTag = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userWorkInfo", function() { return userWorkInfo; });
// initial state
var state = {
  workInfoStatus: {
    0: '待审核',
    1: '审核通过',
    2: '审核未通过'
  },
  fields: [{ prop: 'id', label: 'ID' }, { prop: 'userid', label: '提交用户ID' }, { prop: 'cellphone', label: '手机号' }, { prop: 'status_cn', label: '状态' }, { prop: 'workinfo_passed_times', label: '审核通过次数' }, { prop: 'created_at', label: '提交时间' }, { prop: 'updated_at', label: '更新时间' }]

  // getters
};var getters = {};

// actions
var actions = {};

// mutations
var mutations = {};

var userWorkInfo = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "users", function() { return users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(97);


var _mutations;



// initial state
// shape: [{ id, quantity }]
var state = {
  userOptions: [],
  options: {
    status: [{ label: '待验证', value: 0 }, { label: '已验证', value: 1 }, { label: '阶段封号', value: -1 }, { label: '永久封号', value: -2 }],
    currentstatus: [{ label: '未激活', value: 0 }, { label: '活跃', value: 1 }, { label: '待机', value: 3 }, { label: '未转化', value: 4 }],
    level: [{ label: '铁牌', value: 0 }, { label: '铜牌', value: 1 }, { label: '银牌', value: 2 }, { label: '金牌', value: 3 }, { label: '铂金', value: 4 }, { label: '钻石', value: 5 }],
    believable: [{ label: '不可信', value: 0 }, { label: '可信', value: 1 }],
    type: [{ label: '店内员工', value: 11 }, { label: '销售与督导', value: 12 }, { label: '其他', value: 13 }, { label: 'SJF销售', value: 90 }],
    bankcardverified: [{ label: '未验证', value: 0 }, { label: '已验证', value: 1 }],
    idnumverified: [{ label: '未验证', value: 0, color: '#333333' }, { label: '待完善', value: 1, color: '#999999' }, { label: '已验证', value: 2, color: '#67C23A' }, { label: '验证失败', value: 3, color: '#F56C6C' }],
    zfb_accountverified: [{ label: '未验证', value: 0 }, { label: '已验证', value: 1 }],
    workinfoStatus: [{ label: '待完善', value: 0 }, { label: '待审核', value: 1 }, { label: '审核通过', value: 2 }, { label: '审核不通过', value: 3 }, { label: '已过期', value: 4 }],
    provinces: [],
    abilities: [],
    attributes: [],
    work_type: [],
    business_type: [],
    business_work_type: [],
    is_forbidden_withdraw: [{ label: '否', value: 0 }, { label: '是', value: 1 }],
    register_app_type: [{ label: '爱零工', value: 1 }, { label: '查理宝', value: 2 }, { label: '主平台', value: 3 }]
  },
  deviceDetailFields: [{ prop: 'id', label: 'ID' }, { prop: 'devicenum', label: '设备号' }, { prop: 'userid', label: '用户ID' }, { prop: 'realname', label: '真实姓名' }, { prop: 'province_name', label: '省份' }, { prop: 'city_name', label: '城市' }, { prop: 'area_name', label: '地区' }, { prop: 'user_is_blocked', label: '是否被封号', formatter: function formatter(row) {
      return row.user_is_blocked === true ? '是' : '否';
    } }, { prop: 'user_is_exclusive', label: '是否独占标签', formatter: function formatter(row) {
      return row.user_is_exclusive === true ? '是' : '否';
    } }, { prop: 'user_is_unregister', label: '是否注销', formatter: function formatter(row) {
      return row.user_is_unregister === true ? '是' : '否';
    } }, { prop: 'last_login_at', label: '最后登录时间' }, { prop: 'app_type', label: '登录App', formatter: function formatter(row) {
      return Number(row.app_type) === 1 ? '爱零工' : '查理宝';
    } }],
  deviceDetailExportFields: [{ prop: 'id', label: 'ID' }, { prop: 'devicenum', label: '设备号' }, { prop: 'userid', label: '用户ID' }, { prop: 'realname', label: '真实姓名' }, { prop: 'province_name', label: '省份' }, { prop: 'city_name', label: '城市' }, { prop: 'area_name', label: '地区' }, { prop: 'cellphone', label: '手机号' }, { prop: 'strcurrentstatus', label: '用户当前状态' }, { prop: 'registertime', label: '注册时间' }, { prop: 'cumulative_bounty', label: '累计赏金' }, { prop: 'balance', label: '账户余额' }, { prop: 'business_type', label: '行业' }, { prop: 'work_type', label: '工种' }, { prop: 'belongto', label: '公司名称' }, { prop: 'main_brand', label: '主营品牌' }, { prop: 'workinfo_status_cn', label: '职业信息状态' }, { prop: 'last_login_at', label: '最后登录时间' }, { prop: 'user_is_blocked', label: '是否被封号', formatter: function formatter(row) {
      return row.user_is_blocked === true ? '是' : '否';
    } }, { prop: 'user_is_exclusive', label: '是否独占标签', formatter: function formatter(row) {
      return row.user_is_exclusive === true ? '是' : '否';
    } }, { prop: 'user_is_unregister', label: '是否注销', formatter: function formatter(row) {
      return row.user_is_unregister === true ? '是' : '否';
    } }, { prop: 'app_type', label: '登录App', formatter: function formatter(row) {
      return Number(row.app_type) === 1 ? '爱零工' : '查理宝';
    } }],
  riskusersOpts: {
    riskStatusOpts: {
      1: '风险用户',
      2: '正常用户'
    },
    riskConfirmStatusOpts: {
      1: '待确认',
      2: '无需确认',
      3: '确认风险',
      4: '确认正常'
    }
  }

  // getters
};var getters = {}
// demoTable: state => state.table


// actions
;var actions = {
  getUserDetail: function getUserDetail(_ref, id) {
    var commit = _ref.commit,
        state = _ref.state;

    var promised = request.alert('getUserDetail', id);
    return promised;
  },
  getUserRelatedOptions: function getUserRelatedOptions(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;

    var promised = request.page('getUserRelatedOptions', params);
    promised.then(function (res) {
      commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["c" /* SET_USER_RELATED_OPTIONS */], res.data);
    }, Function.prototype);
    return promised;
  },
  getQueryCustomerService: function getQueryCustomerService(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var promised = request.alert('getQueryCustomerService', params);
    return promised;
  },
  addCustomerService: function addCustomerService(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var promised = request.alert('addCustomerService', params);
    return promised;
  },
  modifyCustomerService: function modifyCustomerService(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var promised = request.alert('modifyCustomerService', params);
    return promised;
  },
  getUserDevice: function getUserDevice(_ref6, id) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var promised = request.alert('getUserDevice', id);
    return promised;
  },
  getUserOperate: function getUserOperate(_ref7, id) {
    var commit = _ref7.commit,
        state = _ref7.state;

    var promised = request.alert('getUserOperate', id);
    return promised;
  },
  getUserAccount: function getUserAccount(_ref8, id) {
    var commit = _ref8.commit,
        state = _ref8.state;

    var promised = request.alert('getUserAccount', id);
    return promised;
  },
  getUserLog: function getUserLog(_ref9, id) {
    var commit = _ref9.commit,
        state = _ref9.state;

    var promised = request.alert('getUserLog', id);
    return promised;
  },
  getUserCredit: function getUserCredit(_ref10, id) {
    var commit = _ref10.commit,
        state = _ref10.state;

    var promised = request.alert('getUserCredit', id);
    return promised;
  },
  getCreditList: function getCreditList(_ref11, params) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var promised = request.alert('getCreditList', params);
    return promised;
  },
  getPointList: function getPointList(_ref12, params) {
    var commit = _ref12.commit,
        state = _ref12.state;

    var promised = request.alert('getPointList', params);
    return promised;
  },
  getUserPoints: function getUserPoints(_ref13, id) {
    var commit = _ref13.commit,
        state = _ref13.state;

    var promised = request.alert('getUserPoints', id);
    return promised;
  },
  getMasTable: function getMasTable(_ref14, id) {
    var commit = _ref14.commit,
        state = _ref14.state;

    var promised = request.alert('getMasTable', id);
    return promised;
  },
  getCityList: function getCityList(_ref15, id) {
    var commit = _ref15.commit,
        state = _ref15.state;

    var promised = request.alert('getCityList', id);
    return promised;
  },
  getProvinceList: function getProvinceList(_ref16, params) {
    var commit = _ref16.commit,
        state = _ref16.state;

    var promised = request.alert('getProvinceList', params);
    return promised;
  },
  getMarketInfo: function getMarketInfo(_ref17, params) {
    var commit = _ref17.commit,
        state = _ref17.state;

    var promised = request.alert('getMarketInfo', params);
    return promised;
  },
  getTagInfo: function getTagInfo(_ref18, params) {
    var commit = _ref18.commit,
        state = _ref18.state;

    var promised = request.alert('getTagInfo', params);
    return promised;
  },
  uploadUserMasImg: function uploadUserMasImg(_ref19, params) {
    var commit = _ref19.commit,
        state = _ref19.state;

    var promised = request.alert('uploadUserMasImg', params);
    return promised;
  },
  addUserMas: function addUserMas(_ref20, params) {
    var commit = _ref20.commit,
        state = _ref20.state;

    var promised = request.alert('addUserMas', params);
    return promised;
  },
  getUserMasDetail: function getUserMasDetail(_ref21, id) {
    var commit = _ref21.commit,
        state = _ref21.state;

    var promised = request.alert('getUserMasDetail', id);
    return promised;
  },
  getAreaList: function getAreaList(_ref22, id) {
    var commit = _ref22.commit,
        state = _ref22.state;

    var promised = request.alert('getAreaList', id);
    return promised;
  }
};

// mutations
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["c" /* SET_USER_RELATED_OPTIONS */], function (state, data) {
  state.userOptions = data;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* SET_USER_OPTIONS */], function (state, data) {
  filter.setLoop(state.options, data);
}), _mutations);

var users = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessType", function() { return workInfoBusinessType; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {
  workInfoBusinessTypeQuery: function workInfoBusinessTypeQuery(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('workInfoBusinessTypeQuery', params);
  },
  workInfoBusinessTypeCreate: function workInfoBusinessTypeCreate(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('workInfoBusinessTypeCreate', params);
  },
  workInfoBusinessTypeEdit: function workInfoBusinessTypeEdit(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('workInfoBusinessTypeEdit', params);
  },
  workInfoBusinessTypeGet: function workInfoBusinessTypeGet(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;
    return request.alert('workInfoBusinessTypeGet', params);
  },
  workInfoBusinessTypeDelete: function workInfoBusinessTypeDelete(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return request.alert('workInfoBusinessTypeDelete', params);
  }

  // mutations
};var mutations = {};

var workInfoBusinessType = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompany", function() { return workInfoCompany; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(97);



// initial state
var state = {
  options: {}

  // getters
};var getters = {}
// workInfoCompanyTable: state => state.table


// actions
;var actions = {
  workInfoCompanyQuery: function workInfoCompanyQuery(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('workInfoCompanyQuery', params);
  },
  workInfoCompanyCreate: function workInfoCompanyCreate(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('workInfoCompanyCreate', params);
  },
  workInfoCompanyEdit: function workInfoCompanyEdit(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('workInfoCompanyEdit', params);
  },
  workInfoCompanyGet: function workInfoCompanyGet(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;
    return request.alert('workInfoCompanyGet', params);
  },
  workInfoCompanyDelete: function workInfoCompanyDelete(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return request.alert('workInfoCompanyDelete', params);
  }

  // mutations
};var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["a" /* SET_USER_OPTIONS */], function (state, data) {
  filter.setLoop(state.options, data);
});

var workInfoCompany = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkType", function() { return workInfoWorkType; });
// initial state
var state = {};

// getters
var getters = {};

// actions
var actions = {
  workInfoWorkTypeQuery: function workInfoWorkTypeQuery(_ref, params) {
    var commit = _ref.commit,
        state = _ref.state;
    return request.alert('workInfoWorkTypeQuery', params);
  },
  workInfoWorkTypeCreate: function workInfoWorkTypeCreate(_ref2, params) {
    var commit = _ref2.commit,
        state = _ref2.state;
    return request.alert('workInfoWorkTypeCreate', params);
  },
  workInfoWorkTypeEdit: function workInfoWorkTypeEdit(_ref3, params) {
    var commit = _ref3.commit,
        state = _ref3.state;
    return request.alert('workInfoWorkTypeEdit', params);
  },
  workInfoWorkTypeGet: function workInfoWorkTypeGet(_ref4, params) {
    var commit = _ref4.commit,
        state = _ref4.state;
    return request.alert('workInfoWorkTypeGet', params);
  },
  workInfoWorkTypeDelete: function workInfoWorkTypeDelete(_ref5, params) {
    var commit = _ref5.commit,
        state = _ref5.state;
    return request.alert('workInfoWorkTypeDelete', params);
  },
  workInfoWorkTypeChangeStatus: function workInfoWorkTypeChangeStatus(_ref6, params) {
    var commit = _ref6.commit,
        state = _ref6.state;
    return request.alert('workInfoWorkTypeChangeStatus', params);
  }

  // mutations
};var mutations = {};

var workInfoWorkType = {
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main__ = __webpack_require__(791);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LoginBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_vue__ = __webpack_require__(792);



var LoginBoxConstructor = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_1__main_vue__["a" /* default */]);

var instance = void 0;

var initInstance = function initInstance() {
  instance = new LoginBoxConstructor({
    el: document.createElement('div')
  });
  document.body.appendChild(instance.$el);
};

var LoginBox = function LoginBox(options) {
  if (!instance) {
    initInstance();
  }
  instance.visible = true;
};

/* harmony default export */ __webpack_exports__["a"] = (LoginBox);


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e6899c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(799);
function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55e6899c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */,
/* 796 */,
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-signin"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"login-wrap"},[_c('el-form',{ref:"loginForm",attrs:{"rules":_vm.rules,"model":_vm.form,"label-position":"left"}},[_c('el-form-item',{attrs:{"prop":"name"}},[_c('el-input',{attrs:{"placeholder":"用户名"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"type":"password","placeholder":"密码"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),(_vm.accountOrPwdWrong)?_c('el-form-item',{attrs:{"prop":"captchacode"}},[_c('div',{staticClass:"captchacode-container"},[_c('el-input',{attrs:{"placeholder":"验证码"},model:{value:(_vm.form.captchacode),callback:function ($$v) {_vm.$set(_vm.form, "captchacode", $$v)},expression:"form.captchacode"}}),_vm._v(" "),_c('img',{staticStyle:{"margin-left":"10px","width":"50px","height":"25px"},attrs:{"src":_vm.codeImageData},on:{"click":_vm.refreshCaptchaCode}})],1)]):_vm._e(),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"submit-btn",attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.login}},[_c('i',{staticClass:"el-icon-check"})])],1),_vm._v(" "),(_vm.errorMsg != '')?_c('div',{staticClass:"login-error"},[_vm._v(_vm._s(_vm.errorMsg)+"\n      ")]):_vm._e()],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-signin-heading"},[_c('h1',{staticClass:"sign-title"},[_vm._v("登 录")]),_vm._v(" "),_c('img',{attrs:{"width":"150","src":__webpack_require__(798),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"width":"330px","visible":_vm.visible,"show-close":false,"close-on-click-modal":false,"close-on-press-escape":false,"custom-class":"login-dialog"},on:{"update:visible":function($event){_vm.visible=$event}}},[(_vm.visible)?_c('login',{on:{"login":_vm.onLogin}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* global process */


// 文档标题
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('title', {
  inserted: function inserted(el, binding) {
    document.title = binding.value + ' - ' + window._env_.VUE_APP_NAME;
  },
  update: function update(el, binding) {
    if (binding.oldValue !== binding.value) {
      document.title = binding.value + ' - ' + window._env_.VUE_APP_NAME;
    }
  }
});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


// 用户权限
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('permission', {
  inserted: function inserted(el, binding, vnode) {
    var value = binding.value;


    var hasPermission = false;

    try {
      hasPermission = filter.hasPermission(value);
    } catch (e) {
      throw new Error('need permissions! Like v-permission="1" or v-permission="[1,2]"');
    }

    // 表示该权限不在用户权限内时
    if (binding.modifiers.not) {
      hasPermission = !hasPermission;
    }

    // 无权限时删除元素
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);


// 用户权限
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.directive('api-permission', {
  inserted: function inserted(el, binding, vnode) {
    var value = binding.value;


    var hasPermission = false;

    try {
      hasPermission = filter.hasApiPermission(value);
    } catch (e) {
      throw new Error('need permissions! Like v-permission="`edit_project`" or v-permission="[`edit_project`, `delete_project`]"');
    }

    // 表示该权限不在用户权限内时
    if (binding.modifiers.not) {
      hasPermission = !hasPermission;
    }

    // 无权限时删除元素
    if (!hasPermission) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
});

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar_css_perfect_scrollbar_css__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_perfect_scrollbar_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__ = __webpack_require__(273);
// 滚动条美化插件
// https://github.com/inuyaksa/jquery.nicescroll



// 美化滚动条
Vue.directive('perfectScrollbar', {
  inserted: function inserted(el, binding) {
    if (binding.modifiers.relative) {
      el.style.position = 'relative';
    }
    return new __WEBPACK_IMPORTED_MODULE_1_perfect_scrollbar__["a" /* default */](el, binding.value);
  }
});

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(77);




// 添加请求拦截器
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  // 记录取消请求Token
  request.cancelToken && (config.cancelToken = request.cancelToken);

  // TODO 百旺本地服务需要过滤掉 SJ-Auth-Token
  if (config.url.indexOf('127.0.0.1:15000') === -1) {
    // 已登录
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["d" /* isLoggedIn */])()) {
      config.headers['SJ-Auth-Token'] = Object(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["c" /* getToken */])();
    }
  }
  // 发送请求配置
  return config;
}, function (error) {
  // 返回请求错误
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 添加响应拦截器
// axios.interceptors.response.use((response) => {})

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_components_LayoutPanel__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_components_ExportExcelBox__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_components_RemoteSelect__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_components_ButtonGutter__ = __webpack_require__(264);
/*
 * Vue全局组件
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:09
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-07-20 13:49:54
 */






var components = {
  LayoutPanel: __WEBPACK_IMPORTED_MODULE_1__core_components_LayoutPanel__["a" /* default */],
  ExportExcelBox: __WEBPACK_IMPORTED_MODULE_2__core_components_ExportExcelBox__["a" /* default */],
  RemoteSelect: __WEBPACK_IMPORTED_MODULE_3__core_components_RemoteSelect__["a" /* default */],
  ButtonGutter: __WEBPACK_IMPORTED_MODULE_4__core_components_ButtonGutter__["a" /* default */]
};

for (var key in components) {
  var component = components[key];
  __WEBPACK_IMPORTED_MODULE_0_vue___default.a.component(component.name, component);
}

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$export = __WEBPACK_IMPORTED_MODULE_2__core_components_ExportExcelBox__["a" /* default */].export;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"panel"},[(_vm.showHeader)?_c('header',{class:['panel-heading', _vm.isCollapse?'up':'']},[_c('span',{staticClass:"panel-heading-title"},[_vm._t("header")],2),_vm._v(" "),_c('span',{staticClass:"tools"},[_vm._t("tools"),_vm._v(" "),_c('el-tooltip',{attrs:{"content":_vm.isCollapse?'展开':'收起',"placement":"top"}},[(_vm.hideCollapse === false)?_c('button',{class:[_vm.isCollapse?'el-icon-arrow-up':'el-icon-arrow-down'],on:{"click":function($event){_vm.isCollapse = !_vm.isCollapse}}}):_vm._e()])],2)]):_vm._e(),_vm._v(" "),_c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCollapse),expression:"!isCollapse"}]},[_c('div',{staticClass:"panel-body",style:(_vm.bodyStyle)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main__ = __webpack_require__(810);


/* istanbul ignore next */
__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */].install = function (Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main__["a" /* default */]);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ExportExcelBox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main_vue__ = __webpack_require__(811);




var defaults = {
  loading: false,
  visible: false,
  type: 'object', // object array
  total: 0,
  fileType: 'xlsx',
  fileName: 'unnamed',
  fileHeader: null,
  fileData: [],
  request: null,
  requestParams: {},
  getResponseData: function getResponseData(data) {
    return data;
  },
  currentPage: 1,
  perPage: 50,
  retryTotal: 0,
  autoDownload: true,
  autoStart: true,
  backendRequestParams: {},
  /**
   * 开始 start
   * 停止 stop
   * 结束 end
   * 错误 error
   */
  status: ''
};

var ExportExcelConstructor = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.extend(__WEBPACK_IMPORTED_MODULE_2__main_vue__["a" /* default */]);

var currentMsg = void 0,
    instance = void 0;
var msgQueue = [];

var initInstance = function initInstance() {
  instance = new ExportExcelConstructor({
    el: document.createElement('div')
  });
};

var showNextMsg = function showNextMsg() {
  if (!instance) {
    initInstance();
  }
  instance.action = '';

  if (!instance.visible || instance.closeTimer) {
    if (msgQueue.length > 0) {
      currentMsg = msgQueue.shift();

      var options = currentMsg.options;
      for (var prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop];
        }
      }

      var oldCb = instance.callback;
      instance.callback = function (action, instance) {
        oldCb(action, instance);
        showNextMsg();
      };

      document.body.appendChild(instance.$el);

      if (instance.status === 'end') {
        instance.download();
      } else {
        __WEBPACK_IMPORTED_MODULE_1_vue___default.a.nextTick(function () {
          instance.visible = true;
        });
      }
    }
  }
};

var ExportExcelBox = function ExportExcelBox(options) {
  msgQueue.push({
    options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, defaults, options)
  });
  showNextMsg();
};

ExportExcelBox.export = function (fileName, fileData) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  // 直接传入数据导出
  if (Array.isArray(fileData)) {
    options.total = fileData.length;
    options.status = 'end';
  } else {
    // 传入第二参数为 options
    options = fileData;
    fileData = [];
  }

  return ExportExcelBox(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
    fileName: fileName,
    fileData: fileData
  }, options));
};

/* harmony default export */ __webpack_exports__["a"] = (ExportExcelBox);


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_600e5345_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__ = __webpack_require__(818);
function injectStyle (ssrContext) {
  __webpack_require__(812)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_600e5345_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */,
/* 814 */,
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);

/*
 * excel文件的导出
 * @Author anker.wang
 * @Date: 2018-01-08 11:16:50
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-13 17:43:58
 */




function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xFF;
  }return buf;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 转换对象列表转换为二维数组列表
   * [{}] => [[]]
   * @param {array} arrayObjects 数组对象
   * @param {array} keys 字段顺序列表，使转换后的值顺序保持一致
   * @returns {Array}
   * @constructor
   */
  ArrayObjectsToArrays: function ArrayObjectsToArrays(arrayObjects, keys) {
    var arrays = [];
    // 为数组且数组有内容
    if (arrayObjects && arrayObjects instanceof Array && arrayObjects.length) {
      // 获得标题行
      if (!(keys && keys.length)) {
        keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(arrayObjects[0]);
      }
      // 写入标题行
      arrays.push(keys);
      // 获得数据列
      arrayObjects.forEach(function (arrayObject) {
        var array = [];
        // 必须为对象
        if (arrayObject instanceof Object) {
          // 根据标题行顺序获取内容保障数组顺序
          keys.forEach(function (key) {
            array.push(arrayObject[key]);
          });
        }
        arrays.push(array);
      });
    }
    return arrays;
  },
  exportXlsx: function exportXlsx(arrays, options) {
    options.sheetName = options.sheetName || 'Sheet1';
    options.fileName = options.fileName || 'unnamed';
    options.fileType = options.fileType || 'xlsx';
    var wb = {
      SheetNames: [],
      Sheets: {}
    };

    var ws = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.utils.aoa_to_sheet(arrays);

    /* add worksheet to workbook */
    wb.SheetNames.push(options.sheetName);
    wb.Sheets[options.sheetName] = ws;

    /* bookType can be 'xlsx' or 'xlsm' or 'xlsb' or 'ods' */
    var wopts = { bookType: options.fileType, bookSST: false, type: 'binary' };
    var wbout = __WEBPACK_IMPORTED_MODULE_1_xlsx___default.a.write(wb, wopts);

    /* the saveAs call downloads a file on the local machine */
    __WEBPACK_IMPORTED_MODULE_2_file_saver___default.a.saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), options.fileName + '.' + options.fileType);
  }
});

/***/ }),
/* 816 */,
/* 817 */,
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"导出EXCEL文件","custom-class":"layout-progress-dialog","visible":_vm.visible,"close-on-click-modal":false,"close-on-press-escape":false,"before-close":_vm.close,"width":"380px"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('p',{staticClass:"layout-progress-name"},[_vm._v(_vm._s(_vm.lastFileName)+"."+_vm._s(_vm.fileType))]),_vm._v(" "),_c('el-progress',{attrs:{"text-inside":true,"stroke-width":18,"percentage":_vm.percentage,"status":_vm.progressStatus}})],1),_vm._v(" "),_c('span',{attrs:{"slot":"footer"},slot:"footer"},[(_vm.loading)?_c('span',{staticClass:"layout-progress-alert"},[_vm._v("正在查找数据中……")]):_c('span',{staticClass:"layout-progress-alert"},[_vm._v(_vm._s(_vm.progressMessage))]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'end' || _vm.status === 'stop'),expression:"status === 'end' || status === 'stop'"}],attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.download()}}},[_vm._v("下 载")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === ''),expression:"status === ''"},{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.start()}}},[_vm._v("开 始")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'start'),expression:"status === 'start'"}],attrs:{"type":"warning","size":"small"},on:{"click":function($event){return _vm.stop()}}},[_vm._v("暂 停")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'stop'),expression:"status === 'stop'"}],attrs:{"type":"success","size":"small"},on:{"click":function($event){return _vm.start()}}},[_vm._v("继 续")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'error' && _vm.retryTotal),expression:"status === 'error' && retryTotal"}],attrs:{"type":"warning","size":"small"},on:{"click":function($event){return _vm.jump()}}},[_vm._v("跳 过")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'error' && !_vm.retryTotal),expression:"status === 'error' && !retryTotal"}],attrs:{"type":"danger","size":"small"},on:{"click":function($event){return _vm.retry()}}},[_vm._v("重 试")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"width-max",attrs:{"filterable":"","remote":"","multiple":_vm.multiple,"collapse-tags":_vm.collapseTags,"multiple-limit":_vm.multipleLimit,"disabled":_vm.disabled,"clearable":_vm.clearable,"placeholder":_vm.placeholder,"remote-method":_vm.remoteMethod,"loading":_vm.loading,"autocomplete":_vm.currentAutocomplete},on:{"focus":_vm.focus,"visible-change":_vm.visibleChange,"change":_vm.change},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item[_vm.valueKey],attrs:{"label":_vm.getLabel(item),"value":item[_vm.valueKey]}},[_vm._t("default",[_c('span',[_vm._v(_vm._s(item[_vm.labelKey]))]),_vm._v(" "),_c('span',{staticClass:"info"},[_vm._v("/"+_vm._s(item[_vm.idKey]))])],{"item":item})],2)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-gutter"},[_c('div',{staticClass:"button-gutter-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_router_interceptors__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_router_common_route__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_router_routes__ = __webpack_require__(839);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["default"]({
  // history 模式，需要服务器后端配合做路由代理，将所有的前端路由同步代理到 /
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },

  routes: Object(__WEBPACK_IMPORTED_MODULE_4__core_router_routes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__core_router_common_route__["a" /* default */])
});

router.beforeEach(__WEBPACK_IMPORTED_MODULE_2__core_router_interceptors__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(42))(70);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(77);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  // 切换路由取消上一个页面的请求
  request.cancelAll('switch to a new route ' + to.path);
  request.createCancelToken();

  var logined = Object(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* isLoggedIn */])();
  // 是否需要认证
  if (to.meta.auth !== false) {
    // 未登录
    if (!logined) {
      // 进入登录页
      return next(filter.loginPath(to.fullPath));
    }
  } else {
    // 已登录的自动跳转，已登录并在登录页面
    if (logined && to.path === '/login') {
      return next('/');
    }
  }
  return next();
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_pages_exception_NotFound__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_pages_Skeleton__ = __webpack_require__(835);



var routes = [{
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_0__core_pages_exception_NotFound__["default"],
  name: '404',
  meta: {
    auth: false
  }
}, {
  path: '/skeleton',
  component: __WEBPACK_IMPORTED_MODULE_1__core_pages_Skeleton__["a" /* default */],
  name: '首次加载等待页'
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exception-body"},[_c('div',{staticClass:"exception-code"},[_c('strong',[_vm._v(_vm._s(_vm.code))])]),_vm._v(" "),_c('div',{staticClass:"exception-message"},[_c('h3',[_vm._v(_vm._s(_vm.meaasge)+"\n      "),(_vm.form && _vm.form.path && _vm.form.path !== '/')?_c('div',[_c('router-link',{staticStyle:{"text-decoration":"none","color":"#DCDFE6","line-height":"22px","font-size":"12px","font-weight":"normal"},attrs:{"to":_vm.form.fullPath}},[_vm._v(_vm._s(_vm.form.name)+" "+_vm._s(_vm.form.path)+"\n        ")])],1):_vm._e()])]),_vm._v(" "),_c('div',[_c('el-button-group',[_c('el-button',{attrs:{"type":"primary","round":"","size":"medium"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v("首页\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","round":"","size":"medium"},on:{"click":function($event){return _vm.$router.go(-2)}}},[_vm._v("返回上一页\n      ")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('exception',{attrs:{"code":"404","meaasge":"哎呀...找不到页面了！","form":_vm.from}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skeleton_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0399f1ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skeleton_vue__ = __webpack_require__(838);
function injectStyle (ssrContext) {
  __webpack_require__(836)
  __webpack_require__(837)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Skeleton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0399f1ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Skeleton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader-bg"}),_vm._v(" "),_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-inner pacman"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// 载入 views 目录下所有路由文件模块
var modules = __webpack_require__(96).requires(__webpack_require__(840));

var routes = function routes() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  for (var key in modules) {
    Array.prototype.push.apply(routes, modules[key]);
  }
  return routes;
};

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./admin-inbox-message/admin-inbox-message.route.js": 841,
	"./app-banner/app-banner.route.js": 855,
	"./app-popup/app-popup.route.js": 856,
	"./audio-asr-check/audio-asr-check.route.js": 857,
	"./audit-intern/audit-intern.route.js": 863,
	"./audit-task-setting/audit-task-setting.route.js": 864,
	"./audit-task/audit-task.route.js": 865,
	"./banquet-task/banquet-task.route.js": 866,
	"./batch-jobs/batch-jobs.route.js": 867,
	"./big-data-view/big-data-view.route.js": 868,
	"./city-map/city-map.route.js": 869,
	"./clb-alipay-flow/clb-alipay-flow.route.js": 870,
	"./clb-product-area/clb-product-area.route.js": 871,
	"./clb-product-category/clb-product-category.route.js": 872,
	"./clb-product/clb-product.route.js": 873,
	"./clb-step-template/clb-step-template.route.js": 874,
	"./clb-task-template/clb-task-template.route.js": 878,
	"./company-bank-account/company-bank-account.route.js": 879,
	"./cover-estimate/cover-estimate.route.js": 880,
	"./customer-batch/customer-batch.route.js": 881,
	"./customer-project-report/customer-project-report.route.js": 882,
	"./customer-project/customer-project.route.js": 883,
	"./customer-projectcost/customer-projectcost.route.js": 884,
	"./customer-receipt/customer-receipt.route.js": 885,
	"./customer-task/customer-task.route.js": 886,
	"./customer/customer.route.js": 887,
	"./exception/exception.route.js": 888,
	"./executive-budget/executive-budget.route.js": 889,
	"./fair-prize/fairPrize.route.js": 890,
	"./fair-reward/fairReward.route.js": 891,
	"./fair-stock/fairStock.route.js": 892,
	"./fair-upload/fairUpload.route.js": 893,
	"./fair/fair.route.js": 894,
	"./finance-config/finance-config.route.js": 895,
	"./finance/finance.route.js": 896,
	"./flbanner/flbanner.route.js": 897,
	"./group-batch/group-batch.route.js": 898,
	"./home/home.route.js": 899,
	"./hr/hr.route.js": 900,
	"./img-flow-config/img-flow-config.route.js": 901,
	"./img-flow-model/img-flow-model.route.js": 902,
	"./img-flow-order/img-flow-order.route.js": 903,
	"./img-flow-product/img-flow-product.route.js": 904,
	"./intelligent-customer-service/intelligent-customer-service.route.js": 905,
	"./intelligent-outbound-call/intelligent-outbound-call.route.js": 906,
	"./invoice-apply/invoice-apply.route.js": 907,
	"./launch-page-activity/launch-page-activity.route.js": 908,
	"./login/login.route.js": 909,
	"./map-comment-feedback/map-comment-feedback.route.js": 910,
	"./market-ng/market-ng.route.js": 911,
	"./market/market.route.js": 912,
	"./midan/midan.route.js": 913,
	"./middle-end-task/middle-end-task.route.js": 914,
	"./occupation-questionnaire/occupation-questionnaire.route.js": 915,
	"./occupation/occupation.route.js": 916,
	"./order-image-recapture-detection/order-image-recapture-detection.route.js": 917,
	"./order-review-target-management/order-review-assessment.route.js": 918,
	"./order-review/order-review.route.js": 919,
	"./order/order.route.js": 920,
	"./pay-conditions/pay-conditions.route.js": 921,
	"./payment-approval-new/payment-approval.route.js": 922,
	"./payment-approval/payment-approval.route.js": 923,
	"./payment-center/payment-center.route.js": 924,
	"./payment-manager-new/payment-manager.route.js": 925,
	"./payment-manager/payment-manager.route.js": 926,
	"./payment-refund/payment-refund.route.js": 927,
	"./permission-apply/permission-apply.route.js": 928,
	"./permission-group/permission-group.route.js": 929,
	"./platform-androidapk-test/platform-androidapk-test.route.js": 930,
	"./platform-department/platform-department.route.js": 931,
	"./platform-role/platform-role.route.js": 932,
	"./platform-upload/platform-upload.route.js": 933,
	"./platform-user-province/platform-user-province.route.js": 934,
	"./platform-user-whitelist/platform-user-whitelist.route.js": 935,
	"./platform-user/platform-user.route.js": 936,
	"./platform/platform.route.js": 937,
	"./point/point.route.js": 938,
	"./position/position.route.js": 939,
	"./price-batch/price-batch.route.js": 946,
	"./project-task-package/project-task-package.route.js": 947,
	"./project/project.route.js": 948,
	"./received-payment/received-payment.route.js": 949,
	"./resume/resume.route.js": 950,
	"./satisfaction-email/satisfaction-email.route.js": 951,
	"./settings/settings.route.js": 952,
	"./statistic/statistic.route.js": 953,
	"./step-template/step-template.route.js": 954,
	"./store-collection/store-collection.route.js": 955,
	"./task-notice/task-notice.route.js": 956,
	"./task-order/task-order.route.js": 957,
	"./task-package-home/task-package-home.route.js": 958,
	"./task/task.route.js": 959,
	"./teke-customer/tekeCustomer.route.js": 960,
	"./teke-order/tekeOrder.route.js": 961,
	"./teke-tag/tekeTag.route.js": 962,
	"./todo/todo.route.js": 963,
	"./training/training.route.js": 964,
	"./user-bank-account/user-bank-account.route.js": 974,
	"./user-batch-tag/user-batch-tag.route.js": 975,
	"./user-cover/user-cover.route.js": 976,
	"./user-credit/user-credit.route.js": 977,
	"./user-order-stat/userOrderStat.route.js": 978,
	"./user-tag/userTag.route.js": 979,
	"./user-workinfo/user-workinfo.route.js": 980,
	"./users/users.route.js": 981,
	"./violation-alert/violation-alert.route.js": 982,
	"./work-info-business-type/work-info-business-type.route.js": 983,
	"./work-info-company/work-info-company.route.js": 984,
	"./work-info-work-type/work-info-work-type.route.js": 985,
	"./workbench/workbench.route.js": 986
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "adminInboxMessage", function() { return adminInboxMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var adminInboxMessage = [{
  path: '/admin-inbox-message',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(356).then(__webpack_require__.bind(null, 996));
    },
    meta: {
      title: '消息通知'
    }
  }]
}];

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutHeader_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f8c2cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutHeader_vue__ = __webpack_require__(847);
function injectStyle (ssrContext) {
  __webpack_require__(845)
  __webpack_require__(846)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29f8c2cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f8c2cc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('div',{staticClass:"header"},[_c('div',{staticClass:"content clear-both"},[_c('div',{staticClass:"pull-left"},[_c('el-button',{staticClass:"collapse-btn",attrs:{"type":"text","icon":"sj-icon-category"},on:{"click":function($event){return _vm.COLLAPSE_MENU(!_vm.collapse)}}})],1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('el-dropdown',{attrs:{"trigger":"click"},on:{"command":_vm.handleCommand}},[_c('div',{staticClass:"el-dropdown-link"},[_c('i',{staticClass:"sj-icon-user-avatar",staticStyle:{"font-size":"22px","margin-right":"5px"}}),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"3px"}},[_c('span',[_vm._v(_vm._s(_vm.user.name))]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})])]),_vm._v(" "),_c('el-dropdown-menu',{staticClass:"dropdown-menu",attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',{staticClass:"dropdown-menu__switch-item"},[_c('div',{staticClass:"dropdown-switch-item",on:{"click":function($event){$event.stopPropagation();return _vm.toggleAutoCollapseMenu($event)}}},[_c('span',[_vm._v("自动收起菜单")]),_vm._v(" "),_c('el-switch',{attrs:{"value":_vm.autoCollapseMenu},on:{"change":_vm.SET_AUTO_COLLAPSE_MENU},nativeOn:{"click":function($event){$event.stopPropagation();}}})],1)]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"changePassword"}},[_c('span',{staticClass:"sj-icon-change-passwd"},[_vm._v(" 修改密码")])]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"logout"}},[_c('span',{staticClass:"sj-icon-logout"},[_vm._v(" 退出登录")])])],1)],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutMenu_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbb4b26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutMenu_vue__ = __webpack_require__(851);
function injectStyle (ssrContext) {
  __webpack_require__(849)
  __webpack_require__(850)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fbb4b26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayoutMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbb4b26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayoutMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-menu',{attrs:{"default-active":_vm.activeMenu,"collapse":_vm.collapse,"background-color":"#424f63","text-color":"#FFFFFF","active-text-color":"#409EFF","router":true,"unique-opened":true},on:{"select":_vm.onMenuSelect}},[_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([5,26,118,215,262,263,264,267,269,20001,20002,20003,20004,20006]),expression:"[5,26,118,215,262,263,264,267,269,20001,20002,20003,20004,20006]"}],attrs:{"index":"/users"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('i',{staticClass:"sj-icon-user-manager"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("用户管理")])]},proxy:true}])},[_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(5),expression:"5"}],attrs:{"index":"/users/table"}},[_vm._v("用户列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(264),expression:"264"}],attrs:{"index":"/users/communicate-table"}},[_vm._v("用户沟通记录\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/users/user-account-table"}},[_vm._v("用户账户查询\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/users/points-table"}},[_vm._v("零豆管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(262),expression:"262"}],attrs:{"index":"/users/occupation"}},[_vm._v("自选职业\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(263),expression:"263"}],attrs:{"index":"/user-workinfo/table"}},[_vm._v("用户职业信息审核\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(26),expression:"26"}],attrs:{"index":"/users/mas"}},[_vm._v("群发消息\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(118),expression:"118"}],attrs:{"index":"/usertag/table"}},[_vm._v("标签管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(5),expression:"5"}],attrs:{"index":"/user-cover/table"}},[_vm._v("覆盖查询\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(215),expression:"215"}],attrs:{"index":"/users/batch/table"}},[_vm._v("批量用户\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/executive-budget/approve/table"}},[_vm._v("执行审批\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(267),expression:"267"}],attrs:{"index":"/user-order-stat/table"}},[_vm._v("条件搜索添加标签\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(269),expression:"269"}],attrs:{"index":"/users/deleted-table"}},[_vm._v("注销用户列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(20001),expression:"20001"}],attrs:{"index":"/users/newbie-config"}},[_vm._v("新用户定义配置\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(20002),expression:"20002"}],attrs:{"index":"/users/newbie-mission-config"}},[_vm._v("新手任务配置\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(20003),expression:"20003"}],attrs:{"index":"/users/devices"}},[_vm._v(" 用户设备列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(20004),expression:"20004"}],attrs:{"index":"/users/riskusers"}},[_vm._v(" 风险用户统计\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(20006),expression:"20006"}],attrs:{"index":"/violation-alert/table"}},[_vm._v("违规预警\n      ")])],1),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:(23),expression:"23"}],attrs:{"index":"/stores"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-market"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("门店管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(15),expression:"15"}],attrs:{"index":"/market/table"}},[_vm._v("门店列表")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(15),expression:"15"}],attrs:{"index":"/store-collection/table"}},[_vm._v("门店信息收集\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(15),expression:"15"}],attrs:{"index":"/market-ng/table"}},[_vm._v("异常门店\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(48),expression:"48"}],attrs:{"index":"/market/upload/table"}},[_vm._v("门店上传\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/city-map/table"}},[_vm._v("区域管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(48),expression:"48"}],attrs:{"index":"/map-comment-feedback/table"}},[_vm._v("地图评价反馈\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(10001),expression:"10001"}],attrs:{"index":"/market/cs-location-log"}},[_vm._v("客服修改经纬度日志\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/cover-estimate/table"}},[_vm._v("覆盖预估\n      ")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([283,284,285,286]),expression:"[283,284,285,286]"}],attrs:{"index":"/work-info"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-suitcase"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("职业信息管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(283),expression:"283"}],attrs:{"index":"/work-info-company/table"}},[_vm._v("职业信息公司\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(284),expression:"284"}],attrs:{"index":"/work-info-business-type/table"}},[_vm._v("职业信息行业\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(285),expression:"285"}],attrs:{"index":"/work-info-work-type/table"}},[_vm._v("职业信息工种\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(286),expression:"286"}],attrs:{"index":"/work-info-business-type/batch-jobs"}},[_vm._v("批量任务\n      ")])],2),_vm._v(" "),(_vm.canViewTaskMenu)?_c('el-submenu',{attrs:{"index":"/task"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-task-manager"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("任务管理")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/task/table"}},[_vm._v("任务管理")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/task/archived/table"}},[_vm._v("任务管理(归档)")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/order/table"}},[_vm._v("工单管理")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/order/archived/table"}},[_vm._v("工单管理(归档)")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/task-order/table"}},[_vm._v("任务工单管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(289),expression:"289"}],attrs:{"index":"/order/appeal/table"}},[_vm._v("工单申诉管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(90),expression:"90"}],attrs:{"index":"/step-template/table"}},[_vm._v("分步模板")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(83),expression:"83"}],attrs:{"index":"/price-batch"}},[_vm._v("调价批次\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(238),expression:"238"}],attrs:{"index":"/task/batch/table"}},[_vm._v("批量任务")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(239),expression:"239"}],attrs:{"index":"/middle-end-task/audit/table"}},[_vm._v("任务审批")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(237),expression:"237"}],attrs:{"index":"/task-notice"}},[_vm._v("任务提示")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(245),expression:"245"}],attrs:{"index":"/group-batch/customer-table"}},[_vm._v("群组控制")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(249),expression:"249"}],attrs:{"index":"/midan/table"}},[_vm._v("米单配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(282),expression:"282"}],attrs:{"index":"/task/map"}},[_vm._v("任务地图看板")])],2):_vm._e(),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:(36001),expression:"36001"}],attrs:{"index":"/banquet-task"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-s-order"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("新宴席管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(36001),expression:"36001"}],attrs:{"index":"/banquet-task/records"}},[_vm._v("宴席任务")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(36001),expression:"36001"}],attrs:{"index":"/banquet-task/batch"}},[_vm._v("宴席批量导入")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([30,224,261,266,13001]),expression:"[30,224,261,266,13001]"}],attrs:{"index":"/platform"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-s-platform"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("平台管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(29),expression:"29"}],attrs:{"index":"/app-banner/table"}},[_vm._v("App Banner管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(253),expression:"253"}],attrs:{"index":"/app-popup/table"}},[_vm._v("\n        App浮窗管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(0),expression:"0"}],attrs:{"index":"/platform-user"}},[_vm._v("平台用户管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(-100),expression:"-100"}],attrs:{"index":"/settings/set-project-config"}},[_vm._v("项目审核人管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(-100),expression:"-100"}],attrs:{"index":"/settings/set-receipt-apply-config"}},[_vm._v("开票抄送人管理\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/permission-apply/table"}},[_vm._v("权限申请\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(29),expression:"29"}],attrs:{"index":"/platform/tag_table"}},[_vm._v("热标签搜索\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(29),expression:"29"}],attrs:{"index":"/platform/education_table"}},[_vm._v("教程管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(230),expression:"230"}],attrs:{"index":"/flbanner/table"}},[_vm._v("福利社管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(29),expression:"29"}],attrs:{"index":"/platform/home-module-table"}},[_vm._v("APP首页模块管理\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/platform/sign-feedback-table"}},[_vm._v("签到问题反馈\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/platform/order-comment-table"}},[_vm._v("评价管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(0),expression:"0"}],attrs:{"index":"/platform-upload/table"}},[_vm._v("平台上传管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(29),expression:"29"}],attrs:{"index":"/task-package-home"}},[_vm._v("首页任务包设置\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(13001),expression:"13001"}],attrs:{"index":"/project-task-package"}},[_vm._v("任务包及培训配置\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/platform-user-whitelist"}},[_vm._v("发布白名单用户\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/platform-androidapk-test"}},[_vm._v("安卓APK发布\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(252),expression:"252"}],attrs:{"index":"/batch-jobs/all-batch-jobs-table"}},[_vm._v("\n        所有批量任务列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(224),expression:"224"}],attrs:{"index":"/fair/table"}},[_vm._v("活动管理\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/launch-page-activity/table"}},[_vm._v("启动页活动\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(224),expression:"224"}],attrs:{"index":"/fair-upload/table"}},[_vm._v("活动上传管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(261),expression:"261"}],attrs:{"index":"/intelligent-outbound-call/table"}},[_vm._v("智能外呼\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(261),expression:"261"}],attrs:{"index":"/intelligent-outbound-call/upload"}},[_vm._v("外呼批量任务\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(266),expression:"266"}],attrs:{"index":"/intelligent-customer-service/update"}},[_vm._v("智能客服参数配置\n      ")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([18]),expression:"[18]"}],attrs:{"index":"/finance"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-finance-manager"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("财务管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/batch-withdraw-table"}},[_vm._v("批量提现列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/withdraw-bank-table"}},[_vm._v("银行卡提现管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/bank-withdraw-table"}},[_vm._v("银行卡提现批次管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/withdraw-alipay-table"}},[_vm._v("支付宝提现管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/alipay-withdraw-table"}},[_vm._v("支付宝提现批次管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/withdraw-wx-table"}},[_vm._v("微信提现管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/wx-withdraw-table"}},[_vm._v("微信提现批次管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/batch-withdraw-option-table"}},[_vm._v("批量提现操作列表\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/finance/inactive-user-table"}},[_vm._v("不活跃用户\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/invoice-apply/approve/table"}},[_vm._v("开票审批\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(18),expression:"18"}],attrs:{"index":"/finance/ajx/project/table"}},[_vm._v("爱绩效项目审核\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/received-approval"}},[_vm._v("回款管理\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/invoice-apply/received-payment/table/type/1"}},[_vm._v("回款管理(旧)\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(234),expression:"234"}],attrs:{"index":"/payment-approval/table"}},[_vm._v("付款审批\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(291),expression:"291"}],attrs:{"index":"/payment-approval-new/table"}},[_vm._v("付款审批(新)")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(292),expression:"292"}],attrs:{"index":"/payment-center/table"}},[_vm._v("支付中心(新)")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(234),expression:"234"}],attrs:{"index":"/payment-refund/finance/table"}},[_vm._v("付款退款")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/batch-jobs/finance-export-jobs"}},[_vm._v("财务数据导出任务")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 27001]),expression:"[271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 27001]"}],attrs:{"index":"/finance-config"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-caidanlan-caiwu-caiwushezhi"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("财务中心设置")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(271),expression:"271"}],attrs:{"index":"/finance-config/approval-value"}},[_vm._v("审批起始值\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(272),expression:"272"}],attrs:{"index":"/finance-config/subject-management"}},[_vm._v("付款科目管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(273),expression:"273"}],attrs:{"index":"/finance-config/company-account"}},[_vm._v("公司管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(277),expression:"277"}],attrs:{"index":"/finance-config/company-account-management/table"}},[_vm._v("账户管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(278),expression:"278"}],attrs:{"index":"/finance-config/invoice-name-management"}},[_vm._v("开票名称管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(274),expression:"274"}],attrs:{"index":"/finance-config/department-management"}},[_vm._v("部门管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(275),expression:"275"}],attrs:{"index":"/company-bank-account/table"}},[_vm._v("对公账户列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(276),expression:"276"}],attrs:{"index":"/user-bank-account/table"}},[_vm._v("员工账户列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(279),expression:"279"}],attrs:{"index":"/customer-receipt/table"}},[_vm._v("客户开票信息管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(280),expression:"280"}],attrs:{"index":"/pay-conditions/table"}},[_vm._v("账期管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(27001),expression:"27001"}],attrs:{"index":"/finance-config/finance-email-notify"}},[_vm._v("财务邮件设置\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(281),expression:"281"}],attrs:{"index":"/finance-config/tax-panel"}},[_vm._v("百旺自动开票配置管理\n      ")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([62,193,207,240,241,242,243,244,248,14001]),expression:"[62,193,207,240,241,242,243,244,248,14001]"}],attrs:{"index":"/customer"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-customer"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("客户管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(62),expression:"62"}],attrs:{"index":"/customer/table"}},[_vm._v("客户管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(62),expression:"62"}],attrs:{"index":"/customer/ajx/table"}},[_vm._v("爱绩效客户管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(207),expression:"207"}],attrs:{"index":"/customer-task/table"}},[_vm._v("客户任务管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(14001),expression:"14001"}],attrs:{"index":"/project/progress-table"}},[_vm._v("项目进度列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(193),expression:"193"}],attrs:{"index":"/customer-projectcost/table"}},[_vm._v("项目成本列表\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(62),expression:"62"}],attrs:{"index":"/satisfaction-email/table"}},[_vm._v("满意度邮件\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(240),expression:"240"}],attrs:{"index":"/invoice-apply/table"}},[_vm._v("开票管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(241),expression:"241"}],attrs:{"index":"/received-payment"}},[_vm._v("回款管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(242),expression:"242"}],attrs:{"index":"/invoice-apply/received-payment/table/type/10"}},[_vm._v("回款管理(旧)\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(248),expression:"248"}],attrs:{"index":"/customer/batch-table"}},[_vm._v("批量客户\n      ")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/executive-budget/table"}},[_vm._v("\n        执行预算分配\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(243),expression:"243"}],attrs:{"index":"/payment-manager/table"}},[_vm._v("付款管理\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(244),expression:"244"}],attrs:{"index":"/payment-refund/table"}},[_vm._v("付款退款")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(246),expression:"246"}],attrs:{"index":"/payment-manager-new/table"}},[_vm._v("付款管理(新)\n      ")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([2081]),expression:"[2081]"}],attrs:{"index":"/todo"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("待办事项")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/todo/project/table"}},[_vm._v("项目审核\n      ")])],2),_vm._v(" "),(_vm.canViewStatisticMenu)?_c('el-submenu',{attrs:{"index":"/statistic"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-statistic"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("统计管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(25),expression:"25"}],attrs:{"index":"/statistic/city-group-config"}},[_vm._v("城市分组配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(25),expression:"25"}],attrs:{"index":"/statistic/promoter"}},[_vm._v("推广人员配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(25),expression:"25"}],attrs:{"index":"/statistic/screen-project"}},[_vm._v("大屏项目配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(25),expression:"25"}],attrs:{"index":"/statistic/screen-project/audit-screen-config"}},[_vm._v("审单大屏配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(25),expression:"25"}],attrs:{"index":"/statistic/screen-project/batch-jobs"}},[_vm._v("批量任务")]),_vm._v(" "),(!_vm.isIntern)?_c('el-menu-item',{attrs:{"index":"/big-data"}},[_vm._v("推广项目进度\n      ")]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([40001,40008,40009,40013]),expression:"[40001,40008,40009,40013]"}],attrs:{"index":"/audit-intern"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-user-manager"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("实习生管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(40001),expression:"40001"}],attrs:{"index":"/audit-intern/table"}},[_vm._v("实习生列表")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(40008),expression:"40008"}],attrs:{"index":"/audit-intern/cronjob"}},[_vm._v("实习生批量任务")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(40009),expression:"40009"}],attrs:{"index":"/audit-intern/monthly-onduty-table"}},[_vm._v("实习生月度出勤")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(40014),expression:"40014"}],attrs:{"index":"/audit-intern/attendance-plan-monthly"}},[_vm._v("考勤计划月度列表")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(40013),expression:"40013"}],attrs:{"index":"/audit-intern/performance"}},[_vm._v("审单绩效统计")])],2),_vm._v(" "),(_vm.isIntern)?_c('el-submenu',{attrs:{"index":"/workbench","title":"工作管理"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-s-home"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("工作管理")])]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/workbench"}},[_vm._v("工作台")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/customer/customer-order-review/table"}},[_vm._v("客户审单管理")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/audit-task/table"}},[_vm._v("我的审单")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/training/self-examination"}},[_vm._v("我的问卷")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/workbench/attendance-plan"}},[_vm._v("出勤设置")]),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"/admin-inbox-message/table"}},[_c('span',{staticClass:"inbox-menu-label"},[_vm._v("\n          消息通知\n          "),(_vm.unreadInboxCount > 0)?_c('el-badge',{staticClass:"inbox-menu-badge",attrs:{"value":_vm.unreadInboxCount,"max":99}}):_vm._e()],1)])],2):_vm._e(),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([85,86,87,88]),expression:"[85,86,87,88]"}],attrs:{"index":"/audit-task-setting","title":"审单管理"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-task-manager"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("审单管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(85),expression:"85"}],attrs:{"index":"/audit-task-setting/table"}},[_vm._v("审单系统配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(86),expression:"86"}],attrs:{"index":"/order/assigned-review-table"}},[_vm._v("待分配复核列表")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(87),expression:"87"}],attrs:{"index":("/task/review-task-table?adminid=" + (_vm.user.id))}},[_vm._v("复核任务列表")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(88),expression:"88"}],attrs:{"index":"/task/review-plan/table"}},[_vm._v("复核目标配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(87),expression:"87"}],attrs:{"index":"/audit-task-setting/return-order-evaluation/table"}},[_vm._v("退单评价列表")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([41,42,43]),expression:"[41,42,43]"}],attrs:{"index":"/order-review-assessment","title":"审单考核管理"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-tickets"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("审单考核管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(43),expression:"43"}],attrs:{"index":"/audit-intern/attendance-project-target/table"}},[_vm._v("项目出勤配置\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(41),expression:"41"}],attrs:{"index":"/order-review-assessment/target-setting"}},[_vm._v("审单目标配置\n      ")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(42),expression:"42"}],attrs:{"index":"/order-review-assessment/keyin-exception-feedback"}},[_vm._v("KeyIn异常工单反馈\n      ")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:(290),expression:"290"}],attrs:{"index":"/hr"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"sj-icon-activity"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("人事管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(290),expression:"290"}],attrs:{"index":"/hr/employee"}},[_vm._v("员工管理")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([34001,34002,34003,34004,34005]),expression:"[34001,34002,34003,34004,34005]"}],attrs:{"index":"/training"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-notebook-2"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("考试培训管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34001),expression:"34001"}],attrs:{"index":"/training/instruction"}},[_vm._v("培训管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34002),expression:"34002"}],attrs:{"index":"/training/user-course"}},[_vm._v("零工教程管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34006),expression:"34006"}],attrs:{"index":"/training/intern-course"}},[_vm._v("实习生教程管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34003),expression:"34003"}],attrs:{"index":"/training/examination"}},[_vm._v("零工考试管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34007),expression:"34007"}],attrs:{"index":"/training/intern-examination"}},[_vm._v("实习生考试管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34004),expression:"34004"}],attrs:{"index":"/training/question"}},[_vm._v("题目管理")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(34005),expression:"34005"}],attrs:{"index":"/training/knowledge"}},[_vm._v("知识库管理")])],2),_vm._v(" "),_c('el-submenu',{directives:[{name:"permission",rawName:"v-permission",value:([35001,35002,35003]),expression:"[35001,35002,35003]"}],attrs:{"index":"/audio-asr-check"}},[_c('template',{slot:"title"},[_c('i',{staticClass:"el-icon-microphone"}),_vm._v(" "),_c('span',{staticClass:"menu-text"},[_vm._v("录音风险管理")])]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(35002),expression:"35002"}],attrs:{"index":"/audio-asr-check/template"}},[_vm._v("录音风险配置")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(35003),expression:"35003"}],attrs:{"index":"/audio-asr-check/result"}},[_vm._v("录音风险列表")]),_vm._v(" "),_c('el-menu-item',{directives:[{name:"permission",rawName:"v-permission",value:(35001),expression:"35001"}],attrs:{"index":"/audio-asr-check/stats"}},[_vm._v("项目统计")])],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{style:({ height: _vm.clientHeight + 'px'})},[_c('div',{attrs:{"id":"left-container"}},[_c('el-container',[_c('router-link',{attrs:{"to":"/"}},[_c('div',{class:[_vm.collapse ? 'collapse' : 'not-collapse'],attrs:{"id":"logo"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapse),expression:"!collapse"}],attrs:{"src":__webpack_require__(853)}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.collapse),expression:"collapse"}],attrs:{"src":__webpack_require__(854)}})])])],1),_vm._v(" "),_c('el-aside',{class:[_vm.collapse ? 'collapse' : 'not-collapse'],style:({ height: (_vm.clientHeight - 50) + 'px' }),attrs:{"id":"menu"}},[_c('layout-menu')],1)],1),_vm._v(" "),_c('div',{attrs:{"id":"right-container"}},[_c('el-container',{attrs:{"id":"header"}},[_c('layout-header')],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!!~~_vm.loading),expression:"!!~~loading"}],attrs:{"id":"main-container"}},[_c('el-main',{style:({ height: _vm.$root.mainHeight + 'px'}),attrs:{"id":"main"}},[_c('router-view')],1)],1),_vm._v(" "),_c('el-footer',{attrs:{"id":"footer","height":"20"}},[_c('span',[_vm._v("© 2023 擞因科技, Inc. · Privacy · Terms · ")]),_vm._v(" "),_c('span',[_vm._v("Versions "+_vm._s(_vm.VUE_APP_VERSION))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appBanner", function() { return appBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var appBanner = [{
  path: '/app-banner',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 997));
    },
    meta: {
      title: 'banner列表'
    }
  }, {
    path: 'logs/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 998));
    },
    meta: {
      title: 'banner操作日志列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 274));
    },
    meta: {
      title: '添加banner'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 274));
    },
    meta: {
      title: '修改banner'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(272).then(__webpack_require__.bind(null, 999));
    },
    meta: {
      title: 'banner详情'
    }
  }]
}];

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appPopup", function() { return appPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var appPopup = [{
  path: '/app-popup',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(206).then(__webpack_require__.bind(null, 1000));
    },
    meta: {
      title: 'APP浮窗管理列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(31/* duplicate */).then(__webpack_require__.bind(null, 159));
    },
    meta: {
      title: '添加APP浮窗管理'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(31/* duplicate */).then(__webpack_require__.bind(null, 159));
    },
    meta: {
      title: '修改APP浮窗'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(31/* duplicate */).then(__webpack_require__.bind(null, 159));
    },
    meta: {
      title: 'APP浮窗配置详情'
    }
  }]
}];

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "audioAsrCheckRoute", function() { return audioAsrCheckRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var audioAsrCheckRoute = [{
  path: '/audio-asr-check',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'template'
  }, {
    path: 'template',
    component: function component() {
      return __webpack_require__.e/* import() */(186).then(__webpack_require__.bind(null, 1001));
    },
    meta: {
      title: '录音风险配置'
    }
  }, {
    path: 'template/create',
    component: function component() {
      return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 275));
    },
    meta: {
      title: '新建录音风险配置',
      activeMenu: '/audio-asr-check/template'
    }
  }, {
    path: 'template/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 275));
    },
    meta: {
      title: '编辑录音风险配置',
      activeMenu: '/audio-asr-check/template'
    }
  }, {
    path: 'result',
    component: function component() {
      return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1002));
    },
    meta: {
      title: '录音风险列表'
    }
  }, {
    path: 'stats',
    component: function component() {
      return __webpack_require__.e/* import() */(271).then(__webpack_require__.bind(null, 1003));
    },
    meta: {
      title: '录音风险项目统计'
    }
  }]
}];

/***/ }),
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditIntern", function() { return auditIntern; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var auditIntern = [{
  path: '/audit-intern',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(215).then(__webpack_require__.bind(null, 1004));
    },
    meta: {
      title: '实习生账号列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(170).then(__webpack_require__.bind(null, 1005));
    },
    meta: {
      title: '新增实习生账号',
      pageType: 'create'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 1006));
    },
    meta: {
      title: '修改实习生账号',
      pageType: 'update'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, 1007));
    },
    meta: {
      title: '实习生账号详情'
    }
  }, {
    path: 'cronjob',
    component: function component() {
      return __webpack_require__.e/* import() */(283).then(__webpack_require__.bind(null, 1008));
    },
    meta: {
      title: '实习生批量任务'
    }
  }, {
    path: 'monthly-onduty-table',
    component: function component() {
      return __webpack_require__.e/* import() */(231).then(__webpack_require__.bind(null, 1009));
    },
    meta: {
      title: '实习生月度出勤统计'
    }
  }, {
    path: 'attendance-plan-monthly',
    component: function component() {
      return __webpack_require__.e/* import() */(380).then(__webpack_require__.bind(null, 1010));
    },
    meta: {
      title: '考勤计划月度列表'
    }
  }, {
    path: 'attendance-plan-detail/:internUserId/:planMonth',
    component: function component() {
      return __webpack_require__.e/* import() */(381).then(__webpack_require__.bind(null, 1011));
    },
    meta: {
      title: '考勤计划明细'
    }
  }, {
    path: 'daily-onduty-table',
    component: function component() {
      return __webpack_require__.e/* import() */(232).then(__webpack_require__.bind(null, 1012));
    },
    meta: {
      title: '实习生出勤明细'
    }
  }, {
    path: 'attendance-project-target/table',
    component: function component() {
      return __webpack_require__.e/* import() */(141).then(__webpack_require__.bind(null, 1013));
    },
    meta: {
      title: '项目出勤设置'
    }
  }, {
    path: 'attendance-notify-cfg-table',
    component: function component() {
      return __webpack_require__.e/* import() */(252).then(__webpack_require__.bind(null, 1014));
    },
    meta: {
      title: '出勤日历提醒通知列表'
    }
  }, {
    path: 'attendance-notify-cfg/create',
    component: function component() {
      return __webpack_require__.e/* import() */(384).then(__webpack_require__.bind(null, 266));
    },
    meta: {
      title: '新增出勤日历提醒通知'
    }
  }, {
    path: 'attendance-notify-cfg/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 266));
    },
    meta: {
      title: '修改出勤日历提醒通知'
    }
  }, {
    path: 'attendance-notify-history/:refId/table',
    component: function component() {
      return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 1015));
    },
    meta: {
      title: '出勤日历提醒通知发送记录'
    }
  }, {
    path: 'performance',
    component: function component() {
      return __webpack_require__.e/* import() */(275).then(__webpack_require__.bind(null, 1016));
    },
    meta: {
      title: '审单绩效统计'
    }
  }]
}];

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditTaskSetting", function() { return auditTaskSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var auditTaskSetting = [{
  path: '/audit-task-setting',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(313).then(__webpack_require__.bind(null, 1017));
    },
    meta: {
      title: '审单系统配置'
    }
  }, {
    path: 'log/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(355).then(__webpack_require__.bind(null, 1018));
    },
    meta: {
      title: '审单系统配置日志'
    }
  }, {
    path: 'form',
    component: function component() {
      return __webpack_require__.e/* import() */(59/* duplicate */).then(__webpack_require__.bind(null, 276));
    },
    meta: {
      title: '新增审单系统配置'
    }
  }, {
    path: 'form/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(59/* duplicate */).then(__webpack_require__.bind(null, 276));
    },
    meta: {
      title: '修改审单系统配置'
    }
  }, {
    path: 'project-order-review/table',
    component: function component() {
      return __webpack_require__.e/* import() */(312).then(__webpack_require__.bind(null, 1019));
    },
    meta: {
      title: '项目审单统计'
    }
  }, {
    path: 'return-order-evaluation/table',
    component: function component() {
      return __webpack_require__.e/* import() */(311).then(__webpack_require__.bind(null, 1020));
    },
    meta: {
      title: '退单评价列表'
    }
  }]
}];

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "auditTask", function() { return auditTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var auditTask = [{
  path: '/audit-task',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(235).then(__webpack_require__.bind(null, 1021));
    },
    name: '审单管理',
    meta: {
      title: '审单管理'
    }
  }]
}];

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "banquetTask", function() { return banquetTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var banquetTask = [{
  path: '/banquet-task',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'records'
  }, {
    path: 'records',
    component: function component() {
      return __webpack_require__.e/* import() */(310).then(__webpack_require__.bind(null, 1022));
    },
    name: '宴席任务',
    meta: {
      title: '宴席任务',
      activeMenu: '/banquet-task/records'
    }
  }, {
    path: 'records/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(354).then(__webpack_require__.bind(null, 1023));
    },
    name: '宴席任务详情',
    meta: {
      title: '宴席任务详情',
      activeMenu: '/banquet-task/records'
    }
  }, {
    path: 'batch',
    component: function component() {
      return __webpack_require__.e/* import() */(174).then(__webpack_require__.bind(null, 1024));
    },
    name: '宴席批量导入',
    meta: {
      title: '宴席批量导入',
      activeMenu: '/banquet-task/batch'
    }
  }]
}];

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "batchJobsRouter", function() { return batchJobsRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var batchJobsRouter = [{
  path: '/batch-jobs',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'all-batch-jobs-table'
  }, {
    path: 'all-batch-jobs-table',
    component: function component() {
      return __webpack_require__.e/* import() */(173).then(__webpack_require__.bind(null, 1025));
    },
    name: '所有批量任务列表',
    meta: {
      title: '所有批量任务列表'
    }
  }, {
    path: 'finance-export-jobs',
    component: function component() {
      return __webpack_require__.e/* import() */(172).then(__webpack_require__.bind(null, 1026));
    },
    name: '财务数据导出任务',
    meta: {
      title: '财务数据导出任务'
    }
  }]
}];

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BigData", function() { return BigData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);

var BigData = [{
  path: '/big-data',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{ path: '', component: function component() {
      return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1027));
    }, name: '首页' }]
}];

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cityMap", function() { return cityMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var cityMap = [{
  path: '/city-map',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1028));
    },
    name: '区域管理',
    meta: {
      title: '区域管理'
    }
  }]
}];

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbAlipayFlow", function() { return clbAlipayFlow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var clbAlipayFlow = [{
  path: '/clb-alipay-flow',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(205).then(__webpack_require__.bind(null, 1029));
    },
    meta: {
      title: '查理宝支付宝流水列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 277));
    },
    meta: {
      title: '添加查理宝支付宝流水'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 277));
    },
    meta: {
      title: '修改查理宝支付宝流水'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(270).then(__webpack_require__.bind(null, 1030));
    },
    meta: {
      title: '查理宝支付宝流水详情'
    }
  }]
}];

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbProductArea", function() { return clbProductArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var clbProductArea = [{
  path: '/clb-product-area',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(204).then(__webpack_require__.bind(null, 1031));
    },
    meta: {
      title: '查理任务区域列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 278));
    },
    meta: {
      title: '添加查理任务区域'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 278));
    },
    meta: {
      title: '修改查理任务区域'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(269).then(__webpack_require__.bind(null, 1032));
    },
    meta: {
      title: '查理任务区域详情'
    }
  }]
}];

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbProductCategory", function() { return clbProductCategory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var clbProductCategory = [{
  path: '/clb-product-category',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(203).then(__webpack_require__.bind(null, 1033));
    },
    meta: {
      title: '查理宝任务分类列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 279));
    },
    meta: {
      title: '添加查理宝任务分类'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 279));
    },
    meta: {
      title: '修改查理宝任务分类'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(268).then(__webpack_require__.bind(null, 1034));
    },
    meta: {
      title: '查理宝任务分类详情'
    }
  }]
}];

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbProduct", function() { return clbProduct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var clbProduct = [{
  path: '/clb-product',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(158).then(__webpack_require__.bind(null, 1035));
    },
    meta: {
      title: '查理任务产品列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 280));
    },
    meta: {
      title: '添加查理任务产品'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 280));
    },
    meta: {
      title: '修改查理任务产品'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(267).then(__webpack_require__.bind(null, 1036));
    },
    meta: {
      title: '查理任务产品详情'
    }
  }]
}];

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbStepTemplate", function() { return clbStepTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var clbStepTemplate = [{
  path: '/clb-step-template',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1037));
    },
    children: [{
      path: 'create',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 109));
      },
      meta: {
        title: '添加查理宝分步模板'
      }
    }, {
      path: 'update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 109));
      },
      meta: {
        title: '修改查理宝分步模板'
      }
    }]
  }]
}];

/***/ }),
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clbTaskTemplate", function() { return clbTaskTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var clbTaskTemplate = [{
  path: '/clb-task-template',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(202).then(__webpack_require__.bind(null, 1039));
    },
    meta: {
      title: '查理宝任务模板列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 281));
    },
    meta: {
      title: '添加查理宝任务模板'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 281));
    },
    meta: {
      title: '编辑查理宝任务模板'
    }
  }]
}];

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "companyBankAccount", function() { return companyBankAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var companyBankAccount = [{
  path: '/company-bank-account',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(185).then(__webpack_require__.bind(null, 1040));
    },
    name: '对公账户列表',
    meta: {
      title: '对公账户列表'
    }
  }, {
    path: 'create/batch',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1041));
    },
    name: '批量添加对公账户',
    meta: {
      title: '批量添加/修改对公账户'
    }
  }]
}];

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coverEstimate", function() { return coverEstimate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var coverEstimate = [{
  path: '/cover-estimate',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(216).then(__webpack_require__.bind(null, 1042));
    },
    name: '覆盖预估',
    meta: {
      title: '覆盖预估'
    }
  }]
}];

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerBatch", function() { return customerBatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customerBatch = [{
  path: '/customer-batch',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table/:projectid'
  }, {
    path: 'table/:projectid',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1043));
    },
    name: '客户批次管理',
    meta: {
      title: '客户批次管理'
    }
  }, {
    path: 'create/project-:projectId',
    component: function component() {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 282));
    },
    name: '添加客户批次',
    meta: {
      title: '添加客户批次'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 282));
    },
    name: '修改客户批次',
    meta: {
      title: '修改客户批次'
    }
  }, {
    path: 'salary-increasing/:batchId',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1044));
    },
    name: '客户批次任务加值',
    meta: {
      title: '客户批次任务加值'
    }
  }]
}, {
  path: '/batch',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table/:projectid',
    component: function component() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1045));
    },
    name: '批次管理',
    meta: {
      title: '批次管理'
    }
  }]
}];

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerProjectReport", function() { return customerProjectReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customerProjectReport = [{
  path: '/customer-project-report',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table/:customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1046));
    },
    name: '项目报告列表',
    meta: {
      title: '项目报告列表'
    }
  }]
}];

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerProject", function() { return customerProject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customerProject = [{
  path: '/customer-project',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table/:customerid'
  }, {
    path: 'table/:customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1047));
    },
    name: '客户项目管理',
    meta: {
      title: '客户项目管理'
    }
  }, {
    path: 'create/:customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 160));
    },
    name: '新增客户项目信息',
    meta: {
      title: '新增客户项目信息'
    }
  }, {
    path: 'update/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 160));
    },
    name: '修改客户项目信息',
    meta: {
      title: '修改客户项目信息',
      isUpdate: true
    }
  }, {
    path: 'create/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 160));
    },
    name: '复制客户项目信息',
    meta: {
      title: '新增客户项目信息'
    }
  }, {
    path: 'audit/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1048));
    },
    name: '审核客户项目信息',
    meta: {
      title: '审核客户项目信息'
    }
  }, {
    path: 'finance/update/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1049));
    },
    name: '修改客户项目财务信息',
    meta: {
      title: '修改客户项目财务信息'
    }
  }, {
    path: 'flow/table/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1050));
    },
    name: '项目明细',
    meta: {
      title: '项目明细'
    }
  }, {
    path: 'budget/table/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1051));
    },
    name: '项目预算修改历史',
    meta: {
      title: '项目预算修改历史'
    }
  }, {
    path: 'usebudget/detail/:customerid/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1052));
    },
    name: '预算使用情况',
    meta: {
      title: '预算使用情况'
    }
  }]
}, {
  path: '/project',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 156));
    },
    name: '项目管理',
    meta: {
      title: '项目管理',
      type: 'customer-project-table'
    }
  }, {
    path: 'ajx/table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 267));
    },
    name: '爱绩效项目管理',
    meta: {
      title: '爱绩效项目管理'
    }
  }]
}];

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerProjectcost", function() { return customerProjectcost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customerProjectcost = [{
  path: '/customer-projectcost',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 283));
    },
    name: '项目成本列表',
    meta: {
      title: '项目成本列表'
    }
  }, {
    path: 'table/type/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 283));
    },
    meta: {
      title: '查理宝项目成本列表'
    }
  }]
}];

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerReceipt", function() { return customerReceipt; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customerReceipt = [{
  path: '/customer-receipt',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(184).then(__webpack_require__.bind(null, 1053));
    },
    meta: {
      title: '客户开票信息列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 284));
    },
    meta: {
      title: '添加客户开票信息'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 284));
    },
    meta: {
      title: '修改客户开票信息'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1054));
    },
    meta: {
      title: '客户开票信息详情'
    }
  }, {
    path: 'batch/create',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 285));
    },
    meta: {
      title: '批量添加客户开票信息',
      isUpdate: false
    }
  }, {
    path: 'batch/update',
    component: function component() {
      return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 285));
    },
    meta: {
      title: '批量更新客户开票信息',
      isUpdate: true
    }
  }]
}];

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customerTask", function() { return customerTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customerTask = [{
  path: '/customer-task',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 286));
    },
    name: '客户任务管理',
    meta: {
      title: '客户任务管理'
    }
  }, {
    path: 'table/type/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 286));
    },
    meta: {
      title: '客户任务管理'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 287));
    },
    meta: {
      title: '新增客户'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 287));
    },
    meta: {
      title: '编辑客户'
    }
  }]
}];

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customer", function() { return customer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var customer = [{
  path: '/customer',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 288));
    },
    name: '客户列表',
    meta: {
      title: '客户列表'
    }
  }, {
    path: 'table/type/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 288));
    },
    meta: {
      title: '客户列表'
    }
  }, {
    path: 'ajx/table',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1055));
    },
    name: '爱绩效客户列表',
    meta: {
      title: '爱绩效客户列表'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1056));
    },
    name: '客户详情',
    meta: {
      title: '客户详情'
    }
  }, {
    path: 'balance-flow/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1057));
    },
    meta: {
      title: '客户消费流水'
    }
  }, {
    path: 'relationship/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(308).then(__webpack_require__.bind(null, 1058));
    },
    name: '客户关系',
    meta: {
      title: '客户关系'
    }
  }, {
    path: 'batch-table',
    component: function component() {
      return __webpack_require__.e/* import() */(166).then(__webpack_require__.bind(null, 1059));
    },
    name: '批量客户',
    meta: {
      title: '批量客户'
    }
  }, {
    path: 'receipt/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 995));
    },
    name: '开票信息',
    meta: {
      title: '开票信息'
    }
  }, {
    path: 'customer-order-review/table',
    component: function component() {
      return __webpack_require__.e/* import() */(234).then(__webpack_require__.bind(null, 1060));
    },
    name: '客户审单管理',
    meta: {
      title: '客户审单管理'
    }
  }, {
    path: 'project-order-review/table',
    component: function component() {
      return __webpack_require__.e/* import() */(233).then(__webpack_require__.bind(null, 1061));
    },
    name: '项目审单管理',
    meta: {
      title: '项目审单管理'
    }
  }, {
    path: 'batch-order-review/table',
    component: function component() {
      return __webpack_require__.e/* import() */(309).then(__webpack_require__.bind(null, 1062));
    },
    name: '批次审单管理',
    meta: {
      title: '批次审单管理'
    }
  }]
}];

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exception", function() { return exception; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var exception = [{
  path: '/exception',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '404',
    component: function component() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 222));
    },
    name: 'NotFound',
    meta: {
      title: 'NotFound'
    }
  }, {
    path: '403',
    component: function component() {
      return __webpack_require__.e/* import() */(357).then(__webpack_require__.bind(null, 1063));
    },
    name: 'Forbidden',
    meta: {
      title: 'Forbidden'
    }
  }, {
    path: '424',
    component: function component() {
      return __webpack_require__.e/* import() */(358).then(__webpack_require__.bind(null, 1064));
    },
    name: 'FailedDependency',
    meta: {
      title: 'FailedDependency'
    }
  }]
}];

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "executiveBudget", function() { return executiveBudget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var executiveBudget = [{
  path: '/executive-budget',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(200).then(__webpack_require__.bind(null, 1065));
    },
    meta: {
      title: '执行预算分配列表'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(157).then(__webpack_require__.bind(null, 1066));
    },
    meta: {
      title: '加值金额分配-编辑'
    }
  }, {
    path: 'approve/table',
    component: function component() {
      return __webpack_require__.e/* import() */(201).then(__webpack_require__.bind(null, 1067));
    },
    meta: {
      title: '执行审批'
    }
  }]
}];

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairPrize", function() { return fairPrize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var fairPrize = [{
  path: '/fair_prize',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'index',
    component: function component() {
      return __webpack_require__.e/* import() */(379).then(__webpack_require__.bind(null, 1068));
    },
    name: '活动奖品管理',
    meta: {
      title: '活动奖品管理'
    }
  }, {
    path: 'new',
    component: function component() {
      return __webpack_require__.e/* import() */(69/* duplicate */).then(__webpack_require__.bind(null, 289));
    },
    name: '新增奖品',
    meta: {
      title: '新增奖品'
    }
  }, {
    path: 'edit/:prizeId',
    component: function component() {
      return __webpack_require__.e/* import() */(69/* duplicate */).then(__webpack_require__.bind(null, 289));
    },
    name: '修改奖品',
    meta: {
      title: '修改奖品'
    }
  }, {
    path: 'log/index/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(378).then(__webpack_require__.bind(null, 1069));
    },
    name: '活动奖品日志',
    meta: {
      title: '活动奖品日志'
    }
  }]
}];

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairReward", function() { return fairReward; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var fairReward = [{
  path: '/fair_reward',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table/:fairid',
    component: function component() {
      return __webpack_require__.e/* import() */(377).then(__webpack_require__.bind(null, 1070));
    },
    name: '获奖记录',
    meta: {
      title: '获奖记录'
    }
  }, {
    path: 'form/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 290));
    },
    name: '填写物流',
    meta: {
      title: '填写物流'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 290));
    },
    name: '修改物流',
    meta: {
      title: '修改物流'
    }
  }]
}];

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairStock", function() { return fairStock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var fairStock = [{
  path: '/fair-stock',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table/:fairid',
    component: function component() {
      return __webpack_require__.e/* import() */(376).then(__webpack_require__.bind(null, 1071));
    },
    name: '转盘库存管理',
    meta: {
      title: '转盘库存管理'
    }
  }]
}];

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fairUpload", function() { return fairUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var fairUpload = [{
  path: '/fair-upload',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(375).then(__webpack_require__.bind(null, 1072));
    },
    name: '活动上传列表',
    meta: {
      title: '活动上传列表'
    }
  }]
}];

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fair", function() { return fair; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var fair = [{
  path: '/fair',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(353).then(__webpack_require__.bind(null, 1073));
    },
    name: '活动管理',
    meta: {
      title: '活动管理'
    }
  }, {
    path: 'form',
    component: function component() {
      return __webpack_require__.e/* import() */(28/* duplicate */).then(__webpack_require__.bind(null, 161));
    },
    name: '活动添加',
    meta: {
      title: '活动添加'
    }
  }, {
    path: 'view/:fairid',
    component: function component() {
      return __webpack_require__.e/* import() */(28/* duplicate */).then(__webpack_require__.bind(null, 161));
    },
    name: '查看活动',
    meta: {
      title: '查看活动'
    }
  }, {
    path: 'update/:fairid',
    component: function component() {
      return __webpack_require__.e/* import() */(28/* duplicate */).then(__webpack_require__.bind(null, 161));
    },
    name: '活动编辑',
    meta: {
      title: '活动编辑'
    }
  }, {
    path: 'remaining_prize_table/:fairid',
    component: function component() {
      return __webpack_require__.e/* import() */(374).then(__webpack_require__.bind(null, 1074));
    },
    name: '转盘当天剩余奖品',
    meta: {
      title: '转盘当天剩余奖品'
    }
  }, {
    path: 'user_limit_table/:fairid',
    component: function component() {
      return __webpack_require__.e/* import() */(373).then(__webpack_require__.bind(null, 1075));
    },
    name: '转盘用户当天剩余次数',
    meta: {
      title: '转盘用户当天剩余次数'
    }
  }]
}];

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "financeConfig", function() { return financeConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "financeConfigCompanyAccountManagement", function() { return financeConfigCompanyAccountManagement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var financeConfig = [{
  path: '/finance-config',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'approval-value'
  }, {
    path: 'approval-value',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1076));
    },
    meta: {
      title: '审批起始值设置'
    }
  }, {
    path: 'subject-management',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 162));
    },
    meta: {
      title: '付款科目管理'
    }
  }, {
    path: 'second-subject-management',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1077));
    },
    meta: {
      title: '付款科目管理'
    }
  }, {
    path: 'subject-relationships-management',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1078));
    },
    meta: {
      title: '付款科目管理'
    }
  }, {
    path: 'subject-relationships-management-form/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1079));
    },
    meta: {
      title: '付款科目管理'
    }
  }, {
    path: 'company-account',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1080));
    },
    meta: {
      title: '公司管理'
    }
  }, {
    path: 'invoice-name-management',
    component: function component() {
      return __webpack_require__.e/* import() */(181).then(__webpack_require__.bind(null, 1081));
    },
    meta: {
      title: '开票名称管理'
    }
  }, {
    path: 'invoice-category',
    component: function component() {
      return __webpack_require__.e/* import() */(182).then(__webpack_require__.bind(null, 1082));
    },
    meta: {
      title: '开票名称类别列表'
    }
  }, {
    path: 'invoice-name-batch-create',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 291));
    },
    meta: {
      type: 'batch_create',
      title: '批量添加开票名称'
    }
  }, {
    path: 'invoice-name-batch-update',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 291));
    },
    meta: {
      type: 'batch_edit',
      title: '批量更新开票名称'
    }
  }, {
    path: 'invoice-name-create',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 292));
    },
    meta: {
      type: 'create',
      title: '添加开票名称'
    }
  }, {
    path: 'invoice-name-update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 292));
    },
    meta: {
      type: 'edit',
      title: '更新开票名称'
    }
  }, {
    path: 'department-management',
    component: function component() {
      return __webpack_require__.e/* import() */(183).then(__webpack_require__.bind(null, 1083));
    },
    meta: {
      title: '部门管理'
    }
  }, {
    path: 'department-management/batch-create',
    component: function component() {
      return __webpack_require__.e/* import() */(146).then(__webpack_require__.bind(null, 1084));
    },
    meta: {
      title: '批量添加部门'
    }
  }, {
    path: 'department-management/batch-create-job',
    component: function component() {
      return __webpack_require__.e/* import() */(145).then(__webpack_require__.bind(null, 1085));
    },
    meta: {
      title: '批量添加岗位'
    }
  }, {
    path: 'department-management/:department_id/jobs',
    component: function component() {
      return __webpack_require__.e/* import() */(168).then(__webpack_require__.bind(null, 1086));
    },
    meta: {
      title: '岗位管理'
    }
  }, {
    path: 'public-accounts',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 162));
    },
    meta: {
      title: '对公账户列表'
    }
  }, {
    path: 'employee-accounts',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 162));
    },
    meta: {
      title: '员工账户列表'
    }
  }, {
    path: 'finance-email-notify',
    component: function component() {
      return __webpack_require__.e/* import() */(155).then(__webpack_require__.bind(null, 1087));
    },
    meta: {
      title: '财务邮件通知设置'
    }
  }, {
    path: 'tax-panel',
    component: function component() {
      return __webpack_require__.e/* import() */(230).then(__webpack_require__.bind(null, 1088));
    },
    meta: {
      title: '百旺自动开票配置项设置'
    }
  }]
}];

var financeConfigCompanyAccountManagement = [{
  path: '/finance-config/company-account-management',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(167).then(__webpack_require__.bind(null, 1089));
    },
    meta: {
      title: '账户管理'
    }
  }]
}];

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "finance", function() { return finance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var finance = [{
  path: '/finance',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'batch-withdraw-table',
    component: function component() {
      return __webpack_require__.e/* import() */(187).then(__webpack_require__.bind(null, 1090));
    },
    name: '批量提现列表',
    meta: {
      title: '批量提现列表'
    }
  }, {
    path: 'bank-withdraw-table',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 163));
    },
    name: '银行卡提现批次管理',
    meta: {
      title: '银行卡提现批次管理',
      type: 1
    }
  }, {
    path: 'alipay-withdraw-table',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 163));
    },
    name: '支付宝提现批次管理',
    meta: {
      title: '支付宝提现批次管理',
      type: 2
    }
  }, {
    path: 'wx-withdraw-table',
    component: function component() {
      return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 163));
    },
    name: '微信提现批次管理',
    meta: {
      title: '微信提现批次管理',
      type: 3
    }
  }, {
    path: 'batch-withdraw-option-table',
    component: function component() {
      return __webpack_require__.e/* import() */(188).then(__webpack_require__.bind(null, 1091));
    },
    name: '批量提现操作列表',
    meta: {
      title: '批量提现操作列表'
    }
  }, {
    path: 'withdraw-wx-table',
    component: function component() {
      return __webpack_require__.e/* import() */(32/* duplicate */).then(__webpack_require__.bind(null, 164));
    },
    name: '微信提现管理',
    meta: {
      title: '微信提现管理'
    }
  }, {
    path: 'withdraw-alipay-table',
    component: function component() {
      return __webpack_require__.e/* import() */(32/* duplicate */).then(__webpack_require__.bind(null, 164));
    },
    name: '支付宝提现管理',
    meta: {
      title: '支付宝提现管理'
    }
  }, {
    path: 'withdraw-bank-table',
    component: function component() {
      return __webpack_require__.e/* import() */(32/* duplicate */).then(__webpack_require__.bind(null, 164));
    },
    name: '银行卡提现管理',
    meta: {
      title: '银行卡提现管理'
    }
  }, {
    path: 'batch-withdraw-detail/:type/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(250).then(__webpack_require__.bind(null, 1092));
    },
    name: '提现批次详情',
    meta: {
      title: '提现批次详情'
    }
  }, {
    path: 'ajx/project/table',
    component: function component() {
      return __webpack_require__.e/* import() */(251).then(__webpack_require__.bind(null, 267));
    },
    name: '爱绩效项目审核',
    meta: {
      title: '爱绩效项目审核'
    }
  }, {
    path: 'inactive-user-table',
    component: function component() {
      return __webpack_require__.e/* import() */(307).then(__webpack_require__.bind(null, 1093));
    },
    name: '不活跃用户',
    meta: {
      title: '不活跃用户'
    }
  }]
}];

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flbanner", function() { return flbanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var flbanner = [{
  path: '/flbanner',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(371).then(__webpack_require__.bind(null, 1094));
    },
    name: '福利社活动管理',
    meta: {
      title: '福利社活动管理'
    }
  }, {
    path: 'form',
    component: function component() {
      return __webpack_require__.e/* import() */(282).then(__webpack_require__.bind(null, 1095));
    },
    name: '新增福利社',
    meta: {
      title: '新增福利社'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(281).then(__webpack_require__.bind(null, 1096));
    },
    name: '编辑福利社',
    meta: {
      title: '编辑福利社'
    }
  }, {
    path: 'log/table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(372).then(__webpack_require__.bind(null, 1097));
    },
    name: '福利社历史记录',
    meta: {
      title: '福利社历史记录'
    }
  }]
}];

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "groupBatch", function() { return groupBatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var groupBatch = [{
  path: '/group-batch',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'customer-table',
    component: function component() {
      return __webpack_require__.e/* import() */(280).then(__webpack_require__.bind(null, 1098));
    },
    meta: {
      title: '群组控制'
    }
  }, {
    path: 'create/:tenant_customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 293));
    },
    meta: {
      title: '创建群组控制'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 293));
    },
    meta: {
      title: '修改群组控制'
    }
  }, {
    path: 'log-table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(229).then(__webpack_require__.bind(null, 1099));
    },
    meta: {
      title: '群组控制修改日志'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(266).then(__webpack_require__.bind(null, 1100));
    },
    meta: {
      title: '群组群组控制'
    }
  }, {
    path: 'table/:tenant_customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1101));
    },
    meta: {
      title: '群组控制列表'
    }
  }, {
    path: 'batch-upload/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(249).then(__webpack_require__.bind(null, 1102));
    },
    meta: {
      title: '上传群组控制目标数'
    }
  }, {
    path: 'batch-upload-table/:customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(228).then(__webpack_require__.bind(null, 1103));
    },
    meta: {
      title: '批量上传群组控制目标数'
    }
  }, {
    path: 'target-table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1104));
    },
    meta: {
      title: '群组控制目标数'
    }
  }, {
    path: 'market-upload-table/:customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 294));
    },
    meta: {
      title: '上传客户群组门店关系'
    }
  }, {
    path: 'market-upload-table/:customerid/project/:projectid',
    component: function component() {
      return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 294));
    },
    meta: {
      title: '上传项目群组门店关系'
    }
  }, {
    path: 'market-table/:customerid',
    component: function component() {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 295));
    },
    meta: {
      title: '客户群组门店关系列表'
    }
  }, {
    path: 'market-table/:customerid/project/:projectid',
    component: function component() {
      return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 295));
    },
    meta: {
      title: '项目群组门店关系列表'
    }
  }]
}];

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "home", function() { return home; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var home = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{ path: '', component: function component() {
      return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1105));
    }, name: '首页' }]
}];

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hr", function() { return hr; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var hr = [{
  path: '/hr',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'employee',
    component: function component() {
      return __webpack_require__.e/* import() */(152).then(__webpack_require__.bind(null, 1106));
    },
    name: '员工管理',
    meta: {
      title: '员工管理'
    }
  }, {
    path: 'employee/add',
    component: function component() {
      return __webpack_require__.e/* import() */(30/* duplicate */).then(__webpack_require__.bind(null, 165));
    },
    name: '员工新增',
    meta: {
      title: '员工新增'
    }
  }, {
    path: 'employee/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(30/* duplicate */).then(__webpack_require__.bind(null, 165));
    },
    name: '员工编辑',
    meta: {
      title: '员工编辑'
    }
  }, {
    path: 'employee/detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(30/* duplicate */).then(__webpack_require__.bind(null, 165));
    },
    name: '员工详情',
    meta: {
      title: '员工详情',
      isOnlyView: true // 只是查看
    }
  }, {
    path: 'employee/birthday-list',
    component: function component() {
      return __webpack_require__.e/* import() */(370).then(__webpack_require__.bind(null, 1107));
    },
    name: '查看生日祝福',
    meta: {
      title: '查看生日祝福'
    }
  }]
}];

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowConfig", function() { return imgFlowConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var imgFlowConfig = [{
  path: '/img-flow-config',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(199).then(__webpack_require__.bind(null, 1108));
    },
    name: '图片流转配置列表',
    meta: {
      title: '图片流转配置列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 296));
    },
    name: '添加图片流转配置',
    meta: {
      title: '添加图片流转配置'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 296));
    },
    name: '修改图片流转配置',
    meta: {
      title: '修改图片流转配置'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(265).then(__webpack_require__.bind(null, 1109));
    },
    name: '图片流转配置详情',
    meta: {
      title: '图片流转配置详情'
    }
  }]
}];

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowModel", function() { return imgFlowModel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var imgFlowModel = [{
  path: '/img-flow-model',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(198).then(__webpack_require__.bind(null, 1110));
    },
    name: '图片流转模型列表',
    meta: {
      title: '图片流转模型列表'
    }
  }]
}];

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowOrder", function() { return imgFlowOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var imgFlowOrder = [{
  path: '/img-flow-order',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(197).then(__webpack_require__.bind(null, 1111));
    },
    name: '图片流转工单列表',
    meta: {
      title: '图片流转工单列表'
    }
  }]
}];

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imgFlowProduct", function() { return imgFlowProduct; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var imgFlowProduct = [{
  path: '/img-flow-product',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(196).then(__webpack_require__.bind(null, 1112));
    },
    name: '图片流转产品列表',
    meta: {
      title: '图片流转产品列表'
    }
  },
  // {
  //   path: 'create',
  //   component: () => import(/* webpackChunkName: "img-flow-product-form" */ './pages/ImgFlowProductForm.vue'),
  //   name: '添加图片流转产品',
  // },
  {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(227).then(__webpack_require__.bind(null, 1113));
    },
    name: '修改图片流转产品',
    meta: {
      title: '修改图片流转产品'
    }
  }, {
    path: 'batch/update',
    component: function component() {
      return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, 1114));
    },
    name: '批量更新图片流转产品别名',
    meta: {
      title: '批量更新图片流转产品别名'
    }
  }]
}];

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntelligentCustomerServiceRoute", function() { return IntelligentCustomerServiceRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var IntelligentCustomerServiceRoute = [{
  path: '/intelligent-customer-service',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'update'
  }, {
    path: 'update',
    component: function component() {
      return __webpack_require__.e/* import() */(352).then(__webpack_require__.bind(null, 1115));
    },
    name: '参数配置',
    meta: {
      title: '参数配置'
    }
  }]
}];

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intelligentOutboundCall", function() { return intelligentOutboundCall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var intelligentOutboundCall = [{
  path: '/intelligent-outbound-call',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1116));
    },
    meta: {
      title: '智能外呼列表'
    }
  }, {
    path: 'detail-table/:call_task_id',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1117));
    },
    meta: {
      title: '外呼明细'
    }
  }, {
    path: 'record-table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1118));
    },
    meta: {
      title: '外呼记录'
    }
  }, {
    path: 'upload',
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1119));
    },
    meta: {
      title: '批量任务'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 297));
    },
    meta: {
      title: '添加智能外呼'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 297));
    },
    meta: {
      title: '修改智能外呼'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(264).then(__webpack_require__.bind(null, 1120));
    },
    meta: {
      title: '智能外呼详情'
    }
  }]
}];

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invoiceApply", function() { return invoiceApply; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var invoiceApply = [{
  path: '/invoice-apply',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(27/* duplicate */).then(__webpack_require__.bind(null, 166));
    },
    name: '开票管理',
    meta: {
      is_pre_received: false,
      title: '开票管理',
      type: 'table'
    }
  }, {
    path: 'approval',
    component: function component() {
      return __webpack_require__.e/* import() */(27/* duplicate */).then(__webpack_require__.bind(null, 166));
    },
    name: '开票待审批列表',
    meta: {
      is_pre_received: false,
      title: '开票待审批列表',
      type: 'approval'
    }
  }, {
    path: 'detail-redirect/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(351).then(__webpack_require__.bind(null, 1121));
    },
    name: '开票详情跳转页面',
    meta: {
      title: '跳转开票详情'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 298));
    },
    name: '开票详情',
    meta: {
      title: '开票详情',
      isFinancePage: false
    }
  }, {
    path: 'finance/detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 298));
    },
    name: '开票详情',
    meta: {
      title: '开票单详情页',
      isFinancePage: true
    }
  }, {
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(124).then(__webpack_require__.bind(null, 1122));
    },
    name: '开票审批页面(旧)',
    meta: {
      title: '开票审批页面(旧)'
    }
  }, {
    path: 'review/bu-review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1123));
    },
    name: '开票BU审批页面',
    meta: {
      title: '开票BU审批页面'
    }
  }, {
    path: 'review/finance-approve/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1124));
    },
    name: '开票财务审批页面',
    meta: {
      title: '开票财务审批页面',
      isFinancePage: true
    }
  }, {
    path: 'review/complete/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 1125));
    },
    name: '完成开票',
    meta: {
      title: '完成开票'
    }
  }, {
    path: 'review/signed-off/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(116).then(__webpack_require__.bind(null, 1126));
    },
    name: '开票客户签收页面',
    meta: {
      title: '开票客户签收页面'
    }
  }, {
    path: 'review/return/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(114).then(__webpack_require__.bind(null, 1127));
    },
    name: '开票退票申请页面',
    meta: {
      title: '开票退票申请页面'
    }
  }, {
    path: 'review/abandon/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 1128));
    },
    name: '开票放弃申请页面',
    meta: {
      title: '开票放弃申请页面'
    }
  }, {
    path: 'review/void/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1129));
    },
    name: '开票作废审批',
    meta: {
      title: '开票作废审批',
      isFinancePage: true
    }
  }, {
    path: 'review/bu-deduct/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 1130));
    },
    name: '预收款开票-抵扣BU审批页面',
    meta: {
      title: '预收款开票-抵扣BU审批页面'
    }
  }, {
    path: 'review/waiver-deduct/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(118).then(__webpack_require__.bind(null, 1131));
    },
    name: '预收款开票-放弃抵扣页面',
    meta: {
      title: '预收款开票-放弃抵扣页面'
    }
  }, {
    path: 'review/deduct-apply/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 1132));
    },
    name: '预收款开票-抵扣申请页面',
    meta: {
      title: '预收款开票-抵扣申请页面'
    }
  }, {
    path: 'review/deduct-finance-approve/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1133));
    },
    name: '预收款开票-抵扣财务审批页面',
    meta: {
      title: '预收款开票-抵扣财务审批页面',
      isFinancePage: true
    }
  }, {
    path: 'split/table',
    component: function component() {
      return __webpack_require__.e/* import() */(161).then(__webpack_require__.bind(null, 1134));
    },
    name: '拆分发票列表',
    meta: {
      title: '拆分发票列表'
    }
  }, {
    path: 'pre-received/table',
    component: function component() {
      return __webpack_require__.e/* import() */(27/* duplicate */).then(__webpack_require__.bind(null, 166));
    },
    name: '预收款开票管理',
    meta: {
      is_pre_received: true,
      title: '预收款开票管理',
      type: 'pre_received'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(58/* duplicate */).then(__webpack_require__.bind(null, 299));
    },
    name: '添加开票申请',
    meta: {
      title: '添加开票申请'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(58/* duplicate */).then(__webpack_require__.bind(null, 299));
    },
    name: '修改开票申请',
    meta: {
      title: '修改开票申请'
    }
  }, {
    path: 'approve/table',
    component: function component() {
      return __webpack_require__.e/* import() */(56/* duplicate */).then(__webpack_require__.bind(null, 300));
    },
    name: '开票审批',
    meta: {
      is_pre_received: false,
      title: '开票审批'
    }
  }, {
    path: 'approve/pre-received/table',
    component: function component() {
      return __webpack_require__.e/* import() */(56/* duplicate */).then(__webpack_require__.bind(null, 300));
    },
    name: '预收款开票审批',
    meta: {
      is_pre_received: true,
      title: '预收款开票审批'
    }
  }, {
    path: 'received-payment/table/type/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1135));
    },
    name: '回款管理(旧)'
  }, {
    path: 'received-payment-detail/:id/type/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(148).then(__webpack_require__.bind(null, 1136));
    },
    name: '回款详情(旧)'
  }, {
    path: 'received-payment-log/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(195).then(__webpack_require__.bind(null, 1137));
    },
    name: '回款日志(旧)'
  }]
}];

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "launchPageActivity", function() { return launchPageActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var launchPageActivity = [{
  path: '/launch-page-activity',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(194).then(__webpack_require__.bind(null, 1138));
    },
    name: '登录页图片',
    meta: {
      title: '登录页图片'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 301));
    },
    name: '添加活动',
    meta: {
      title: '添加活动'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 301));
    },
    name: '修改活动',
    meta: {
      title: '修改活动'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(263).then(__webpack_require__.bind(null, 1139));
    },
    name: '活动详情',
    meta: {
      title: '活动详情'
    }
  }]
}];

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
var login = [{
  path: '/login',
  component: function component() {
    return __webpack_require__.e/* import() */(350).then(__webpack_require__.bind(null, 1140));
  },
  meta: {
    title: '用户登录',
    auth: false
  }
}];

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapCommentFeedback", function() { return mapCommentFeedback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var mapCommentFeedback = [{
  path: '/map-comment-feedback',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(306).then(__webpack_require__.bind(null, 1141));
    },
    name: '地图评价反馈',
    meta: {
      title: '地图评价反馈'
    }
  }]
}];

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "marketNg", function() { return marketNg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var marketNg = [{
  path: '/market-ng',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1142));
    },
    name: '门店异常列表',
    meta: {
      title: '门店异常列表'
    }
  }, {
    path: 'detail/:marketId',
    component: function component() {
      return __webpack_require__.e/* import() */(349).then(__webpack_require__.bind(null, 1143));
    },
    name: '门店异常详情',
    meta: {
      title: '门店异常详情'
    }
  }]
}];

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "market", function() { return market; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var market = [{
  path: '/market',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1144));
    },
    name: '门店列表',
    meta: {
      title: '门店列表'
    }
  }, {
    path: 'upload/table',
    component: function component() {
      return __webpack_require__.e/* import() */(164).then(__webpack_require__.bind(null, 1145));
    },
    name: '门店上传',
    meta: {
      title: '门店上传'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 302));
    },
    name: '门店添加',
    meta: {
      title: '门店添加'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 302));
    },
    name: '门店修改',
    meta: {
      title: '门店修改'
    }
  }, {
    path: 'log/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(154).then(__webpack_require__.bind(null, 1146));
    },
    name: '门店信息更新日志',
    meta: {
      title: '门店信息更新日志'
    }
  }, {
    path: 'location',
    component: function component() {
      return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 1147));
    },
    name: '门店经纬度修改',
    meta: {
      title: '门店经纬度修改'
    }
  }, {
    path: 'cs-location-log',
    component: function component() {
      return __webpack_require__.e/* import() */(369).then(__webpack_require__.bind(null, 1148));
    },
    name: '客服修改经纬度日志',
    meta: {
      title: '客服修改经纬度日志'
    }
  }]
}];

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "midan", function() { return midan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var midan = [{
  path: '/midan',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(156).then(__webpack_require__.bind(null, 1149));
    },
    name: '米单列表',
    meta: {
      title: '米单列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 303));
    },
    name: '添加米单',
    meta: {
      title: '添加米单'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 303));
    },
    name: '修改米单',
    meta: {
      title: '修改米单'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 1150));
    },
    name: '米单详情',
    meta: {
      title: '米单详情'
    }
  }]
}];

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "middleEndTask", function() { return middleEndTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var middleEndTask = [{
  path: '/middle-end-task',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 268));
    },
    name: '添加中台任务',
    meta: {
      title: '添加中台任务'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 268));
    },
    name: '修改中台任务',
    meta: {
      title: '修改中台任务'
    }
  }, {
    path: 'audit/table',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1151));
    },
    name: '任务审批',
    meta: {
      title: '任务审批'
    }
  }]
}];

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "occupationQuestionnaire", function() { return occupationQuestionnaire; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var occupationQuestionnaire = [{
  path: '/users/occupation-questionnaire',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(193).then(__webpack_require__.bind(null, 1152));
    },
    meta: {
      title: '自选职业推送列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 304));
    },
    meta: {
      title: '添加自选职业推送'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 304));
    },
    meta: {
      title: '修改自选职业推送'
    }
  }, {
    path: 'preview/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(262).then(__webpack_require__.bind(null, 1153));
    },
    meta: {
      title: '自选职业推送预览'
    }
  }]
}];

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "occupation", function() { return occupation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var occupation = [{
  path: '/users/occupation',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1154));
    },
    meta: {
      title: '自选职业列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 305));
    },
    meta: {
      title: '添加自选职业'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 305));
    },
    meta: {
      title: '修改自选职业'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(261).then(__webpack_require__.bind(null, 1155));
    },
    meta: {
      title: '自选职业详情'
    }
  }, {
    path: ':id/users',
    component: function component() {
      return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1156));
    },
    meta: {
      title: '自选职业用户列表'
    }
  }]
}];

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderImageRecaptureDetection", function() { return orderImageRecaptureDetection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var orderImageRecaptureDetection = [{
  path: '/order-image-recapture-detection',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'summary-customer-table',
    component: function component() {
      return __webpack_require__.e/* import() */(224).then(__webpack_require__.bind(null, 1157));
    },
    meta: {
      title: '翻拍统计'
    }
  }, {
    path: 'summary-project-table',
    component: function component() {
      return __webpack_require__.e/* import() */(225).then(__webpack_require__.bind(null, 1158));
    },
    meta: {
      title: '翻拍统计'
    }
  }, {
    path: 'summary-batch-table',
    component: function component() {
      return __webpack_require__.e/* import() */(226).then(__webpack_require__.bind(null, 1159));
    },
    meta: {
      title: '翻拍统计'
    }
  }, {
    path: 'image-table',
    component: function component() {
      return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 1160));
    },
    meta: {
      title: '翻拍图片列表'
    }
  }]
}];

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderReviewAssessment", function() { return orderReviewAssessment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var orderReviewAssessment = [{
  path: '/order-review-assessment',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'questionnaire-config'
  }, {
    path: 'questionnaire-config',
    component: function component() {
      return __webpack_require__.e/* import() */(273).then(__webpack_require__.bind(null, 1161));
    },
    name: '问卷配置',
    meta: {
      title: '问卷配置'
    }
  }, {
    path: 'target-setting',
    component: function component() {
      return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, 1162));
    },
    name: '目标项目设定',
    meta: {
      title: '目标项目设定'
    }
  }, {
    path: 'target-setting/detail/:projectId',
    component: function component() {
      return __webpack_require__.e/* import() */(151).then(__webpack_require__.bind(null, 1163));
    },
    name: '目标设置',
    meta: {
      title: '目标设置'
    }
  }, {
    path: 'keyin-exception-feedback',
    component: function component() {
      return __webpack_require__.e/* import() */(305).then(__webpack_require__.bind(null, 1164));
    },
    name: 'KeyIn异常工单反馈',
    meta: {
      title: 'KeyIn异常工单反馈'
    }
  }]
}];

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orderReview", function() { return orderReview; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var orderReview = [{
  path: '/order',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 81));
    },
    name: '订单审核',
    meta: {
      title: '订单审核'
    }
  }, {
    path: 'review-audit-quality/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 81));
    },
    name: '复核审单结果',
    meta: {
      title: '复核审单结果',
      pageType: 'reviewAuditQuality'
    }
  }, {
    path: 'review-audit-quality-detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 81));
    },
    name: '查看审单复核结果',
    meta: {
      title: '查看审单复核结果',
      pageType: 'viewReviewAuditQuality'
    }
  }]
}, {
  path: '/clb-order',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 81));
    },
    name: '查理宝订单审核',
    meta: {
      title: '查理宝订单审核'
    }
  }]
}];

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "order", function() { return order; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var order = [{
  path: '/order',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 167));
    },
    name: '工单列表',
    meta: {
      title: '工单列表'
    }
  }, {
    path: 'assigned-review-table',
    component: function component() {
      return __webpack_require__.e/* import() */(134).then(__webpack_require__.bind(null, 1165));
    },
    name: '待分配复核列表',
    meta: {
      title: '待分配复核列表'
    }
  }, {
    path: 'assign-review',
    component: function component() {
      return __webpack_require__.e/* import() */(131).then(__webpack_require__.bind(null, 1166));
    },
    name: '分配复核',
    meta: {
      title: '分配复核'
    }
  }, {
    path: 'archived/table',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1167));
    },
    name: '工单列表(归档)',
    meta: {
      title: '工单列表(归档)'
    }
  }, {
    path: 'appeal/table',
    component: function component() {
      return __webpack_require__.e/* import() */(192).then(__webpack_require__.bind(null, 1168));
    },
    name: '工单申诉列表',
    meta: {
      title: '工单申诉列表'
    }
  }, {
    path: 'appeal/intern-stat',
    component: function component() {
      return __webpack_require__.e/* import() */(223).then(__webpack_require__.bind(null, 1169));
    },
    name: '工单申诉实习生统计',
    meta: {
      title: '工单申诉实习生统计'
    }
  }, {
    path: 'appeal/review-order/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, 81));
    },
    name: '工单申诉审核',
    meta: {
      title: '工单申诉审核',
      pageType: 'reviewOrderAppeal'
    }
  }, {
    path: 'appeal/detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(191).then(__webpack_require__.bind(null, 1170));
    },
    name: '工单申诉详情',
    meta: {
      title: '工单申诉详情'
    }
  }, {
    path: 'md/table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(126).then(__webpack_require__.bind(null, 1171));
    },
    name: '米单任务列表',
    meta: {
      title: '米单任务列表'
    }
  }, {
    path: 'table/platform/:platformtype',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 167));
    },
    meta: {
      title: '工单列表'
    }
  }, {
    path: 'table/platform/:platformtype/status/:status',
    component: function component() {
      return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 167));
    },
    meta: {
      title: '待审核工单列表'
    }
  }, {
    path: 'detail/:orderid',
    component: function component() {
      return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, 1172));
    },
    name: '工单详情',
    meta: {
      title: '工单详情'
    }
  }]
}];

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "payConditions", function() { return payConditions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var payConditions = [{
  path: '/pay-conditions',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(222).then(__webpack_require__.bind(null, 1173));
    },
    meta: {
      title: '账期列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 306));
    },
    meta: {
      title: '添加账期'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 306));
    },
    meta: {
      title: '修改账期'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(214).then(__webpack_require__.bind(null, 1174));
    },
    meta: {
      title: '账期详情'
    }
  }]
}];

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentApprovalNew", function() { return paymentApprovalNew; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var paymentApprovalNew = [{
  path: '/payment-approval-new',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, 1175));
    },
    meta: {
      title: '付款审批列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 307));
    },
    meta: {
      title: '添加付款审批'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 307));
    },
    meta: {
      title: '修改付款审批'
    }
  }, {
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 308));
    },
    meta: {
      isReview: true,
      isApproval: true,
      title: '付款申请详情'
    }
  }, {
    // 退款
    path: 'refund/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 308));
    },
    meta: {
      isRefund: true,
      isReview: true,
      isApproval: true,
      title: '付款申请详情'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(37/* duplicate */).then(__webpack_require__.bind(null, 107));
    },
    meta: {
      isApproval: true,
      showConfirmAmount: true,
      title: '付款审批详情'
    }
  }]
}];

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentApproval", function() { return paymentApproval; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var paymentApproval = [{
  path: '/payment-approval',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(143).then(__webpack_require__.bind(null, 1176));
    },
    meta: {
      title: '付款审批列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 309));
    },
    meta: {
      title: '添加付款审批'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 309));
    },
    meta: {
      title: '修改付款审批'
    }
  }, {
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 310));
    },
    meta: {
      isReview: true,
      isApproval: true,
      title: '付款申请详情'
    }
  }, {
    // 退款
    path: 'refund/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 310));
    },
    meta: {
      isRefund: true,
      isReview: true,
      isApproval: true,
      title: '付款申请详情'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 155));
    },
    meta: {
      isApproval: true,
      title: '付款审批详情'
    }
  }]
}];

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentCenter", function() { return paymentCenter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var paymentCenter = [{
  path: '/payment-center',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(147).then(__webpack_require__.bind(null, 1177));
    },
    meta: {
      title: '支付中心'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(37/* duplicate */).then(__webpack_require__.bind(null, 107));
    },
    meta: {
      isApproval: true,
      showConfirmAmount: true,
      title: '支付中心详情'
    }
  }, {
    // 退款: 直接复用付款审批的详情页
    path: 'refund/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(36/* duplicate */).then(__webpack_require__.bind(null, 311));
    },
    meta: {
      isRefund: true,
      isReview: true,
      isApproval: true,
      title: '退款'
    }
  }, {
    // 付款信息回填
    path: 'upload-receipt/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(36/* duplicate */).then(__webpack_require__.bind(null, 311));
    },
    meta: {
      isReview: true,
      isApproval: true,
      title: '付款信息回填'
    }
  }]
}];

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentManagerNew", function() { return paymentManagerNew; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var paymentManagerNew = [{
  path: '/payment-manager-new',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 312));
    },
    meta: {
      title: '付款申请列表',
      type: 'table'
    }
  }, {
    path: 'approval',
    component: function component() {
      return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 312));
    },
    meta: {
      title: '付款申请待审批列表',
      type: 'approval'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 110));
    },
    meta: {
      title: '添加付款申请'
    }
  }, {
    path: 'bach-create',
    component: function component() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 110));
    },
    meta: {
      isBatch: true,
      title: '发起批量付款申请'
    }
  }, {
    path: 'detail-redirect/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(348).then(__webpack_require__.bind(null, 1178));
    },
    meta: {
      title: '付款详情跳转页'
    }
  }, {
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 107));
    },
    meta: {
      isReview: true,
      title: '付款申请详情'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 110));
    },
    meta: {
      title: '修改付款申请'
    }
  }, {
    path: 'batch-update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, 110));
    },
    meta: {
      isBatch: true,
      title: '修改批量付款申请'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 107));
    },
    meta: {
      title: '付款申请详情'
    }
  }, {
    path: 'write-off/create/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 168));
    },
    meta: {
      title: '冲销申请'
    }
  }, {
    path: 'write-off/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 168));
    },
    meta: {
      title: '冲销申请',
      isUpdate: true
    }
  }, {
    path: 'write-off/review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 168));
    },
    meta: {
      title: '冲销申请',
      isReview: true
    }
  }]
}];

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentManager", function() { return paymentManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var paymentManager = [{
  path: '/payment-manager',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 313));
    },
    meta: {
      title: '付款申请列表',
      type: 'table'
    }
  }, {
    path: 'approval',
    component: function component() {
      return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 313));
    },
    meta: {
      title: '付款申请待审批列表',
      type: 'approval'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 111));
    },
    meta: {
      title: '添加付款申请'
    }
  }, {
    path: 'bach-create',
    component: function component() {
      return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 111));
    },
    meta: {
      isBatch: true,
      title: '发起批量付款申请'
    }
  }, {
    path: 'detail-redirect/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(347).then(__webpack_require__.bind(null, 1179));
    },
    meta: {
      title: '付款详情跳转页'
    }
  }, {
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 155));
    },
    meta: {
      isReview: true,
      title: '付款申请详情'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 111));
    },
    meta: {
      title: '修改付款申请'
    }
  }, {
    path: 'batch-update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(12/* duplicate */).then(__webpack_require__.bind(null, 111));
    },
    meta: {
      isBatch: true,
      title: '修改批量付款申请'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 155));
    },
    meta: {
      title: '付款申请详情'
    }
  }, {
    path: 'write-off/create/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 169));
    },
    meta: {
      title: '冲销申请'
    }
  }, {
    path: 'write-off/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 169));
    },
    meta: {
      title: '冲销申请',
      isUpdate: true
    }
  }, {
    path: 'write-off/review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 169));
    },
    meta: {
      title: '冲销申请',
      isReview: true
    }
  }]
}];

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "paymentRefund", function() { return paymentRefund; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var paymentRefund = [{
  path: '/payment-refund',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(65/* duplicate */).then(__webpack_require__.bind(null, 314));
    },
    meta: {
      type: 'customer',
      title: '付款退款单列表'
    }
  }, {
    path: 'finance/table',
    component: function component() {
      return __webpack_require__.e/* import() */(65/* duplicate */).then(__webpack_require__.bind(null, 314));
    },
    meta: {
      type: 'finance',
      title: '付款退款单列表'
    }
  }, {
    path: 'finance/detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 315));
    },
    meta: {
      type: 'finance',
      title: '付款退款单详情'
    }
  }, {
    path: 'detail-redirect/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(346).then(__webpack_require__.bind(null, 1180));
    },
    meta: {
      title: '付款退款单跳转页'
    }
  }, {
    path: 'customer/detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 315));
    },
    meta: {
      type: 'customer',
      title: '付款退款单详情'
    }
  }]
}];

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissionApply", function() { return permissionApply; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var permissionApply = [{
  path: '/permission-apply',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(153).then(__webpack_require__.bind(null, 1181));
    },
    name: '权限申请',
    meta: {
      title: '权限申请'
    }
  }]
}];

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "permissionGroup", function() { return permissionGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var permissionGroup = [{
  path: '/permission-group',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'manage'
  }, {
    path: 'manage',
    component: function component() {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1182));
    },
    name: '权限组管理',
    meta: {
      title: '权限组管理'
    }
  }, {
    path: 'select',
    component: function component() {
      return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 1183));
    },
    name: '权限组选择DEMO',
    meta: {
      title: '权限组选择DEMO'
    }
  }]
}];

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformAndroidapkTest", function() { return platformAndroidapkTest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformAndroidapkTest = [{
  path: '/platform-androidapk-test',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(190).then(__webpack_require__.bind(null, 1184));
    },
    name: '安卓APK发布列表',
    meta: {
      title: '安卓APK发布列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 316));
    },
    name: '添加安卓APK',
    meta: {
      title: '添加安卓APK'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 316));
    },
    name: '修改安卓APK',
    meta: {
      title: '修改安卓APK'
    }
  }]
}];

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformDepartment", function() { return platformDepartment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformDepartment = [{
  path: '/platform-department',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(304).then(__webpack_require__.bind(null, 1185));
    },
    name: '部门管理',
    meta: {
      title: '部门管理'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 317));
    },
    name: '新增部门',
    meta: {
      title: '新增部门'
    }
  }, {
    path: 'update/:departmentId',
    component: function component() {
      return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 317));
    },
    name: '编辑部门',
    meta: {
      title: '编辑部门'
    }
  }]
}];

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformRole", function() { return platformRole; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformRole = [{
  path: '/platform-role',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(303).then(__webpack_require__.bind(null, 1186));
    },
    name: '后台用户角色管理',
    meta: {
      title: '后台用户角色管理'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 318));
    },
    name: '新增后台用户角色',
    meta: {
      title: '新增后台用户角色'
    }
  }, {
    path: 'update/:roleId',
    component: function component() {
      return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 318));
    },
    name: '编辑后台用户角色',
    meta: {
      title: '编辑后台用户角色'
    }
  }]
}, {
  path: '/platform-role/ui-role',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 319));
    },
    name: '新增UI权限角色',
    meta: {
      title: '新增UI权限角色'
    }
  }, {
    path: 'update/:roleId',
    component: function component() {
      return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 319));
    },
    name: '编辑UI权限角色',
    meta: {
      title: '编辑UI权限角色'
    }
  }]
}];

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUpload", function() { return platformUpload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformUpload = [{
  path: '/platform-upload',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(165).then(__webpack_require__.bind(null, 1187));
    },
    name: '平台列表',
    meta: {
      title: '平台列表'
    }
  }]
}];

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUserProvince", function() { return platformUserProvince; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformUserProvince = [{
  path: '/platform-user-province',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'update/:userid',
    component: function component() {
      return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 1188));
    },
    meta: {
      title: '分配用户资源详情'
    }
  }]
}];

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUserWhitelist", function() { return platformUserWhitelist; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformUserWhitelist = [{
  path: '/platform-user-whitelist',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(189).then(__webpack_require__.bind(null, 1189));
    },
    name: '发布白名单用户列表',
    meta: {
      title: '发布白名单用户列表'
    }
  }, {
    path: 'add/form',
    component: function component() {
      return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1190));
    },
    name: '添加发布白名单用户',
    meta: {
      title: '添加发布白名单用户'
    }
  }, {
    path: 'delete/:form',
    component: function component() {
      return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 1191));
    },
    name: '删除发布白名单用户',
    meta: {
      title: '删除发布白名单用户'
    }
  }]
}];

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformUser", function() { return platformUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platformUser = [{
  path: '/platform-user',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(260).then(__webpack_require__.bind(null, 1192));
    },
    name: '后台用户管理',
    meta: {
      title: '后台用户管理'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 320));
    },
    name: '新增后台用户',
    meta: {
      title: '新增后台用户'
    }
  }, {
    path: 'update/:userId',
    component: function component() {
      return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 320));
    },
    name: '编辑后台用户',
    meta: {
      title: '编辑后台用户'
    }
  }, {
    path: 'allot-many',
    component: function component() {
      return __webpack_require__.e/* import() */(345).then(__webpack_require__.bind(null, 1193));
    },
    name: '批量分配客户',
    meta: {
      title: '批量分配客户'
    }
  }, {
    path: 'ui-permissions/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1194));
    },
    name: 'UI权限管理'
  }, {
    path: 'audit-log',
    component: function component() {
      return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 1195));
    },
    name: '审计日志'
  }, {
    path: 'dispatch-roles/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(180).then(__webpack_require__.bind(null, 1196));
    },
    name: '批量分配权限角色'
  }]
}];

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platform", function() { return platform; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var platform = [{
  path: '/platform',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'tag_table',
    component: function component() {
      return __webpack_require__.e/* import() */(342).then(__webpack_require__.bind(null, 1197));
    },
    name: '热搜标签管理',
    meta: {
      title: '热搜标签管理'
    }
  }, {
    path: 'education_table',
    component: function component() {
      return __webpack_require__.e/* import() */(344).then(__webpack_require__.bind(null, 1198));
    },
    name: '教程管理',
    meta: {
      title: '教程管理'
    }
  }, {
    path: 'education_form',
    component: function component() {
      return __webpack_require__.e/* import() */(259).then(__webpack_require__.bind(null, 1199));
    },
    name: '教程详情',
    meta: {
      title: '教程详情'
    }
  }, {
    path: 'home-module-table',
    component: function component() {
      return __webpack_require__.e/* import() */(343).then(__webpack_require__.bind(null, 1200));
    },
    name: 'APP首页模块配置',
    meta: {
      title: 'APP首页模块配置'
    }
  }, {
    path: 'home-module-form',
    component: function component() {
      return __webpack_require__.e/* import() */(302).then(__webpack_require__.bind(null, 1201));
    },
    name: '首页模块详情',
    meta: {
      title: '首页模块详情'
    }
  }, {
    path: 'home-module-log-form',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1202));
    },
    name: '首页模块操作日志',
    meta: {
      title: '首页模块操作日志'
    }
  }, {
    path: 'order-comment-table',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1203));
    },
    name: '评价管理',
    meta: {
      title: '评价管理'
    }
  }, {
    path: 'sign-feedback-table',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1204));
    },
    name: '签到反馈',
    meta: {
      title: '签到问题反馈'
    }
  }, {
    path: 'sign-feedback-form',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1205));
    },
    name: '更新门店',
    meta: {
      title: '更新门店'
    }
  }]
}];

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "point", function() { return point; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var point = [{
  path: '/point',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'deduct/form/:userid',
    component: function component() {
      return __webpack_require__.e/* import() */(220).then(__webpack_require__.bind(null, 1206));
    },
    name: '零豆扣除',
    meta: {
      title: '零豆扣除'
    }
  }, {
    path: 'add/form/:userid',
    component: function component() {
      return __webpack_require__.e/* import() */(221).then(__webpack_require__.bind(null, 1207));
    },
    name: '零豆添加',
    meta: {
      title: '零豆添加'
    }
  }]
}];

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "position", function() { return position; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var position = [{
  path: '/position',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{ path: 'table', component: function component() {
      return __webpack_require__.e/* import() */(299).then(__webpack_require__.bind(null, 1208));
    }, name: '职位列表' }, { path: 'detail/:id', component: function component() {
      return __webpack_require__.e/* import() */(247).then(__webpack_require__.bind(null, 1209));
    }, name: '职位详情' }, { path: 'upload', component: function component() {
      return __webpack_require__.e/* import() */(341).then(__webpack_require__.bind(null, 1210));
    }, name: '批量上传' }, { path: 'update/:id', component: function component() {
      return __webpack_require__.e/* import() */(212).then(__webpack_require__.bind(null, 1211));
    }, name: '修改职业详情' }, { path: 'pending-audit-table', component: function component() {
      return __webpack_require__.e/* import() */(300).then(__webpack_require__.bind(null, 1212));
    }, name: '待审核职位' }, { path: 'audit-table', component: function component() {
      return __webpack_require__.e/* import() */(301).then(__webpack_require__.bind(null, 1213));
    }, name: '已审核职位' }, { path: 'audit-detail/:id', component: function component() {
      return __webpack_require__.e/* import() */(248).then(__webpack_require__.bind(null, 1214));
    }, name: '已审核职位详情' }, {
    path: 'pending-audit-detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(246).then(__webpack_require__.bind(null, 1215));
    },
    name: '待审核职位详情',
    meta: {
      title: '待审核职位详情'
    }
  }, { path: 'pending-check-detail/:id', component: function component() {
      return __webpack_require__.e/* import() */(213).then(__webpack_require__.bind(null, 1216));
    }, name: '职位审核' }, { path: 'pending-audit-update/:id', component: function component() {
      return __webpack_require__.e/* import() */(211).then(__webpack_require__.bind(null, 1217));
    }, name: '职位修改' }]
}];

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 深拷贝JSON对象
   * @param jsonObject
   * @returns {any}
   */
  copyJson: function copyJson(jsonObject) {
    return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(jsonObject));
  },

  /**
   * 把来源的对象的值循环赋值到目标对象
   * 2021-07-12 12:00 Anker 支持对多层对象和数组引用写入，保持双向绑定
   * 2018-09-25 14:44 Anker
   * @param {*} target
   * @param {*} source
   * @param setMethod
   */
  setLoop: function setLoop(target, source) {
    var setMethod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key) && Object.prototype.hasOwnProperty.call(target, key)) {
        if (setMethod) {
          target[key] = setMethod(target[key], source[key]);
        } else if (target[key] instanceof Array) {
          var _target$key;

          (_target$key = target[key]).splice.apply(_target$key, [0, target[key].length].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(source[key])));
        } else if (target[key] instanceof Object) {
          this.setLoop(target[key], source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
  },

  /**
   * 合并一个数组到数组中, 保持数组唯一性, 可根据关键字段匹配
   * @param array
   * @param array1
   * @param field {string} 数组对象中key
   */
  concatArray: function concatArray(array, array1, field) {
    if (field) {
      array1 = _.differenceBy(array1, array, field);
    } else {
      array1 = _.difference(array1, array);
    }
    // 必须使用传入的数组使用 push, 否则 vue 数据绑定无法触发
    array.push.apply(array, array1);
  },

  /**
   * 从数组中获得匹配的引用数组
   * @param findArrays
   * @param quoteArrays
   * @param field
   * @returns {Array}
   */
  findQuoteArray: function findQuoteArray(findArrays, quoteArrays) {
    var field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

    var _quoteArrays = [];
    for (var index = 0; index < quoteArrays.length; index++) {
      for (var _index = 0; _index < findArrays.length; _index++) {
        if (quoteArrays[index][field] === findArrays[_index][field]) {
          quoteArrays[index] = findArrays[_index];
          _quoteArrays.push(findArrays[_index]);
          break;
        }
      }
    }
    return _quoteArrays;
  },

  /**
   * 数据类型转换
   * @param value
   * @param type
   * @returns {*}
   * @deprecated
   */
  dataTypeConve: function dataTypeConve(value, type) {
    // 递归对象验证内容
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var field in type) {
        if (value[field]) {
          value[field] = this.dataTypeConve(value[field], type[field]);
        }
      }
    } else if (value.constructor !== type) {
      // 日期处理
      if (type === Date) {
        value = new Date(value);
      } else {
        value = type(value);
      }
    }
    return value;
  },


  /**
   * URL 参数解析
   * @param url
   * @returns {*}
   * @constructor
   */
  URLParamsParse: function URLParamsParse(url) {
    var params = url.match(/([^?=&]+)(=([^&]*))/g) || [];
    return params.reduce(function (a, v) {
      a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1);
      return a;
    }, {});
  },

  /**
   * 去除字符串中的html
   * @param text
   * @returns {string | string}
   */
  stripTags: function stripTags(text) {
    var div = document.createElement('div');
    div.innerHTML = text;
    return div.textContent || div.innerText || '';
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

  /**
   * 匹配字符串为单词
   * @param str
   */
  matchStrCase: function matchStrCase(str) {
    return str && str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g);
  },

  /**
   * 转为大驼峰
   * @param str
   * @returns {*}
   */
  toLargeCamelCase: function toLargeCamelCase(str) {
    return this.matchStrCase(str).map(function (x) {
      return x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase();
    }).join('');
  },

  /**
   * 转为小驼峰
   * @param str
   * @returns {string}
   */
  toSmallCamelCase: function toSmallCamelCase(str) {
    str = this.matchStrCase(str).map(function (x) {
      return x.slice(0, 1).toUpperCase() + x.slice(1).toLowerCase();
    }).join('');
    return str.slice(0, 1).toLowerCase() + str.slice(1);
  },

  /**
   * 转为分隔符连接
   * @param str
   * @param separator
   * @returns {*}
   */
  toSeparatorCase: function toSeparatorCase(str) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';

    return this.matchStrCase(str).map(function (x) {
      return x.toLowerCase();
    }).join(separator);
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 日期格式化
   *
   * @param date
   * @param format default YYYY-MM-DD HH:mm:ss
   * @returns {string}
   */
  formatDate: function formatDate(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD HH:mm:ss');
  },
  formatOnlyDate: function formatOnlyDate(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('YYYY-MM-DD');
  },


  /**
   * 时间戳格式化
   * @param time
   * @returns {string}
   */
  formatUnix: function formatUnix(time) {
    if (time.constructor !== Number) {
      time = Number(time);
    }
    return __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(time).format('YYYY-MM-DD HH:mm:ss');
  },

  /**
   * 日期转时间戳
   * @param date
   * @returns {number}
   */
  toUnix: function toUnix(date) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).unix();
  },


  /**
   * 秒数转换为时分秒的计时器格式
   *
   * @param value
   * @returns {string}
   */
  formatTimer: function formatTimer(value) {
    if (value) {
      var formats = [__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).hours(), __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).minutes(), __WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).seconds()];
      // 超过24小时
      if (value >= 86400) {
        formats[0] += 24 * parseInt(value / 86400);
      }
      formats.forEach(function (n, index) {
        formats[index] = ('00' + n).substr(('' + n).length);
      });
      return formats.join(':');
    }
    return '00:00:00';
  },


  /**
   * 秒数转换为人类倒计时格式
   *
   * @param value 秒
   * @param withSeconds 是否精确到秒
   * @returns {string}
   */
  formatTimerHumanize: function formatTimerHumanize(value, withSeconds) {
    var formats = [[Math.floor(__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).asDays()), '天'], [__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).hours(), '小时'], [__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).minutes(), '分钟']];

    if (withSeconds) {
      formats.push([__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(value * 1000).seconds(), '秒']);
    }

    return formats.reduce(function (a, b) {
      return a + (b[0] ? b.join('') : '');
    }, '');
  }
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 数组转换为对象
   * @param array
   * @param keys 转换后的键名
   */
  arraySplitObject: function arraySplitObject(array) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var object = {};
    array.forEach(function (val, index) {
      object[keys[index]] = val;
    });
    return object;
  },


  /**
   * 数组交换位置
   * @param array
   * @param oldIndex
   * @param newIndex
   */
  arraySwap: function arraySwap(array, oldIndex, newIndex) {
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    return array;
  },
  getLabelText: function getLabelText(array, value) {
    var item = array.find(function (item) {
      return item.value === value;
    });
    return item ? item.label : '';
  }
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isOss(value) {
  return value.includes('.aliyuncs.com') || /sj[a-zA-z]+\.slicejobs\.com/.test(value);
}

/**
 * 获得OSS正确的URL协议和地址
 * @param {*} value
 * @param {*} suffix
 */
function ossHost(value) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (!value) return '';
  if (!isOss(value)) return value;
  value = value.toString();
  // 把http以及https替换为自动协议
  value = value.replace(/^https*:\/\//, '//');
  // 追加后缀前取消原后缀
  if (suffix) {
    value = value.replace(/[?&#].*$/, '') + suffix;
  }
  // 把已存在的错误URl修正, img开头无法访问https
  // https://help.aliyun.com/knowledge_detail/39539.html
  value = value.replace('img-cn-shanghai.aliyuncs.com', 'oss-cn-shanghai.aliyuncs.com');
  // 把带有hangzhou oss 路径的文件 替换成 slicejobs(ps: 之前后台做的替换)
  value = value.replace('.oss-cn-hangzhou.aliyuncs.com', '.slicejobs.com');
  return value;
}

/**
 * 获得文件名
 *
 * @param src
 * @returns {*}
 */
function baseName(src) {
  return src.replace(/^.*\//, '').replace(/[?&#].*$/, '');
}

/**
 * 格式化图片为JPG
 *
 * @param string
 * @returns {string}
 */
function ossFormatJpg(string) {
  return string + '?x-oss-process=image/format,jpg';
}

/**
 * 获得缩略图
 *
 * @param value
 * @param width
 * @param height
 * @param color
 * @returns {*}
 */
function ossThumbnail(value, width) {
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var color = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var mode = '';
  if (typeof height === 'string') {
    color = height;
    height = null;
  }

  if (!height) {
    height = width;
  }

  if (color) {
    color = ',color_' + color;
    mode = ',m_pad';
  }

  if (height) {
    height = ',h_' + height;
  }

  if (width) {
    width = ',w_' + width;
  }
  return ossHost(value, '?x-oss-process=image/resize' + mode + width + height + color);
}

function ossConvertMP4(value) {
  value = ossHost(value);
  var index = value.lastIndexOf('.');
  return value.substr(0, index).replace('taskcert', 'slicejobsvideo').replace('sjvideopub', 'sjvideopubcnv') + '.mp4';
}

function ossImageInfo(value) {
  return axios.create().get(ossHost(value, '?x-oss-process=image/info'));
}

/* harmony default export */ __webpack_exports__["a"] = ({ isOss: isOss, ossHost: ossHost, baseName: baseName, ossFormatJpg: ossFormatJpg, ossThumbnail: ossThumbnail, ossConvertMP4: ossConvertMP4, ossImageInfo: ossImageInfo });

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 获得登录路由
   * @param fullPath
   * @returns {{path: string}}
   */
  loginPath: function loginPath(fullPath) {
    var path = { path: '/login'
      // 非默认路由进行登录后跳转
    };if (fullPath && fullPath !== '/') {
      path.query = { 'to': fullPath };
    }
    return path;
  }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "priceBatchForm", function() { return priceBatchForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var priceBatchForm = [{
  path: '/price-batch',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(279).then(__webpack_require__.bind(null, 1218));
    },
    name: '调价批次',
    meta: {
      title: '调价批次'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 323));
    },
    name: '新增调价批次',
    meta: {
      title: '新增调价批次'
    }
  }, {
    path: 'detail/:priceId',
    component: function component() {
      return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 323));
    },
    name: '调价批次详情',
    meta: {
      title: '调价批次详情'
    },
    props: true
  }]
}];

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectTaskPackage", function() { return projectTaskPackage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var projectTaskPackage = [{
  path: '/project-task-package',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(258).then(__webpack_require__.bind(null, 1219));
    },
    name: '任务包及培训配置',
    meta: {
      title: '任务包及培训配置'
    }
  }, {
    path: 'config/:projectId',
    component: function component() {
      return __webpack_require__.e/* import() */(219).then(__webpack_require__.bind(null, 1220));
    },
    name: '任务包配置',
    meta: {
      title: '任务包配置'
    }
  }]
}];

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "project", function() { return project; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var project = [{
  path: '/project',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'progress-table',
    component: function component() {
      return __webpack_require__.e/* import() */(278).then(__webpack_require__.bind(null, 1221));
    },
    name: '项目进度列表',
    meta: {
      title: '项目进度列表'
    }
  }, {
    path: 'progress-detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1222));
    },
    name: '项目进度详情',
    meta: {
      title: '项目进度详情'
    }
  }, {
    path: 'progress-node-snapshot',
    component: function component() {
      return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 1223));
    },
    name: '项目节点历史记录',
    meta: {
      title: '项目节点历史记录'
    }
  }]
}];

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "receivedPayment", function() { return receivedPayment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var receivedPayment = [{
  path: '/received-payment',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 324));
    },
    meta: {
      title: '回款列表',
      type: 'payment'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 325));
    },
    meta: {
      title: '回款详情',
      type: 'payment'
    }
  }, {
    path: 'detail-redirect/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(340).then(__webpack_require__.bind(null, 1224));
    },
    name: '回款详情跳转页面',
    meta: {
      title: '回款详情跳转页面'
    }
  }]
}, {
  path: '/received-approval',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 324));
    },
    meta: {
      title: '财务回款列表',
      type: 'approval'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 326));
    },
    meta: {
      title: '财务新增回款',
      type: 'approval'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 326));
    },
    meta: {
      title: '财务修改回款',
      type: 'approval'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 325));
    },
    meta: {
      title: '财务回款详情',
      type: 'approval'
    }
  }]
}];

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resume", function() { return resume; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var resume = [{
  path: '/resume',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{ path: 'table', component: function component() {
      return __webpack_require__.e/* import() */(296).then(__webpack_require__.bind(null, 1225));
    }, name: '投递简历' }, { path: 'detail', component: function component() {
      return __webpack_require__.e/* import() */(243).then(__webpack_require__.bind(null, 1226));
    }, name: '管理员下单简历详情' }, { path: 'audit-table', component: function component() {
      return __webpack_require__.e/* import() */(297).then(__webpack_require__.bind(null, 1227));
    }, name: '查看简历' }, { path: 'audit-detail', component: function component() {
      return __webpack_require__.e/* import() */(244).then(__webpack_require__.bind(null, 1228));
    }, name: '简历详情' }, { path: 'all_table', component: function component() {
      return __webpack_require__.e/* import() */(298).then(__webpack_require__.bind(null, 1229));
    }, name: '全部简历' }, { path: 'form/:id', component: function component() {
      return __webpack_require__.e/* import() */(175).then(__webpack_require__.bind(null, 1230));
    }, name: '简历编辑' }, { path: 'all-detail', component: function component() {
      return __webpack_require__.e/* import() */(245).then(__webpack_require__.bind(null, 1231));
    }, name: '全部简历详情' }]
}];

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "satisfactionEmail", function() { return satisfactionEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var satisfactionEmail = [{
  path: '/satisfaction-email',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(338).then(__webpack_require__.bind(null, 1232));
    },
    name: '满意度邮件',
    meta: {
      title: '满意度邮件'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 327));
    },
    name: '新增邮件',
    meta: {
      title: '新增邮件'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 327));
    },
    name: '修改满意度邮件',
    meta: {
      title: '修改满意度邮件'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(383).then(__webpack_require__.bind(null, 1233));
    },
    name: '查看满意度邮件',
    meta: {
      title: '查看满意度邮件'
    }
  }, {
    path: 'push-log/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(339).then(__webpack_require__.bind(null, 1234));
    },
    name: '推送记录',
    meta: {
      title: '推送记录'
    }
  }, {
    path: 'log/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(368).then(__webpack_require__.bind(null, 1235));
    },
    name: '修改日志',
    meta: {
      title: '修改日志'
    }
  }]
}];

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() { return settings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var settings = [{
  path: '/settings',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'change-password',
    component: function component() {
      return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 328));
    },
    name: '修改密码',
    meta: {
      title: '修改密码'
    }
  }, {
    path: 'set-project-config',
    component: function component() {
      return __webpack_require__.e/* import() */(337).then(__webpack_require__.bind(null, 1236));
    },
    name: '项目审核人管理',
    meta: {
      title: '项目审核人管理'
    }
  }, {
    path: 'set-receipt-apply-config',
    component: function component() {
      return __webpack_require__.e/* import() */(336).then(__webpack_require__.bind(null, 1237));
    },
    name: '开票抄送人管理',
    meta: {
      title: '开票抄送人管理'
    }
  }]
}, {
  path: '/change-password',
  component: function component() {
    return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 328));
  },
  name: '修改密码',
  meta: {
    title: '修改密码',
    isBeforLogin: true
  }
}];

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ([{
  path: '/statistic',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  meta: {
    title: '数据统计',
    icon: 'el-icon-data-line',
    hidden: false,
    alwaysShow: true
  },
  children: [{
    path: '',
    redirect: 'city-group-config',
    hidden: true
  },
  // 城市分组
  {
    path: 'city-group-config',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1238));
    },
    name: 'CityGroupConfig',
    meta: {
      title: '城市分组配置',
      icon: 'el-icon-menu',
      noCache: false,
      hidden: false,
      breadcrumb: false
    }
  }, {
    path: 'city-group-config/detail',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1239));
    },
    name: 'CityGroupDetail',
    meta: {
      title: '城市分组详情',
      noCache: true,
      hidden: true,
      activeMenu: '/statistic/city-group-config'
    }
  },
  // 推广人员配置
  {
    path: 'promoter',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1240));
    },
    name: 'Promoter',
    meta: {
      title: '推广人员配置',
      icon: 'el-icon-user',
      noCache: false,
      hidden: false
    }
  }, {
    path: 'promoter/detail',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1241));
    },
    name: 'PromoterDetail',
    meta: {
      title: '推广人员详情',
      noCache: true,
      hidden: true,
      activeMenu: '/statistic/promoter'
    }
  },
  // 大屏项目配置
  {
    path: 'screen-project',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1242));
    },
    name: 'ScreenProject',
    meta: {
      title: '大屏项目配置',
      icon: 'el-icon-monitor',
      noCache: false,
      hidden: false
    }
  }, {
    path: 'screen-project/detail',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1243));
    },
    name: 'ScreenProjectDetail',
    meta: {
      title: '大屏项目详情',
      noCache: true,
      hidden: true,
      activeMenu: '/statistic/screen-project'
    }
  }, {
    path: 'screen-project/display-settings',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1244));
    },
    name: 'ScreenProjectDisplaySettings',
    meta: {
      title: '大屏项目展示设置',
      noCache: true,
      hidden: true,
      activeMenu: '/statistic/screen-project'
    }
  }, {
    path: 'screen-project/audit-screen-config',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1245));
    },
    name: 'AuditScreenConfig',
    meta: {
      title: '审单大屏配置',
      noCache: true,
      hidden: true,
      activeMenu: '/statistic/screen-project'
    }
  },
  // 批量任务
  {
    path: 'screen-project/batch-jobs',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1246));
    },
    name: '统计管理批量任务',
    meta: {
      title: '批量任务',
      icon: 'el-icon-upload',
      noCache: false,
      hidden: false
    }
  }]
}]);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stepTemplate", function() { return stepTemplate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var stepTemplate = [{
  path: '/step-template',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1247));
    },
    children: [{
      path: 'create',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 109));
      },
      name: '添加分步模板',
      meta: {
        title: '添加分步模板'
      }
    }, {
      path: 'update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 109));
      },
      name: '修改分步模板',
      meta: {
        title: '修改分步模板'
      }
    }]
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 329));
    },
    name: '分步模板列表',
    meta: {
      title: '分步模板列表'
    }
  }, {
    path: 'table/type/:type',
    component: function component() {
      return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 329));
    },
    meta: {
      title: '分步模板列表'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(257).then(__webpack_require__.bind(null, 1248));
    },
    name: '分步模板详情',
    meta: {
      title: '分步模板详情'
    }
  }]
}];

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeCollection", function() { return storeCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var storeCollection = [{
  path: '/store-collection',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(295).then(__webpack_require__.bind(null, 1249));
    },
    name: '门店信息收集',
    meta: {
      title: '门店信息收集'
    }
  }]
}];

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskNotice", function() { return taskNotice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var taskNotice = [{
  path: '/task-notice',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(179).then(__webpack_require__.bind(null, 1250));
    },
    meta: {
      title: '任务提示列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 330));
    },
    meta: {
      title: '添加任务提示'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 330));
    },
    meta: {
      title: '修改任务提示'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(256).then(__webpack_require__.bind(null, 1251));
    },
    meta: {
      title: '任务提示详情'
    }
  }]
}];

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskOrder", function() { return taskOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var taskOrder = [{
  path: '/task-order',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 1252));
    },
    name: '任务工单列表',
    meta: {
      title: '任务工单列表'
    }
  }]
}];

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "taskPackageHome", function() { return taskPackageHome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var taskPackageHome = [{
  path: '/task-package-home',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(294).then(__webpack_require__.bind(null, 1253));
    },
    name: '首页任务包设置',
    meta: {
      title: '首页任务包设置'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 331));
    },
    name: '新增任务包',
    meta: {
      title: '新增任务包'
    }
  }, {
    path: 'update/:packageId',
    component: function component() {
      return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 331));
    },
    name: '修改任务包',
    meta: {
      title: '修改任务包'
    }
  }, {
    path: 'preview',
    component: function component() {
      return __webpack_require__.e/* import() */(163).then(__webpack_require__.bind(null, 1254));
    },
    name: '任务包预览',
    meta: {
      title: '任务包预览'
    }
  }]
}];

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "task", function() { return task; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var task = [{
  path: '/task',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1255));
    },
    name: '任务列表',
    meta: {
      title: '任务列表'
    }
  }, {
    path: 'archived/table',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1256));
    },
    name: '任务列表(归档)',
    meta: {
      title: '任务列表(归档)'
    }
  }, {
    path: 'md/table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, 1257));
    },
    name: '米单任务列表',
    meta: {
      title: '米单任务列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 332));
    },
    name: '添加任务',
    meta: {
      title: '添加任务'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 332));
    },
    name: '修改任务',
    meta: {
      title: '修改任务'
    }
  }, {
    path: 'detail/:taskid',
    component: function component() {
      return __webpack_require__.e/* import() */(255).then(__webpack_require__.bind(null, 1258));
    },
    name: '任务详情',
    meta: {
      title: '任务详情'
    }
  }, {
    path: 'batch/table',
    component: function component() {
      return __webpack_require__.e/* import() */(162).then(__webpack_require__.bind(null, 1259));
    },
    name: '批量任务',
    meta: {
      title: '批量任务'
    }
  }, {
    path: 'preview-app/:taskid',
    component: function component() {
      return __webpack_require__.e/* import() */(335).then(__webpack_require__.bind(null, 1260));
    },
    name: '任务预览',
    meta: {
      title: '任务预览'
    }
  }, {
    path: 'nearby-users/:taskid',
    component: function component() {
      return __webpack_require__.e/* import() */(240).then(__webpack_require__.bind(null, 1261));
    },
    name: '周边零工',
    meta: {
      title: '周边零工'
    }
  }, {
    path: 'map',
    component: function component() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1262));
    },
    name: '任务地图看板',
    meta: {
      title: '任务地图看板'
    }
  }, {
    path: 'map-covered-users/:taskid',
    component: function component() {
      return __webpack_require__.e/* import() */(241).then(__webpack_require__.bind(null, 1263));
    },
    name: '周边零工-历史工单覆盖',
    meta: {
      title: '周边零工-历史工单覆盖'
    }
  }, {
    path: 'map-idcard-users/:taskid',
    component: function component() {
      return __webpack_require__.e/* import() */(242).then(__webpack_require__.bind(null, 1264));
    },
    name: '周边零工-身份证覆盖',
    meta: {
      title: '周边零工-身份证覆盖'
    }
  }, {
    path: 'review-task-table',
    component: function component() {
      return __webpack_require__.e/* import() */(277).then(__webpack_require__.bind(null, 1265));
    },
    name: '复核任务列表',
    meta: {
      title: '复核任务列表',
      pageType: 'review-order-task'
    }
  }, {
    path: 'review-plan/table',
    component: function component() {
      return __webpack_require__.e/* import() */(293).then(__webpack_require__.bind(null, 1266));
    },
    name: '复核目标管理',
    meta: {
      title: '复核目标配置'
    }
  }, {
    path: 'review-plan/form',
    component: function component() {
      return __webpack_require__.e/* import() */(103/* duplicate */).then(__webpack_require__.bind(null, 333));
    },
    name: '添加复核目标',
    meta: {
      title: '添加复核目标'
    }
  }, {
    path: 'review-plan/form/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(103/* duplicate */).then(__webpack_require__.bind(null, 333));
    },
    name: '修改复核目标',
    meta: {
      title: '修改复核目标'
    }
  }]
}];

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tekeCustomer", function() { return tekeCustomer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var tekeCustomer = [{
  path: '/teke_customer',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(367).then(__webpack_require__.bind(null, 1267));
    },
    name: '客户管理',
    meta: {
      title: '客户管理'
    }
  }, {
    path: 'form',
    component: function component() {
      return __webpack_require__.e/* import() */(332).then(__webpack_require__.bind(null, 1268));
    },
    name: '添加客户',
    meta: {
      title: '添加客户'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(326).then(__webpack_require__.bind(null, 1269));
    },
    name: '编辑客户',
    meta: {
      title: '编辑客户'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(333).then(__webpack_require__.bind(null, 1270));
    },
    name: '客户详细信息',
    meta: {
      title: '客户详细信息'
    }
  }, {
    path: 'member/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(330).then(__webpack_require__.bind(null, 1271));
    },
    name: '成员管理',
    meta: {
      title: '成员管理'
    }
  }, {
    path: 'member/form/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(331).then(__webpack_require__.bind(null, 1272));
    },
    name: '添加成员',
    meta: {
      title: '添加成员'
    }
  }, {
    path: 'member/update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(329).then(__webpack_require__.bind(null, 1273));
    },
    name: '修改成员',
    meta: {
      title: '修改成员'
    }
  }, {
    path: 'recharge/table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(327).then(__webpack_require__.bind(null, 1274));
    },
    name: '客户充值记录',
    meta: {
      title: '客户充值记录'
    }
  }, {
    path: 'recharge/form/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(328).then(__webpack_require__.bind(null, 1275));
    },
    name: '新增客户充值信息',
    meta: {
      title: '新增客户充值信息'
    }
  }, {
    path: 'balance/table/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(334).then(__webpack_require__.bind(null, 1276));
    },
    name: '客户消费流水',
    meta: {
      title: '客户消费流水'
    }
  }]
}];

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tekeOrder", function() { return tekeOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var tekeOrder = [{
  path: '/teke-order',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(324).then(__webpack_require__.bind(null, 1277));
    },
    name: '全部问卷',
    meta: {
      title: '全部问卷'
    }
  }, {
    path: 'audit-table',
    component: function component() {
      return __webpack_require__.e/* import() */(325).then(__webpack_require__.bind(null, 1278));
    },
    name: '待复审问卷',
    meta: {
      title: '待复审问卷'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(34/* duplicate */).then(__webpack_require__.bind(null, 334));
    },
    name: '问卷详情',
    meta: {
      title: '问卷详情'
    }
  }, {
    path: 'review/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(34/* duplicate */).then(__webpack_require__.bind(null, 334));
    },
    name: '问卷审核',
    meta: {
      title: '问卷审核'
    }
  }]
}];

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tekeTag", function() { return tekeTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var tekeTag = [{
  path: '/teke_tag',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(364).then(__webpack_require__.bind(null, 1279));
    },
    name: '标签管理',
    meta: {
      title: '标签管理'
    }
  }, {
    path: 'form',
    component: function component() {
      return __webpack_require__.e/* import() */(321).then(__webpack_require__.bind(null, 1280));
    },
    name: '新建标签',
    meta: {
      title: '新建标签'
    }
  }, {
    path: 'update/:tagid',
    component: function component() {
      return __webpack_require__.e/* import() */(320).then(__webpack_require__.bind(null, 1281));
    },
    name: '修改标签',
    meta: {
      title: '修改标签'
    }
  }, {
    path: 'infinite_table',
    component: function component() {
      return __webpack_require__.e/* import() */(366).then(__webpack_require__.bind(null, 1282));
    },
    name: '标签列表',
    meta: {
      title: '标签列表'
    }
  }, {
    path: 'infinite_form/:tagid',
    component: function component() {
      return __webpack_require__.e/* import() */(323).then(__webpack_require__.bind(null, 1283));
    },
    name: '新建标签类别',
    meta: {
      title: '新建标签类别'
    }
  }, {
    path: 'infinite_update/:tagid',
    component: function component() {
      return __webpack_require__.e/* import() */(322).then(__webpack_require__.bind(null, 1284));
    },
    name: '修改标签类别',
    meta: {
      title: '修改标签类别'
    }
  }, {
    path: 'infinite_upload_table',
    component: function component() {
      return __webpack_require__.e/* import() */(365).then(__webpack_require__.bind(null, 1285));
    },
    name: '上传列表',
    meta: {
      title: '上传列表'
    }
  }]
}];

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "todo", function() { return todo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var todo = [{
  path: '/todo',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'project/table',
    component: function component() {
      return __webpack_require__.e/* import() */(74/* duplicate */).then(__webpack_require__.bind(null, 156));
    },
    name: '项目审核',
    meta: {
      title: '项目审核',
      type: 'todo-project-table'
    }
  }, {
    path: 'project/my-approval',
    component: function component() {
      return __webpack_require__.e/* import() */(74/* duplicate */).then(__webpack_require__.bind(null, 156));
    },
    name: '待审批项目',
    meta: {
      title: '待审批项目',
      type: 'todo-project-my-approval'
    }
  }]
}];

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trainingRoute", function() { return trainingRoute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_TrainingPageLayout_vue__ = __webpack_require__(965);



var trainingRoute = [{
  path: '/training',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_1__layouts_TrainingPageLayout_vue__["a" /* default */],
    children: [
    // 培训
    {
      path: 'instruction',
      component: function component() {
        return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 1286));
      },
      meta: {
        title: '培训管理',
        aiContext: 'instruction-list'
      }
    }, {
      path: 'instruction/create',
      component: function component() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 335));
      },
      meta: {
        title: '新增培训',
        aiContext: 'instruction-form',
        activeMenu: '/training/instruction'
      }
    }, {
      path: 'instruction/update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 335));
      },
      meta: {
        title: '编辑培训',
        aiContext: 'instruction-form',
        activeMenu: '/training/instruction'
      }
    }, {
      path: 'instruction/records/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(127).then(__webpack_require__.bind(null, 1287));
      },
      meta: {
        title: '学习记录',
        aiContext: 'instruction-records',
        activeMenu: '/training/instruction'
      }
    }, {
      path: 'instruction/exam-records/:id/detail/:recordId',
      component: function component() {
        return __webpack_require__.e/* import() */(159).then(__webpack_require__.bind(null, 1288));
      },
      meta: {
        title: '考试记录详情',
        aiContext: 'instruction-exam-detail',
        activeMenu: '/training/instruction'
      }
    }, {
      path: 'instruction/exam-records/:instructionId',
      component: function component() {
        return __webpack_require__.e/* import() */(128).then(__webpack_require__.bind(null, 269));
      },
      meta: {
        title: '培训答卷记录',
        aiContext: 'instruction-exam-records',
        activeMenu: '/training/instruction'
      }
    }, {
      path: 'instruction/bind-history/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(292).then(__webpack_require__.bind(null, 1289));
      },
      meta: {
        title: '绑定历史',
        aiContext: 'instruction-bind-history',
        activeMenu: '/training/instruction'
      }
    },

    // 实习生教程
    {
      path: 'self-examination',
      component: function component() {
        return __webpack_require__.e/* import() */(319).then(__webpack_require__.bind(null, 1290));
      },
      meta: {
        title: '我的问卷'
      }
    }, {
      path: 'self-examination/:id/result/:recordId',
      component: function component() {
        return __webpack_require__.e/* import() */(210).then(__webpack_require__.bind(null, 1291));
      },
      meta: {
        title: '考试详情',
        activeMenu: '/training/self-examination'
      }
    }, {
      path: 'self-examination/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, 1292));
      },
      meta: {
        title: '考试答题',
        activeMenu: '/training/self-examination'
      }
    }, {
      path: 'examination/:examinationId/intern/records/:recordId',
      component: function component() {
        return __webpack_require__.e/* import() */(160).then(__webpack_require__.bind(null, 1293));
      },
      meta: {
        title: '实习生答卷详情',
        activeMenu: '/training/intern-examination'
      }
    }, {
      path: 'examination/:examinationId/intern/records',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1294));
      },
      meta: {
        title: '实习生答卷记录',
        aiContext: 'examination-intern-records'
      }
    }, {
      path: 'self-course',
      component: function component() {
        return __webpack_require__.e/* import() */(150).then(__webpack_require__.bind(null, 1295));
      },
      meta: {
        title: '我的全部培训',
        aiContext: 'course-list-intern'
      }
    }, {
      path: 'intern-course',
      component: function component() {
        return __webpack_require__.e/* import() */(239).then(__webpack_require__.bind(null, 1296));
      },
      meta: {
        title: '实习生教程管理',
        aiContext: 'course-list-intern'
      }
    }, {
      path: 'intern-course/create',
      component: function component() {
        return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 336));
      },
      meta: {
        title: '创建实习生教程',
        aiContext: 'course-form-intern',
        activeMenu: '/training/intern-course'
      }
    }, {
      path: 'intern-course/update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 336));
      },
      meta: {
        title: '编辑实习生教程',
        aiContext: 'course-form-intern',
        activeMenu: '/training/intern-course'
      }
    },

    // 零工教程
    {
      path: 'user-course',
      component: function component() {
        return __webpack_require__.e/* import() */(238).then(__webpack_require__.bind(null, 1297));
      },
      meta: {
        title: '零工教程管理',
        aiContext: 'course-list'
      }
    }, {
      path: 'user-course/create',
      component: function component() {
        return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 337));
      },
      meta: {
        title: '创建零工教程',
        aiContext: 'course-form',
        activeMenu: '/training/user-course'
      }
    }, {
      path: 'user-course/update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 337));
      },
      meta: {
        title: '编辑零工教程',
        aiContext: 'course-form',
        activeMenu: '/training/user-course'
      }
    },

    // 考试
    {
      path: 'examination',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1298));
      },
      meta: {
        title: '零工考试管理',
        aiContext: 'examination-list'
      }
    }, {
      path: 'examination/create',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 338));
      },
      meta: {
        title: '创建零工考试',
        activeMenu: '/training/examination'
      }
    }, {
      path: 'examination/update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 338));
      },
      meta: {
        title: '编辑零工考试',
        activeMenu: '/training/examination'
      }
    }, {
      path: 'examination/exam-records/:examinationId',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 269));
      },
      meta: {
        title: '零工考试答卷记录',
        aiContext: 'examination-exam-records',
        activeMenu: '/training/examination'
      }
    },

    // 实习生考试
    {
      path: 'intern-examination',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1299));
      },
      meta: {
        title: '实习生考试管理',
        aiContext: 'examination-list'
      }
    }, {
      path: 'intern-examination/create',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 339));
      },
      meta: {
        title: '创建实习生考试',
        activeMenu: '/training/intern-examination'
      }
    }, {
      path: 'intern-examination/update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 339));
      },
      meta: {
        title: '编辑实习生考试',
        activeMenu: '/training/intern-examination'
      }
    },

    // 题目
    {
      path: 'question',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1300));
      },
      meta: {
        title: '题目管理',
        aiContext: 'question-list'
      }
    }, {
      path: 'question/create',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 340));
      },
      meta: {
        title: '创建题目',
        activeMenu: '/training/question'
      }
    }, {
      path: 'question/update/:id',
      component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 340));
      },
      meta: {
        title: '编辑题目',
        activeMenu: '/training/question'
      }
    },

    // 知识库
    {
      path: 'knowledge',
      component: function component() {
        return __webpack_require__.e/* import() */(237).then(__webpack_require__.bind(null, 1301));
      },
      meta: {
        title: '知识库管理',
        aiContext: 'knowledge-list'
      }
    }]
  }]
}];

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingPageLayout_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f27bab3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingPageLayout_vue__ = __webpack_require__(973);
function injectStyle (ssrContext) {
  __webpack_require__(966)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f27bab3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingPageLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f27bab3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingPageLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingAiAssistantSidebar_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2eb53d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingAiAssistantSidebar_vue__ = __webpack_require__(971);
function injectStyle (ssrContext) {
  __webpack_require__(968)
  __webpack_require__(969)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2eb53d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrainingAiAssistantSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2eb53d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrainingAiAssistantSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildWelcomeMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = mockSendTrainingAiMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var CONTEXT_HINTS = {
  'instruction-list': '💡 培训模块：我可以帮你筛选培训、解读上下架规则、分析学习进度。',
  'instruction-form': '💡 我可以帮你检查培训配置、推荐关联考试与知识库内容。',
  'instruction-bind-history': '💡 绑定历史：我可以帮你解读项目/批次绑定关系与生效范围。',
  'instruction-records': '💡 培训记录：我可以帮你分析学习进度、导出字段含义与异常数据。',
  'instruction-exam-records': '💡 答卷列表：我可以帮你解读通过率、筛选高价值样本。',
  'instruction-exam-detail': '💡 答卷详情：我可以帮你分析错题分布、知识点薄弱项。',
  'course-list': '💡 教程模块：我可以帮你梳理教程结构、检查关联培训配置。',
  'course-form': '💡 我可以帮你优化教程章节与媒体素材说明。',
  'knowledge-list': '💡 知识库模块：我可以帮你分析文档、检测内容冲突。'
};

var WELCOME_SUFFIX = '\n\n请告诉我需要什么帮助？';

function getContextHint(context) {
  return CONTEXT_HINTS[context] || '💡 考试培训管理：我可以帮你解答当前页面的操作与数据问题。';
}

function buildWelcomeMessage(context) {
  return '\u4F60\u597D\uFF01\u6211\u662F AI \u52A9\u624B\u3002\n\n' + getContextHint(context) + WELCOME_SUFFIX;
}

function pickReply(message, context) {
  var text = (message || '').trim();
  var lower = text.toLowerCase();

  if (!text) {
    return '请输入您的问题，我会尽力解答。';
  }

  if (text.includes('上架') || text.includes('下架')) {
    return '培训上下架说明：\n• 新建培训默认为「未上架」，需手动上架后才会对用户可见\n• 已上架培训修改核心配置前建议先下架\n• 下架后已学习用户的历史记录仍会保留';
  }

  if (text.includes('导出') || lower.includes('export')) {
    return '导出说明：\n• 培训记录页支持导出当前筛选条件下的学习进度\n• 导出字段与列表列一致，适合线下分析\n• 建议先缩小筛选范围再导出，避免数据量过大';
  }

  if (text.includes('绑定') || context === 'instruction-bind-history') {
    return '绑定历史说明：\n• 记录培训与项目/批次的绑定关系\n• 绑定后对应批次用户可在任务链路中触发培训\n• 当前为一次性绑定，暂不支持解绑记录展示';
  }

  if (text.includes('答卷') || text.includes('考试') || context.includes('exam')) {
    return '答卷相关说明：\n• 仅展示已提交或进行中的考试记录\n• 详情页可查看逐题得分与正确答案对比\n• 可通过状态、来源、项目批次等条件筛选';
  }

  if (text.includes('进度') || text.includes('记录') || context === 'instruction-records') {
    return '学习进度说明：\n• 进度按教程/考试完成度综合计算\n• 可结合用户类型、来源、地区等维度筛选\n• 异常低进度用户可优先排查是否未完成前置任务';
  }

  if (text.includes('创建') || text.includes('配置') || context === 'instruction-form') {
    return '培训配置建议：\n• 先确定目标用户类型，再选择知识库/教程/考试组合\n• 零工用户可配置 App 学习中心展示与分组\n• 关联考试须为已上架状态';
  }

  if (text.includes('搜索') || text.includes('筛选')) {
    return '筛选技巧：\n• 支持培训名称、客户、分组、创建人等多维组合\n• 清空条件后点击「重置」可恢复默认列表\n• 所属用户类型可区分零工与审核实习生数据';
  }

  if (text.includes('知识库') || context === 'knowledge-list') {
    return '知识库提示：\n• 可作为培训内容来源\n• 建议保持文档结构清晰，便于后续生成题目\n• 变更知识库后需检查已关联培训是否需要更新';
  }

  if (text.includes('教程') || context.includes('course')) {
    return '教程提示：\n• 教程可独立维护，再关联到培训任务\n• 建议章节粒度适中，便于统计学习进度\n• 媒体素材上传后可在预览中核对展示效果';
  }

  return '\u6536\u5230\u60A8\u7684\u95EE\u9898\uFF1A\u300C' + text + '\u300D\n\n' + getContextHint(context) + '\n\n\uFF08\u5F53\u524D\u4E3A\u6A21\u62DF\u56DE\u590D\uFF0C\u6B63\u5F0F AI \u63A5\u53E3\u63A5\u5165\u540E\u5C06\u63D0\u4F9B\u66F4\u7CBE\u51C6\u7684\u56DE\u7B54\u3002\uFF09';
}

function mockSendTrainingAiMessage(_ref) {
  var message = _ref.message,
      context = _ref.context,
      pageTitle = _ref.pageTitle;

  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    var delay = 600 + Math.floor(Math.random() * 500);
    setTimeout(function () {
      resolve({
        id: Date.now() + '-' + Math.random().toString(36).slice(2, 8),
        role: 'assistant',
        content: pickReply(message, context || ''),
        timestamp: new Date(),
        meta: {
          context: context,
          pageTitle: pageTitle,
          mocked: true
        }
      });
    }, delay);
  });
}

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:['training-ai-assistant', _vm.expanded ? 'is-expanded' : 'is-collapsed']},[(_vm.expanded)?[_c('div',{staticClass:"training-ai-assistant__header"},[_vm._m(0),_vm._v(" "),_c('el-button',{staticClass:"training-ai-assistant__close",attrs:{"type":"text","icon":"el-icon-close","title":"收起 AI 助手"},on:{"click":function($event){_vm.expanded = false}}})],1),_vm._v(" "),_c('div',{ref:"messageList",staticClass:"training-ai-assistant__messages"},[_vm._l((_vm.messages),function(item){return _c('div',{key:item.id,class:['training-ai-assistant__message-row', item.role === 'user' ? 'is-user' : 'is-assistant']},[_c('div',{class:['training-ai-assistant__avatar', item.role === 'user' ? 'is-user' : 'is-assistant']},[(item.role === 'user')?_c('span',[_vm._v("我")]):_c('i',{staticClass:"el-icon-magic-stick"})]),_vm._v(" "),_c('div',{staticClass:"training-ai-assistant__bubble-wrap"},[_c('div',{class:['training-ai-assistant__bubble', item.role === 'user' ? 'is-user' : 'is-assistant']},[_c('div',{staticClass:"training-ai-assistant__bubble-text"},[_vm._v(_vm._s(item.content))])]),_vm._v(" "),_c('div',{staticClass:"training-ai-assistant__time"},[_vm._v(_vm._s(_vm.formatTime(item.timestamp)))])])])}),_vm._v(" "),(_vm.replying)?_c('div',{staticClass:"training-ai-assistant__message-row is-assistant"},[_vm._m(1),_vm._v(" "),_vm._m(2)]):_vm._e()],2),_vm._v(" "),(_vm.quickPrompts.length)?_c('div',{staticClass:"training-ai-assistant__prompts"},_vm._l((_vm.quickPrompts),function(prompt){return _c('button',{key:prompt,staticClass:"training-ai-assistant__prompt",attrs:{"type":"button","disabled":_vm.replying},on:{"click":function($event){return _vm.sendMessage(prompt)}}},[_vm._v("\n        "+_vm._s(prompt)+"\n      ")])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"training-ai-assistant__composer"},[_c('el-input',{attrs:{"type":"textarea","rows":3,"resize":"none","placeholder":"输入消息... (Enter 发送，Shift + Enter 换行)","disabled":_vm.replying},nativeOn:{"keydown":function($event){return _vm.onComposerKeydown($event)}},model:{value:(_vm.draft),callback:function ($$v) {_vm.draft=$$v},expression:"draft"}}),_vm._v(" "),_c('el-button',{staticClass:"training-ai-assistant__send",attrs:{"type":"primary","icon":"el-icon-s-promotion","disabled":!_vm.canSend,"loading":_vm.replying},on:{"click":function($event){return _vm.sendMessage()}}},[_vm._v("\n        发送\n      ")])],1)]:[_c('button',{staticClass:"training-ai-assistant__expand-btn",attrs:{"type":"button","title":"展开 AI 助手"},on:{"click":function($event){_vm.expanded = true}}},[_c('i',{staticClass:"el-icon-d-arrow-left"})]),_vm._v(" "),_vm._m(3)]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-ai-assistant__brand"},[_c('span',{staticClass:"training-ai-assistant__logo"},[_c('i',{staticClass:"el-icon-magic-stick"})]),_vm._v(" "),_c('span',{staticClass:"training-ai-assistant__title"},[_vm._v("AI 助手")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-ai-assistant__avatar is-assistant"},[_c('i',{staticClass:"el-icon-magic-stick"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-ai-assistant__bubble-wrap"},[_c('div',{staticClass:"training-ai-assistant__bubble is-assistant is-loading"},[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "),_c('span',[_vm._v("思考中...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-ai-assistant__collapsed-logo",attrs:{"title":"AI 助手"}},[_c('i',{staticClass:"el-icon-magic-stick"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRAINING_AI_ASSISTANT_ENABLED; });
/** 培训模块 AI 助手开关，第二期上线时改为 true */
var TRAINING_AI_ASSISTANT_ENABLED = false;

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training-page-layout"},[_c('div',{staticClass:"training-page-layout__main",style:(_vm.mainStyle)},[_c('router-view')],1),_vm._v(" "),(_vm.aiAssistantEnabled)?_c('training-ai-assistant-sidebar',{attrs:{"context":_vm.aiContext,"page-title":_vm.pageTitle},on:{"expand-change":_vm.onSidebarExpandChange}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userBankAccount", function() { return userBankAccount; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userBankAccount = [{
  path: '/user-bank-account',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(178).then(__webpack_require__.bind(null, 1302));
    },
    name: '员工账户列表',
    meta: {
      title: '员工账户列表'
    }
  }, {
    path: 'create/batch',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 341));
    },
    name: '批量添加员工账户',
    meta: {
      type: 'create',
      title: '批量添加员工账户'
    }
  }, {
    path: 'edit/batch',
    component: function component() {
      return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 341));
    },
    name: '批量修改员工账户',
    meta: {
      type: 'edit',
      title: '批量修改员工账户'
    }
  }]
}];

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userBatchTag", function() { return userBatchTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userBatchTag = [{
  path: '/user-batch-tag',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'add/form',
    component: function component() {
      return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1303));
    },
    name: '批量添加用户标签',
    meta: {
      title: '批量添加用户标签'
    }
  }, {
    path: 'delete/form',
    component: function component() {
      return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1304));
    },
    name: '批量删除用户标签',
    meta: {
      title: '批量删除用户标签'
    }
  }]
}];

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userCover", function() { return userCover; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userCover = [{
  path: '/user-cover',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(209).then(__webpack_require__.bind(null, 1305));
    },
    name: '覆盖查询列表',
    meta: {
      title: '覆盖查询列表'
    }
  }]
}];

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userCredit", function() { return userCredit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userCredit = [{
  path: '/user-credit',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'update/:userid',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1306));
    },
    name: '修改用户赏金',
    meta: {
      title: '修改用户赏金'
    }
  }]
}];

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userOrderStat", function() { return userOrderStat; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userOrderStat = [{
  path: '/user-order-stat',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(171).then(__webpack_require__.bind(null, 1307));
    },
    name: '条件搜索添加标签列表',
    meta: {
      title: '条件搜索添加标签列表'
    }
  }, {
    path: 'detail/:userid',
    component: function component() {
      return __webpack_require__.e/* import() */(291).then(__webpack_require__.bind(null, 1308));
    },
    name: '用户统计数据详情',
    meta: {
      title: '用户统计数据详情'
    }
  }]
}];

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userTag", function() { return userTag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userTag = [{
  path: '/usertag',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1309));
    },
    name: '用户标签列表',
    meta: {
      title: '用户标签列表'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 342));
    },
    name: '用户标签创建',
    meta: {
      title: '用户标签创建'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 342));
    },
    name: '用户标签编辑',
    meta: {
      title: '用户标签编辑'
    }
  }]
}];

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userWorkInfo", function() { return userWorkInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var userWorkInfo = [{
  path: '/user-workinfo',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(236).then(__webpack_require__.bind(null, 1310));
    },
    meta: {
      title: '职业信息审核列表'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(62/* duplicate */).then(__webpack_require__.bind(null, 343));
    },
    meta: {
      title: '职业信息提交详情',
      type: 'detail'
    }
  }, {
    path: 'audit/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(62/* duplicate */).then(__webpack_require__.bind(null, 343));
    },
    meta: {
      title: '职业信息审核',
      type: 'audit'
    }
  }]
}];

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "users", function() { return users; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var users = [{
  path: '/users',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: 'detail',
    component: function component() {
      return __webpack_require__.e/* import() */(317).then(__webpack_require__.bind(null, 1311));
    },
    children: [{
      path: 'info',
      component: function component() {
        return __webpack_require__.e/* import() */(254).then(__webpack_require__.bind(null, 1312));
      },
      name: '用户详情',
      meta: {
        title: '用户详情'
      }
    }, {
      path: 'service',
      component: function component() {
        return __webpack_require__.e/* import() */(208).then(__webpack_require__.bind(null, 1313));
      },
      name: '客服记录',
      meta: {
        title: '客服记录'
      }
    }, {
      path: 'account',
      component: function component() {
        return __webpack_require__.e/* import() */(316).then(__webpack_require__.bind(null, 1314));
      },
      name: '账户信息',
      meta: {
        title: '账户信息'
      }
    }, {
      path: 'device',
      component: function component() {
        return __webpack_require__.e/* import() */(382).then(__webpack_require__.bind(null, 1315));
      },
      name: '设备信息',
      meta: {
        title: '设备信息'
      }
    }, {
      path: 'operate',
      component: function component() {
        return __webpack_require__.e/* import() */(314).then(__webpack_require__.bind(null, 1316));
      },
      name: '运营信息',
      meta: {
        title: '运营信息'
      }
    }, {
      path: 'log',
      component: function component() {
        return __webpack_require__.e/* import() */(315).then(__webpack_require__.bind(null, 1318));
      },
      name: '管理日志',
      meta: {
        title: '管理日志'
      }
    }, {
      path: 'workinfo-log',
      component: function component() {
        return __webpack_require__.e/* import() */(177).then(__webpack_require__.bind(null, 1319));
      },
      name: '工作信息记录',
      meta: {
        title: '工作信息记录'
      }
    }]
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, 1320));
    },
    name: '用户列表',
    meta: {
      title: '用户列表'
    }
  }, {
    path: 'amount',
    component: function component() {
      return __webpack_require__.e/* import() */(362).then(__webpack_require__.bind(null, 1321));
    },
    name: '金额详情',
    meta: {
      title: '金额详情'
    }
  }, {
    path: 'point',
    component: function component() {
      return __webpack_require__.e/* import() */(318).then(__webpack_require__.bind(null, 1322));
    },
    name: '积分详情',
    meta: {
      title: '积分详情'
    }
  }, {
    path: 'mas',
    component: function component() {
      return __webpack_require__.e/* import() */(207).then(__webpack_require__.bind(null, 1323));
    },
    name: '群发消息',
    meta: {
      title: '群发消息'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(51/* duplicate */).then(__webpack_require__.bind(null, 344));
    },
    name: '修改用户',
    meta: {
      type: 'edit_user',
      title: '修改用户'
    }
  }, {
    path: 'form',
    component: function component() {
      return __webpack_require__.e/* import() */(51/* duplicate */).then(__webpack_require__.bind(null, 344));
    },
    name: '创建用户',
    meta: {
      type: 'add_user',
      title: '创建用户'
    }
  }, {
    path: 'freeze/form/:userid',
    component: function component() {
      return __webpack_require__.e/* import() */(217).then(__webpack_require__.bind(null, 1324));
    },
    name: '修改封号',
    meta: {
      title: '修改封号'
    }
  }, {
    path: 'batch/table',
    component: function component() {
      return __webpack_require__.e/* import() */(149).then(__webpack_require__.bind(null, 1325));
    },
    name: '批量用户',
    meta: {
      title: '批量用户'
    }
  }, {
    path: 'user-account-table',
    component: function component() {
      return __webpack_require__.e/* import() */(290).then(__webpack_require__.bind(null, 1326));
    },
    name: '用户账户查询',
    meta: {
      title: '用户账户查询'
    }
  }, {
    path: 'points-table',
    component: function component() {
      return __webpack_require__.e/* import() */(289).then(__webpack_require__.bind(null, 1327));
    },
    name: '零豆管理',
    meta: {
      title: '零豆管理'
    }
  }, {
    path: 'communicate-table',
    component: function component() {
      return __webpack_require__.e/* import() */(169).then(__webpack_require__.bind(null, 1328));
    },
    name: '用户沟通记录',
    meta: {
      title: '用户沟通记录'
    }
  }, {
    path: 'deleted-table',
    component: function component() {
      return __webpack_require__.e/* import() */(363).then(__webpack_require__.bind(null, 1329));
    },
    name: '注销用户列表',
    meta: {
      title: '注销用户列表'
    }
  }, {
    path: 'devices',
    component: function component() {
      return __webpack_require__.e/* import() */(276).then(__webpack_require__.bind(null, 1330));
    },
    name: '用户设备列表',
    meta: {
      title: '用户设备列表'
    }
  }, {
    path: 'devices/user-list',
    component: function component() {
      return __webpack_require__.e/* import() */(287).then(__webpack_require__.bind(null, 1331));
    },
    name: '设备关联记录',
    meta: {
      title: '设备关联记录'
    }
  }, {
    path: 'newbie-config',
    component: function component() {
      return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 345));
    },
    name: '新用户定义配置',
    meta: {
      title: '新用户定义配置'
    }
  }, {
    path: 'view-newbie-config',
    component: function component() {
      return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 345));
    },
    name: '新用户定义查看页',
    meta: {
      title: '新用户定义查看页',
      pageType: 'view'
    }
  }, {
    path: 'newbie-mission-config',
    component: function component() {
      return __webpack_require__.e/* import() */(218).then(__webpack_require__.bind(null, 1332));
    },
    name: '新手引导任务配置',
    meta: {
      title: '新手引导任务配置'
    }
  }, {
    path: 'riskusers',
    component: function component() {
      return __webpack_require__.e/* import() */(274).then(__webpack_require__.bind(null, 1333));
    },
    name: '风险用户统计',
    meta: {
      title: '风险用户统计'
    }
  }, {
    path: 'riskusers/detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(288).then(__webpack_require__.bind(null, 1334));
    },
    name: '风险用户统计详情',
    meta: {
      title: '风险用户统计详情'
    }
  }]
}];

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "violationAlert", function() { return violationAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var violationAlert = [{
  path: '/violation-alert',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(361).then(__webpack_require__.bind(null, 1335));
    },
    name: '违规预警列表',
    meta: {
      title: '违规预警'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(286).then(__webpack_require__.bind(null, 1336));
    },
    name: '添加违规预警消息',
    meta: {
      title: '添加违规预警消息'
    }
  }, {
    path: 'types/create',
    component: function component() {
      return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 346));
    },
    name: '新增违规类型',
    meta: {
      title: '新增违规类型'
    }
  }, {
    path: 'types/edit/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 346));
    },
    name: '编辑违规类型',
    meta: {
      title: '编辑违规类型'
    }
  }, {
    path: 'types',
    component: function component() {
      return __webpack_require__.e/* import() */(285).then(__webpack_require__.bind(null, 1337));
    },
    name: '违规类型管理',
    meta: {
      title: '违规类型管理'
    }
  }, {
    path: 'detail/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(253).then(__webpack_require__.bind(null, 1338));
    },
    name: '违规预警发送名单',
    meta: {
      title: '发送名单'
    }
  }]
}];

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoBusinessType", function() { return workInfoBusinessType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var workInfoBusinessType = [{
  path: '/work-info-business-type',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(284).then(__webpack_require__.bind(null, 1339));
    },
    name: '职业信息行业',
    meta: {
      title: '职业信息行业'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 347));
    },
    name: '新增职业信息行业',
    meta: {
      title: '新增职业信息行业'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 347));
    },
    name: '编辑职业信息行业',
    meta: {
      title: '编辑职业信息行业'
    }
  }, {
    path: 'batch-jobs',
    component: function component() {
      return __webpack_require__.e/* import() */(176).then(__webpack_require__.bind(null, 1340));
    },
    name: '职业信息批量任务',
    meta: {
      title: '职业信息批量任务'
    }
  }]
}];

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoCompany", function() { return workInfoCompany; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var workInfoCompany = [{
  path: '/work-info-company',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(360).then(__webpack_require__.bind(null, 1341));
    },
    name: '职业信息公司',
    meta: {
      title: '职业信息公司'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 348));
    },
    name: '新增职业信息公司',
    meta: {
      title: '新增职业信息公司'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 348));
    },
    name: '编辑职业信息公司',
    meta: {
      title: '编辑职业信息公司'
    }
  }]
}];

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workInfoWorkType", function() { return workInfoWorkType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var workInfoWorkType = [{
  path: '/work-info-work-type',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],

  children: [{
    path: '',
    redirect: 'table'
  }, {
    path: 'table',
    component: function component() {
      return __webpack_require__.e/* import() */(359).then(__webpack_require__.bind(null, 1342));
    },
    name: '职业信息工种',
    meta: {
      title: '职业信息工种'
    }
  }, {
    path: 'create',
    component: function component() {
      return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 349));
    },
    name: '新增职业信息工种',
    meta: {
      title: '新增职业信息工种'
    }
  }, {
    path: 'update/:id',
    component: function component() {
      return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 349));
    },
    name: '编辑职业信息工种',
    meta: {
      title: '编辑职业信息工种'
    }
  }]
}];

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workbench", function() { return workbench; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_Index__ = __webpack_require__(1);


var workbench = [{
  path: '/workbench',
  component: __WEBPACK_IMPORTED_MODULE_0__layout_Index__["a" /* default */],
  children: [{
    path: '',
    component: function component() {
      return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1343));
    },
    name: '工作台',
    meta: {
      title: '工作台'
    }
  }, {
    path: 'attendance-plan',
    component: function component() {
      return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 1344));
    },
    name: '出勤设置',
    meta: {
      title: '出勤设置'
    }
  }]
}];

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ad9bbf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(989);
function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ad9bbf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 990 */,
/* 991 */,
/* 992 */
/***/ (function(module, exports) {

module.exports = plugins_library;

/***/ }),
/* 993 */,
/* 994 */
/***/ (function(module, exports) {

module.exports = fabric;

/***/ }),
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */
/***/ (function(module, exports) {

module.exports = go;

/***/ }),
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */
/***/ (function(module, exports) {

module.exports = echarts;

/***/ })
],[350]);


// WEBPACK FOOTER //
// static/js/app.4165769697048e68b178.js